import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: string; output: string; }
  JSON: { input: Record<string, any>; output: Record<string, any>; }
  UUID: { input: string; output: string; }
};

export type AiAdvisorEvent = BaseEvent & {
  __typename?: 'AIAdvisorEvent';
  analysisResult?: Maybe<Scalars['JSON']['output']>;
  analysisType?: Maybe<Scalars['String']['output']>;
  confidenceScore?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  projectId: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  suggestions?: Maybe<Array<Scalars['String']['output']>>;
  timestamp: Scalars['DateTime']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  type: EventType;
  userId: Scalars['String']['output'];
};

export type AiAdvisorMessageType = {
  __typename?: 'AIAdvisorMessageType';
  actionTaken?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  extractedInfo?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  orderIndex: Scalars['Int']['output'];
  phase: Scalars['String']['output'];
  role: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  suggestions?: Maybe<Array<Scalars['String']['output']>>;
};

export type AiAdvisorSessionType = {
  __typename?: 'AIAdvisorSessionType';
  analysisResult?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['String']['output']>;
  context: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  currentPhase: Scalars['String']['output'];
  id: Scalars['String']['output'];
  meetingStatus: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  phaseFlow: Array<Scalars['String']['output']>;
  progressPercentage: Scalars['Float']['output'];
  projectId: Scalars['String']['output'];
  projectType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type AbstractItem = {
  __typename?: 'AbstractItem';
  confidence: Scalars['Float']['output'];
  content: Scalars['String']['output'];
  importance: Scalars['Float']['output'];
  reasoning?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type AbstractLayerResult = {
  __typename?: 'AbstractLayerResult';
  count: Scalars['Int']['output'];
  items: Array<AbstractItem>;
};

export type AdminPageInput = {
  audience?: Scalars['String']['input'];
  bc: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  enabledActions?: InputMaybe<Array<Scalars['String']['input']>>;
  entity: Scalars['String']['input'];
  labelJa?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
};

export type AdminPageType = {
  __typename?: 'AdminPageType';
  audience: Scalars['String']['output'];
  bc: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enabledActions: Array<Scalars['String']['output']>;
  entity: Scalars['String']['output'];
  labelJa?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
};

export type AnalysisCapabilities = {
  __typename?: 'AnalysisCapabilities';
  capabilities: Scalars['JSON']['output'];
  performance: Scalars['JSON']['output'];
  version: Scalars['String']['output'];
};

export type AnalysisOptions = {
  analysisDepth?: Scalars['String']['input'];
  domain?: Scalars['String']['input'];
  includeAbstracts?: Scalars['Boolean']['input'];
  includeCrossLayer?: Scalars['Boolean']['input'];
  includeEmotionFluctuation?: Scalars['Boolean']['input'];
  includeEmotions?: Scalars['Boolean']['input'];
  includeFacts?: Scalars['Boolean']['input'];
  includeIdeals?: Scalars['Boolean']['input'];
  includePerspectives?: Scalars['Boolean']['input'];
  includeTeamMorale?: Scalars['Boolean']['input'];
  language?: Scalars['String']['input'];
  maxItemsPerType?: Scalars['Int']['input'];
};

export type AnalysisSummary = {
  __typename?: 'AnalysisSummary';
  keyFindings: Array<Scalars['String']['output']>;
  layersAnalyzed: Array<Scalars['String']['output']>;
  totalItemsExtracted: Scalars['Int']['output'];
};

export type ApiCatalogType = {
  __typename?: 'ApiCatalogType';
  apiOverview: ApiOverviewType;
  apiVersion?: Maybe<Scalars['String']['output']>;
  crawlCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  crawlError?: Maybe<Scalars['String']['output']>;
  crawlStartedAt?: Maybe<Scalars['DateTime']['output']>;
  crawlStatus: CrawlStatusEnum;
  createdAt: Scalars['DateTime']['output'];
  documentationUrls: Array<Scalars['String']['output']>;
  endpointCount: Scalars['Int']['output'];
  endpoints: Array<ApiEndpointType>;
  groundingSources: Array<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  implementationKnowledge?: Maybe<Scalars['JSON']['output']>;
  organizationId: Scalars['UUID']['output'];
  projectId?: Maybe<Scalars['UUID']['output']>;
  provider: Scalars['String']['output'];
  serviceName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  verification?: Maybe<VerificationResultType>;
};

export type ApiCrawlEvent = BaseEvent & {
  __typename?: 'ApiCrawlEvent';
  catalogId: Scalars['String']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  endpointCount?: Maybe<Scalars['Int']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  serviceName: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  type: EventType;
};

export type ApiEndpointType = {
  __typename?: 'ApiEndpointType';
  authRequired: Scalars['Boolean']['output'];
  deprecated: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  method: Scalars['String']['output'];
  parameters?: Maybe<Scalars['JSON']['output']>;
  path: Scalars['String']['output'];
  requestBody?: Maybe<Scalars['JSON']['output']>;
  responseSchema?: Maybe<Scalars['JSON']['output']>;
};

export type ApiOverviewType = {
  __typename?: 'ApiOverviewType';
  authDetails: Scalars['String']['output'];
  authType: Scalars['String']['output'];
  baseUrl: Scalars['String']['output'];
  description: Scalars['String']['output'];
  rateLimits: Scalars['String']['output'];
};

export type ApplyConstitutionCandidateInput = {
  candidateId: Scalars['String']['input'];
  modifications?: InputMaybe<Scalars['JSON']['input']>;
  projectId: Scalars['UUID']['input'];
};

export type ApproveConstitutionInput = {
  notes?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['UUID']['input'];
  version: Scalars['Int']['input'];
};

export type ArtifactDdd = {
  __typename?: 'ArtifactDDD';
  artifactType: Scalars['String']['output'];
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['UUID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Int']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  format: Scalars['String']['output'];
  generatedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  projectId: Scalars['UUID']['output'];
  proposalMetadata?: Maybe<ProposalMetadata>;
  status: Scalars['String']['output'];
  systemSpecData?: Maybe<Scalars['JSON']['output']>;
  title: Scalars['String']['output'];
};

export type ArtifactDddConnection = {
  __typename?: 'ArtifactDDDConnection';
  edges: Array<ArtifactDddEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ArtifactDddEdge = {
  __typename?: 'ArtifactDDDEdge';
  cursor: Scalars['String']['output'];
  node: ArtifactDdd;
};

export type ArtifactDownloadResult = {
  __typename?: 'ArtifactDownloadResult';
  error?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Int']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum ArtifactFormatEnum {
  Docx = 'DOCX',
  GoogleSlides = 'GOOGLE_SLIDES',
  Html = 'HTML',
  Json = 'JSON',
  Markdown = 'MARKDOWN',
  Pdf = 'PDF',
  Pptx = 'PPTX',
  SourceCode = 'SOURCE_CODE'
}

export enum ArtifactTypeEnum {
  Deliverable = 'DELIVERABLE',
  Presentation = 'PRESENTATION',
  Proposal = 'PROPOSAL',
  Report = 'REPORT',
  Sitemap = 'SITEMAP',
  Slides = 'SLIDES',
  Specification = 'SPECIFICATION',
  System = 'SYSTEM'
}

export type AtomBaseType = {
  __typename?: 'AtomBaseType';
  atomType: AtomTypeType;
  category?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['UUID']['output']>;
  contentFormat: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['UUID']['output'];
  embeddingModel?: Maybe<Scalars['String']['output']>;
  filePath?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Int']['output']>;
  fileType?: Maybe<Scalars['String']['output']>;
  fullContent?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  industryId?: Maybe<Scalars['UUID']['output']>;
  isVectorized: Scalars['Boolean']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  metaInfo?: Maybe<Scalars['JSON']['output']>;
  organizationId: Scalars['UUID']['output'];
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  processingError?: Maybe<Scalars['String']['output']>;
  processingProgress?: Maybe<Scalars['Float']['output']>;
  projectId?: Maybe<Scalars['UUID']['output']>;
  qualityScore?: Maybe<Scalars['Float']['output']>;
  sourceId?: Maybe<Scalars['UUID']['output']>;
  sourceType: Scalars['String']['output'];
  status: AtomStatusType;
  tags: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['UUID']['output']>;
  usageCount: Scalars['Int']['output'];
  viewCount: Scalars['Int']['output'];
};

export type AtomConnection = {
  __typename?: 'AtomConnection';
  edges: Array<AtomEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AtomEdge = {
  __typename?: 'AtomEdge';
  cursor: Scalars['String']['output'];
  node: AtomBaseType;
};

export type AtomEvent = BaseEvent & {
  __typename?: 'AtomEvent';
  atomId: Scalars['String']['output'];
  atomType?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  extractionResult?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  title?: Maybe<Scalars['String']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
  type: EventType;
  userId: Scalars['String']['output'];
};

export type AtomFilterInput = {
  atomType?: InputMaybe<AtomTypeType>;
  category?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  createdBy?: InputMaybe<Scalars['UUID']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  hasFile?: InputMaybe<Scalars['Boolean']['input']>;
  industryId?: InputMaybe<Scalars['UUID']['input']>;
  isVectorized?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AtomStatusType>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum AtomInputType {
  Audio = 'AUDIO',
  Document = 'DOCUMENT',
  Text = 'TEXT',
  Url = 'URL'
}

export type AtomProcessingResult = {
  __typename?: 'AtomProcessingResult';
  atom?: Maybe<AtomBaseType>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  extractedMetadata?: Maybe<Scalars['JSON']['output']>;
  processingTimeMs?: Maybe<Scalars['Float']['output']>;
  success: Scalars['Boolean']['output'];
  taskId?: Maybe<Scalars['String']['output']>;
};

export enum AtomSourceEntityTypeEnum {
  Client = 'CLIENT',
  Industry = 'INDUSTRY',
  Organization = 'ORGANIZATION'
}

export type AtomSourceFilterInput = {
  entityType?: InputMaybe<AtomSourceEntityTypeEnum>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<SourceTypeEnum>;
  status?: InputMaybe<AtomSourceStatusEnum>;
};

export type AtomSourceGql = {
  __typename?: 'AtomSourceGQL';
  collectionFrequency: CollectionFrequencyEnum;
  contentFilters: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  entityId: Scalars['UUID']['output'];
  entityType: AtomSourceEntityTypeEnum;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  languageCode: Scalars['String']['output'];
  lastCollectedAt?: Maybe<Scalars['DateTime']['output']>;
  metadata: Scalars['JSON']['output'];
  nextCollectionAt?: Maybe<Scalars['DateTime']['output']>;
  organizationId: Scalars['UUID']['output'];
  sourceConfig: Scalars['JSON']['output'];
  sourceName: Scalars['String']['output'];
  sourceType: SourceTypeEnum;
  sourceUrl: Scalars['String']['output'];
  status: AtomSourceStatusEnum;
  updatedAt: Scalars['DateTime']['output'];
};

export type AtomSourceListGql = {
  __typename?: 'AtomSourceListGQL';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  sources: Array<AtomSourceGql>;
  totalCount: Scalars['Int']['output'];
};

export type AtomSourceMutationResponse = {
  __typename?: 'AtomSourceMutationResponse';
  message: Scalars['String']['output'];
  source?: Maybe<AtomSourceGql>;
  success: Scalars['Boolean']['output'];
};

export type AtomSourceStatsGql = {
  __typename?: 'AtomSourceStatsGQL';
  activeSources: Scalars['Int']['output'];
  byEntityType: Scalars['JSON']['output'];
  bySourceType: Scalars['JSON']['output'];
  errorSources: Scalars['Int']['output'];
  inactiveSources: Scalars['Int']['output'];
  totalSources: Scalars['Int']['output'];
};

export enum AtomSourceStatusEnum {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Error = 'ERROR',
  Paused = 'PAUSED'
}

export enum AtomStatusType {
  Archived = 'ARCHIVED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export type AtomTaskStatus = {
  __typename?: 'AtomTaskStatus';
  atomId: Scalars['UUID']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
  taskId?: Maybe<Scalars['String']['output']>;
  taskResult?: Maybe<Scalars['JSON']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export enum AtomTypeType {
  BestPractice = 'BEST_PRACTICE',
  Checklist = 'CHECKLIST',
  Document = 'DOCUMENT',
  Faq = 'FAQ',
  Guide = 'GUIDE',
  Policy = 'POLICY',
  Template = 'TEMPLATE'
}

export enum AuthProviderType {
  Github = 'GITHUB',
  Google = 'GOOGLE',
  Local = 'LOCAL',
  Microsoft = 'MICROSOFT'
}

export type AuthUser = {
  __typename?: 'AuthUser';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isSuperuser: Scalars['Boolean']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationRole?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type AutoRegisterClientInput = {
  autoEnrich?: Scalars['Boolean']['input'];
  corporateNumber?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['UUID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  relationshipType?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type BcCatalogEntryType = {
  __typename?: 'BCCatalogEntryType';
  description: Scalars['String']['output'];
  entities: Array<Scalars['String']['output']>;
  entityNamesJa: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nameJa: Scalars['String']['output'];
};

export type BcEventInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  description?: Scalars['String']['input'];
  name: Scalars['String']['input'];
  payloadFields?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceBc?: InputMaybe<Scalars['String']['input']>;
};

export type BcEventType = {
  __typename?: 'BCEventType';
  action?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  payloadFields: Array<Scalars['String']['output']>;
  sourceBc?: Maybe<Scalars['String']['output']>;
};

export type BcMatchType = {
  __typename?: 'BCMatchType';
  bcName: Scalars['String']['output'];
  confidence: Scalars['Float']['output'];
  matchedFeatures: Array<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
};

export type BcRefInput = {
  listRpc?: InputMaybe<Scalars['String']['input']>;
  purpose?: InputMaybe<Scalars['String']['input']>;
  rpc: Scalars['String']['input'];
  sourceField?: InputMaybe<Scalars['String']['input']>;
  targetBc: Scalars['String']['input'];
  targetEntity: Scalars['String']['input'];
};

export type BcRefType = {
  __typename?: 'BCRefType';
  listRpc?: Maybe<Scalars['String']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
  rpc: Scalars['String']['output'];
  sourceField?: Maybe<Scalars['String']['output']>;
  targetBc: Scalars['String']['output'];
  targetEntity: Scalars['String']['output'];
};

export type BaseEvent = {
  id: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  type: EventType;
};

export type BcSummaryType = {
  __typename?: 'BcSummaryType';
  bcName: Scalars['String']['output'];
  dependsOn: Array<Scalars['String']['output']>;
  entityCount: Scalars['Int']['output'];
  nameJa?: Maybe<Scalars['String']['output']>;
  publishesEventCount: Scalars['Int']['output'];
};

export type BoundedContextInput = {
  dynamicSpec?: InputMaybe<Scalars['JSON']['input']>;
  integrationApi?: InputMaybe<Scalars['String']['input']>;
  justification?: Scalars['String']['input'];
  name: Scalars['String']['input'];
  nameJa: Scalars['String']['input'];
  publishes?: InputMaybe<Array<BcEventInput>>;
  refs?: InputMaybe<Array<BcRefInput>>;
  subscribes?: InputMaybe<Array<BcEventInput>>;
  type?: Scalars['String']['input'];
};

export type BoundedContextType = {
  __typename?: 'BoundedContextType';
  dynamicSpec?: Maybe<Scalars['JSON']['output']>;
  entities: Array<DynamicEntitySummaryType>;
  entityCount: Scalars['Int']['output'];
  integrationApi?: Maybe<Scalars['String']['output']>;
  isFrozen: Scalars['Boolean']['output'];
  justification: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nameJa: Scalars['String']['output'];
  publishes: Array<BcEventType>;
  refs: Array<BcRefType>;
  subscribes: Array<BcEventType>;
  type: Scalars['String']['output'];
};

export type BusinessFlowStoryInput = {
  category?: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  involvedBcs?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  nameEn?: InputMaybe<Scalars['String']['input']>;
  priority?: Scalars['String']['input'];
  steps?: InputMaybe<Array<FlowStepInput>>;
};

export type BusinessFlowStoryType = {
  __typename?: 'BusinessFlowStoryType';
  category: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  involvedBcs: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nameEn?: Maybe<Scalars['String']['output']>;
  priority: Scalars['String']['output'];
  steps: Array<FlowStepType>;
};

export type CategoryMutationResponse = {
  __typename?: 'CategoryMutationResponse';
  category?: Maybe<IndustryCategory>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ChangePasswordInput = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type ClientConnection = {
  __typename?: 'ClientConnection';
  edges: Array<ClientEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClientEdge = {
  __typename?: 'ClientEdge';
  cursor: Scalars['String']['output'];
  node: ClientType;
};

export type ClientFilterInput = {
  industry?: InputMaybe<Scalars['String']['input']>;
  industryId?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isParentOnly?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<ClientSizeType>;
};

export type ClientResearchEvent = BaseEvent & {
  __typename?: 'ClientResearchEvent';
  clientId: Scalars['String']['output'];
  clientName?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  type: EventType;
};

export enum ClientSizeType {
  Enterprise = 'ENTERPRISE',
  Individual = 'INDIVIDUAL',
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Small = 'SMALL'
}

export type ClientType = {
  __typename?: 'ClientType';
  addressOutside?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  clientType?: Maybe<ClientTypeEnum>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  corporateCloseDate?: Maybe<Scalars['DateTime']['output']>;
  corporateNumber?: Maybe<Scalars['String']['output']>;
  corporateStatus?: Maybe<Scalars['String']['output']>;
  corporateStatusDisplay?: Maybe<Scalars['String']['output']>;
  corporateUpdateDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['UUID']['output'];
  dataQualityScore?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displaySize: Scalars['String']['output'];
  fullAddress?: Maybe<Scalars['String']['output']>;
  hasActiveProjects: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  industry?: Maybe<Industry>;
  industryId?: Maybe<Scalars['UUID']['output']>;
  industryName?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isAutoRegistered: Scalars['Boolean']['output'];
  isEnterprise: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  nameEnglish?: Maybe<Scalars['String']['output']>;
  nameKana?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['UUID']['output'];
  parentId?: Maybe<Scalars['UUID']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  prefecture?: Maybe<Scalars['String']['output']>;
  projectCount: Scalars['Int']['output'];
  size?: Maybe<ClientSizeType>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  totalLifetimeValue?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export enum ClientTypeEnum {
  Corporation = 'CORPORATION',
  Individual = 'INDIVIDUAL',
  Other = 'OTHER',
  PublicOrganization = 'PUBLIC_ORGANIZATION'
}

export type CollectedItemFilterInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  minRelevanceScore?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<CollectedItemStatusEnum>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type CollectedItemGql = {
  __typename?: 'CollectedItemGQL';
  atomId?: Maybe<Scalars['UUID']['output']>;
  categories: Array<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  contextAnalysis: Scalars['JSON']['output'];
  createdAt: Scalars['DateTime']['output'];
  entityId: Scalars['UUID']['output'];
  entityType: AtomSourceEntityTypeEnum;
  id: Scalars['UUID']['output'];
  metadata: Scalars['JSON']['output'];
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  relevanceScore: Scalars['Float']['output'];
  sourceId: Scalars['UUID']['output'];
  sourceUrl: Scalars['String']['output'];
  status: CollectedItemStatusEnum;
  summary?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CollectedItemListGql = {
  __typename?: 'CollectedItemListGQL';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  items: Array<CollectedItemGql>;
  totalCount: Scalars['Int']['output'];
};

export enum CollectedItemStatusEnum {
  Analyzed = 'ANALYZED',
  Collected = 'COLLECTED',
  Failed = 'FAILED',
  Processed = 'PROCESSED',
  Registered = 'REGISTERED',
  Skipped = 'SKIPPED'
}

export enum CollectionFrequencyEnum {
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  Realtime = 'REALTIME',
  Weekly = 'WEEKLY'
}

export type CompanyProfileResearchEvent = BaseEvent & {
  __typename?: 'CompanyProfileResearchEvent';
  companyName?: Maybe<Scalars['String']['output']>;
  companyProfileId: Scalars['String']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  type: EventType;
};

export enum CompanyProfileStatusType {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Incomplete = 'INCOMPLETE'
}

export type CompanyProfileType = {
  __typename?: 'CompanyProfileType';
  achievements?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  addressOutside?: Maybe<Scalars['String']['output']>;
  annualRevenue?: Maybe<Scalars['String']['output']>;
  businessContent?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  competitors?: Maybe<Scalars['String']['output']>;
  completenessPercentage: Scalars['Int']['output'];
  corporateCloseDate?: Maybe<Scalars['DateTime']['output']>;
  corporateNumber?: Maybe<Scalars['String']['output']>;
  corporateStatus?: Maybe<Scalars['String']['output']>;
  corporateStatusDisplay?: Maybe<Scalars['String']['output']>;
  corporateUpdateDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['UUID']['output'];
  dataQualityScore?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displaySize: Scalars['String']['output'];
  displayStatus: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  employeeCount?: Maybe<Scalars['Int']['output']>;
  foundedDate?: Maybe<Scalars['Date']['output']>;
  fullAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  industry?: Maybe<Industry>;
  industryId?: Maybe<Scalars['UUID']['output']>;
  isComplete: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  nameEnglish?: Maybe<Scalars['String']['output']>;
  nameKana?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['UUID']['output'];
  organizationName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  prefecture?: Maybe<Scalars['String']['output']>;
  size?: Maybe<CompanySizeType>;
  status: CompanyProfileStatusType;
  streetAddress?: Maybe<Scalars['String']['output']>;
  strengths?: Maybe<Scalars['String']['output']>;
  targetMarket?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export enum CompanySizeType {
  Enterprise = 'ENTERPRISE',
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Small = 'SMALL'
}

export type ComparisonResult = {
  __typename?: 'ComparisonResult';
  abstractSimilarity?: Maybe<Scalars['JSON']['output']>;
  emotionShift?: Maybe<Scalars['JSON']['output']>;
  factConsistency?: Maybe<Scalars['JSON']['output']>;
  perspectiveAlignment?: Maybe<Scalars['JSON']['output']>;
};

export type CompleteAiAdvisorSessionInput = {
  generateTitle?: Scalars['Boolean']['input'];
  sessionId: Scalars['String']['input'];
};

export type CompleteSessionResultType = {
  __typename?: 'CompleteSessionResultType';
  errorMessage?: Maybe<Scalars['String']['output']>;
  generatedTitle?: Maybe<Scalars['String']['output']>;
  session?: Maybe<AiAdvisorSessionType>;
  success: Scalars['Boolean']['output'];
};

export type ConsolidatedDeliverableEvent = BaseEvent & {
  __typename?: 'ConsolidatedDeliverableEvent';
  data?: Maybe<Scalars['JSON']['output']>;
  deliverableId?: Maybe<Scalars['String']['output']>;
  deliverableName?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  functionsCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  progress?: Maybe<Scalars['Float']['output']>;
  projectAnalysis?: Maybe<Scalars['String']['output']>;
  projectId: Scalars['String']['output'];
  sitemapGenerated?: Maybe<Scalars['Boolean']['output']>;
  sitemapPages?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  type: EventType;
  userId: Scalars['String']['output'];
};

export type ConsolidatedDeliverableSuggestionInput = {
  complexityLevel?: InputMaybe<Scalars['String']['input']>;
  focusAreas?: InputMaybe<Array<Scalars['String']['input']>>;
  maxFunctions?: InputMaybe<Scalars['Int']['input']>;
  technicalPreferences?: InputMaybe<Array<Scalars['String']['input']>>;
  timelineMonths?: InputMaybe<Scalars['Int']['input']>;
};

export type ConsolidatedSitemapGenerationResult = {
  __typename?: 'ConsolidatedSitemapGenerationResult';
  errors: Array<Scalars['String']['output']>;
  functionCategories: Array<Scalars['String']['output']>;
  generationTimeMs: Scalars['Int']['output'];
  sitemapJson?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  totalPages: Scalars['Int']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type ConsolidatedTaskStatus = {
  __typename?: 'ConsolidatedTaskStatus';
  completedAt?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
};

export type ConstitutionCandidate = {
  __typename?: 'ConstitutionCandidate';
  confidence: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  extractedFrom: Scalars['String']['output'];
  factType: ConstitutionFactType;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  reasoning: Scalars['String']['output'];
  source: Scalars['String']['output'];
  value: Scalars['JSON']['output'];
};

export type ConstitutionFact = {
  __typename?: 'ConstitutionFact';
  confidence: Scalars['Float']['output'];
  extractedAt?: Maybe<Scalars['DateTime']['output']>;
  factType: ConstitutionFactType;
  key: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  sourceRef?: Maybe<Scalars['String']['output']>;
  sourceType: ConstitutionFactSource;
  value: Scalars['JSON']['output'];
};

export type ConstitutionFactEntry = {
  __typename?: 'ConstitutionFactEntry';
  fact: ConstitutionFact;
  key: Scalars['String']['output'];
};

export type ConstitutionFactInput = {
  confidence?: Scalars['Float']['input'];
  factType: ConstitutionFactType;
  key: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  sourceRef?: InputMaybe<Scalars['String']['input']>;
  sourceType: ConstitutionFactSource;
  value: Scalars['JSON']['input'];
};

export enum ConstitutionFactSource {
  Chat = 'CHAT',
  ContentProcessing = 'CONTENT_PROCESSING',
  ContextAnalysis = 'CONTEXT_ANALYSIS',
  Document = 'DOCUMENT',
  Email = 'EMAIL',
  ManualInput = 'MANUAL_INPUT',
  Meeting = 'MEETING'
}

export enum ConstitutionFactType {
  Budget = 'BUDGET',
  Constraint = 'CONSTRAINT',
  Decision = 'DECISION',
  Objective = 'OBJECTIVE',
  Other = 'OTHER',
  Requirement = 'REQUIREMENT',
  Risk = 'RISK',
  Scope = 'SCOPE',
  Stakeholder = 'STAKEHOLDER',
  Timeline = 'TIMELINE'
}

export type ConstitutionHistoryEntry = {
  __typename?: 'ConstitutionHistoryEntry';
  changedAt: Scalars['DateTime']['output'];
  changedBy: Scalars['UUID']['output'];
  changes: Array<Scalars['String']['output']>;
  factsSnapshot: Scalars['JSON']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type ConstitutionalLaws = {
  __typename?: 'ConstitutionalLaws';
  needs: Array<Maybe<Scalars['String']['output']>>;
  seeds: Array<Maybe<Scalars['String']['output']>>;
};

export type ContentGenerationFilterInput = {
  contentType?: InputMaybe<UnifiedContentTypeEnum>;
  createdAfter?: InputMaybe<Scalars['String']['input']>;
  createdBefore?: InputMaybe<Scalars['String']['input']>;
  outputFormat?: InputMaybe<UnifiedOutputFormatEnum>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ContentGenerationHistory = {
  __typename?: 'ContentGenerationHistory';
  artifactId?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['String']['output']>;
  contentType: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deliverableId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  outputFormat: Scalars['String']['output'];
  processingTime?: Maybe<Scalars['Float']['output']>;
  projectId: Scalars['String']['output'];
  qualityScore?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
};

export type ContentGenerationHistoryConnection = {
  __typename?: 'ContentGenerationHistoryConnection';
  edges: Array<ContentGenerationHistory>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type ConvertSessionToPrismInput = {
  generateScopes?: Scalars['Boolean']['input'];
  runAnalysis?: Scalars['Boolean']['input'];
  sessionId: Scalars['String']['input'];
};

export type ConvertToPrismResultType = {
  __typename?: 'ConvertToPrismResultType';
  atomCount: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  scopeCount: Scalars['Int']['output'];
  session?: Maybe<AiAdvisorSessionType>;
  success: Scalars['Boolean']['output'];
  viewCount: Scalars['Int']['output'];
};

export type CorporateInfo = {
  __typename?: 'CorporateInfo';
  changeDate?: Maybe<Scalars['DateTime']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  closeDate?: Maybe<Scalars['DateTime']['output']>;
  closeReason?: Maybe<Scalars['String']['output']>;
  corporateNumber: Scalars['String']['output'];
  kind?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nameEn?: Maybe<Scalars['String']['output']>;
  nameKana?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  prefecture?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  updateDate?: Maybe<Scalars['DateTime']['output']>;
};

export type CorporateSearchInput = {
  corporateNumber?: InputMaybe<Scalars['String']['input']>;
  exactMatch?: InputMaybe<Scalars['Boolean']['input']>;
  includeClosed?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  prefecture?: InputMaybe<Scalars['String']['input']>;
};

export type CorporateSearchResult = {
  __typename?: 'CorporateSearchResult';
  error?: Maybe<Scalars['String']['output']>;
  results: Array<CorporateInfo>;
  success: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
};

export type CrawlRequestResult = {
  __typename?: 'CrawlRequestResult';
  catalogId: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
};

export enum CrawlStatusEnum {
  Completed = 'COMPLETED',
  CrawlingDetails = 'CRAWLING_DETAILS',
  CrawlingIndex = 'CRAWLING_INDEX',
  Failed = 'FAILED',
  FeasibilityChecking = 'FEASIBILITY_CHECKING',
  Pending = 'PENDING'
}

export type CreateAiAdvisorSessionInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  meetingStatus: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  projectType: Scalars['String']['input'];
};

export type CreateArtifactDddInput = {
  artifactType: ArtifactTypeEnum;
  autoGenerationEnabled?: Scalars['Boolean']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  format: ArtifactFormatEnum;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  projectId: Scalars['UUID']['input'];
  systemSpecData?: InputMaybe<Scalars['JSON']['input']>;
  title: Scalars['String']['input'];
};

export type CreateAtomFromSourceInput = {
  atomType?: Scalars['String']['input'];
  autoGenerateTags?: Scalars['Boolean']['input'];
  autoVectorize?: Scalars['Boolean']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentFormat?: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['UUID']['input']>;
  filePath?: InputMaybe<Scalars['String']['input']>;
  industryId?: InputMaybe<Scalars['UUID']['input']>;
  inputType: AtomInputType;
  isProposal?: Scalars['Boolean']['input'];
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  scrapingConfig?: InputMaybe<Scalars['JSON']['input']>;
  sourceId?: InputMaybe<Scalars['UUID']['input']>;
  sourceType?: Scalars['String']['input'];
  tags?: Array<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAtomInput = {
  atomType?: AtomTypeType;
  category?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  contentFormat?: Scalars['String']['input'];
  filePath?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  fileType?: InputMaybe<Scalars['String']['input']>;
  fullContent?: InputMaybe<Scalars['String']['input']>;
  industryId?: InputMaybe<Scalars['UUID']['input']>;
  isProposal?: Scalars['Boolean']['input'];
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<AtomStatusType>;
  tags?: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateAtomSourceInput = {
  collectionFrequency?: CollectionFrequencyEnum;
  contentFilters?: InputMaybe<Scalars['JSON']['input']>;
  entityId: Scalars['UUID']['input'];
  entityType: AtomSourceEntityTypeEnum;
  languageCode?: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  sourceConfig?: InputMaybe<Scalars['JSON']['input']>;
  sourceName: Scalars['String']['input'];
  sourceType: SourceTypeEnum;
  sourceUrl: Scalars['String']['input'];
};

export type CreateClientInput = {
  clientType?: InputMaybe<ClientTypeEnum>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  industryId?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  parentId?: InputMaybe<Scalars['UUID']['input']>;
  size?: InputMaybe<ClientSizeType>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCompanyProfileInput = {
  achievements?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  annualRevenue?: InputMaybe<Scalars['String']['input']>;
  businessContent?: InputMaybe<Scalars['String']['input']>;
  competitors?: InputMaybe<Scalars['String']['input']>;
  corporateNumber?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employeeCount?: InputMaybe<Scalars['Int']['input']>;
  foundedDate?: InputMaybe<Scalars['Date']['input']>;
  industryId?: InputMaybe<Scalars['UUID']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<CompanySizeType>;
  strengths?: InputMaybe<Scalars['String']['input']>;
  targetMarket?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGithubRepoForSystemInstanceInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  private?: Scalars['Boolean']['input'];
  repoName: Scalars['String']['input'];
  systemInstanceId: Scalars['UUID']['input'];
};

export type CreateGithubRepoResult = {
  __typename?: 'CreateGithubRepoResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  githubRepoName?: Maybe<Scalars['String']['output']>;
  repoUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateIndustryInput = {
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  industryProfile?: InputMaybe<Scalars['JSON']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
};

export type CreateOrganizationInput = {
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  billingContact?: InputMaybe<Scalars['String']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  planType?: PlanType;
  requireEmailVerification?: Scalars['Boolean']['input'];
  taxId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProjectDeliverableInput = {
  adminPages?: InputMaybe<Array<AdminPageInput>>;
  boundedContexts: Array<BoundedContextInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabledScenes?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['String']['input']>;
  publicPages?: InputMaybe<Array<PublicPageInput>>;
};

export type CreateProjectInput = {
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  developmentType?: InputMaybe<DevelopmentTypeEnum>;
  name: Scalars['String']['input'];
  newInstanceGithubRepoName?: InputMaybe<Scalars['String']['input']>;
  newInstanceIsMain?: InputMaybe<Scalars['Boolean']['input']>;
  newInstanceName?: InputMaybe<Scalars['String']['input']>;
  newInstanceOutputPath?: InputMaybe<Scalars['String']['input']>;
  newInstanceSlug?: InputMaybe<Scalars['String']['input']>;
  newInstanceVpsHost?: InputMaybe<Scalars['String']['input']>;
  newInstanceVpsUser?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['UUID']['input'];
  priority?: InputMaybe<ProjectPriorityType>;
  projectKind?: InputMaybe<Scalars['String']['input']>;
  projectMetadata?: InputMaybe<Scalars['JSON']['input']>;
  projectPhase?: InputMaybe<ProjectPhaseType>;
  projectType?: InputMaybe<ProjectTypeEnum>;
  promptCore?: InputMaybe<Scalars['String']['input']>;
  promptElements?: InputMaybe<Scalars['JSON']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  systemInstanceId?: InputMaybe<Scalars['UUID']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateSessionResultType = {
  __typename?: 'CreateSessionResultType';
  errorMessage?: Maybe<Scalars['String']['output']>;
  initialMessage?: Maybe<AiAdvisorMessageType>;
  session?: Maybe<AiAdvisorSessionType>;
  success: Scalars['Boolean']['output'];
};

export type CreateSystemInstanceInput = {
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  gitDefaultBranch?: Scalars['String']['input'];
  githubRepoName?: InputMaybe<Scalars['String']['input']>;
  isMain?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  outputPath: Scalars['String']['input'];
  portOffset?: Scalars['Int']['input'];
  slug: Scalars['String']['input'];
  vpsDeploymentConfig?: InputMaybe<Scalars['JSON']['input']>;
  vpsHost?: InputMaybe<Scalars['String']['input']>;
  vpsUser?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUiProjectInput = {
  description?: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sitemap?: Scalars['String']['input'];
};

export type CreateUserInput = {
  authProvider?: AuthProviderType;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  locale?: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  providerUserId?: InputMaybe<Scalars['String']['input']>;
  timezone?: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type DeployStatusResult = {
  __typename?: 'DeployStatusResult';
  attempted: Scalars['Boolean']['output'];
  conclusion?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  found: Scalars['Boolean']['output'];
  headSha?: Maybe<Scalars['String']['output']>;
  htmlUrl?: Maybe<Scalars['String']['output']>;
  markedRunning: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  runId?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export enum DeployTargetType {
  HostLocalhost = 'HOST_LOCALHOST',
  Vps = 'VPS'
}

export type DeploymentConfigType = {
  __typename?: 'DeploymentConfigType';
  domain?: Maybe<Scalars['String']['output']>;
  githubOwner?: Maybe<Scalars['String']['output']>;
  githubRepoName?: Maybe<Scalars['String']['output']>;
  githubTokenSet: Scalars['Boolean']['output'];
  providerType: Scalars['String']['output'];
  vpsAuthMethod: Scalars['String']['output'];
  vpsHost?: Maybe<Scalars['String']['output']>;
  vpsPasswordSet: Scalars['Boolean']['output'];
  vpsPort: Scalars['Int']['output'];
  vpsSshKeySet: Scalars['Boolean']['output'];
  vpsUsername?: Maybe<Scalars['String']['output']>;
};

export type DeploymentListType = {
  __typename?: 'DeploymentListType';
  deployments: Array<DeploymentType>;
  totalCount: Scalars['Int']['output'];
};

export enum DeploymentStatusType {
  Archived = 'ARCHIVED',
  Generated = 'GENERATED',
  NotGenerated = 'NOT_GENERATED',
  Pushed = 'PUSHED',
  Running = 'RUNNING'
}

export type DeploymentType = {
  __typename?: 'DeploymentType';
  artifactId: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy: Scalars['String']['output'];
  currentStage?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  githubRepoUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  liveUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pipelineProgress?: Maybe<Scalars['JSON']['output']>;
  progressPercentage: Scalars['Float']['output'];
  projectId: Scalars['String']['output'];
  providerType: Scalars['String']['output'];
  retryCount: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
};

export type DesignInsight = {
  __typename?: 'DesignInsight';
  evidenceFromText: Array<Scalars['String']['output']>;
  expectedImpact: Scalars['String']['output'];
  implementationNotes: Scalars['String']['output'];
  perspective: Scalars['String']['output'];
  priority: Scalars['String']['output'];
  rationale: Scalars['String']['output'];
  requirements: Array<Scalars['JSON']['output']>;
};

export type DesignProposalType = {
  __typename?: 'DesignProposalType';
  conceptDescription?: Maybe<Scalars['String']['output']>;
  conceptName: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  designGuidelines?: Maybe<Scalars['JSON']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isSelected: Scalars['Boolean']['output'];
  projectId: Scalars['ID']['output'];
  referenceUrls?: Maybe<Array<Scalars['String']['output']>>;
  status: Scalars['String']['output'];
};

export enum DetailLevelEnum {
  Full = 'FULL',
  Minimal = 'MINIMAL',
  Summary = 'SUMMARY'
}

export enum DevelopmentTypeEnum {
  Integration = 'INTEGRATION',
  Maintenance = 'MAINTENANCE',
  Migration = 'MIGRATION',
  NewDevelopment = 'NEW_DEVELOPMENT'
}

export type DeviceCodeInput = {
  clientId: Scalars['String']['input'];
  scope?: InputMaybe<Scalars['String']['input']>;
};

export type DeviceCodeResponse = {
  __typename?: 'DeviceCodeResponse';
  deviceCode: Scalars['String']['output'];
  expiresIn: Scalars['Int']['output'];
  interval: Scalars['Int']['output'];
  userCode: Scalars['String']['output'];
  verificationUri: Scalars['String']['output'];
  verificationUriComplete: Scalars['String']['output'];
};

export type DynamicEntitySummaryType = {
  __typename?: 'DynamicEntitySummaryType';
  fieldCount: Scalars['Int']['output'];
  keyFields: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nameJa: Scalars['String']['output'];
};

export type EditedPageInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  pageType: Scalars['String']['input'];
  sectionId: Scalars['String']['input'];
  sectionTitle: Scalars['String']['input'];
  subsectionTitle?: InputMaybe<Scalars['String']['input']>;
  targetLength?: InputMaybe<Scalars['Int']['input']>;
  templateName?: InputMaybe<Scalars['String']['input']>;
};

export type EditedSectionInput = {
  customPrompt?: InputMaybe<Scalars['String']['input']>;
  pages?: Array<EditedPageInput>;
  required?: Scalars['Boolean']['input'];
  sectionId: Scalars['String']['input'];
  sectionTitle: Scalars['String']['input'];
};

export type EmailVerificationResponse = {
  __typename?: 'EmailVerificationResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type EmotionFluctuationItem = {
  __typename?: 'EmotionFluctuationItem';
  contextCoherence: Scalars['Float']['output'];
  intensityVariance: Scalars['Float']['output'];
  surfaceEmotion: Scalars['String']['output'];
  temporalPattern: Scalars['String']['output'];
  underlyingPatterns: Array<Scalars['JSON']['output']>;
};

export type EmotionItem = {
  __typename?: 'EmotionItem';
  confidence: Scalars['Float']['output'];
  content: Scalars['String']['output'];
  culturalWeight: Scalars['Float']['output'];
  designOpportunity?: Maybe<Scalars['String']['output']>;
  emotionType: Scalars['String']['output'];
  empathy: Scalars['Float']['output'];
  extractedIntent?: Maybe<Scalars['String']['output']>;
  intensity: Scalars['Float']['output'];
  motivation: Scalars['Float']['output'];
  motivationFactor?: Maybe<Scalars['String']['output']>;
  polarity: Scalars['String']['output'];
  stressIndicator?: Maybe<Scalars['String']['output']>;
  subjectivity: Scalars['Float']['output'];
};

export type EmotionResult = {
  __typename?: 'EmotionResult';
  count: Scalars['Int']['output'];
  emotionalTrends?: Maybe<Array<Scalars['String']['output']>>;
  fluctuations?: Maybe<Array<EmotionFluctuationItem>>;
  items: Array<EmotionItem>;
  overallSentiment?: Maybe<Scalars['JSON']['output']>;
  teamMorale?: Maybe<Scalars['Float']['output']>;
};

export type EndpointVerdictType = {
  __typename?: 'EndpointVerdictType';
  exists: Scalars['Boolean']['output'];
  method: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type EnhancedProposalGenerationInput = {
  config?: InputMaybe<ProposalConfigInput>;
  projectId: Scalars['UUID']['input'];
};

export enum EventType {
  AiAnalysisCompleted = 'AI_ANALYSIS_COMPLETED',
  AiAnalysisFailed = 'AI_ANALYSIS_FAILED',
  AiAnalysisProgress = 'AI_ANALYSIS_PROGRESS',
  AiAnalysisStarted = 'AI_ANALYSIS_STARTED',
  AiMessage = 'AI_MESSAGE',
  ApiCrawlCompleted = 'API_CRAWL_COMPLETED',
  ApiCrawlFailed = 'API_CRAWL_FAILED',
  ApiCrawlProgress = 'API_CRAWL_PROGRESS',
  ApiCrawlStarted = 'API_CRAWL_STARTED',
  AtomCompleted = 'ATOM_COMPLETED',
  AtomCreated = 'ATOM_CREATED',
  AtomDeleted = 'ATOM_DELETED',
  AtomFailed = 'ATOM_FAILED',
  AtomProcessing = 'ATOM_PROCESSING',
  AtomUpdated = 'ATOM_UPDATED',
  ClientResearchCompleted = 'CLIENT_RESEARCH_COMPLETED',
  ClientResearchFailed = 'CLIENT_RESEARCH_FAILED',
  ClientResearchProgress = 'CLIENT_RESEARCH_PROGRESS',
  ClientResearchStarted = 'CLIENT_RESEARCH_STARTED',
  CompanyProfileResearchCompleted = 'COMPANY_PROFILE_RESEARCH_COMPLETED',
  CompanyProfileResearchFailed = 'COMPANY_PROFILE_RESEARCH_FAILED',
  CompanyProfileResearchProgress = 'COMPANY_PROFILE_RESEARCH_PROGRESS',
  CompanyProfileResearchStarted = 'COMPANY_PROFILE_RESEARCH_STARTED',
  ConsolidatedDeliverableCompleted = 'CONSOLIDATED_DELIVERABLE_COMPLETED',
  ConsolidatedDeliverableFailed = 'CONSOLIDATED_DELIVERABLE_FAILED',
  ConsolidatedDeliverableProgress = 'CONSOLIDATED_DELIVERABLE_PROGRESS',
  ConsolidatedDeliverableStarted = 'CONSOLIDATED_DELIVERABLE_STARTED',
  ConsolidatedSitemapCompleted = 'CONSOLIDATED_SITEMAP_COMPLETED',
  ConsolidatedSitemapFailed = 'CONSOLIDATED_SITEMAP_FAILED',
  ConsolidatedSitemapStarted = 'CONSOLIDATED_SITEMAP_STARTED',
  IndustryResearchCompleted = 'INDUSTRY_RESEARCH_COMPLETED',
  IndustryResearchFailed = 'INDUSTRY_RESEARCH_FAILED',
  IndustryResearchProgress = 'INDUSTRY_RESEARCH_PROGRESS',
  IndustryResearchStarted = 'INDUSTRY_RESEARCH_STARTED',
  NotificationCreated = 'NOTIFICATION_CREATED',
  NotificationDeleted = 'NOTIFICATION_DELETED',
  NotificationRead = 'NOTIFICATION_READ',
  PrismOrientCompleted = 'PRISM_ORIENT_COMPLETED',
  PrismOrientFailed = 'PRISM_ORIENT_FAILED',
  PrismOrientStarted = 'PRISM_ORIENT_STARTED',
  PrismScopeCompleted = 'PRISM_SCOPE_COMPLETED',
  PrismScopeFailed = 'PRISM_SCOPE_FAILED',
  PrismScopeStarted = 'PRISM_SCOPE_STARTED',
  ProjectCreated = 'PROJECT_CREATED',
  ProjectDeleted = 'PROJECT_DELETED',
  ProjectPriorityChanged = 'PROJECT_PRIORITY_CHANGED',
  ProjectStatusChanged = 'PROJECT_STATUS_CHANGED',
  ProjectUpdated = 'PROJECT_UPDATED',
  PromptEvolutionCompleted = 'PROMPT_EVOLUTION_COMPLETED',
  PromptEvolutionFailed = 'PROMPT_EVOLUTION_FAILED',
  PromptEvolutionProgress = 'PROMPT_EVOLUTION_PROGRESS',
  PromptEvolutionStarted = 'PROMPT_EVOLUTION_STARTED',
  SystemHealth = 'SYSTEM_HEALTH',
  SystemMaintenance = 'SYSTEM_MAINTENANCE',
  SystemMetric = 'SYSTEM_METRIC',
  SystemStatus = 'SYSTEM_STATUS',
  TaskCompleted = 'TASK_COMPLETED',
  TaskCreated = 'TASK_CREATED',
  TaskFailed = 'TASK_FAILED',
  TaskProgress = 'TASK_PROGRESS',
  TaskUpdated = 'TASK_UPDATED',
  UnifiedContentCompleted = 'UNIFIED_CONTENT_COMPLETED',
  UnifiedContentFailed = 'UNIFIED_CONTENT_FAILED',
  UnifiedContentProgress = 'UNIFIED_CONTENT_PROGRESS',
  UnifiedContentStarted = 'UNIFIED_CONTENT_STARTED',
  UserActivity = 'USER_ACTIVITY',
  UserOffline = 'USER_OFFLINE',
  UserOnline = 'USER_ONLINE',
  UserTyping = 'USER_TYPING'
}

export type ExtractedFeatureType = {
  __typename?: 'ExtractedFeatureType';
  category: Scalars['String']['output'];
  description: Scalars['String']['output'];
  likelyBcMatch?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  priority: Scalars['String']['output'];
};

export type FactItem = {
  __typename?: 'FactItem';
  confidence: Scalars['Float']['output'];
  content: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  type: Scalars['String']['output'];
};

export type FactLayerResult = {
  __typename?: 'FactLayerResult';
  count: Scalars['Int']['output'];
  items: Array<FactItem>;
};

export type FlowStepInput = {
  action: Scalars['String']['input'];
  actor?: Scalars['String']['input'];
  bc?: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  pagePath?: InputMaybe<Scalars['String']['input']>;
  stepType?: Scalars['String']['input'];
};

export type FlowStepType = {
  __typename?: 'FlowStepType';
  action: Scalars['String']['output'];
  actor: Scalars['String']['output'];
  bc: Scalars['String']['output'];
  condition?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<Scalars['String']['output']>;
  isPublic: Scalars['Boolean']['output'];
  mutation?: Maybe<Scalars['String']['output']>;
  noStep?: Maybe<Scalars['Int']['output']>;
  notificationChannel?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  pagePath?: Maybe<Scalars['String']['output']>;
  query?: Maybe<Scalars['String']['output']>;
  requiresAuth: Scalars['Boolean']['output'];
  stepType: Scalars['String']['output'];
  triggerAction?: Maybe<Scalars['String']['output']>;
  triggerEvent?: Maybe<Scalars['String']['output']>;
  yesStep?: Maybe<Scalars['Int']['output']>;
};

export type FunctionCandidateType = {
  __typename?: 'FunctionCandidateType';
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  priority?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export type GenerateConsolidatedSitemapInput = {
  categorizationMode?: InputMaybe<Scalars['String']['input']>;
  depthLevel?: InputMaybe<Scalars['Int']['input']>;
};

export type GenerateStubArtifactResult = {
  __typename?: 'GenerateStubArtifactResult';
  artifactId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  fileCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type GeneratedSystemRecord = {
  __typename?: 'GeneratedSystemRecord';
  adminEmail: Scalars['String']['output'];
  adminPassword: Scalars['String']['output'];
  adminUrl: Scalars['String']['output'];
  backendUrl: Scalars['String']['output'];
  bcNames: Array<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  dynamicBcNames: Array<Scalars['String']['output']>;
  frontendUrl: Scalars['String']['output'];
  generationTimeSeconds: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  outputDir: Scalars['String']['output'];
  projectId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  sysadminUrl: Scalars['String']['output'];
  systemAdminEmail: Scalars['String']['output'];
  systemAdminPassword: Scalars['String']['output'];
  systemName: Scalars['String']['output'];
  systemNameJa: Scalars['String']['output'];
  totalFiles: Scalars['Int']['output'];
};

export type GenerationFile = {
  __typename?: 'GenerationFile';
  content?: Maybe<Scalars['String']['output']>;
  lines: Scalars['Int']['output'];
  path: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type GithubSecretSyncEntry = {
  __typename?: 'GithubSecretSyncEntry';
  error?: Maybe<Scalars['String']['output']>;
  secretName: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type GithubSecretSyncResult = {
  __typename?: 'GithubSecretSyncResult';
  allSuccess: Scalars['Boolean']['output'];
  attempted: Scalars['Boolean']['output'];
  entries: Array<GithubSecretSyncEntry>;
  reason?: Maybe<Scalars['String']['output']>;
  setCount: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
};

export enum GrantType {
  ClientCredentials = 'CLIENT_CREDENTIALS',
  Password = 'PASSWORD',
  RefreshToken = 'REFRESH_TOKEN'
}

export type GroundedEntityType = {
  __typename?: 'GroundedEntityType';
  atomCount: Scalars['Int']['output'];
  canonicalName?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  industryRelevance?: Maybe<Scalars['String']['output']>;
  integrationProtocols: Array<Scalars['String']['output']>;
  keyFeatures: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  officialUrl?: Maybe<Scalars['String']['output']>;
  providerCompany?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['String']['output']>;
  technologyStack: Array<Scalars['String']['output']>;
};

export type HardDeleteProjectResult = {
  __typename?: 'HardDeleteProjectResult';
  cascadeSummary: Scalars['String']['output'];
  projectId: Scalars['UUID']['output'];
  success: Scalars['Boolean']['output'];
};

export type HealthCheck = {
  __typename?: 'HealthCheck';
  status: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  version: Scalars['String']['output'];
};

export type IdealItem = {
  __typename?: 'IdealItem';
  achievability: Scalars['Float']['output'];
  confidence: Scalars['Float']['output'];
  content: Scalars['String']['output'];
  currentGap?: Maybe<Scalars['String']['output']>;
  emotionalDrivers?: Maybe<Array<Scalars['String']['output']>>;
  requiredElements?: Maybe<Array<Scalars['String']['output']>>;
  timeframe: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type IdealLayerResult = {
  __typename?: 'IdealLayerResult';
  count: Scalars['Int']['output'];
  items: Array<IdealItem>;
};

export type Industry = {
  __typename?: 'Industry';
  categories: Array<IndustryCategory>;
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hasProfileData: Scalars['Boolean']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  industryProfile: Scalars['JSON']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type IndustryCategory = {
  __typename?: 'IndustryCategory';
  code: Scalars['String']['output'];
  displayOrder: Scalars['Int']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['UUID']['output']>;
  subcategories: Array<IndustryCategory>;
};

export type IndustryCategoryCreateInput = {
  code: Scalars['String']['input'];
  displayOrder?: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['UUID']['input']>;
};

export type IndustryCategoryUpdateInput = {
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type IndustryConnection = {
  __typename?: 'IndustryConnection';
  edges: Array<IndustryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type IndustryEdge = {
  __typename?: 'IndustryEdge';
  cursor: Scalars['String']['output'];
  node: IndustryType;
};

export type IndustryFilterInput = {
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type IndustryMutationResponse = {
  __typename?: 'IndustryMutationResponse';
  industry?: Maybe<Industry>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type IndustryResearchEvent = BaseEvent & {
  __typename?: 'IndustryResearchEvent';
  data?: Maybe<Scalars['JSON']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  industryId: Scalars['String']['output'];
  industryName?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  type: EventType;
};

export type IndustryStatsType = {
  __typename?: 'IndustryStatsType';
  activeIndustries: Scalars['Int']['output'];
  inactiveIndustries: Scalars['Int']['output'];
  totalIndustries: Scalars['Int']['output'];
};

export type IndustryType = {
  __typename?: 'IndustryType';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  industryProfile: Scalars['JSON']['output'];
  isActive: Scalars['Boolean']['output'];
  metadata: Scalars['JSON']['output'];
  name: Scalars['String']['output'];
  organizationUuid?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type IntegrateProjectResultType = {
  __typename?: 'IntegrateProjectResultType';
  bcsAdded: Array<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  newBcSet: Array<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['UUID']['output']>;
  regenNeeded: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
  systemInstanceId?: Maybe<Scalars['UUID']['output']>;
};

export type IntegrationPreviewType = {
  __typename?: 'IntegrationPreviewType';
  actuallyAdded: Array<Scalars['String']['output']>;
  alreadyInSet: Array<Scalars['String']['output']>;
  bcSummaries: Array<BcSummaryType>;
  currentBcSet: Array<Scalars['String']['output']>;
  projectId: Scalars['UUID']['output'];
  proposedAdditions: Array<Scalars['String']['output']>;
  regenNeeded: Scalars['Boolean']['output'];
  resultingBcSet: Array<Scalars['String']['output']>;
  systemInstanceId: Scalars['UUID']['output'];
};

export type JwtLoginInput = {
  deviceFingerprint?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  deviceType?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  scopes?: InputMaybe<Array<Scalars['String']['input']>>;
  username: Scalars['String']['input'];
};

export type JwtTokenResponse = {
  __typename?: 'JWTTokenResponse';
  accessToken: Scalars['String']['output'];
  expiresIn: Scalars['Int']['output'];
  idToken?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  tokenType: Scalars['String']['output'];
};

export type JudgmentType = {
  __typename?: 'JudgmentType';
  actionable: Scalars['Boolean']['output'];
  aspect: Scalars['String']['output'];
  assessment: Scalars['String']['output'];
  severity: Scalars['Float']['output'];
};

export type LegacySystemGenerationResult = {
  __typename?: 'LegacySystemGenerationResult';
  deploymentUrl?: Maybe<Scalars['String']['output']>;
  files: Array<GenerationFile>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  qualityScore: Scalars['Float']['output'];
  totalLines: Scalars['Int']['output'];
};

export type LocalHostDeployResult = {
  __typename?: 'LocalHostDeployResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  steps: Array<Scalars['String']['output']>;
  subdomainUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  systemInstanceId: Scalars['UUID']['output'];
  teardownCount: Scalars['Int']['output'];
};

export type LoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  csrfToken?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  user?: Maybe<AuthUser>;
};

export type LogoutResponse = {
  __typename?: 'LogoutResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type MappingResultType = {
  __typename?: 'MappingResultType';
  matched: Array<BcMatchType>;
  unmatchedFeatures: Array<ExtractedFeatureType>;
};

export type MetaPerspectiveItem = {
  __typename?: 'MetaPerspectiveItem';
  confidence: Scalars['Float']['output'];
  contextualInsights: Array<Scalars['String']['output']>;
  creativeSolutions: Array<Scalars['String']['output']>;
  deepQuestions: Array<Scalars['String']['output']>;
  fluctuationAnalysis: Scalars['JSON']['output'];
  hiddenNeeds: Array<Scalars['String']['output']>;
  surfaceAnalysis: Scalars['JSON']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activateAtomSource: AtomSourceMutationResponse;
  activateIndustry?: Maybe<IndustryType>;
  activateIndustryDdd?: Maybe<IndustryType>;
  analyzeSitemap: Array<UiPageInfo>;
  applyConstitutionCandidate: ProjectConstitution;
  approveConstitution: ProjectConstitution;
  archiveClient: ClientType;
  archiveSystemInstance: SystemInstanceOperationResult;
  attachPluginToIndustry: IndustryMutationResponse;
  autoRegisterClient: ClientType;
  changeMyPassword: LogoutResponse;
  changeOrganizationStatus: Scalars['Boolean']['output'];
  changePassword: Scalars['Boolean']['output'];
  changeUserStatus: Scalars['Boolean']['output'];
  checkSystemInstanceDeployStatus: DeployStatusResult;
  completeAiAdvisorSession: CompleteSessionResultType;
  completeAtomProcessing: Scalars['Boolean']['output'];
  completeGenerationDdd: ArtifactDdd;
  convertAiAdvisorSessionToPrism: ConvertToPrismResultType;
  convertSitemapToDeliverables: Scalars['JSON']['output'];
  createAiAdvisorSession: CreateSessionResultType;
  createArtifactDdd: ArtifactDdd;
  createAtom: AtomBaseType;
  createAtomFromSource: AtomProcessingResult;
  createAtomSource: AtomSourceMutationResponse;
  createClient: ClientType;
  createCompanyProfile: CompanyProfileType;
  createConsolidatedDeliverableWithAi: Scalars['String']['output'];
  createGithubRepoForSystemInstance: CreateGithubRepoResult;
  createIndustry: IndustryType;
  createIndustryCategory: CategoryMutationResponse;
  createIndustryDdd: IndustryType;
  createObserverPlugin: PluginMutationResponse;
  createOrganization: OrganizationType;
  createProjectDdd: Project;
  createProjectDeliverableFromSuggestions: ProjectDeliverableType;
  createSystemInstance: SystemInstanceOperationResult;
  createUiProject: UiProject;
  createUser: UserType;
  deactivateAtomSource: AtomSourceMutationResponse;
  deactivateIndustry?: Maybe<IndustryType>;
  deactivateIndustryDdd?: Maybe<IndustryType>;
  /** API Catalogをソフトデリート */
  deleteApiCatalog: Scalars['Boolean']['output'];
  deleteArtifactDdd: Scalars['Boolean']['output'];
  deleteAtom: Scalars['Boolean']['output'];
  deleteAtomSource: AtomSourceMutationResponse;
  deleteClient: Scalars['Boolean']['output'];
  deleteCompanyProfile: Scalars['Boolean']['output'];
  /** デプロイメントを削除 */
  deleteDeployment: Scalars['Boolean']['output'];
  /** プロジェクトの全デザイン提案を削除 */
  deleteDesignProposals: Scalars['Boolean']['output'];
  deleteIndustry: Scalars['Boolean']['output'];
  deleteIndustryCategory: CategoryMutationResponse;
  deleteIndustryDdd: Scalars['Boolean']['output'];
  deleteOrganization: Scalars['Boolean']['output'];
  /** プロジェクトの全ページデザインを削除 */
  deletePageDesigns: Scalars['Boolean']['output'];
  deleteProjectDdd: Scalars['Boolean']['output'];
  /** Scopeを削除（紐づくViewも連動削除） */
  deleteScope: Scalars['Boolean']['output'];
  deleteUiProject: Scalars['Boolean']['output'];
  deleteUser: Scalars['Boolean']['output'];
  /** Viewを削除（紐づくScopeも連動削除） */
  deleteView: Scalars['Boolean']['output'];
  deploySystemInstanceLocal: LocalHostDeployResult;
  deploySystemInstanceViaSsh: SshDeployResult;
  downloadArtifactAsPptx: ArtifactDownloadResult;
  executeSitemapIntegrationFlow: Scalars['JSON']['output'];
  failAtomProcessing: Scalars['Boolean']['output'];
  generateCompanyReport: Scalars['String']['output'];
  generateConsolidatedSitemap: ConsolidatedSitemapGenerationResult;
  /** デザイン提案生成を開始（Celeryタスク） */
  generateDesignProposals: Scalars['Boolean']['output'];
  generateEnhancedProposal: ArtifactDdd;
  /** プロジェクトの一般Scope自動生成（Atom不要・Client/Industry情報のみ） */
  generateGeneralScopes: Array<Scalars['String']['output']>;
  /** プロジェクトのOrient（統合判断）を生成 */
  generateOrient: Scalars['Boolean']['output'];
  /** サイトマップ全ページのデザインHTML生成を開始（Celeryタスク） */
  generatePageDesigns: Scalars['Boolean']['output'];
  /** プロジェクトコンテキストからシステムを生成 */
  generateProjectFromContext: NlProjectGenerationResult;
  /** 自然言語からシステムを生成 */
  generateProjectFromDescription: NlProjectGenerationResult;
  /** デプロイ用スタブArtifact生成（マルチコンテナ構成） */
  generateStubArtifact: GenerateStubArtifactResult;
  generateSystemInstance: SystemGenerationResultGraphql;
  generateUnifiedContent: UnifiedContentGenerationResult;
  hardDeleteProjectDdd: HardDeleteProjectResult;
  hardDeleteUser: Scalars['Boolean']['output'];
  integrateProjectIntoSystemInstance: IntegrateProjectResultType;
  login: LoginResponse;
  loginJwt: JwtTokenResponse;
  logout: LogoutResponse;
  markAtomVectorized: Scalars['Boolean']['output'];
  markSystemInstanceGenerated: SystemInstanceOperationResult;
  markSystemInstancePushed: SystemInstanceOperationResult;
  markSystemInstanceRunning: SystemInstanceOperationResult;
  ping: Scalars['String']['output'];
  /** 既存デプロイメントの設定で再デプロイ */
  redeployDeployment: StartDeploymentResult;
  /** AIチャットでScopeをリファイン（削除/更新/追加） */
  refineScopesWithAi: ScopeRefinementResult;
  refreshToken: JwtTokenResponse;
  /** 生成 snapshot の BC 構成で SI を再生成 (= 2026-06-09 一本化) */
  regenerateFromSnapshot: RegenerateFromSnapshotResult;
  regenerateSitemapForExistingDeliverable: ConsolidatedSitemapGenerationResult;
  /** Grounded Entityをプロジェクトの全Atomから削除 */
  removeGroundedEntity: Scalars['Boolean']['output'];
  /** APIクロールをリクエスト（Celeryタスク起動） */
  requestApiCrawl: CrawlRequestResult;
  requestDeviceCode: DeviceCodeResponse;
  requestPasswordReset: PasswordResetResponse;
  requestToken: JwtTokenResponse;
  researchCompany: Scalars['Boolean']['output'];
  researchCompanyProfile: Scalars['Boolean']['output'];
  researchIndustry: Scalars['Boolean']['output'];
  resetPasswordWithToken: PasswordResetResponse;
  restoreProjectDdd: Scalars['Boolean']['output'];
  restoreUser?: Maybe<UserType>;
  /** APIクロールをリトライ */
  retryApiCrawl: CrawlRequestResult;
  retryAtomProcessing: Scalars['Boolean']['output'];
  /** デプロイメントをリトライ */
  retryDeployment: StartDeploymentResult;
  retryFailedAtom: AtomProcessingResult;
  retryGenerationDdd: ArtifactDdd;
  revokeToken: TokenRevocationResponse;
  runAiAdvisorAnalysis: RunAnalysisResultType;
  runContextAnalysis: TextAnalysisResult;
  /** プロジェクトのデプロイメント設定を保存 */
  saveDeploymentConfig: DeploymentConfigType;
  /** デザイン提案を選択 */
  selectDesignProposal: Scalars['Boolean']['output'];
  sendAiAdvisorMessage: SendMessageResultType;
  sendVerificationEmail: EmailVerificationResponse;
  setAsMainSystemInstance: SystemInstanceOperationResult;
  setSystemInstanceGithubToken: SetGithubTokenResult;
  setSystemInstanceVpsCredentials: SetVpsCredentialsResult;
  startAtomProcessing: Scalars['Boolean']['output'];
  /** デプロイメントを開始（Celeryタスク実行） */
  startDeployment: StartDeploymentResult;
  startGenerationDdd: ArtifactDdd;
  /** デプロイメント接続テスト（SSH） */
  testDeploymentConnection: TestConnectionResult;
  transferOrganizationOwnership: TransferOwnershipResult;
  triggerAtomCollection: AtomSourceMutationResponse;
  unarchiveClient: ClientType;
  unarchiveSystemInstance: SystemInstanceOperationResult;
  updateArtifactDdd: ArtifactDdd;
  updateArtifactTheme: ArtifactDownloadResult;
  updateAtom?: Maybe<AtomBaseType>;
  updateAtomProgress: Scalars['Boolean']['output'];
  updateAtomSource: AtomSourceMutationResponse;
  updateClient: ClientType;
  updateClientContact: ClientType;
  updateCompanyProfile: CompanyProfileType;
  updateConstitutionalFacts: ProjectConstitution;
  updateIndustry?: Maybe<IndustryType>;
  updateIndustryCategory: CategoryMutationResponse;
  updateIndustryDdd?: Maybe<IndustryType>;
  /** ロックフィールドを更新 */
  updateLockedFields: Scalars['Boolean']['output'];
  updateOrganization: OrganizationType;
  /** プロジェクトコンテキストを手動編集 */
  updateProjectContext: Scalars['Boolean']['output'];
  updateProjectDdd: Project;
  updateProjectDeliverable: ProjectDeliverableType;
  updateProjectSitemap: UpdateSitemapResponse;
  /** Scopeのフィールドを更新 */
  updateScope?: Maybe<ScopeType>;
  updateSystemInstance: SystemInstanceOperationResult;
  updateUiProject?: Maybe<UiProject>;
  updateUser: UserType;
  upgradeOrganizationPlan: OrganizationType;
  verifyEmail: Scalars['Boolean']['output'];
  verifyEmailWithToken: EmailVerificationResponse;
  verifyOrganization: Scalars['Boolean']['output'];
};


export type MutationActivateAtomSourceArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationActivateIndustryArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationActivateIndustryDddArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationAnalyzeSitemapArgs = {
  sitemapJson: Scalars['String']['input'];
};


export type MutationApplyConstitutionCandidateArgs = {
  input: ApplyConstitutionCandidateInput;
};


export type MutationApproveConstitutionArgs = {
  input: ApproveConstitutionInput;
};


export type MutationArchiveClientArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationArchiveSystemInstanceArgs = {
  id: Scalars['UUID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAttachPluginToIndustryArgs = {
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  industryId: Scalars['UUID']['input'];
  pluginId: Scalars['UUID']['input'];
  priority?: Scalars['Int']['input'];
};


export type MutationAutoRegisterClientArgs = {
  input: AutoRegisterClientInput;
};


export type MutationChangeMyPasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationChangeOrganizationStatusArgs = {
  id: Scalars['UUID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};


export type MutationChangeUserStatusArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  status: UserStatusType;
  userId: Scalars['UUID']['input'];
};


export type MutationCheckSystemInstanceDeployStatusArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationCompleteAiAdvisorSessionArgs = {
  input: CompleteAiAdvisorSessionInput;
};


export type MutationCompleteAtomProcessingArgs = {
  atomId: Scalars['UUID']['input'];
  extractedContent?: InputMaybe<Scalars['String']['input']>;
  extractedTags?: InputMaybe<Array<Scalars['String']['input']>>;
  processingTimeMs?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCompleteGenerationDddArgs = {
  artifactId: Scalars['UUID']['input'];
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  success: Scalars['Boolean']['input'];
};


export type MutationConvertAiAdvisorSessionToPrismArgs = {
  input: ConvertSessionToPrismInput;
};


export type MutationConvertSitemapToDeliverablesArgs = {
  projectId: Scalars['UUID']['input'];
  requirements?: InputMaybe<Scalars['JSON']['input']>;
  sitemapData: Scalars['JSON']['input'];
  uiCompletionData?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationCreateAiAdvisorSessionArgs = {
  input: CreateAiAdvisorSessionInput;
};


export type MutationCreateArtifactDddArgs = {
  input: CreateArtifactDddInput;
};


export type MutationCreateAtomArgs = {
  input: CreateAtomInput;
};


export type MutationCreateAtomFromSourceArgs = {
  input: CreateAtomFromSourceInput;
};


export type MutationCreateAtomSourceArgs = {
  input: CreateAtomSourceInput;
};


export type MutationCreateClientArgs = {
  input: CreateClientInput;
};


export type MutationCreateCompanyProfileArgs = {
  input: CreateCompanyProfileInput;
};


export type MutationCreateConsolidatedDeliverableWithAiArgs = {
  input: ConsolidatedDeliverableSuggestionInput;
  projectId: Scalars['String']['input'];
};


export type MutationCreateGithubRepoForSystemInstanceArgs = {
  input: CreateGithubRepoForSystemInstanceInput;
};


export type MutationCreateIndustryArgs = {
  input: CreateIndustryInput;
};


export type MutationCreateIndustryCategoryArgs = {
  input: IndustryCategoryCreateInput;
};


export type MutationCreateIndustryDddArgs = {
  input: CreateIndustryInput;
};


export type MutationCreateObserverPluginArgs = {
  input: PluginCreateInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreateProjectDddArgs = {
  input: CreateProjectInput;
};


export type MutationCreateProjectDeliverableFromSuggestionsArgs = {
  input: CreateProjectDeliverableInput;
  projectId: Scalars['String']['input'];
};


export type MutationCreateSystemInstanceArgs = {
  input: CreateSystemInstanceInput;
};


export type MutationCreateUiProjectArgs = {
  input: CreateUiProjectInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationDeactivateAtomSourceArgs = {
  id: Scalars['UUID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeactivateIndustryArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeactivateIndustryDddArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteApiCatalogArgs = {
  catalogId: Scalars['UUID']['input'];
};


export type MutationDeleteArtifactDddArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteAtomArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteAtomSourceArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteClientArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteCompanyProfileArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteDeploymentArgs = {
  deploymentId: Scalars['String']['input'];
};


export type MutationDeleteDesignProposalsArgs = {
  projectId: Scalars['ID']['input'];
};


export type MutationDeleteIndustryArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteIndustryCategoryArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteIndustryDddArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteOrganizationArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeletePageDesignsArgs = {
  projectId: Scalars['ID']['input'];
};


export type MutationDeleteProjectDddArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteScopeArgs = {
  scopeId: Scalars['UUID']['input'];
};


export type MutationDeleteUiProjectArgs = {
  projectId: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteViewArgs = {
  viewId: Scalars['UUID']['input'];
};


export type MutationDeploySystemInstanceLocalArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeploySystemInstanceViaSshArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDownloadArtifactAsPptxArgs = {
  artifactId: Scalars['String']['input'];
  colorScheme?: InputMaybe<Scalars['String']['input']>;
};


export type MutationExecuteSitemapIntegrationFlowArgs = {
  generateSystem?: Scalars['Boolean']['input'];
  projectId: Scalars['UUID']['input'];
  requirements?: InputMaybe<Scalars['JSON']['input']>;
  selectedDeliverableId?: InputMaybe<Scalars['String']['input']>;
  sitemapData: Scalars['JSON']['input'];
  uiCompletionData?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationFailAtomProcessingArgs = {
  atomId: Scalars['UUID']['input'];
  errorCode?: InputMaybe<Scalars['String']['input']>;
  errorMessage: Scalars['String']['input'];
};


export type MutationGenerateCompanyReportArgs = {
  clientId: Scalars['UUID']['input'];
};


export type MutationGenerateConsolidatedSitemapArgs = {
  input?: InputMaybe<GenerateConsolidatedSitemapInput>;
  projectId: Scalars['String']['input'];
};


export type MutationGenerateDesignProposalsArgs = {
  projectId: Scalars['ID']['input'];
  referenceUrls?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationGenerateEnhancedProposalArgs = {
  input: EnhancedProposalGenerationInput;
};


export type MutationGenerateGeneralScopesArgs = {
  projectId: Scalars['UUID']['input'];
};


export type MutationGenerateOrientArgs = {
  projectId: Scalars['UUID']['input'];
};


export type MutationGeneratePageDesignsArgs = {
  projectId: Scalars['ID']['input'];
};


export type MutationGenerateProjectFromContextArgs = {
  input: NlProjectFromContextInput;
};


export type MutationGenerateProjectFromDescriptionArgs = {
  input: NlProjectInput;
};


export type MutationGenerateStubArtifactArgs = {
  projectId: Scalars['String']['input'];
};


export type MutationGenerateSystemInstanceArgs = {
  dryRun?: Scalars['Boolean']['input'];
  force?: Scalars['Boolean']['input'];
  id: Scalars['UUID']['input'];
};


export type MutationGenerateUnifiedContentArgs = {
  input: UnifiedContentGenerationInput;
};


export type MutationHardDeleteProjectDddArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationHardDeleteUserArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationIntegrateProjectIntoSystemInstanceArgs = {
  projectId: Scalars['UUID']['input'];
  systemInstanceId: Scalars['UUID']['input'];
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationLoginJwtArgs = {
  input: JwtLoginInput;
};


export type MutationMarkAtomVectorizedArgs = {
  atomId: Scalars['UUID']['input'];
  embeddingModel: Scalars['String']['input'];
  processingTimeMs?: InputMaybe<Scalars['Int']['input']>;
  vectorDimension: Scalars['Int']['input'];
};


export type MutationMarkSystemInstanceGeneratedArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationMarkSystemInstancePushedArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationMarkSystemInstanceRunningArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRedeployDeploymentArgs = {
  deploymentId: Scalars['String']['input'];
};


export type MutationRefineScopesWithAiArgs = {
  message: Scalars['String']['input'];
  projectId: Scalars['UUID']['input'];
};


export type MutationRefreshTokenArgs = {
  input: RefreshTokenInput;
};


export type MutationRegenerateFromSnapshotArgs = {
  snapshotId: Scalars['ID']['input'];
  systemInstanceId: Scalars['ID']['input'];
};


export type MutationRegenerateSitemapForExistingDeliverableArgs = {
  input?: InputMaybe<GenerateConsolidatedSitemapInput>;
  projectId: Scalars['String']['input'];
};


export type MutationRemoveGroundedEntityArgs = {
  entityName: Scalars['String']['input'];
  projectId: Scalars['UUID']['input'];
};


export type MutationRequestApiCrawlArgs = {
  input: RequestApiCrawlInput;
};


export type MutationRequestDeviceCodeArgs = {
  input: DeviceCodeInput;
};


export type MutationRequestPasswordResetArgs = {
  input: RequestPasswordResetInput;
};


export type MutationRequestTokenArgs = {
  input: TokenRequestInput;
};


export type MutationResearchCompanyArgs = {
  clientId: Scalars['UUID']['input'];
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResearchCompanyProfileArgs = {
  id: Scalars['UUID']['input'];
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResearchIndustryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetPasswordWithTokenArgs = {
  input: ResetPasswordInput;
};


export type MutationRestoreProjectDddArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRestoreUserArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRetryApiCrawlArgs = {
  catalogId: Scalars['UUID']['input'];
  documentationUrls?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationRetryAtomProcessingArgs = {
  atomId: Scalars['UUID']['input'];
};


export type MutationRetryDeploymentArgs = {
  deploymentId: Scalars['String']['input'];
};


export type MutationRetryFailedAtomArgs = {
  atomId: Scalars['UUID']['input'];
};


export type MutationRetryGenerationDddArgs = {
  artifactId: Scalars['UUID']['input'];
};


export type MutationRevokeTokenArgs = {
  input: TokenRevocationInput;
};


export type MutationRunAiAdvisorAnalysisArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationRunContextAnalysisArgs = {
  options?: InputMaybe<AnalysisOptions>;
  projectId: Scalars['UUID']['input'];
};


export type MutationSaveDeploymentConfigArgs = {
  input: SaveDeploymentConfigInput;
};


export type MutationSelectDesignProposalArgs = {
  proposalId: Scalars['ID']['input'];
};


export type MutationSendAiAdvisorMessageArgs = {
  input: SendAiAdvisorMessageInput;
};


export type MutationSendVerificationEmailArgs = {
  input: SendVerificationEmailInput;
};


export type MutationSetAsMainSystemInstanceArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationSetSystemInstanceGithubTokenArgs = {
  input: SetSystemInstanceGithubTokenInput;
};


export type MutationSetSystemInstanceVpsCredentialsArgs = {
  input: SetVpsCredentialsInput;
};


export type MutationStartAtomProcessingArgs = {
  atomId: Scalars['UUID']['input'];
  taskId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationStartDeploymentArgs = {
  input: StartDeploymentInput;
};


export type MutationStartGenerationDddArgs = {
  artifactId: Scalars['UUID']['input'];
  generationParameters?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationTestDeploymentConnectionArgs = {
  projectId: Scalars['String']['input'];
};


export type MutationTransferOrganizationOwnershipArgs = {
  newOwnerId: Scalars['UUID']['input'];
  organizationId: Scalars['UUID']['input'];
};


export type MutationTriggerAtomCollectionArgs = {
  maxItems?: Scalars['Int']['input'];
  sourceId: Scalars['UUID']['input'];
};


export type MutationUnarchiveClientArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationUnarchiveSystemInstanceArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationUpdateArtifactDddArgs = {
  autoGenerationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateArtifactThemeArgs = {
  artifactId: Scalars['String']['input'];
  colorScheme: Scalars['String']['input'];
};


export type MutationUpdateAtomArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateAtomInput;
};


export type MutationUpdateAtomProgressArgs = {
  atomId: Scalars['UUID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  percentage: Scalars['Float']['input'];
};


export type MutationUpdateAtomSourceArgs = {
  input: UpdateAtomSourceInput;
};


export type MutationUpdateClientArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateClientInput;
};


export type MutationUpdateClientContactArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCompanyProfileArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateCompanyProfileInput;
};


export type MutationUpdateConstitutionalFactsArgs = {
  input: UpdateConstitutionalFactsInput;
};


export type MutationUpdateIndustryArgs = {
  input: UpdateIndustryInput;
};


export type MutationUpdateIndustryCategoryArgs = {
  id: Scalars['UUID']['input'];
  input: IndustryCategoryUpdateInput;
};


export type MutationUpdateIndustryDddArgs = {
  input: UpdateIndustryInput;
};


export type MutationUpdateLockedFieldsArgs = {
  lockedFields: Array<Scalars['String']['input']>;
  projectId: Scalars['UUID']['input'];
};


export type MutationUpdateOrganizationArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateOrganizationInput;
};


export type MutationUpdateProjectContextArgs = {
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  estimatedScale?: InputMaybe<Scalars['String']['input']>;
  objectives?: InputMaybe<Array<Scalars['String']['input']>>;
  projectId: Scalars['UUID']['input'];
  purpose?: InputMaybe<Scalars['String']['input']>;
  targetAudience?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateProjectDddArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateProjectInput;
};


export type MutationUpdateProjectDeliverableArgs = {
  input: UpdateProjectDeliverableInput;
  projectId: Scalars['String']['input'];
};


export type MutationUpdateProjectSitemapArgs = {
  projectId: Scalars['UUID']['input'];
  sitemapData: Scalars['JSON']['input'];
};


export type MutationUpdateScopeArgs = {
  input: UpdateScopeInput;
  scopeId: Scalars['UUID']['input'];
};


export type MutationUpdateSystemInstanceArgs = {
  input: UpdateSystemInstanceInput;
};


export type MutationUpdateUiProjectArgs = {
  input: UpdateUiProjectInput;
  projectId: Scalars['String']['input'];
};


export type MutationUpdateUserArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateUserInput;
};


export type MutationUpgradeOrganizationPlanArgs = {
  id: Scalars['UUID']['input'];
  planType: PlanType;
};


export type MutationVerifyEmailArgs = {
  userId: Scalars['UUID']['input'];
};


export type MutationVerifyEmailWithTokenArgs = {
  input: VerifyEmailInput;
};


export type MutationVerifyOrganizationArgs = {
  id: Scalars['UUID']['input'];
};

export type NlProjectFromContextInput = {
  additionalDescription?: Scalars['String']['input'];
  outputDir?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
};

export type NlProjectGenerationResult = {
  __typename?: 'NLProjectGenerationResult';
  bcNames: Array<Scalars['String']['output']>;
  dynamicBcNames: Array<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  features: Array<ExtractedFeatureType>;
  generationTimeSeconds: Scalars['Float']['output'];
  mapping: MappingResultType;
  outputDir: Scalars['String']['output'];
  projectName: Scalars['String']['output'];
  projectNameJa: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  totalFiles: Scalars['Int']['output'];
};

export type NlProjectInput = {
  description: Scalars['String']['input'];
  outputDir?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationEvent = BaseEvent & {
  __typename?: 'NotificationEvent';
  actionLabel?: Maybe<Scalars['String']['output']>;
  actionUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isRead: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  notificationId: Scalars['String']['output'];
  notificationType: Scalars['String']['output'];
  priority: Scalars['String']['output'];
  readAt?: Maybe<Scalars['DateTime']['output']>;
  timestamp: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  type: EventType;
  userId: Scalars['String']['output'];
};

export type NotificationEventTaskEvent = NotificationEvent | TaskEvent;

export type ObserverPlugin = {
  __typename?: 'ObserverPlugin';
  author?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  configuration: Scalars['JSON']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pluginType: Scalars['String']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

export type OrganizationConnection = {
  __typename?: 'OrganizationConnection';
  edges: Array<OrganizationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OrganizationEdge = {
  __typename?: 'OrganizationEdge';
  cursor: Scalars['String']['output'];
  node: OrganizationType;
};

export type OrganizationFilterInput = {
  domain?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  planType?: InputMaybe<PlanType>;
};

export enum OrganizationRoleType {
  Admin = 'ADMIN',
  Member = 'MEMBER',
  Owner = 'OWNER',
  Viewer = 'VIEWER'
}

export type OrganizationType = {
  __typename?: 'OrganizationType';
  activeProjectCount: Scalars['Int']['output'];
  activeUserCount: Scalars['Int']['output'];
  billingAddress?: Maybe<Scalars['String']['output']>;
  billingContact?: Maybe<Scalars['String']['output']>;
  billingEmail?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  isEnterprisePlan: Scalars['Boolean']['output'];
  isFreePlan: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  maxClients: Scalars['Int']['output'];
  maxProjects: Scalars['Int']['output'];
  maxUsers: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  planType: PlanType;
  requireEmailVerification: Scalars['Boolean']['output'];
  sharedKnowledgeEnabled: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  storageLimitGb: Scalars['Int']['output'];
  storageUsageGb: Scalars['Float']['output'];
  taxId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrientType = {
  __typename?: 'OrientType';
  confidence: Scalars['Float']['output'];
  generatedAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  judgments: Array<JudgmentType>;
  modelUsed: Scalars['String']['output'];
  projectContext?: Maybe<ProjectContextType>;
  projectId: Scalars['UUID']['output'];
  recommendations: Array<Scalars['String']['output']>;
  summary: Scalars['String']['output'];
  userLockedFields: Array<Scalars['String']['output']>;
};

export type PageDesignType = {
  __typename?: 'PageDesignType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  pageName: Scalars['String']['output'];
  pagePath: Scalars['String']['output'];
  projectId: Scalars['ID']['output'];
  sectionName?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PasswordResetResponse = {
  __typename?: 'PasswordResetResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type PersonaInput = {
  department?: InputMaybe<Scalars['String']['input']>;
  focusAreas?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
  seniority?: InputMaybe<Scalars['String']['input']>;
};

export type Perspective = {
  __typename?: 'Perspective';
  concerns: Array<Scalars['String']['output']>;
  confidence: Scalars['Float']['output'];
  interests: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  role: Scalars['String']['output'];
  textEvidence: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type PerspectiveItem = {
  __typename?: 'PerspectiveItem';
  alignmentWithOthers: Scalars['JSON']['output'];
  concerns: Array<Scalars['String']['output']>;
  confidence: Scalars['Float']['output'];
  conflicts: Array<Scalars['JSON']['output']>;
  gaps: Array<Scalars['JSON']['output']>;
  hiddenMessages: Array<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  observations: Array<Scalars['String']['output']>;
  priorities: Array<Scalars['String']['output']>;
  recommendations: Array<Scalars['String']['output']>;
  trustIndicators: Scalars['JSON']['output'];
  underlyingConcerns: Array<Scalars['String']['output']>;
  viewpoint: Scalars['String']['output'];
};

export type PerspectiveResult = {
  __typename?: 'PerspectiveResult';
  alignments?: Maybe<Array<Scalars['JSON']['output']>>;
  count: Scalars['Int']['output'];
  gaps?: Maybe<Array<Scalars['JSON']['output']>>;
  items: Array<PerspectiveItem>;
  primaryPerspective?: Maybe<Scalars['String']['output']>;
};

export enum PlanType {
  Enterprise = 'ENTERPRISE',
  Free = 'FREE',
  Professional = 'PROFESSIONAL',
  Starter = 'STARTER'
}

export type PluginCreateInput = {
  code: Scalars['String']['input'];
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pluginType?: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};

export type PluginMutationResponse = {
  __typename?: 'PluginMutationResponse';
  message: Scalars['String']['output'];
  plugin?: Maybe<ObserverPlugin>;
  success: Scalars['Boolean']['output'];
};

export type PrismOrientEvent = BaseEvent & {
  __typename?: 'PrismOrientEvent';
  data?: Maybe<Scalars['JSON']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  orientId?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  projectId: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  type: EventType;
};

export type PrismScopeEvent = BaseEvent & {
  __typename?: 'PrismScopeEvent';
  data?: Maybe<Scalars['JSON']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  projectId: Scalars['String']['output'];
  scopeCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  type: EventType;
};

export type Project = {
  __typename?: 'Project';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  canStart: Scalars['Boolean']['output'];
  clientId?: Maybe<Scalars['UUID']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  constitutionalApprovedAt?: Maybe<Scalars['DateTime']['output']>;
  constitutionalApprovedBy?: Maybe<Scalars['UUID']['output']>;
  constitutionalFacts: Scalars['JSON']['output'];
  constitutionalLaws: ConstitutionalLaws;
  constitutionalVersion: Scalars['Int']['output'];
  contextAnalysis: Scalars['JSON']['output'];
  contextAnalysisUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  developmentType?: Maybe<DevelopmentTypeEnum>;
  gitBranch?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['UUID']['output']>;
  hasApprovedConstitution: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  isCompleted: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isInProgress: Scalars['Boolean']['output'];
  kind?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['UUID']['output'];
  ownerId: Scalars['UUID']['output'];
  prNumber?: Maybe<Scalars['Int']['output']>;
  prUrl?: Maybe<Scalars['String']['output']>;
  priority: ProjectPriorityType;
  progress: Scalars['Int']['output'];
  progressInfo: ProjectProgress;
  projectMetadata?: Maybe<Scalars['JSON']['output']>;
  projectPhase?: Maybe<ProjectPhaseType>;
  projectType: ProjectTypeEnum;
  promptEvolution: PromptEvolution;
  settings: Scalars['JSON']['output'];
  status: ProjectStatusType;
  systemInstanceId?: Maybe<Scalars['UUID']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProjectAiProposalState = {
  __typename?: 'ProjectAiProposalState';
  adminPageCount: Scalars['Int']['output'];
  bcCount: Scalars['Int']['output'];
  deliverableVersion?: Maybe<Scalars['Int']['output']>;
  hasProposal: Scalars['Boolean']['output'];
  lastUpdatedAt?: Maybe<Scalars['String']['output']>;
  projectId: Scalars['String']['output'];
  publicPageCount: Scalars['Int']['output'];
};

export type ProjectConstitution = {
  __typename?: 'ProjectConstitution';
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  approvedBy?: Maybe<Scalars['UUID']['output']>;
  confirmedFactsCount: Scalars['Int']['output'];
  facts: Array<ConstitutionFactEntry>;
  history: Array<ConstitutionHistoryEntry>;
  lastAnalysisAt?: Maybe<Scalars['DateTime']['output']>;
  needsLaws: Array<Scalars['String']['output']>;
  pendingFactsCount: Scalars['Int']['output'];
  projectId: Scalars['UUID']['output'];
  seedsLaws: Array<Scalars['String']['output']>;
  totalFactsCount: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

export type ProjectContextType = {
  __typename?: 'ProjectContextType';
  additionalNotes: Scalars['String']['output'];
  estimatedScale: Scalars['String']['output'];
  objectives: Array<Scalars['String']['output']>;
  purpose: Scalars['String']['output'];
  targetAudience: Scalars['String']['output'];
};

export type ProjectDeliverableFilterInput = {
  bcName?: InputMaybe<Scalars['String']['input']>;
  hasAdminPages?: InputMaybe<Scalars['Boolean']['input']>;
  hasPublicPages?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectDeliverableListResult = {
  __typename?: 'ProjectDeliverableListResult';
  deliverables: Array<ProjectDeliverableType>;
  totalCount: Scalars['Int']['output'];
};

export type ProjectDeliverableType = {
  __typename?: 'ProjectDeliverableType';
  actualHours?: Maybe<Scalars['Int']['output']>;
  adminPageCount: Scalars['Int']['output'];
  adminPages: Array<AdminPageType>;
  bcCount: Scalars['Int']['output'];
  boundedContexts: Array<BoundedContextType>;
  businessFlowStories: Array<BusinessFlowStoryType>;
  completionPercentage: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enabledScenes: Array<Scalars['String']['output']>;
  estimatedHours?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  isCompleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  priority: Scalars['String']['output'];
  progress: Scalars['Int']['output'];
  projectId: Scalars['String']['output'];
  publicPageCount: Scalars['Int']['output'];
  publicPages: Array<PublicPageType>;
  systemArchitecture?: Maybe<SystemArchitectureType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  version: Scalars['Int']['output'];
};

export type ProjectEvent = BaseEvent & {
  __typename?: 'ProjectEvent';
  data?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['String']['output'];
  newPriority?: Maybe<Scalars['Int']['output']>;
  newStatus?: Maybe<Scalars['String']['output']>;
  oldPriority?: Maybe<Scalars['Int']['output']>;
  oldStatus?: Maybe<Scalars['String']['output']>;
  projectId: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  type: EventType;
  userId: Scalars['String']['output'];
};

export type ProjectListResult = {
  __typename?: 'ProjectListResult';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  projects: Array<Project>;
  totalCount: Scalars['Int']['output'];
};

export enum ProjectPhaseType {
  Closure = 'CLOSURE',
  Execution = 'EXECUTION',
  Initiation = 'INITIATION',
  Monitoring = 'MONITORING',
  Planning = 'PLANNING'
}

export enum ProjectPriorityType {
  Critical = 'CRITICAL',
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type ProjectProgress = {
  __typename?: 'ProjectProgress';
  progress: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export enum ProjectStatusType {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Dreaming = 'DREAMING',
  OnHold = 'ON_HOLD',
  Planning = 'PLANNING'
}

export enum ProjectTypeEnum {
  WebDevelopment = 'WEB_DEVELOPMENT'
}

export type PromptElements = {
  __typename?: 'PromptElements';
  needs: Array<Maybe<PromptNeed>>;
  seeds: Array<Maybe<PromptSeed>>;
  wildIdeas: Array<Maybe<WildIdea>>;
};

export type PromptEvolution = {
  __typename?: 'PromptEvolution';
  core: Scalars['String']['output'];
  elements: PromptElements;
  history: Scalars['JSON']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
};

export type PromptEvolutionEvent = BaseEvent & {
  __typename?: 'PromptEvolutionEvent';
  changeSummary?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  progress?: Maybe<Scalars['Float']['output']>;
  projectId: Scalars['String']['output'];
  promptContent?: Maybe<Scalars['String']['output']>;
  qualityScore?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  type: EventType;
  userId: Scalars['String']['output'];
  version?: Maybe<Scalars['Int']['output']>;
};

export type PromptNeed = {
  __typename?: 'PromptNeed';
  category: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
};

export type PromptSeed = {
  __typename?: 'PromptSeed';
  confidence: Scalars['Float']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ProposalConfigInput = {
  customInstructions?: InputMaybe<Scalars['String']['input']>;
  deliverableDetails: DetailLevelEnum;
  includeDeliverables: Scalars['Boolean']['input'];
  includeSitemap: Scalars['Boolean']['input'];
  includeTechSpecs: Scalars['Boolean']['input'];
  sitemapDetails: DetailLevelEnum;
  style?: InputMaybe<ProposalStyleEnum>;
  targetAudience: TargetAudienceEnum;
};

export type ProposalMetadata = {
  __typename?: 'ProposalMetadata';
  dataSource?: Maybe<Scalars['String']['output']>;
  deliverablesCount?: Maybe<Scalars['Int']['output']>;
  estimatedReadingTime?: Maybe<Scalars['Int']['output']>;
  includesDeliverables?: Maybe<Scalars['Boolean']['output']>;
  includesSitemap?: Maybe<Scalars['Boolean']['output']>;
  includesTechSpecs?: Maybe<Scalars['Boolean']['output']>;
  sitemapPagesCount?: Maybe<Scalars['Int']['output']>;
  style?: Maybe<Scalars['String']['output']>;
  targetAudience?: Maybe<Scalars['String']['output']>;
  techComponentsCount?: Maybe<Scalars['Int']['output']>;
  totalContentLength?: Maybe<Scalars['Int']['output']>;
};

export type ProposalStructurePreviewType = {
  __typename?: 'ProposalStructurePreviewType';
  proposalId: Scalars['String']['output'];
  sections: Array<ProposedSectionType>;
  totalPages: Scalars['Int']['output'];
};

export enum ProposalStyleEnum {
  Basic = 'BASIC',
  Comprehensive = 'COMPREHENSIVE',
  Custom = 'CUSTOM'
}

export type ProposedPageType = {
  __typename?: 'ProposedPageType';
  contentType?: Maybe<Scalars['String']['output']>;
  pageNumber: Scalars['Int']['output'];
  pageType: Scalars['String']['output'];
  sectionId: Scalars['String']['output'];
  sectionTitle: Scalars['String']['output'];
  subsectionTitle?: Maybe<Scalars['String']['output']>;
  targetLength?: Maybe<Scalars['Int']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
};

export type ProposedSectionType = {
  __typename?: 'ProposedSectionType';
  pages: Array<ProposedPageType>;
  required: Scalars['Boolean']['output'];
  sectionId: Scalars['String']['output'];
  sectionTitle: Scalars['String']['output'];
};

export type PublicPageInput = {
  acceptance?: InputMaybe<Scalars['String']['input']>;
  actions?: InputMaybe<Array<Scalars['String']['input']>>;
  audience?: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  displayFields?: InputMaybe<Array<Scalars['String']['input']>>;
  path: Scalars['String']['input'];
  primaryBc?: InputMaybe<Scalars['String']['input']>;
  primaryEntity?: InputMaybe<Scalars['String']['input']>;
  requiresAuth?: Scalars['Boolean']['input'];
  role: Scalars['String']['input'];
  secondaryBcs?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: Scalars['String']['input'];
};

export type PublicPageType = {
  __typename?: 'PublicPageType';
  acceptance?: Maybe<Scalars['String']['output']>;
  actions: Array<Scalars['String']['output']>;
  audience: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayFields: Array<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  primaryBc?: Maybe<Scalars['String']['output']>;
  primaryEntity?: Maybe<Scalars['String']['output']>;
  requiresAuth: Scalars['Boolean']['output'];
  role: Scalars['String']['output'];
  secondaryBcs: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  aiAdvisorMessages: Array<AiAdvisorMessageType>;
  aiAdvisorSession?: Maybe<AiAdvisorSessionType>;
  aiAdvisorSessions: Array<SessionSummaryType>;
  analysisCapabilities: AnalysisCapabilities;
  analyzeBatch: Array<TextAnalysisResult>;
  analyzeStakeholders: StakeholderAnalysisResult;
  analyzeTextWithContext: TextAnalysisResult;
  /** API CatalogをUUIDで取得 */
  apiCatalog?: Maybe<ApiCatalogType>;
  /** API Catalogをサービス名で取得（System Generator向け名前引き） */
  apiCatalogByServiceName?: Maybe<ApiCatalogType>;
  /** API Catalog一覧を取得 */
  apiCatalogs: Array<ApiCatalogType>;
  artifactDdd?: Maybe<ArtifactDdd>;
  artifactPreviewHtml?: Maybe<Scalars['String']['output']>;
  artifactProposalStructure: ProposalStructurePreviewType;
  artifactsDdd: Array<ArtifactDdd>;
  atom?: Maybe<AtomBaseType>;
  atomSource?: Maybe<AtomSourceGql>;
  atomSourceStats: AtomSourceStatsGql;
  atomSources: AtomSourceListGql;
  atomStats: Scalars['JSON']['output'];
  atomTaskStatus?: Maybe<AtomTaskStatus>;
  atoms: AtomConnection;
  /** 利用可能なBC一覧を取得 */
  availableBcs: Array<BcCatalogEntryType>;
  availableProposals: Array<ArtifactDdd>;
  /** 利用可能な業務シーン(セット)一覧を取得 */
  availableScenes: Array<SceneOptionType>;
  childClients: Array<ClientType>;
  client?: Maybe<ClientType>;
  clients: ClientConnection;
  collectedItems: CollectedItemListGql;
  companyProfile?: Maybe<CompanyProfileType>;
  companyProfileById?: Maybe<CompanyProfileType>;
  compareTexts: TextComparisonResult;
  consolidatedTaskStatus: ConsolidatedTaskStatus;
  constitutionCandidates: Array<ConstitutionCandidate>;
  contentGenerationHistory: ContentGenerationHistoryConnection;
  contextAnalysisResult?: Maybe<TextAnalysisResult>;
  deletedUsers: UserConnection;
  /** デプロイメントを取得 */
  deployment?: Maybe<DeploymentType>;
  /** プロジェクトのデプロイメント設定を取得 */
  deploymentConfig: DeploymentConfigType;
  /** プロジェクトのデプロイメント一覧を取得 */
  deploymentsByProject: DeploymentListType;
  /** デザイン提案のHTMLプレビューを取得 */
  designProposalPreviewHtml?: Maybe<Scalars['String']['output']>;
  /** プロジェクトのデザイン提案一覧を取得 */
  designProposals: Array<DesignProposalType>;
  /** 生成済みシステム一覧 */
  generatedSystems: Array<GeneratedSystemRecord>;
  hasCompanyProfile: Scalars['Boolean']['output'];
  healthCheck: HealthCheck;
  hello: Scalars['String']['output'];
  industries: Array<Industry>;
  industriesDdd: IndustryConnection;
  industry?: Maybe<Industry>;
  industryByCode?: Maybe<Industry>;
  industryByCodeDdd?: Maybe<IndustryType>;
  industryCategories: Array<IndustryCategory>;
  industryDdd?: Maybe<IndustryType>;
  industryStats: IndustryStatsType;
  industryStatsDdd: IndustryStatsType;
  introspectToken: TokenIntrospectionResponse;
  /** プロジェクトの最新デプロイメントを取得 */
  latestDeployment?: Maybe<DeploymentType>;
  mainSystemInstance?: Maybe<SystemInstanceType>;
  me?: Maybe<AuthUser>;
  myOrganizations: Array<OrganizationType>;
  observerPlugins: Array<ObserverPlugin>;
  organization?: Maybe<OrganizationType>;
  organizationBySlug?: Maybe<OrganizationType>;
  organizationClients: Array<ClientType>;
  organizationOwner?: Maybe<UserOrganizationType>;
  organizations: OrganizationConnection;
  /** プロジェクトのOrient（統合判断）取得 */
  orientForProject?: Maybe<OrientType>;
  /** ページデザインのHTMLプレビューを取得 */
  pageDesignPreviewHtml?: Maybe<Scalars['String']['output']>;
  /** プロジェクトの全ページデザイン一覧を取得 */
  pageDesigns: Array<PageDesignType>;
  pendingAtoms: Array<AtomBaseType>;
  previewProjectIntegration?: Maybe<IntegrationPreviewType>;
  projectAiProposalStates: Array<ProjectAiProposalState>;
  projectArtifactsDdd: ArtifactDddConnection;
  projectConstitution: ProjectConstitution;
  projectDdd?: Maybe<Project>;
  projectDeliverable?: Maybe<ProjectDeliverableType>;
  projectDeliverables: ProjectDeliverableListResult;
  /** プロジェクトのAtomから抽出・グラウンディングされた固有名詞一覧 */
  projectGroundedEntities: Array<GroundedEntityType>;
  /** プロジェクトの全Scope取得 */
  projectScopes: Array<ScopeType>;
  /** プロジェクトのView一覧 */
  projectViews: Array<ViewType>;
  projectsDdd: ProjectListResult;
  proposeProposalStructure: ProposalStructurePreviewType;
  /** Scope詳細 */
  scopeDetail?: Maybe<ScopeType>;
  searchAtoms: Array<AtomBaseType>;
  searchCorporations: CorporateSearchResult;
  searchOrganizations: OrganizationConnection;
  searchUsers: UserConnection;
  sessionInfo?: Maybe<SessionInfo>;
  systemGenerationStatus: SystemGenerationStatusResponse;
  systemInstance?: Maybe<SystemInstanceType>;
  systemInstances: Array<SystemInstanceType>;
  trashedProjectsDdd: ProjectListResult;
  uiGenerationResult?: Maybe<UiGenerationResult>;
  uiProject?: Maybe<UiProject>;
  uiProjects: Array<UiProjectListItem>;
  unifiedContentTaskStatus?: Maybe<UnifiedContentTaskStatus>;
  user?: Maybe<UserType>;
  userByEmail?: Maybe<UserType>;
  userByUsername?: Maybe<UserType>;
  users: UserConnection;
  /** View詳細 */
  viewDetail?: Maybe<ViewType>;
};


export type QueryAiAdvisorMessagesArgs = {
  sessionId: Scalars['String']['input'];
};


export type QueryAiAdvisorSessionArgs = {
  sessionId: Scalars['String']['input'];
};


export type QueryAiAdvisorSessionsArgs = {
  projectId: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAnalyzeBatchArgs = {
  contents: Array<Scalars['String']['input']>;
  options?: InputMaybe<AnalysisOptions>;
};


export type QueryAnalyzeStakeholdersArgs = {
  content: Scalars['String']['input'];
};


export type QueryAnalyzeTextWithContextArgs = {
  content: Scalars['String']['input'];
  options?: InputMaybe<AnalysisOptions>;
  personas?: InputMaybe<Array<PersonaInput>>;
  speakerContext?: InputMaybe<SpeakerContextInput>;
};


export type QueryApiCatalogArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryApiCatalogByServiceNameArgs = {
  serviceName: Scalars['String']['input'];
};


export type QueryApiCatalogsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  projectId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryArtifactDddArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryArtifactPreviewHtmlArgs = {
  artifactId: Scalars['UUID']['input'];
  colorScheme?: InputMaybe<Scalars['String']['input']>;
};


export type QueryArtifactProposalStructureArgs = {
  artifactId: Scalars['String']['input'];
};


export type QueryArtifactsDddArgs = {
  artifactType?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAtomArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryAtomSourceArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryAtomSourcesArgs = {
  entityId?: InputMaybe<Scalars['UUID']['input']>;
  entityType?: InputMaybe<AtomSourceEntityTypeEnum>;
  filter?: InputMaybe<AtomSourceFilterInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryAtomStatsArgs = {
  organizationId: Scalars['UUID']['input'];
};


export type QueryAtomTaskStatusArgs = {
  atomId: Scalars['UUID']['input'];
};


export type QueryAtomsArgs = {
  filter?: InputMaybe<AtomFilterInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryAvailableProposalsArgs = {
  projectId: Scalars['UUID']['input'];
};


export type QueryChildClientsArgs = {
  parentId: Scalars['UUID']['input'];
};


export type QueryClientArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryClientsArgs = {
  filter?: InputMaybe<ClientFilterInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryCollectedItemsArgs = {
  filter?: InputMaybe<CollectedItemFilterInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  sourceId: Scalars['UUID']['input'];
};


export type QueryCompanyProfileByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCompareTextsArgs = {
  content1: Scalars['String']['input'];
  content2: Scalars['String']['input'];
  options?: InputMaybe<AnalysisOptions>;
};


export type QueryConsolidatedTaskStatusArgs = {
  taskId: Scalars['String']['input'];
};


export type QueryConstitutionCandidatesArgs = {
  projectId: Scalars['UUID']['input'];
};


export type QueryContentGenerationHistoryArgs = {
  filterInput?: InputMaybe<ContentGenerationFilterInput>;
  first?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryContextAnalysisResultArgs = {
  projectId: Scalars['UUID']['input'];
};


export type QueryDeletedUsersArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryDeploymentArgs = {
  deploymentId: Scalars['String']['input'];
};


export type QueryDeploymentConfigArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryDeploymentsByProjectArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryDesignProposalPreviewHtmlArgs = {
  proposalId: Scalars['ID']['input'];
};


export type QueryDesignProposalsArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryGeneratedSystemsArgs = {
  projectId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHelloArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIndustriesArgs = {
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIndustriesDddArgs = {
  filter?: InputMaybe<IndustryFilterInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryIndustryArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryIndustryByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryIndustryByCodeDddArgs = {
  code: Scalars['String']['input'];
};


export type QueryIndustryCategoriesArgs = {
  parentId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryIndustryDddArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryIntrospectTokenArgs = {
  input: TokenIntrospectionInput;
};


export type QueryLatestDeploymentArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryMainSystemInstanceArgs = {
  clientId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryObserverPluginsArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  pluginType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganizationArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryOrganizationBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryOrganizationClientsArgs = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['UUID']['input'];
};


export type QueryOrganizationOwnerArgs = {
  organizationId: Scalars['UUID']['input'];
};


export type QueryOrganizationsArgs = {
  filter?: InputMaybe<OrganizationFilterInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryOrientForProjectArgs = {
  projectId: Scalars['UUID']['input'];
};


export type QueryPageDesignPreviewHtmlArgs = {
  designId: Scalars['ID']['input'];
};


export type QueryPageDesignsArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryPendingAtomsArgs = {
  limit?: Scalars['Int']['input'];
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryPreviewProjectIntegrationArgs = {
  projectId: Scalars['UUID']['input'];
  systemInstanceId: Scalars['UUID']['input'];
};


export type QueryProjectAiProposalStatesArgs = {
  projectIds: Array<Scalars['String']['input']>;
};


export type QueryProjectArtifactsDddArgs = {
  artifactType?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['UUID']['input'];
};


export type QueryProjectConstitutionArgs = {
  projectId: Scalars['UUID']['input'];
};


export type QueryProjectDddArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryProjectDeliverableArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryProjectDeliverablesArgs = {
  filter?: InputMaybe<ProjectDeliverableFilterInput>;
};


export type QueryProjectGroundedEntitiesArgs = {
  projectId: Scalars['UUID']['input'];
};


export type QueryProjectScopesArgs = {
  projectId: Scalars['UUID']['input'];
};


export type QueryProjectViewsArgs = {
  limit?: Scalars['Int']['input'];
  projectId: Scalars['UUID']['input'];
};


export type QueryProjectsDddArgs = {
  organizationId: Scalars['UUID']['input'];
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
  status?: InputMaybe<ProjectStatusType>;
};


export type QueryProposeProposalStructureArgs = {
  outputFormat?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
};


export type QueryScopeDetailArgs = {
  scopeId: Scalars['UUID']['input'];
};


export type QuerySearchAtomsArgs = {
  atomType?: InputMaybe<AtomTypeType>;
  limit?: Scalars['Int']['input'];
  organizationId: Scalars['UUID']['input'];
  query: Scalars['String']['input'];
};


export type QuerySearchCorporationsArgs = {
  input: CorporateSearchInput;
};


export type QuerySearchOrganizationsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  plan?: InputMaybe<PlanType>;
  query: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchUsersArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  query: Scalars['String']['input'];
  status?: InputMaybe<UserStatusType>;
};


export type QuerySystemGenerationStatusArgs = {
  taskId: Scalars['String']['input'];
};


export type QuerySystemInstanceArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySystemInstancesArgs = {
  includeArchived?: Scalars['Boolean']['input'];
};


export type QueryTrashedProjectsDddArgs = {
  organizationId: Scalars['UUID']['input'];
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
};


export type QueryUiGenerationResultArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryUiProjectArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryUnifiedContentTaskStatusArgs = {
  taskId: Scalars['String']['input'];
};


export type QueryUserArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryUserByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryUserByUsernameArgs = {
  username: Scalars['String']['input'];
};


export type QueryUsersArgs = {
  filter?: InputMaybe<UserFilterInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryViewDetailArgs = {
  viewId: Scalars['UUID']['input'];
};

export type RefreshTokenInput = {
  deviceFingerprint?: InputMaybe<Scalars['String']['input']>;
  refreshToken: Scalars['String']['input'];
};

export type RegenerateFromSnapshotResult = {
  __typename?: 'RegenerateFromSnapshotResult';
  bcSetLoaded: Array<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  snapshotId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  systemInstanceId: Scalars['String']['output'];
};

export type RequestApiCrawlInput = {
  apiVersion?: InputMaybe<Scalars['String']['input']>;
  documentationUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  serviceName: Scalars['String']['input'];
};

export type RequestPasswordResetInput = {
  email: Scalars['String']['input'];
};

export type ResetPasswordInput = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type RunAnalysisResultType = {
  __typename?: 'RunAnalysisResultType';
  emotions?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  facts?: Maybe<Array<Scalars['String']['output']>>;
  insights?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  summary?: Maybe<Scalars['String']['output']>;
};

export type SaveDeploymentConfigInput = {
  domain?: InputMaybe<Scalars['String']['input']>;
  githubOwner?: InputMaybe<Scalars['String']['input']>;
  githubRepoName?: InputMaybe<Scalars['String']['input']>;
  githubToken?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
  providerType?: Scalars['String']['input'];
  vpsAuthMethod?: Scalars['String']['input'];
  vpsHost?: InputMaybe<Scalars['String']['input']>;
  vpsPassword?: InputMaybe<Scalars['String']['input']>;
  vpsPort?: Scalars['Int']['input'];
  vpsSshKey?: InputMaybe<Scalars['String']['input']>;
  vpsUsername?: InputMaybe<Scalars['String']['input']>;
};

export type SceneOptionType = {
  __typename?: 'SceneOptionType';
  bcNames: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  industry: Scalars['String']['output'];
  isDefaultEnabled: Scalars['Boolean']['output'];
  isPublic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nameJa: Scalars['String']['output'];
};

export enum ScopeOriginType {
  AutoDetected = 'AUTO_DETECTED',
  ContextOs = 'CONTEXT_OS',
  LlmGenerated = 'LLM_GENERATED',
  UserDefined = 'USER_DEFINED'
}

export type ScopeRefinementAction = {
  __typename?: 'ScopeRefinementAction';
  reason: Scalars['String']['output'];
  scopeName: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ScopeRefinementResult = {
  __typename?: 'ScopeRefinementResult';
  actions: Array<ScopeRefinementAction>;
  aiResponse: Scalars['String']['output'];
  scopes: Array<ScopeType>;
};

export type ScopeType = {
  __typename?: 'ScopeType';
  analysisLens?: Maybe<Scalars['String']['output']>;
  boostKeywords: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  focusAtomIds: Array<Scalars['UUID']['output']>;
  functionCandidates: Array<FunctionCandidateType>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  origin: ScopeOriginType;
  plan?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['UUID']['output']>;
  rationale?: Maybe<Scalars['String']['output']>;
  searchQuery?: Maybe<Scalars['String']['output']>;
  viewId: Scalars['UUID']['output'];
};

export type SendAiAdvisorMessageInput = {
  content: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};

export type SendMessageResultType = {
  __typename?: 'SendMessageResultType';
  assistantMessage?: Maybe<AiAdvisorMessageType>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  newPhase?: Maybe<Scalars['String']['output']>;
  phaseChanged: Scalars['Boolean']['output'];
  sessionCompleted: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
  userMessage?: Maybe<AiAdvisorMessageType>;
};

export type SendVerificationEmailInput = {
  email: Scalars['String']['input'];
};

export type SessionInfo = {
  __typename?: 'SessionInfo';
  authenticated: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  csrfToken?: Maybe<Scalars['String']['output']>;
  lastActivity: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type SessionSummaryType = {
  __typename?: 'SessionSummaryType';
  createdAt: Scalars['String']['output'];
  currentPhase: Scalars['String']['output'];
  id: Scalars['String']['output'];
  meetingStatus: Scalars['String']['output'];
  messageCount: Scalars['Int']['output'];
  progressPercentage: Scalars['Float']['output'];
  projectId: Scalars['String']['output'];
  projectType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type SetGithubTokenResult = {
  __typename?: 'SetGithubTokenResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  hasToken: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

export type SetSystemInstanceGithubTokenInput = {
  systemInstanceId: Scalars['UUID']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};

export type SetVpsCredentialsInput = {
  adminDomain?: InputMaybe<Scalars['String']['input']>;
  primaryDomain?: InputMaybe<Scalars['String']['input']>;
  systemInstanceId: Scalars['UUID']['input'];
  vpsHost?: InputMaybe<Scalars['String']['input']>;
  vpsSshKey?: InputMaybe<Scalars['String']['input']>;
  vpsSshPort?: InputMaybe<Scalars['Int']['input']>;
  vpsUser?: InputMaybe<Scalars['String']['input']>;
};

export type SetVpsCredentialsResult = {
  __typename?: 'SetVpsCredentialsResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  githubSync?: Maybe<GithubSecretSyncResult>;
  savedToDb: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

export enum SourceTypeEnum {
  Api = 'API',
  Rss = 'RSS',
  WebScraping = 'WEB_SCRAPING'
}

export type SpeakerContextInput = {
  department?: InputMaybe<Scalars['String']['input']>;
  meetingType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  seniority?: InputMaybe<Scalars['String']['input']>;
};

export type SshDeployResult = {
  __typename?: 'SshDeployResult';
  alembicAttempted: Scalars['Boolean']['output'];
  alembicSuccess: Scalars['Boolean']['output'];
  composeUp: Scalars['Boolean']['output'];
  connected: Scalars['Boolean']['output'];
  elapsedSeconds: Scalars['Float']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  healthPassed: Scalars['Boolean']['output'];
  logTail: Scalars['String']['output'];
  markedRunning: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
  transferred: Scalars['Boolean']['output'];
  transferredBytes: Scalars['Int']['output'];
};

export type StakeholderAnalysisResult = {
  __typename?: 'StakeholderAnalysisResult';
  designInsights: Array<DesignInsight>;
  perspectives: Array<Perspective>;
  recommendations: Array<Scalars['String']['output']>;
  relationshipsGraph: Scalars['JSON']['output'];
  stakeholders: Array<StakeholderProfile>;
  synergies: Array<SynergyOpportunity>;
};

export type StakeholderProfile = {
  __typename?: 'StakeholderProfile';
  capabilities: Array<Scalars['String']['output']>;
  challenges: Array<Scalars['String']['output']>;
  constraints: Array<Scalars['String']['output']>;
  goals: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  influenceLevel: Scalars['Float']['output'];
  interestLevel: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  relationships: Array<Scalars['String']['output']>;
  resources: Scalars['JSON']['output'];
  role: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type StartDeploymentInput = {
  artifactId: Scalars['String']['input'];
  credentials?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  providerConfig?: InputMaybe<Scalars['JSON']['input']>;
  providerType?: Scalars['String']['input'];
};

export type StartDeploymentResult = {
  __typename?: 'StartDeploymentResult';
  deploymentId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  taskId?: Maybe<Scalars['String']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  activeSessionsMonitor: Scalars['String']['output'];
  aiAdvisorUpdates: AiAdvisorEvent;
  apiCrawlUpdates: ApiCrawlEvent;
  atomProcessingUpdates: AtomEvent;
  batchGenerationProgress: Scalars['String']['output'];
  clientResearchUpdates: ClientResearchEvent;
  companyProfileResearchUpdates: CompanyProfileResearchEvent;
  consolidatedDeliverableUpdates: ConsolidatedDeliverableEvent;
  countdown: Scalars['Int']['output'];
  events: SubscriptionEvent;
  industryResearchUpdates: IndustryResearchEvent;
  orchestratorMetricsStream: Scalars['String']['output'];
  prismOrientUpdates: PrismOrientEvent;
  prismScopeUpdates: PrismScopeEvent;
  projectEvents: SubscriptionEvent;
  systemStatus: SystemEvent;
  unifiedContentUpdates: UnifiedContentEvent;
  userNotifications: NotificationEventTaskEvent;
};


export type SubscriptionAiAdvisorUpdatesArgs = {
  projectId: Scalars['String']['input'];
  sessionId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionApiCrawlUpdatesArgs = {
  catalogId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionAtomProcessingUpdatesArgs = {
  atomId?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionBatchGenerationProgressArgs = {
  batchId: Scalars['String']['input'];
};


export type SubscriptionClientResearchUpdatesArgs = {
  clientId: Scalars['String']['input'];
};


export type SubscriptionCompanyProfileResearchUpdatesArgs = {
  companyProfileId: Scalars['String']['input'];
};


export type SubscriptionConsolidatedDeliverableUpdatesArgs = {
  projectId: Scalars['String']['input'];
};


export type SubscriptionCountdownArgs = {
  fromNumber?: Scalars['Int']['input'];
};


export type SubscriptionEventsArgs = {
  filter: SubscriptionFilter;
};


export type SubscriptionIndustryResearchUpdatesArgs = {
  industryId: Scalars['String']['input'];
};


export type SubscriptionPrismOrientUpdatesArgs = {
  projectId: Scalars['String']['input'];
};


export type SubscriptionPrismScopeUpdatesArgs = {
  projectId: Scalars['String']['input'];
};


export type SubscriptionProjectEventsArgs = {
  eventTypes?: InputMaybe<Array<EventType>>;
  projectId: Scalars['String']['input'];
};


export type SubscriptionUnifiedContentUpdatesArgs = {
  projectId: Scalars['String']['input'];
};

export type SubscriptionEvent = AiAdvisorEvent | ApiCrawlEvent | AtomEvent | ClientResearchEvent | CompanyProfileResearchEvent | ConsolidatedDeliverableEvent | IndustryResearchEvent | NotificationEvent | PrismOrientEvent | PrismScopeEvent | ProjectEvent | PromptEvolutionEvent | SystemEvent | TaskEvent | UnifiedContentEvent | UserActivityEvent;

export type SubscriptionFilter = {
  eventTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeEventTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  includeArchived?: Scalars['Boolean']['input'];
  includeSystemEvents?: Scalars['Boolean']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  projectIds?: InputMaybe<Array<Scalars['String']['input']>>;
  scope: SubscriptionScope;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum SubscriptionScope {
  Organization = 'ORGANIZATION',
  Project = 'PROJECT',
  System = 'SYSTEM',
  User = 'USER'
}

export type SynergyOpportunity = {
  __typename?: 'SynergyOpportunity';
  benefits: Scalars['JSON']['output'];
  description: Scalars['String']['output'];
  feasibility: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  impact: Scalars['Float']['output'];
  implementationSteps: Array<Scalars['String']['output']>;
  mechanism: Scalars['String']['output'];
  participants: Array<Scalars['String']['output']>;
  risks: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type SystemArchitectureType = {
  __typename?: 'SystemArchitectureType';
  architectureType: Scalars['String']['output'];
  componentCount: Scalars['Int']['output'];
  componentsJson: Scalars['String']['output'];
  deploymentStrategy: Scalars['String']['output'];
  scalingConsiderations: Array<Scalars['String']['output']>;
};

export type SystemEvent = BaseEvent & {
  __typename?: 'SystemEvent';
  affectedServices?: Maybe<Array<Scalars['String']['output']>>;
  details?: Maybe<Scalars['JSON']['output']>;
  healthStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  maintenanceEnd?: Maybe<Scalars['DateTime']['output']>;
  maintenanceStart?: Maybe<Scalars['DateTime']['output']>;
  maintenanceType?: Maybe<Scalars['String']['output']>;
  metricName?: Maybe<Scalars['String']['output']>;
  metricUnit?: Maybe<Scalars['String']['output']>;
  metricValue?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  type: EventType;
};

export type SystemGenerationResultGraphql = {
  __typename?: 'SystemGenerationResultGraphql';
  capturedLog: Scalars['String']['output'];
  elapsedSeconds: Scalars['Float']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  gitBranch?: Maybe<Scalars['String']['output']>;
  gitCommitHash?: Maybe<Scalars['String']['output']>;
  gitError?: Maybe<Scalars['String']['output']>;
  gitPushError?: Maybe<Scalars['String']['output']>;
  gitPushed: Scalars['Boolean']['output'];
  gitRemoteUrl?: Maybe<Scalars['String']['output']>;
  isIncremental: Scalars['Boolean']['output'];
  outputPath?: Maybe<Scalars['String']['output']>;
  prError?: Maybe<Scalars['String']['output']>;
  prNumber?: Maybe<Scalars['Int']['output']>;
  prUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  systemInstanceId: Scalars['UUID']['output'];
  totalBcs: Scalars['Int']['output'];
  totalFiles: Scalars['Int']['output'];
  touchedBcs: Array<Scalars['String']['output']>;
};

export type SystemGenerationStatusResponse = {
  __typename?: 'SystemGenerationStatusResponse';
  error?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  result?: Maybe<LegacySystemGenerationResult>;
  status: Scalars['String']['output'];
};

export type SystemInstanceOperationResult = {
  __typename?: 'SystemInstanceOperationResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  instance?: Maybe<SystemInstanceType>;
  success: Scalars['Boolean']['output'];
};

export type SystemInstanceType = {
  __typename?: 'SystemInstanceType';
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  clientId?: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deployTarget: DeployTargetType;
  deploymentStatus: DeploymentStatusType;
  gitDefaultBranch: Scalars['String']['output'];
  githubRepoName?: Maybe<Scalars['String']['output']>;
  hasGit: Scalars['Boolean']['output'];
  hasGithubToken: Scalars['Boolean']['output'];
  hasVps: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  isArchived: Scalars['Boolean']['output'];
  isMain: Scalars['Boolean']['output'];
  lastDeployedAt?: Maybe<Scalars['DateTime']['output']>;
  lastGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['UUID']['output'];
  outputPath: Scalars['String']['output'];
  portOffset: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  subdomainUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  vpsDeploymentConfig?: Maybe<Scalars['JSON']['output']>;
  vpsHost?: Maybe<Scalars['String']['output']>;
  vpsUser?: Maybe<Scalars['String']['output']>;
};

export enum TargetAudienceEnum {
  Business = 'BUSINESS',
  Executive = 'EXECUTIVE',
  Technical = 'TECHNICAL'
}

export type TaskEvent = BaseEvent & {
  __typename?: 'TaskEvent';
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  progress?: Maybe<Scalars['Float']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  resourceId?: Maybe<Scalars['String']['output']>;
  resourceType?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['JSON']['output']>;
  status: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
  taskName: Scalars['String']['output'];
  taskType: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  type: EventType;
  userId: Scalars['String']['output'];
};

export type TestConnectionResult = {
  __typename?: 'TestConnectionResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TextAnalysisResult = {
  __typename?: 'TextAnalysisResult';
  abstracts?: Maybe<AbstractLayerResult>;
  analyzedAt: Scalars['DateTime']['output'];
  confidence: Scalars['Float']['output'];
  content: Scalars['String']['output'];
  crossLayerAnalysis?: Maybe<Scalars['JSON']['output']>;
  emotions?: Maybe<EmotionResult>;
  facts?: Maybe<FactLayerResult>;
  ideals?: Maybe<IdealLayerResult>;
  metaPerspective?: Maybe<MetaPerspectiveItem>;
  perspectives?: Maybe<PerspectiveResult>;
  processingTimeSeconds: Scalars['Float']['output'];
  summary: AnalysisSummary;
};

export type TextComparisonResult = {
  __typename?: 'TextComparisonResult';
  analysis1: TextAnalysisResult;
  analysis2: TextAnalysisResult;
  comparison: ComparisonResult;
};

export type TokenIntrospectionInput = {
  token: Scalars['String']['input'];
  tokenTypeHint?: InputMaybe<Scalars['String']['input']>;
};

export type TokenIntrospectionResponse = {
  __typename?: 'TokenIntrospectionResponse';
  active: Scalars['Boolean']['output'];
  aud?: Maybe<Array<Scalars['String']['output']>>;
  clientId?: Maybe<Scalars['String']['output']>;
  exp?: Maybe<Scalars['Int']['output']>;
  iat?: Maybe<Scalars['Int']['output']>;
  iss?: Maybe<Scalars['String']['output']>;
  jti?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  sub?: Maybe<Scalars['String']['output']>;
  tokenType?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type TokenRequestInput = {
  deviceInfo?: InputMaybe<Scalars['String']['input']>;
  grantType: GrantType;
  password?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type TokenRevocationInput = {
  token: Scalars['String']['input'];
  tokenTypeHint?: InputMaybe<Scalars['String']['input']>;
};

export type TokenRevocationResponse = {
  __typename?: 'TokenRevocationResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type TransferOwnershipResult = {
  __typename?: 'TransferOwnershipResult';
  message: Scalars['String']['output'];
  newOwner?: Maybe<UserOrganizationType>;
  success: Scalars['Boolean']['output'];
};

export type UiGenerationResult = {
  __typename?: 'UIGenerationResult';
  errors: Array<Scalars['String']['output']>;
  generationTime: Scalars['Float']['output'];
  projectPath: Scalars['String']['output'];
  qualityScore: Scalars['Float']['output'];
  success: Scalars['Boolean']['output'];
  totalFiles: Scalars['Int']['output'];
  totalLines: Scalars['Int']['output'];
  uiMockUrl?: Maybe<Scalars['String']['output']>;
  warnings: Array<Scalars['String']['output']>;
};

export type UiPageInfo = {
  __typename?: 'UIPageInfo';
  businessLogic: Scalars['String']['output'];
  completionLevel: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  hasFooter: Scalars['Boolean']['output'];
  hasHeader: Scalars['Boolean']['output'];
  hasSidebar: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  keyFeatures: Array<Scalars['String']['output']>;
  layout?: Maybe<Scalars['String']['output']>;
  llmGenerated: Scalars['Boolean']['output'];
  mainPurpose: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pageType: Scalars['String']['output'];
  targetUsers: Array<Scalars['String']['output']>;
};

export type UiProject = {
  __typename?: 'UIProject';
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  errors: Array<Scalars['String']['output']>;
  generatedFilesCount: Scalars['Int']['output'];
  generationTime: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pagesCount: Scalars['Int']['output'];
  qualityScore: Scalars['Float']['output'];
  sitemap: Scalars['String']['output'];
  status: Scalars['String']['output'];
  uiMockUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  warnings: Array<Scalars['String']['output']>;
};

export type UiProjectListItem = {
  __typename?: 'UIProjectListItem';
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pagesCount: Scalars['Int']['output'];
  qualityScore: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type UnifiedContentEvent = BaseEvent & {
  __typename?: 'UnifiedContentEvent';
  artifactId?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  currentStep?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Int']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  outputFormat?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  projectId: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  type: EventType;
  userId: Scalars['String']['output'];
};

export type UnifiedContentGenerationInput = {
  artifactId?: InputMaybe<Scalars['String']['input']>;
  colorScheme?: InputMaybe<Scalars['String']['input']>;
  complexityLevel?: InputMaybe<Scalars['String']['input']>;
  contentType: UnifiedContentTypeEnum;
  customInstructions?: InputMaybe<Scalars['String']['input']>;
  focusAreas?: InputMaybe<Array<Scalars['String']['input']>>;
  hourlyRate?: InputMaybe<Scalars['Int']['input']>;
  includeDeliverables?: Scalars['Boolean']['input'];
  includeSitemap?: Scalars['Boolean']['input'];
  includeTechSpecs?: Scalars['Boolean']['input'];
  maxFunctions?: InputMaybe<Scalars['Int']['input']>;
  outputFormat: UnifiedOutputFormatEnum;
  projectId: Scalars['UUID']['input'];
  sections?: InputMaybe<Array<EditedSectionInput>>;
  timelineMonths?: InputMaybe<Scalars['Int']['input']>;
};

export type UnifiedContentGenerationResult = {
  __typename?: 'UnifiedContentGenerationResult';
  artifactId?: Maybe<Scalars['String']['output']>;
  contentLength?: Maybe<Scalars['Int']['output']>;
  contentType: Scalars['String']['output'];
  deliverableId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Int']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  outputFormat: Scalars['String']['output'];
  processingTime?: Maybe<Scalars['Float']['output']>;
  projectId: Scalars['String']['output'];
  qualityScore?: Maybe<Scalars['Float']['output']>;
  success: Scalars['Boolean']['output'];
  taskId?: Maybe<Scalars['String']['output']>;
};

export type UnifiedContentTaskStatus = {
  __typename?: 'UnifiedContentTaskStatus';
  contentType?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  outputFormat?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['JSON']['output']>;
  status: Scalars['String']['output'];
  taskId: Scalars['String']['output'];
};

export enum UnifiedContentTypeEnum {
  Deliverable = 'DELIVERABLE',
  Proposal = 'PROPOSAL'
}

export enum UnifiedOutputFormatEnum {
  GoogleSlides = 'GOOGLE_SLIDES',
  JsonStructure = 'JSON_STRUCTURE',
  Markdown = 'MARKDOWN',
  Powerpoint = 'POWERPOINT'
}

export type UpdateAtomInput = {
  atomType?: InputMaybe<AtomTypeType>;
  category?: InputMaybe<Scalars['String']['input']>;
  contentFormat?: InputMaybe<Scalars['String']['input']>;
  fullContent?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AtomStatusType>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAtomSourceInput = {
  collectionFrequency?: InputMaybe<CollectionFrequencyEnum>;
  contentFilters?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['UUID']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  sourceConfig?: InputMaybe<Scalars['JSON']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClientInput = {
  addressOutside?: InputMaybe<Scalars['String']['input']>;
  businessDescription?: InputMaybe<Scalars['String']['input']>;
  capital?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clientType?: InputMaybe<ClientTypeEnum>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  corporateNumber?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employeeCount?: InputMaybe<Scalars['String']['input']>;
  foundedYear?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  industryId?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['UUID']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  prefecture?: InputMaybe<Scalars['String']['input']>;
  representative?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<ClientSizeType>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  totalLifetimeValue?: InputMaybe<Scalars['Float']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanyProfileInput = {
  achievements?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  addressOutside?: InputMaybe<Scalars['String']['input']>;
  annualRevenue?: InputMaybe<Scalars['String']['input']>;
  businessContent?: InputMaybe<Scalars['String']['input']>;
  capital?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  competitors?: InputMaybe<Scalars['String']['input']>;
  corporateNumber?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employeeCount?: InputMaybe<Scalars['Int']['input']>;
  foundedDate?: InputMaybe<Scalars['Date']['input']>;
  industryId?: InputMaybe<Scalars['UUID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  prefecture?: InputMaybe<Scalars['String']['input']>;
  representative?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<CompanySizeType>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  strengths?: InputMaybe<Scalars['String']['input']>;
  targetMarket?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateConstitutionalFactsInput = {
  facts: Array<ConstitutionFactInput>;
  projectId: Scalars['UUID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateIndustryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  industryProfile?: InputMaybe<Scalars['JSON']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationInput = {
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  billingContact?: InputMaybe<Scalars['String']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requireEmailVerification?: InputMaybe<Scalars['Boolean']['input']>;
  sharedKnowledgeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  taxId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProjectDeliverableInput = {
  adminPages?: InputMaybe<Array<AdminPageInput>>;
  boundedContexts?: InputMaybe<Array<BoundedContextInput>>;
  businessFlowStories?: InputMaybe<Array<BusinessFlowStoryInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabledScenes?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  publicPages?: InputMaybe<Array<PublicPageInput>>;
};

export type UpdateProjectInput = {
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  developmentType?: InputMaybe<DevelopmentTypeEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<ProjectPriorityType>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  projectMetadata?: InputMaybe<Scalars['JSON']['input']>;
  projectPhase?: InputMaybe<ProjectPhaseType>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<ProjectStatusType>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateScopeInput = {
  analysisLens?: InputMaybe<Scalars['String']['input']>;
  boostKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  rationale?: InputMaybe<Scalars['String']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSitemapResponse = {
  __typename?: 'UpdateSitemapResponse';
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type UpdateSystemInstanceInput = {
  clearGithub?: Scalars['Boolean']['input'];
  clearVps?: Scalars['Boolean']['input'];
  gitDefaultBranch?: InputMaybe<Scalars['String']['input']>;
  githubRepoName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  outputPath?: InputMaybe<Scalars['String']['input']>;
  portOffset?: InputMaybe<Scalars['Int']['input']>;
  systemInstanceId: Scalars['UUID']['input'];
  vpsDeploymentConfig?: InputMaybe<Scalars['JSON']['input']>;
  vpsHost?: InputMaybe<Scalars['String']['input']>;
  vpsUser?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUiProjectInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sitemap?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserActivityEvent = BaseEvent & {
  __typename?: 'UserActivityEvent';
  activityData?: Maybe<Scalars['JSON']['output']>;
  activityType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  isTyping?: Maybe<Scalars['Boolean']['output']>;
  lastSeen?: Maybe<Scalars['DateTime']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  type: EventType;
  typingIn?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type UserConnection = {
  __typename?: 'UserConnection';
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor: Scalars['String']['output'];
  node: UserType;
};

export type UserFilterInput = {
  authProvider?: InputMaybe<AuthProviderType>;
  email?: InputMaybe<Scalars['String']['input']>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<UserStatusType>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserOrganizationType = {
  __typename?: 'UserOrganizationType';
  invitedBy?: Maybe<Scalars['UUID']['output']>;
  joinedAt: Scalars['DateTime']['output'];
  organizationId: Scalars['UUID']['output'];
  role: OrganizationRoleType;
  userId: Scalars['UUID']['output'];
};

export enum UserStatusType {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Suspended = 'SUSPENDED'
}

export type UserType = {
  __typename?: 'UserType';
  authProvider: AuthProviderType;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  isEmailVerified: Scalars['Boolean']['output'];
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  locale: Scalars['String']['output'];
  loginCount: Scalars['Int']['output'];
  organization?: Maybe<OrganizationType>;
  organizations: Array<OrganizationType>;
  ownedProjects: Array<Project>;
  status: UserStatusType;
  timezone: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  username?: Maybe<Scalars['String']['output']>;
};


export type UserTypeOwnedProjectsArgs = {
  limit?: Scalars['Int']['input'];
};

export type VerificationResultType = {
  __typename?: 'VerificationResultType';
  authTypeCorrect: Scalars['String']['output'];
  authTypeVerified: Scalars['Boolean']['output'];
  baseUrlCorrect: Scalars['String']['output'];
  baseUrlVerified: Scalars['Boolean']['output'];
  confidenceScore: Scalars['Float']['output'];
  endpointVerdicts: Array<EndpointVerdictType>;
  errorMessage: Scalars['String']['output'];
  status: Scalars['String']['output'];
  verificationSources: Array<Scalars['String']['output']>;
  verifiedAt?: Maybe<Scalars['String']['output']>;
};

export type VerifyEmailInput = {
  token: Scalars['String']['input'];
};

export type ViewType = {
  __typename?: 'ViewType';
  analysisResult?: Maybe<Scalars['JSON']['output']>;
  analysisSummary: Scalars['String']['output'];
  generatedAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  projectId: Scalars['UUID']['output'];
  scopeId?: Maybe<Scalars['UUID']['output']>;
  sourceAtomIds: Array<Scalars['UUID']['output']>;
  sourceType: Scalars['String']['output'];
};

export type WildIdea = {
  __typename?: 'WildIdea';
  category: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  riskLevel: Scalars['String']['output'];
};

export type CreateAiAdvisorSessionMutationVariables = Exact<{
  input: CreateAiAdvisorSessionInput;
}>;


export type CreateAiAdvisorSessionMutation = { __typename?: 'Mutation', createAiAdvisorSession: { __typename?: 'CreateSessionResultType', success: boolean, errorMessage?: string | null, session?: { __typename?: 'AIAdvisorSessionType', id: string, projectId: string, userId: string, organizationId: string, clientId?: string | null, meetingStatus: string, projectType: string, status: string, title?: string | null, currentPhase: string, phaseFlow: Array<string>, progressPercentage: number, context: string, analysisResult?: string | null, createdAt: string, updatedAt: string, completedAt?: string | null } | null, initialMessage?: { __typename?: 'AIAdvisorMessageType', id: string, sessionId: string, role: string, content: string, phase: string, orderIndex: number, suggestions?: Array<string> | null, extractedInfo?: string | null, actionTaken?: string | null, createdAt: string } | null } };

export type SendAiAdvisorMessageMutationVariables = Exact<{
  input: SendAiAdvisorMessageInput;
}>;


export type SendAiAdvisorMessageMutation = { __typename?: 'Mutation', sendAiAdvisorMessage: { __typename?: 'SendMessageResultType', success: boolean, phaseChanged: boolean, newPhase?: string | null, sessionCompleted: boolean, errorMessage?: string | null, userMessage?: { __typename?: 'AIAdvisorMessageType', id: string, sessionId: string, role: string, content: string, phase: string, orderIndex: number, suggestions?: Array<string> | null, extractedInfo?: string | null, actionTaken?: string | null, createdAt: string } | null, assistantMessage?: { __typename?: 'AIAdvisorMessageType', id: string, sessionId: string, role: string, content: string, phase: string, orderIndex: number, suggestions?: Array<string> | null, extractedInfo?: string | null, actionTaken?: string | null, createdAt: string } | null } };

export type CompleteAiAdvisorSessionMutationVariables = Exact<{
  input: CompleteAiAdvisorSessionInput;
}>;


export type CompleteAiAdvisorSessionMutation = { __typename?: 'Mutation', completeAiAdvisorSession: { __typename?: 'CompleteSessionResultType', success: boolean, generatedTitle?: string | null, errorMessage?: string | null, session?: { __typename?: 'AIAdvisorSessionType', id: string, projectId: string, userId: string, organizationId: string, clientId?: string | null, meetingStatus: string, projectType: string, status: string, title?: string | null, currentPhase: string, phaseFlow: Array<string>, progressPercentage: number, context: string, analysisResult?: string | null, createdAt: string, updatedAt: string, completedAt?: string | null } | null } };

export type ConvertAiAdvisorSessionToPrismMutationVariables = Exact<{
  input: ConvertSessionToPrismInput;
}>;


export type ConvertAiAdvisorSessionToPrismMutation = { __typename?: 'Mutation', convertAiAdvisorSessionToPrism: { __typename?: 'ConvertToPrismResultType', success: boolean, atomCount: number, scopeCount: number, viewCount: number, errorMessage?: string | null, session?: { __typename?: 'AIAdvisorSessionType', id: string, projectId: string, userId: string, organizationId: string, clientId?: string | null, meetingStatus: string, projectType: string, status: string, title?: string | null, currentPhase: string, phaseFlow: Array<string>, progressPercentage: number, context: string, analysisResult?: string | null, createdAt: string, updatedAt: string, completedAt?: string | null } | null } };

export type RunAiAdvisorAnalysisMutationVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type RunAiAdvisorAnalysisMutation = { __typename?: 'Mutation', runAiAdvisorAnalysis: { __typename?: 'RunAnalysisResultType', success: boolean, facts?: Array<string> | null, insights?: Array<string> | null, emotions?: string | null, summary?: string | null, errorMessage?: string | null } };

export type GetAiAdvisorSessionQueryVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type GetAiAdvisorSessionQuery = { __typename?: 'Query', aiAdvisorSession?: { __typename?: 'AIAdvisorSessionType', id: string, projectId: string, userId: string, organizationId: string, clientId?: string | null, meetingStatus: string, projectType: string, status: string, title?: string | null, currentPhase: string, phaseFlow: Array<string>, progressPercentage: number, context: string, analysisResult?: string | null, createdAt: string, updatedAt: string, completedAt?: string | null } | null };

export type GetAiAdvisorSessionsQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAiAdvisorSessionsQuery = { __typename?: 'Query', aiAdvisorSessions: Array<{ __typename?: 'SessionSummaryType', id: string, projectId: string, title?: string | null, status: string, meetingStatus: string, projectType: string, currentPhase: string, progressPercentage: number, messageCount: number, createdAt: string, updatedAt: string }> };

export type GetAiAdvisorMessagesQueryVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type GetAiAdvisorMessagesQuery = { __typename?: 'Query', aiAdvisorMessages: Array<{ __typename?: 'AIAdvisorMessageType', id: string, sessionId: string, role: string, content: string, phase: string, orderIndex: number, suggestions?: Array<string> | null, extractedInfo?: string | null, actionTaken?: string | null, createdAt: string }> };

export type RunContextAnalysisMutationVariables = Exact<{
  projectId: Scalars['UUID']['input'];
  options?: InputMaybe<AnalysisOptions>;
}>;


export type RunContextAnalysisMutation = { __typename?: 'Mutation', runContextAnalysis: { __typename?: 'TextAnalysisResult', content: string, analyzedAt: string, crossLayerAnalysis?: Record<string, any> | null, processingTimeSeconds: number, confidence: number, facts?: { __typename?: 'FactLayerResult', count: number, items: Array<{ __typename?: 'FactItem', content: string, type: string, confidence: number, metadata?: Record<string, any> | null }> } | null, abstracts?: { __typename?: 'AbstractLayerResult', count: number, items: Array<{ __typename?: 'AbstractItem', content: string, type: string, importance: number, confidence: number, reasoning?: string | null }> } | null, emotions?: { __typename?: 'EmotionResult', count: number, overallSentiment?: Record<string, any> | null, teamMorale?: number | null, emotionalTrends?: Array<string> | null, items: Array<{ __typename?: 'EmotionItem', content: string, polarity: string, intensity: number, emotionType: string, designOpportunity?: string | null, confidence: number, subjectivity: number, empathy: number, motivation: number, culturalWeight: number, stressIndicator?: string | null, motivationFactor?: string | null, extractedIntent?: string | null }>, fluctuations?: Array<{ __typename?: 'EmotionFluctuationItem', surfaceEmotion: string, temporalPattern: string, intensityVariance: number, contextCoherence: number, underlyingPatterns: Array<Record<string, any>> }> | null } | null, perspectives?: { __typename?: 'PerspectiveResult', count: number, primaryPerspective?: string | null, gaps?: Array<Record<string, any>> | null, alignments?: Array<Record<string, any>> | null, items: Array<{ __typename?: 'PerspectiveItem', viewpoint: string, observations: Array<string>, concerns: Array<string>, priorities: Array<string>, recommendations: Array<string>, confidence: number, metadata?: Record<string, any> | null, hiddenMessages: Array<string>, alignmentWithOthers: Record<string, any>, underlyingConcerns: Array<string>, trustIndicators: Record<string, any>, gaps: Array<Record<string, any>>, conflicts: Array<Record<string, any>> }> } | null, ideals?: { __typename?: 'IdealLayerResult', count: number, items: Array<{ __typename?: 'IdealItem', content: string, type: string, achievability: number, timeframe: string, currentGap?: string | null, requiredElements?: Array<string> | null, emotionalDrivers?: Array<string> | null, confidence: number }> } | null, metaPerspective?: { __typename?: 'MetaPerspectiveItem', surfaceAnalysis: Record<string, any>, fluctuationAnalysis: Record<string, any>, deepQuestions: Array<string>, hiddenNeeds: Array<string>, contextualInsights: Array<string>, creativeSolutions: Array<string>, confidence: number } | null, summary: { __typename?: 'AnalysisSummary', totalItemsExtracted: number, layersAnalyzed: Array<string>, keyFindings: Array<string> } } };

export type AnalyzeSitemapMutationVariables = Exact<{
  sitemapJson: Scalars['String']['input'];
}>;


export type AnalyzeSitemapMutation = { __typename?: 'Mutation', analyzeSitemap: Array<{ __typename?: 'UIPageInfo', id: string, name: string, description: string, pageType: string, layout?: string | null, hasHeader: boolean, hasFooter: boolean, hasSidebar: boolean, targetUsers: Array<string>, mainPurpose: string, keyFeatures: Array<string>, businessLogic: string, llmGenerated: boolean, completionLevel: number, createdAt: string }> };

export type GetAnalyzeTextWithContextQueryVariables = Exact<{
  content: Scalars['String']['input'];
  speakerContext?: InputMaybe<SpeakerContextInput>;
  options?: InputMaybe<AnalysisOptions>;
  personas?: InputMaybe<Array<PersonaInput> | PersonaInput>;
}>;


export type GetAnalyzeTextWithContextQuery = { __typename?: 'Query', analyzeTextWithContext: { __typename?: 'TextAnalysisResult', content: string, analyzedAt: string, crossLayerAnalysis?: Record<string, any> | null, processingTimeSeconds: number, confidence: number, facts?: { __typename?: 'FactLayerResult', count: number, items: Array<{ __typename?: 'FactItem', content: string, type: string, confidence: number, metadata?: Record<string, any> | null }> } | null, abstracts?: { __typename?: 'AbstractLayerResult', count: number, items: Array<{ __typename?: 'AbstractItem', content: string, type: string, importance: number, confidence: number, reasoning?: string | null }> } | null, emotions?: { __typename?: 'EmotionResult', count: number, overallSentiment?: Record<string, any> | null, teamMorale?: number | null, emotionalTrends?: Array<string> | null, items: Array<{ __typename?: 'EmotionItem', content: string, polarity: string, intensity: number, emotionType: string, designOpportunity?: string | null, confidence: number, subjectivity: number, empathy: number, motivation: number, culturalWeight: number, stressIndicator?: string | null, motivationFactor?: string | null, extractedIntent?: string | null }>, fluctuations?: Array<{ __typename?: 'EmotionFluctuationItem', surfaceEmotion: string, temporalPattern: string, intensityVariance: number, contextCoherence: number, underlyingPatterns: Array<Record<string, any>> }> | null } | null, perspectives?: { __typename?: 'PerspectiveResult', count: number, primaryPerspective?: string | null, gaps?: Array<Record<string, any>> | null, alignments?: Array<Record<string, any>> | null, items: Array<{ __typename?: 'PerspectiveItem', viewpoint: string, observations: Array<string>, concerns: Array<string>, priorities: Array<string>, recommendations: Array<string>, confidence: number, metadata?: Record<string, any> | null, hiddenMessages: Array<string>, alignmentWithOthers: Record<string, any>, underlyingConcerns: Array<string>, trustIndicators: Record<string, any>, gaps: Array<Record<string, any>>, conflicts: Array<Record<string, any>> }> } | null, ideals?: { __typename?: 'IdealLayerResult', count: number, items: Array<{ __typename?: 'IdealItem', content: string, type: string, achievability: number, timeframe: string, currentGap?: string | null, requiredElements?: Array<string> | null, emotionalDrivers?: Array<string> | null, confidence: number }> } | null, metaPerspective?: { __typename?: 'MetaPerspectiveItem', surfaceAnalysis: Record<string, any>, fluctuationAnalysis: Record<string, any>, deepQuestions: Array<string>, hiddenNeeds: Array<string>, contextualInsights: Array<string>, creativeSolutions: Array<string>, confidence: number } | null, summary: { __typename?: 'AnalysisSummary', totalItemsExtracted: number, layersAnalyzed: Array<string>, keyFindings: Array<string> } } };

export type GetAnalyzeStakeholdersQueryVariables = Exact<{
  content: Scalars['String']['input'];
}>;


export type GetAnalyzeStakeholdersQuery = { __typename?: 'Query', analyzeStakeholders: { __typename?: 'StakeholderAnalysisResult', relationshipsGraph: Record<string, any>, recommendations: Array<string>, stakeholders: Array<{ __typename?: 'StakeholderProfile', id: string, name: string, type: string, role: string, resources: Record<string, any>, challenges: Array<string>, goals: Array<string>, capabilities: Array<string>, constraints: Array<string>, relationships: Array<string>, influenceLevel: number, interestLevel: number }>, perspectives: Array<{ __typename?: 'Perspective', name: string, role: string, type: string, concerns: Array<string>, interests: Array<string>, textEvidence: Array<string>, confidence: number }>, synergies: Array<{ __typename?: 'SynergyOpportunity', id: string, type: string, participants: Array<string>, description: string, mechanism: string, benefits: Record<string, any>, implementationSteps: Array<string>, feasibility: number, impact: number, risks: Array<string> }>, designInsights: Array<{ __typename?: 'DesignInsight', perspective: string, rationale: string, evidenceFromText: Array<string>, requirements: Array<Record<string, any>>, expectedImpact: string, priority: string, implementationNotes: string }> } };

export type GetAnalyzeBatchQueryVariables = Exact<{
  contents: Array<Scalars['String']['input']> | Scalars['String']['input'];
  options?: InputMaybe<AnalysisOptions>;
}>;


export type GetAnalyzeBatchQuery = { __typename?: 'Query', analyzeBatch: Array<{ __typename?: 'TextAnalysisResult', content: string, analyzedAt: string, crossLayerAnalysis?: Record<string, any> | null, processingTimeSeconds: number, confidence: number, facts?: { __typename?: 'FactLayerResult', count: number, items: Array<{ __typename?: 'FactItem', content: string, type: string, confidence: number, metadata?: Record<string, any> | null }> } | null, abstracts?: { __typename?: 'AbstractLayerResult', count: number, items: Array<{ __typename?: 'AbstractItem', content: string, type: string, importance: number, confidence: number, reasoning?: string | null }> } | null, emotions?: { __typename?: 'EmotionResult', count: number, overallSentiment?: Record<string, any> | null, teamMorale?: number | null, emotionalTrends?: Array<string> | null, items: Array<{ __typename?: 'EmotionItem', content: string, polarity: string, intensity: number, emotionType: string, designOpportunity?: string | null, confidence: number, subjectivity: number, empathy: number, motivation: number, culturalWeight: number, stressIndicator?: string | null, motivationFactor?: string | null, extractedIntent?: string | null }>, fluctuations?: Array<{ __typename?: 'EmotionFluctuationItem', surfaceEmotion: string, temporalPattern: string, intensityVariance: number, contextCoherence: number, underlyingPatterns: Array<Record<string, any>> }> | null } | null, perspectives?: { __typename?: 'PerspectiveResult', count: number, primaryPerspective?: string | null, gaps?: Array<Record<string, any>> | null, alignments?: Array<Record<string, any>> | null, items: Array<{ __typename?: 'PerspectiveItem', viewpoint: string, observations: Array<string>, concerns: Array<string>, priorities: Array<string>, recommendations: Array<string>, confidence: number, metadata?: Record<string, any> | null, hiddenMessages: Array<string>, alignmentWithOthers: Record<string, any>, underlyingConcerns: Array<string>, trustIndicators: Record<string, any>, gaps: Array<Record<string, any>>, conflicts: Array<Record<string, any>> }> } | null, ideals?: { __typename?: 'IdealLayerResult', count: number, items: Array<{ __typename?: 'IdealItem', content: string, type: string, achievability: number, timeframe: string, currentGap?: string | null, requiredElements?: Array<string> | null, emotionalDrivers?: Array<string> | null, confidence: number }> } | null, metaPerspective?: { __typename?: 'MetaPerspectiveItem', surfaceAnalysis: Record<string, any>, fluctuationAnalysis: Record<string, any>, deepQuestions: Array<string>, hiddenNeeds: Array<string>, contextualInsights: Array<string>, creativeSolutions: Array<string>, confidence: number } | null, summary: { __typename?: 'AnalysisSummary', totalItemsExtracted: number, layersAnalyzed: Array<string>, keyFindings: Array<string> } }> };

export type GetCompareTextsQueryVariables = Exact<{
  content1: Scalars['String']['input'];
  content2: Scalars['String']['input'];
  options?: InputMaybe<AnalysisOptions>;
}>;


export type GetCompareTextsQuery = { __typename?: 'Query', compareTexts: { __typename?: 'TextComparisonResult', analysis1: { __typename?: 'TextAnalysisResult', content: string, analyzedAt: string, crossLayerAnalysis?: Record<string, any> | null, processingTimeSeconds: number, confidence: number, facts?: { __typename?: 'FactLayerResult', count: number } | null, abstracts?: { __typename?: 'AbstractLayerResult', count: number } | null, emotions?: { __typename?: 'EmotionResult', count: number, overallSentiment?: Record<string, any> | null, teamMorale?: number | null, emotionalTrends?: Array<string> | null } | null, perspectives?: { __typename?: 'PerspectiveResult', count: number, primaryPerspective?: string | null, gaps?: Array<Record<string, any>> | null, alignments?: Array<Record<string, any>> | null } | null, ideals?: { __typename?: 'IdealLayerResult', count: number } | null, metaPerspective?: { __typename?: 'MetaPerspectiveItem', surfaceAnalysis: Record<string, any>, fluctuationAnalysis: Record<string, any>, deepQuestions: Array<string>, hiddenNeeds: Array<string>, contextualInsights: Array<string>, creativeSolutions: Array<string>, confidence: number } | null, summary: { __typename?: 'AnalysisSummary', totalItemsExtracted: number, layersAnalyzed: Array<string>, keyFindings: Array<string> } }, analysis2: { __typename?: 'TextAnalysisResult', content: string, analyzedAt: string, crossLayerAnalysis?: Record<string, any> | null, processingTimeSeconds: number, confidence: number, facts?: { __typename?: 'FactLayerResult', count: number } | null, abstracts?: { __typename?: 'AbstractLayerResult', count: number } | null, emotions?: { __typename?: 'EmotionResult', count: number, overallSentiment?: Record<string, any> | null, teamMorale?: number | null, emotionalTrends?: Array<string> | null } | null, perspectives?: { __typename?: 'PerspectiveResult', count: number, primaryPerspective?: string | null, gaps?: Array<Record<string, any>> | null, alignments?: Array<Record<string, any>> | null } | null, ideals?: { __typename?: 'IdealLayerResult', count: number } | null, metaPerspective?: { __typename?: 'MetaPerspectiveItem', surfaceAnalysis: Record<string, any>, fluctuationAnalysis: Record<string, any>, deepQuestions: Array<string>, hiddenNeeds: Array<string>, contextualInsights: Array<string>, creativeSolutions: Array<string>, confidence: number } | null, summary: { __typename?: 'AnalysisSummary', totalItemsExtracted: number, layersAnalyzed: Array<string>, keyFindings: Array<string> } }, comparison: { __typename?: 'ComparisonResult', emotionShift?: Record<string, any> | null, perspectiveAlignment?: Record<string, any> | null, factConsistency?: Record<string, any> | null, abstractSimilarity?: Record<string, any> | null } } };

export type GetContextAnalysisResultQueryVariables = Exact<{
  projectId: Scalars['UUID']['input'];
}>;


export type GetContextAnalysisResultQuery = { __typename?: 'Query', contextAnalysisResult?: { __typename?: 'TextAnalysisResult', content: string, analyzedAt: string, crossLayerAnalysis?: Record<string, any> | null, processingTimeSeconds: number, confidence: number, facts?: { __typename?: 'FactLayerResult', count: number, items: Array<{ __typename?: 'FactItem', content: string, type: string, confidence: number, metadata?: Record<string, any> | null }> } | null, abstracts?: { __typename?: 'AbstractLayerResult', count: number, items: Array<{ __typename?: 'AbstractItem', content: string, type: string, importance: number, confidence: number, reasoning?: string | null }> } | null, emotions?: { __typename?: 'EmotionResult', count: number, overallSentiment?: Record<string, any> | null, teamMorale?: number | null, emotionalTrends?: Array<string> | null, items: Array<{ __typename?: 'EmotionItem', content: string, polarity: string, intensity: number, emotionType: string, designOpportunity?: string | null, confidence: number, subjectivity: number, empathy: number, motivation: number, culturalWeight: number, stressIndicator?: string | null, motivationFactor?: string | null, extractedIntent?: string | null }>, fluctuations?: Array<{ __typename?: 'EmotionFluctuationItem', surfaceEmotion: string, temporalPattern: string, intensityVariance: number, contextCoherence: number, underlyingPatterns: Array<Record<string, any>> }> | null } | null, perspectives?: { __typename?: 'PerspectiveResult', count: number, primaryPerspective?: string | null, gaps?: Array<Record<string, any>> | null, alignments?: Array<Record<string, any>> | null, items: Array<{ __typename?: 'PerspectiveItem', viewpoint: string, observations: Array<string>, concerns: Array<string>, priorities: Array<string>, recommendations: Array<string>, confidence: number, metadata?: Record<string, any> | null, hiddenMessages: Array<string>, alignmentWithOthers: Record<string, any>, underlyingConcerns: Array<string>, trustIndicators: Record<string, any>, gaps: Array<Record<string, any>>, conflicts: Array<Record<string, any>> }> } | null, ideals?: { __typename?: 'IdealLayerResult', count: number, items: Array<{ __typename?: 'IdealItem', content: string, type: string, achievability: number, timeframe: string, currentGap?: string | null, requiredElements?: Array<string> | null, emotionalDrivers?: Array<string> | null, confidence: number }> } | null, metaPerspective?: { __typename?: 'MetaPerspectiveItem', surfaceAnalysis: Record<string, any>, fluctuationAnalysis: Record<string, any>, deepQuestions: Array<string>, hiddenNeeds: Array<string>, contextualInsights: Array<string>, creativeSolutions: Array<string>, confidence: number } | null, summary: { __typename?: 'AnalysisSummary', totalItemsExtracted: number, layersAnalyzed: Array<string>, keyFindings: Array<string> } } | null };

export type GetApiCatalogsQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetApiCatalogsQuery = { __typename?: 'Query', apiCatalogs: Array<{ __typename?: 'ApiCatalogType', id: string, organizationId: string, projectId?: string | null, serviceName: string, provider: string, apiVersion?: string | null, crawlStatus: CrawlStatusEnum, crawlError?: string | null, crawlStartedAt?: string | null, crawlCompletedAt?: string | null, implementationKnowledge?: Record<string, any> | null, groundingSources: Array<string>, documentationUrls: Array<string>, endpointCount: number, createdAt: string, updatedAt: string, apiOverview: { __typename?: 'ApiOverviewType', baseUrl: string, authType: string, authDetails: string, rateLimits: string, description: string }, endpoints: Array<{ __typename?: 'ApiEndpointType', method: string, path: string, description: string, parameters?: Record<string, any> | null, requestBody?: Record<string, any> | null, responseSchema?: Record<string, any> | null, authRequired: boolean, deprecated: boolean }>, verification?: { __typename?: 'VerificationResultType', status: string, confidenceScore: number, baseUrlVerified: boolean, baseUrlCorrect: string, authTypeVerified: boolean, authTypeCorrect: string, verificationSources: Array<string>, errorMessage: string, verifiedAt?: string | null, endpointVerdicts: Array<{ __typename?: 'EndpointVerdictType', method: string, path: string, exists: boolean, notes: string }> } | null }> };

export type GetApiCatalogQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetApiCatalogQuery = { __typename?: 'Query', apiCatalog?: { __typename?: 'ApiCatalogType', id: string, organizationId: string, projectId?: string | null, serviceName: string, provider: string, apiVersion?: string | null, crawlStatus: CrawlStatusEnum, crawlError?: string | null, crawlStartedAt?: string | null, crawlCompletedAt?: string | null, implementationKnowledge?: Record<string, any> | null, groundingSources: Array<string>, documentationUrls: Array<string>, endpointCount: number, createdAt: string, updatedAt: string, apiOverview: { __typename?: 'ApiOverviewType', baseUrl: string, authType: string, authDetails: string, rateLimits: string, description: string }, endpoints: Array<{ __typename?: 'ApiEndpointType', method: string, path: string, description: string, parameters?: Record<string, any> | null, requestBody?: Record<string, any> | null, responseSchema?: Record<string, any> | null, authRequired: boolean, deprecated: boolean }>, verification?: { __typename?: 'VerificationResultType', status: string, confidenceScore: number, baseUrlVerified: boolean, baseUrlCorrect: string, authTypeVerified: boolean, authTypeCorrect: string, verificationSources: Array<string>, errorMessage: string, verifiedAt?: string | null, endpointVerdicts: Array<{ __typename?: 'EndpointVerdictType', method: string, path: string, exists: boolean, notes: string }> } | null } | null };

export type RequestApiCrawlMutationVariables = Exact<{
  input: RequestApiCrawlInput;
}>;


export type RequestApiCrawlMutation = { __typename?: 'Mutation', requestApiCrawl: { __typename?: 'CrawlRequestResult', catalogId: string, taskId: string } };

export type RetryApiCrawlMutationVariables = Exact<{
  catalogId: Scalars['UUID']['input'];
  documentationUrls?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type RetryApiCrawlMutation = { __typename?: 'Mutation', retryApiCrawl: { __typename?: 'CrawlRequestResult', catalogId: string, taskId: string } };

export type DeleteApiCatalogMutationVariables = Exact<{
  catalogId: Scalars['UUID']['input'];
}>;


export type DeleteApiCatalogMutation = { __typename?: 'Mutation', deleteApiCatalog: boolean };

export type CreateAtomMutationVariables = Exact<{
  input: CreateAtomInput;
}>;


export type CreateAtomMutation = { __typename?: 'Mutation', createAtom: { __typename?: 'AtomBaseType', id: string, title: string, fullContent?: string | null, contentFormat: string, sourceType: string, sourceId?: string | null, filePath?: string | null, fileType?: string | null, fileSize?: number | null, status: AtomStatusType, processingError?: string | null, processingProgress?: number | null, processedAt?: string | null, atomType: AtomTypeType, category?: string | null, tags: Array<string>, organizationId: string, clientId?: string | null, projectId?: string | null, industryId?: string | null, metaInfo?: Record<string, any> | null, isVectorized: boolean, embeddingModel?: string | null, viewCount: number, usageCount: number, qualityScore?: number | null, lastUsedAt?: string | null, createdBy: string, updatedBy?: string | null, createdAt: string, updatedAt: string } };

export type UpdateAtomMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: UpdateAtomInput;
}>;


export type UpdateAtomMutation = { __typename?: 'Mutation', updateAtom?: { __typename?: 'AtomBaseType', id: string, title: string, fullContent?: string | null, contentFormat: string, sourceType: string, sourceId?: string | null, filePath?: string | null, fileType?: string | null, fileSize?: number | null, status: AtomStatusType, processingError?: string | null, processingProgress?: number | null, processedAt?: string | null, atomType: AtomTypeType, category?: string | null, tags: Array<string>, organizationId: string, clientId?: string | null, projectId?: string | null, industryId?: string | null, metaInfo?: Record<string, any> | null, isVectorized: boolean, embeddingModel?: string | null, viewCount: number, usageCount: number, qualityScore?: number | null, lastUsedAt?: string | null, createdBy: string, updatedBy?: string | null, createdAt: string, updatedAt: string } | null };

export type DeleteAtomMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteAtomMutation = { __typename?: 'Mutation', deleteAtom: boolean };

export type StartAtomProcessingMutationVariables = Exact<{
  atomId: Scalars['UUID']['input'];
  taskId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type StartAtomProcessingMutation = { __typename?: 'Mutation', startAtomProcessing: boolean };

export type UpdateAtomProgressMutationVariables = Exact<{
  atomId: Scalars['UUID']['input'];
  percentage: Scalars['Float']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateAtomProgressMutation = { __typename?: 'Mutation', updateAtomProgress: boolean };

export type CompleteAtomProcessingMutationVariables = Exact<{
  atomId: Scalars['UUID']['input'];
  extractedContent?: InputMaybe<Scalars['String']['input']>;
  extractedTags?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  processingTimeMs?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CompleteAtomProcessingMutation = { __typename?: 'Mutation', completeAtomProcessing: boolean };

export type FailAtomProcessingMutationVariables = Exact<{
  atomId: Scalars['UUID']['input'];
  errorMessage: Scalars['String']['input'];
  errorCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type FailAtomProcessingMutation = { __typename?: 'Mutation', failAtomProcessing: boolean };

export type RetryAtomProcessingMutationVariables = Exact<{
  atomId: Scalars['UUID']['input'];
}>;


export type RetryAtomProcessingMutation = { __typename?: 'Mutation', retryAtomProcessing: boolean };

export type RetryFailedAtomMutationVariables = Exact<{
  atomId: Scalars['UUID']['input'];
}>;


export type RetryFailedAtomMutation = { __typename?: 'Mutation', retryFailedAtom: { __typename?: 'AtomProcessingResult', success: boolean, errorMessage?: string | null, processingTimeMs?: number | null, extractedMetadata?: Record<string, any> | null, taskId?: string | null, atom?: { __typename?: 'AtomBaseType', id: string, title: string, fullContent?: string | null, contentFormat: string, sourceType: string, sourceId?: string | null, filePath?: string | null, fileType?: string | null, fileSize?: number | null, status: AtomStatusType, processingError?: string | null, processingProgress?: number | null, processedAt?: string | null, atomType: AtomTypeType, category?: string | null, tags: Array<string>, organizationId: string, clientId?: string | null, projectId?: string | null, industryId?: string | null, metaInfo?: Record<string, any> | null, isVectorized: boolean, embeddingModel?: string | null, viewCount: number, usageCount: number, qualityScore?: number | null, lastUsedAt?: string | null, createdBy: string, updatedBy?: string | null, createdAt: string, updatedAt: string } | null } };

export type MarkAtomVectorizedMutationVariables = Exact<{
  atomId: Scalars['UUID']['input'];
  embeddingModel: Scalars['String']['input'];
  vectorDimension: Scalars['Int']['input'];
  processingTimeMs?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MarkAtomVectorizedMutation = { __typename?: 'Mutation', markAtomVectorized: boolean };

export type CreateAtomFromSourceMutationVariables = Exact<{
  input: CreateAtomFromSourceInput;
}>;


export type CreateAtomFromSourceMutation = { __typename?: 'Mutation', createAtomFromSource: { __typename?: 'AtomProcessingResult', success: boolean, errorMessage?: string | null, processingTimeMs?: number | null, extractedMetadata?: Record<string, any> | null, taskId?: string | null, atom?: { __typename?: 'AtomBaseType', id: string, title: string, fullContent?: string | null, contentFormat: string, sourceType: string, sourceId?: string | null, filePath?: string | null, fileType?: string | null, fileSize?: number | null, status: AtomStatusType, processingError?: string | null, processingProgress?: number | null, processedAt?: string | null, atomType: AtomTypeType, category?: string | null, tags: Array<string>, organizationId: string, clientId?: string | null, projectId?: string | null, industryId?: string | null, metaInfo?: Record<string, any> | null, isVectorized: boolean, embeddingModel?: string | null, viewCount: number, usageCount: number, qualityScore?: number | null, lastUsedAt?: string | null, createdBy: string, updatedBy?: string | null, createdAt: string, updatedAt: string } | null } };

export type CreateIndustryDddMutationVariables = Exact<{
  input: CreateIndustryInput;
}>;


export type CreateIndustryDddMutation = { __typename?: 'Mutation', createIndustryDdd: { __typename?: 'IndustryType', id: string, name: string, code: string, description?: string | null, isActive: boolean, icon?: string | null, industryProfile: Record<string, any>, metadata: Record<string, any>, createdAt: string, updatedAt: string, organizationUuid?: string | null } };

export type UpdateIndustryDddMutationVariables = Exact<{
  input: UpdateIndustryInput;
}>;


export type UpdateIndustryDddMutation = { __typename?: 'Mutation', updateIndustryDdd?: { __typename?: 'IndustryType', id: string, name: string, code: string, description?: string | null, isActive: boolean, icon?: string | null, industryProfile: Record<string, any>, metadata: Record<string, any>, createdAt: string, updatedAt: string, organizationUuid?: string | null } | null };

export type ActivateIndustryDddMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ActivateIndustryDddMutation = { __typename?: 'Mutation', activateIndustryDdd?: { __typename?: 'IndustryType', id: string, name: string, code: string, description?: string | null, isActive: boolean, icon?: string | null, industryProfile: Record<string, any>, metadata: Record<string, any>, createdAt: string, updatedAt: string, organizationUuid?: string | null } | null };

export type DeactivateIndustryDddMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeactivateIndustryDddMutation = { __typename?: 'Mutation', deactivateIndustryDdd?: { __typename?: 'IndustryType', id: string, name: string, code: string, description?: string | null, isActive: boolean, icon?: string | null, industryProfile: Record<string, any>, metadata: Record<string, any>, createdAt: string, updatedAt: string, organizationUuid?: string | null } | null };

export type DeleteIndustryDddMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteIndustryDddMutation = { __typename?: 'Mutation', deleteIndustryDdd: boolean };

export type CreateIndustryMutationVariables = Exact<{
  input: CreateIndustryInput;
}>;


export type CreateIndustryMutation = { __typename?: 'Mutation', createIndustry: { __typename?: 'IndustryType', id: string, name: string, code: string, description?: string | null, isActive: boolean, icon?: string | null, industryProfile: Record<string, any>, metadata: Record<string, any>, createdAt: string, updatedAt: string, organizationUuid?: string | null } };

export type UpdateIndustryMutationVariables = Exact<{
  input: UpdateIndustryInput;
}>;


export type UpdateIndustryMutation = { __typename?: 'Mutation', updateIndustry?: { __typename?: 'IndustryType', id: string, name: string, code: string, description?: string | null, isActive: boolean, icon?: string | null, industryProfile: Record<string, any>, metadata: Record<string, any>, createdAt: string, updatedAt: string, organizationUuid?: string | null } | null };

export type ActivateIndustryMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ActivateIndustryMutation = { __typename?: 'Mutation', activateIndustry?: { __typename?: 'IndustryType', id: string, name: string, code: string, description?: string | null, isActive: boolean, icon?: string | null, industryProfile: Record<string, any>, metadata: Record<string, any>, createdAt: string, updatedAt: string, organizationUuid?: string | null } | null };

export type DeactivateIndustryMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeactivateIndustryMutation = { __typename?: 'Mutation', deactivateIndustry?: { __typename?: 'IndustryType', id: string, name: string, code: string, description?: string | null, isActive: boolean, icon?: string | null, industryProfile: Record<string, any>, metadata: Record<string, any>, createdAt: string, updatedAt: string, organizationUuid?: string | null } | null };

export type DeleteIndustryMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteIndustryMutation = { __typename?: 'Mutation', deleteIndustry: boolean };

export type CreateIndustryCategoryMutationVariables = Exact<{
  input: IndustryCategoryCreateInput;
}>;


export type CreateIndustryCategoryMutation = { __typename?: 'Mutation', createIndustryCategory: { __typename?: 'CategoryMutationResponse', success: boolean, message: string, category?: { __typename?: 'IndustryCategory', id: string, name: string, code: string, parentId?: string | null, displayOrder: number, subcategories: Array<{ __typename?: 'IndustryCategory', id: string, name: string, code: string, parentId?: string | null, displayOrder: number }> } | null } };

export type UpdateIndustryCategoryMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: IndustryCategoryUpdateInput;
}>;


export type UpdateIndustryCategoryMutation = { __typename?: 'Mutation', updateIndustryCategory: { __typename?: 'CategoryMutationResponse', success: boolean, message: string, category?: { __typename?: 'IndustryCategory', id: string, name: string, code: string, parentId?: string | null, displayOrder: number, subcategories: Array<{ __typename?: 'IndustryCategory', id: string, name: string, code: string, parentId?: string | null, displayOrder: number }> } | null } };

export type DeleteIndustryCategoryMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteIndustryCategoryMutation = { __typename?: 'Mutation', deleteIndustryCategory: { __typename?: 'CategoryMutationResponse', success: boolean, message: string, category?: { __typename?: 'IndustryCategory', id: string, name: string, code: string, parentId?: string | null, displayOrder: number, subcategories: Array<{ __typename?: 'IndustryCategory', id: string, name: string, code: string, parentId?: string | null, displayOrder: number }> } | null } };

export type AttachPluginToIndustryMutationVariables = Exact<{
  industryId: Scalars['UUID']['input'];
  pluginId: Scalars['UUID']['input'];
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  priority?: Scalars['Int']['input'];
}>;


export type AttachPluginToIndustryMutation = { __typename?: 'Mutation', attachPluginToIndustry: { __typename?: 'IndustryMutationResponse', success: boolean, message: string, industry?: { __typename?: 'Industry', id: string, name: string, code: string, description?: string | null, icon?: string | null, isActive: boolean, industryProfile: Record<string, any>, hasProfileData: boolean, categories: Array<{ __typename?: 'IndustryCategory', id: string, name: string, code: string, parentId?: string | null, displayOrder: number }> } | null } };

export type CreateAtomSourceMutationVariables = Exact<{
  input: CreateAtomSourceInput;
}>;


export type CreateAtomSourceMutation = { __typename?: 'Mutation', createAtomSource: { __typename?: 'AtomSourceMutationResponse', success: boolean, message: string, source?: { __typename?: 'AtomSourceGQL', id: string, organizationId: string, entityType: AtomSourceEntityTypeEnum, entityId: string, sourceType: SourceTypeEnum, sourceName: string, sourceUrl: string, sourceConfig: Record<string, any>, isActive: boolean, collectionFrequency: CollectionFrequencyEnum, lastCollectedAt?: string | null, nextCollectionAt?: string | null, contentFilters: Record<string, any>, languageCode: string, status: AtomSourceStatusEnum, metadata: Record<string, any>, createdAt: string, updatedAt: string } | null } };

export type UpdateAtomSourceMutationVariables = Exact<{
  input: UpdateAtomSourceInput;
}>;


export type UpdateAtomSourceMutation = { __typename?: 'Mutation', updateAtomSource: { __typename?: 'AtomSourceMutationResponse', success: boolean, message: string, source?: { __typename?: 'AtomSourceGQL', id: string, organizationId: string, entityType: AtomSourceEntityTypeEnum, entityId: string, sourceType: SourceTypeEnum, sourceName: string, sourceUrl: string, sourceConfig: Record<string, any>, isActive: boolean, collectionFrequency: CollectionFrequencyEnum, lastCollectedAt?: string | null, nextCollectionAt?: string | null, contentFilters: Record<string, any>, languageCode: string, status: AtomSourceStatusEnum, metadata: Record<string, any>, createdAt: string, updatedAt: string } | null } };

export type ActivateAtomSourceMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ActivateAtomSourceMutation = { __typename?: 'Mutation', activateAtomSource: { __typename?: 'AtomSourceMutationResponse', success: boolean, message: string, source?: { __typename?: 'AtomSourceGQL', id: string, organizationId: string, entityType: AtomSourceEntityTypeEnum, entityId: string, sourceType: SourceTypeEnum, sourceName: string, sourceUrl: string, sourceConfig: Record<string, any>, isActive: boolean, collectionFrequency: CollectionFrequencyEnum, lastCollectedAt?: string | null, nextCollectionAt?: string | null, contentFilters: Record<string, any>, languageCode: string, status: AtomSourceStatusEnum, metadata: Record<string, any>, createdAt: string, updatedAt: string } | null } };

export type DeactivateAtomSourceMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeactivateAtomSourceMutation = { __typename?: 'Mutation', deactivateAtomSource: { __typename?: 'AtomSourceMutationResponse', success: boolean, message: string, source?: { __typename?: 'AtomSourceGQL', id: string, organizationId: string, entityType: AtomSourceEntityTypeEnum, entityId: string, sourceType: SourceTypeEnum, sourceName: string, sourceUrl: string, sourceConfig: Record<string, any>, isActive: boolean, collectionFrequency: CollectionFrequencyEnum, lastCollectedAt?: string | null, nextCollectionAt?: string | null, contentFilters: Record<string, any>, languageCode: string, status: AtomSourceStatusEnum, metadata: Record<string, any>, createdAt: string, updatedAt: string } | null } };

export type DeleteAtomSourceMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteAtomSourceMutation = { __typename?: 'Mutation', deleteAtomSource: { __typename?: 'AtomSourceMutationResponse', success: boolean, message: string, source?: { __typename?: 'AtomSourceGQL', id: string, organizationId: string, entityType: AtomSourceEntityTypeEnum, entityId: string, sourceType: SourceTypeEnum, sourceName: string, sourceUrl: string, sourceConfig: Record<string, any>, isActive: boolean, collectionFrequency: CollectionFrequencyEnum, lastCollectedAt?: string | null, nextCollectionAt?: string | null, contentFilters: Record<string, any>, languageCode: string, status: AtomSourceStatusEnum, metadata: Record<string, any>, createdAt: string, updatedAt: string } | null } };

export type TriggerAtomCollectionMutationVariables = Exact<{
  sourceId: Scalars['UUID']['input'];
  maxItems?: Scalars['Int']['input'];
}>;


export type TriggerAtomCollectionMutation = { __typename?: 'Mutation', triggerAtomCollection: { __typename?: 'AtomSourceMutationResponse', success: boolean, message: string, source?: { __typename?: 'AtomSourceGQL', id: string, organizationId: string, entityType: AtomSourceEntityTypeEnum, entityId: string, sourceType: SourceTypeEnum, sourceName: string, sourceUrl: string, sourceConfig: Record<string, any>, isActive: boolean, collectionFrequency: CollectionFrequencyEnum, lastCollectedAt?: string | null, nextCollectionAt?: string | null, contentFilters: Record<string, any>, languageCode: string, status: AtomSourceStatusEnum, metadata: Record<string, any>, createdAt: string, updatedAt: string } | null } };

export type GetAtomQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetAtomQuery = { __typename?: 'Query', atom?: { __typename?: 'AtomBaseType', id: string, title: string, fullContent?: string | null, contentFormat: string, sourceType: string, sourceId?: string | null, filePath?: string | null, fileType?: string | null, fileSize?: number | null, status: AtomStatusType, processingError?: string | null, processingProgress?: number | null, processedAt?: string | null, atomType: AtomTypeType, category?: string | null, tags: Array<string>, organizationId: string, clientId?: string | null, projectId?: string | null, industryId?: string | null, metaInfo?: Record<string, any> | null, isVectorized: boolean, embeddingModel?: string | null, viewCount: number, usageCount: number, qualityScore?: number | null, lastUsedAt?: string | null, createdBy: string, updatedBy?: string | null, createdAt: string, updatedAt: string } | null };

export type GetAtomsQueryVariables = Exact<{
  filter?: InputMaybe<AtomFilterInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
}>;


export type GetAtomsQuery = { __typename?: 'Query', atoms: { __typename?: 'AtomConnection', totalCount: number, edges: Array<{ __typename?: 'AtomEdge', cursor: string, node: { __typename?: 'AtomBaseType', id: string, title: string, fullContent?: string | null, contentFormat: string, sourceType: string, sourceId?: string | null, filePath?: string | null, fileType?: string | null, fileSize?: number | null, status: AtomStatusType, processingError?: string | null, processingProgress?: number | null, processedAt?: string | null, atomType: AtomTypeType, category?: string | null, tags: Array<string>, organizationId: string, clientId?: string | null, projectId?: string | null, industryId?: string | null, metaInfo?: Record<string, any> | null, isVectorized: boolean, embeddingModel?: string | null, viewCount: number, usageCount: number, qualityScore?: number | null, lastUsedAt?: string | null, createdBy: string, updatedBy?: string | null, createdAt: string, updatedAt: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type SearchAtomsQueryVariables = Exact<{
  query: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  atomType?: InputMaybe<AtomTypeType>;
  limit?: Scalars['Int']['input'];
}>;


export type SearchAtomsQuery = { __typename?: 'Query', searchAtoms: Array<{ __typename?: 'AtomBaseType', id: string, title: string, fullContent?: string | null, contentFormat: string, sourceType: string, sourceId?: string | null, filePath?: string | null, fileType?: string | null, fileSize?: number | null, status: AtomStatusType, processingError?: string | null, processingProgress?: number | null, processedAt?: string | null, atomType: AtomTypeType, category?: string | null, tags: Array<string>, organizationId: string, clientId?: string | null, projectId?: string | null, industryId?: string | null, metaInfo?: Record<string, any> | null, isVectorized: boolean, embeddingModel?: string | null, viewCount: number, usageCount: number, qualityScore?: number | null, lastUsedAt?: string | null, createdBy: string, updatedBy?: string | null, createdAt: string, updatedAt: string }> };

export type GetAtomStatsQueryVariables = Exact<{
  organizationId: Scalars['UUID']['input'];
}>;


export type GetAtomStatsQuery = { __typename?: 'Query', atomStats: Record<string, any> };

export type GetPendingAtomsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  limit?: Scalars['Int']['input'];
}>;


export type GetPendingAtomsQuery = { __typename?: 'Query', pendingAtoms: Array<{ __typename?: 'AtomBaseType', id: string, title: string, fullContent?: string | null, contentFormat: string, sourceType: string, sourceId?: string | null, filePath?: string | null, fileType?: string | null, fileSize?: number | null, status: AtomStatusType, processingError?: string | null, processingProgress?: number | null, processedAt?: string | null, atomType: AtomTypeType, category?: string | null, tags: Array<string>, organizationId: string, clientId?: string | null, projectId?: string | null, industryId?: string | null, metaInfo?: Record<string, any> | null, isVectorized: boolean, embeddingModel?: string | null, viewCount: number, usageCount: number, qualityScore?: number | null, lastUsedAt?: string | null, createdBy: string, updatedBy?: string | null, createdAt: string, updatedAt: string }> };

export type GetAtomTaskStatusQueryVariables = Exact<{
  atomId: Scalars['UUID']['input'];
}>;


export type GetAtomTaskStatusQuery = { __typename?: 'Query', atomTaskStatus?: { __typename?: 'AtomTaskStatus', atomId: string, taskId?: string | null, status: string, progress?: number | null, errorMessage?: string | null, updatedAt?: string | null, taskResult?: Record<string, any> | null } | null };

export type GetIndustryDddQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetIndustryDddQuery = { __typename?: 'Query', industryDdd?: { __typename?: 'IndustryType', id: string, name: string, code: string, description?: string | null, isActive: boolean, icon?: string | null, industryProfile: Record<string, any>, metadata: Record<string, any>, createdAt: string, updatedAt: string, organizationUuid?: string | null } | null };

export type GetIndustryByCodeDddQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type GetIndustryByCodeDddQuery = { __typename?: 'Query', industryByCodeDdd?: { __typename?: 'IndustryType', id: string, name: string, code: string, description?: string | null, isActive: boolean, icon?: string | null, industryProfile: Record<string, any>, metadata: Record<string, any>, createdAt: string, updatedAt: string, organizationUuid?: string | null } | null };

export type GetIndustriesDddQueryVariables = Exact<{
  filter?: InputMaybe<IndustryFilterInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
}>;


export type GetIndustriesDddQuery = { __typename?: 'Query', industriesDdd: { __typename?: 'IndustryConnection', totalCount: number, edges: Array<{ __typename?: 'IndustryEdge', cursor: string, node: { __typename?: 'IndustryType', id: string, name: string, code: string, description?: string | null, isActive: boolean, icon?: string | null, industryProfile: Record<string, any>, metadata: Record<string, any>, createdAt: string, updatedAt: string, organizationUuid?: string | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetIndustriesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
}>;


export type GetIndustriesQuery = { __typename?: 'Query', industries: Array<{ __typename?: 'Industry', id: string, name: string, code: string, description?: string | null, icon?: string | null, isActive: boolean, industryProfile: Record<string, any>, hasProfileData: boolean, categories: Array<{ __typename?: 'IndustryCategory', id: string, name: string, code: string, parentId?: string | null, displayOrder: number, subcategories: Array<{ __typename?: 'IndustryCategory', id: string, name: string, code: string, parentId?: string | null, displayOrder: number }> }> }> };

export type GetIndustryQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetIndustryQuery = { __typename?: 'Query', industry?: { __typename?: 'Industry', id: string, name: string, code: string, description?: string | null, icon?: string | null, isActive: boolean, industryProfile: Record<string, any>, hasProfileData: boolean, categories: Array<{ __typename?: 'IndustryCategory', id: string, name: string, code: string, parentId?: string | null, displayOrder: number, subcategories: Array<{ __typename?: 'IndustryCategory', id: string, name: string, code: string, parentId?: string | null, displayOrder: number }> }> } | null };

export type GetIndustryByCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type GetIndustryByCodeQuery = { __typename?: 'Query', industryByCode?: { __typename?: 'Industry', id: string, name: string, code: string, description?: string | null, icon?: string | null, isActive: boolean, industryProfile: Record<string, any>, hasProfileData: boolean, categories: Array<{ __typename?: 'IndustryCategory', id: string, name: string, code: string, parentId?: string | null, displayOrder: number, subcategories: Array<{ __typename?: 'IndustryCategory', id: string, name: string, code: string, parentId?: string | null, displayOrder: number }> }> } | null };

export type GetIndustryCategoriesQueryVariables = Exact<{
  parentId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetIndustryCategoriesQuery = { __typename?: 'Query', industryCategories: Array<{ __typename?: 'IndustryCategory', id: string, name: string, code: string, parentId?: string | null, displayOrder: number, subcategories: Array<{ __typename?: 'IndustryCategory', id: string, name: string, code: string, parentId?: string | null, displayOrder: number, subcategories: Array<{ __typename?: 'IndustryCategory', id: string, name: string, code: string, parentId?: string | null, displayOrder: number }> }> }> };

export type GetIndustryStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIndustryStatsQuery = { __typename?: 'Query', industryStats: { __typename?: 'IndustryStatsType', totalIndustries: number, activeIndustries: number, inactiveIndustries: number } };

export type GetIndustryStatsDddQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIndustryStatsDddQuery = { __typename?: 'Query', industryStatsDdd: { __typename?: 'IndustryStatsType', totalIndustries: number, activeIndustries: number, inactiveIndustries: number } };

export type GetAtomSourceQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetAtomSourceQuery = { __typename?: 'Query', atomSource?: { __typename?: 'AtomSourceGQL', id: string, organizationId: string, entityType: AtomSourceEntityTypeEnum, entityId: string, sourceType: SourceTypeEnum, sourceName: string, sourceUrl: string, sourceConfig: Record<string, any>, isActive: boolean, collectionFrequency: CollectionFrequencyEnum, lastCollectedAt?: string | null, nextCollectionAt?: string | null, contentFilters: Record<string, any>, languageCode: string, status: AtomSourceStatusEnum, metadata: Record<string, any>, createdAt: string, updatedAt: string } | null };

export type GetAtomSourcesQueryVariables = Exact<{
  entityType?: InputMaybe<AtomSourceEntityTypeEnum>;
  entityId?: InputMaybe<Scalars['UUID']['input']>;
  filter?: InputMaybe<AtomSourceFilterInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
}>;


export type GetAtomSourcesQuery = { __typename?: 'Query', atomSources: { __typename?: 'AtomSourceListGQL', totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean, sources: Array<{ __typename?: 'AtomSourceGQL', id: string, organizationId: string, entityType: AtomSourceEntityTypeEnum, entityId: string, sourceType: SourceTypeEnum, sourceName: string, sourceUrl: string, sourceConfig: Record<string, any>, isActive: boolean, collectionFrequency: CollectionFrequencyEnum, lastCollectedAt?: string | null, nextCollectionAt?: string | null, contentFilters: Record<string, any>, languageCode: string, status: AtomSourceStatusEnum, metadata: Record<string, any>, createdAt: string, updatedAt: string }> } };

export type GetAtomSourceStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAtomSourceStatsQuery = { __typename?: 'Query', atomSourceStats: { __typename?: 'AtomSourceStatsGQL', totalSources: number, activeSources: number, inactiveSources: number, errorSources: number, byEntityType: Record<string, any>, bySourceType: Record<string, any> } };

export type AutoRegisterClientMutationVariables = Exact<{
  input: AutoRegisterClientInput;
}>;


export type AutoRegisterClientMutation = { __typename?: 'Mutation', autoRegisterClient: { __typename?: 'ClientType', id: string, name: string, description?: string | null, organizationId: string, createdBy: string, industryId?: string | null, industryName?: string | null, clientType?: ClientTypeEnum | null, size?: ClientSizeType | null, website?: string | null, contactEmail?: string | null, contactName?: string | null, contactPhone?: string | null, isActive: boolean, totalLifetimeValue?: number | null, createdAt: string, updatedAt: string, metadata?: Record<string, any> | null, corporateNumber?: string | null, nameKana?: string | null, nameEnglish?: string | null, postalCode?: string | null, prefecture?: string | null, city?: string | null, streetAddress?: string | null, addressOutside?: string | null, corporateStatus?: string | null, corporateUpdateDate?: string | null, corporateCloseDate?: string | null, isAutoRegistered: boolean, dataQualityScore?: number | null, parentId?: string | null, projectCount: number, hasActiveProjects: boolean, displaySize: string, isEnterprise: boolean, fullAddress?: string | null, corporateStatusDisplay?: string | null, industry?: { __typename?: 'Industry', id: string, name: string, code: string } | null } };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginResponse', success: boolean, message: string, csrfToken?: string | null, user?: { __typename?: 'AuthUser', id: string, email: string, username?: string | null, displayName: string, isActive: boolean, isSuperuser: boolean, organizationId?: string | null, organizationRole?: string | null, organizationName?: string | null, createdAt?: string | null, updatedAt?: string | null } | null } };

export type LoginJwtMutationVariables = Exact<{
  input: JwtLoginInput;
}>;


export type LoginJwtMutation = { __typename?: 'Mutation', loginJwt: { __typename?: 'JWTTokenResponse', accessToken: string, tokenType: string, expiresIn: number, refreshToken?: string | null, scope?: string | null, idToken?: string | null } };

export type RefreshTokenMutationVariables = Exact<{
  input: RefreshTokenInput;
}>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshToken: { __typename?: 'JWTTokenResponse', accessToken: string, tokenType: string, expiresIn: number, refreshToken?: string | null, scope?: string | null, idToken?: string | null } };

export type RequestTokenMutationVariables = Exact<{
  input: TokenRequestInput;
}>;


export type RequestTokenMutation = { __typename?: 'Mutation', requestToken: { __typename?: 'JWTTokenResponse', accessToken: string, tokenType: string, expiresIn: number, refreshToken?: string | null, scope?: string | null, idToken?: string | null } };

export type RevokeTokenMutationVariables = Exact<{
  input: TokenRevocationInput;
}>;


export type RevokeTokenMutation = { __typename?: 'Mutation', revokeToken: { __typename?: 'TokenRevocationResponse', success: boolean, message: string } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: { __typename?: 'LogoutResponse', success: boolean, message: string } };

export type VerifyEmailWithTokenMutationVariables = Exact<{
  input: VerifyEmailInput;
}>;


export type VerifyEmailWithTokenMutation = { __typename?: 'Mutation', verifyEmailWithToken: { __typename?: 'EmailVerificationResponse', success: boolean, message: string } };

export type ResetPasswordWithTokenMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordWithTokenMutation = { __typename?: 'Mutation', resetPasswordWithToken: { __typename?: 'PasswordResetResponse', success: boolean, message: string } };

export type SetSystemInstanceGithubTokenMutationVariables = Exact<{
  input: SetSystemInstanceGithubTokenInput;
}>;


export type SetSystemInstanceGithubTokenMutation = { __typename?: 'Mutation', setSystemInstanceGithubToken: { __typename?: 'SetGithubTokenResult', success: boolean, hasToken: boolean, errorMessage?: string | null } };

export type GetSessionInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSessionInfoQuery = { __typename?: 'Query', sessionInfo?: { __typename?: 'SessionInfo', sessionId: string, createdAt: string, lastActivity: string, userId: string, authenticated: boolean, csrfToken?: string | null } | null };

export type GetIntrospectTokenQueryVariables = Exact<{
  input: TokenIntrospectionInput;
}>;


export type GetIntrospectTokenQuery = { __typename?: 'Query', introspectToken: { __typename?: 'TokenIntrospectionResponse', active: boolean, scope?: string | null, clientId?: string | null, username?: string | null, exp?: number | null, iat?: number | null, sub?: string | null, aud?: Array<string> | null, iss?: string | null, jti?: string | null, tokenType?: string | null } };

export type CreateClientMutationVariables = Exact<{
  input: CreateClientInput;
}>;


export type CreateClientMutation = { __typename?: 'Mutation', createClient: { __typename?: 'ClientType', id: string, name: string, description?: string | null, organizationId: string, createdBy: string, industryId?: string | null, industryName?: string | null, clientType?: ClientTypeEnum | null, size?: ClientSizeType | null, website?: string | null, contactEmail?: string | null, contactName?: string | null, contactPhone?: string | null, isActive: boolean, totalLifetimeValue?: number | null, createdAt: string, updatedAt: string, metadata?: Record<string, any> | null, corporateNumber?: string | null, nameKana?: string | null, nameEnglish?: string | null, postalCode?: string | null, prefecture?: string | null, city?: string | null, streetAddress?: string | null, addressOutside?: string | null, corporateStatus?: string | null, corporateUpdateDate?: string | null, corporateCloseDate?: string | null, isAutoRegistered: boolean, dataQualityScore?: number | null, parentId?: string | null, projectCount: number, hasActiveProjects: boolean, displaySize: string, isEnterprise: boolean, fullAddress?: string | null, corporateStatusDisplay?: string | null, industry?: { __typename?: 'Industry', id: string, name: string, code: string } | null } };

export type UpdateClientMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: UpdateClientInput;
}>;


export type UpdateClientMutation = { __typename?: 'Mutation', updateClient: { __typename?: 'ClientType', id: string, name: string, description?: string | null, organizationId: string, createdBy: string, industryId?: string | null, industryName?: string | null, clientType?: ClientTypeEnum | null, size?: ClientSizeType | null, website?: string | null, contactEmail?: string | null, contactName?: string | null, contactPhone?: string | null, isActive: boolean, totalLifetimeValue?: number | null, createdAt: string, updatedAt: string, metadata?: Record<string, any> | null, corporateNumber?: string | null, nameKana?: string | null, nameEnglish?: string | null, postalCode?: string | null, prefecture?: string | null, city?: string | null, streetAddress?: string | null, addressOutside?: string | null, corporateStatus?: string | null, corporateUpdateDate?: string | null, corporateCloseDate?: string | null, isAutoRegistered: boolean, dataQualityScore?: number | null, parentId?: string | null, projectCount: number, hasActiveProjects: boolean, displaySize: string, isEnterprise: boolean, fullAddress?: string | null, corporateStatusDisplay?: string | null, industry?: { __typename?: 'Industry', id: string, name: string, code: string } | null } };

export type UpdateClientContactMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateClientContactMutation = { __typename?: 'Mutation', updateClientContact: { __typename?: 'ClientType', id: string, name: string, description?: string | null, organizationId: string, createdBy: string, industryId?: string | null, industryName?: string | null, clientType?: ClientTypeEnum | null, size?: ClientSizeType | null, website?: string | null, contactEmail?: string | null, contactName?: string | null, contactPhone?: string | null, isActive: boolean, totalLifetimeValue?: number | null, createdAt: string, updatedAt: string, metadata?: Record<string, any> | null, corporateNumber?: string | null, nameKana?: string | null, nameEnglish?: string | null, postalCode?: string | null, prefecture?: string | null, city?: string | null, streetAddress?: string | null, addressOutside?: string | null, corporateStatus?: string | null, corporateUpdateDate?: string | null, corporateCloseDate?: string | null, isAutoRegistered: boolean, dataQualityScore?: number | null, parentId?: string | null, projectCount: number, hasActiveProjects: boolean, displaySize: string, isEnterprise: boolean, fullAddress?: string | null, corporateStatusDisplay?: string | null, industry?: { __typename?: 'Industry', id: string, name: string, code: string } | null } };

export type ArchiveClientMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ArchiveClientMutation = { __typename?: 'Mutation', archiveClient: { __typename?: 'ClientType', id: string, name: string, description?: string | null, organizationId: string, createdBy: string, industryId?: string | null, industryName?: string | null, clientType?: ClientTypeEnum | null, size?: ClientSizeType | null, website?: string | null, contactEmail?: string | null, contactName?: string | null, contactPhone?: string | null, isActive: boolean, totalLifetimeValue?: number | null, createdAt: string, updatedAt: string, metadata?: Record<string, any> | null, corporateNumber?: string | null, nameKana?: string | null, nameEnglish?: string | null, postalCode?: string | null, prefecture?: string | null, city?: string | null, streetAddress?: string | null, addressOutside?: string | null, corporateStatus?: string | null, corporateUpdateDate?: string | null, corporateCloseDate?: string | null, isAutoRegistered: boolean, dataQualityScore?: number | null, parentId?: string | null, projectCount: number, hasActiveProjects: boolean, displaySize: string, isEnterprise: boolean, fullAddress?: string | null, corporateStatusDisplay?: string | null, industry?: { __typename?: 'Industry', id: string, name: string, code: string } | null } };

export type UnarchiveClientMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type UnarchiveClientMutation = { __typename?: 'Mutation', unarchiveClient: { __typename?: 'ClientType', id: string, name: string, description?: string | null, organizationId: string, createdBy: string, industryId?: string | null, industryName?: string | null, clientType?: ClientTypeEnum | null, size?: ClientSizeType | null, website?: string | null, contactEmail?: string | null, contactName?: string | null, contactPhone?: string | null, isActive: boolean, totalLifetimeValue?: number | null, createdAt: string, updatedAt: string, metadata?: Record<string, any> | null, corporateNumber?: string | null, nameKana?: string | null, nameEnglish?: string | null, postalCode?: string | null, prefecture?: string | null, city?: string | null, streetAddress?: string | null, addressOutside?: string | null, corporateStatus?: string | null, corporateUpdateDate?: string | null, corporateCloseDate?: string | null, isAutoRegistered: boolean, dataQualityScore?: number | null, parentId?: string | null, projectCount: number, hasActiveProjects: boolean, displaySize: string, isEnterprise: boolean, fullAddress?: string | null, corporateStatusDisplay?: string | null, industry?: { __typename?: 'Industry', id: string, name: string, code: string } | null } };

export type DeleteClientMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteClientMutation = { __typename?: 'Mutation', deleteClient: boolean };

export type GetClientQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetClientQuery = { __typename?: 'Query', client?: { __typename?: 'ClientType', id: string, name: string, description?: string | null, organizationId: string, createdBy: string, industryId?: string | null, industryName?: string | null, clientType?: ClientTypeEnum | null, size?: ClientSizeType | null, website?: string | null, contactEmail?: string | null, contactName?: string | null, contactPhone?: string | null, isActive: boolean, totalLifetimeValue?: number | null, createdAt: string, updatedAt: string, metadata?: Record<string, any> | null, corporateNumber?: string | null, nameKana?: string | null, nameEnglish?: string | null, postalCode?: string | null, prefecture?: string | null, city?: string | null, streetAddress?: string | null, addressOutside?: string | null, corporateStatus?: string | null, corporateUpdateDate?: string | null, corporateCloseDate?: string | null, isAutoRegistered: boolean, dataQualityScore?: number | null, parentId?: string | null, projectCount: number, hasActiveProjects: boolean, displaySize: string, isEnterprise: boolean, fullAddress?: string | null, corporateStatusDisplay?: string | null, industry?: { __typename?: 'Industry', id: string, name: string, code: string } | null } | null };

export type GetClientsQueryVariables = Exact<{
  filter?: InputMaybe<ClientFilterInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
}>;


export type GetClientsQuery = { __typename?: 'Query', clients: { __typename?: 'ClientConnection', totalCount: number, edges: Array<{ __typename?: 'ClientEdge', cursor: string, node: { __typename?: 'ClientType', id: string, name: string, description?: string | null, organizationId: string, createdBy: string, industryId?: string | null, industryName?: string | null, clientType?: ClientTypeEnum | null, size?: ClientSizeType | null, website?: string | null, contactEmail?: string | null, contactName?: string | null, contactPhone?: string | null, isActive: boolean, totalLifetimeValue?: number | null, createdAt: string, updatedAt: string, metadata?: Record<string, any> | null, corporateNumber?: string | null, nameKana?: string | null, nameEnglish?: string | null, postalCode?: string | null, prefecture?: string | null, city?: string | null, streetAddress?: string | null, addressOutside?: string | null, corporateStatus?: string | null, corporateUpdateDate?: string | null, corporateCloseDate?: string | null, isAutoRegistered: boolean, dataQualityScore?: number | null, parentId?: string | null, projectCount: number, hasActiveProjects: boolean, displaySize: string, isEnterprise: boolean, fullAddress?: string | null, corporateStatusDisplay?: string | null, industry?: { __typename?: 'Industry', id: string, name: string, code: string } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetOrganizationClientsQueryVariables = Exact<{
  organizationId: Scalars['UUID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetOrganizationClientsQuery = { __typename?: 'Query', organizationClients: Array<{ __typename?: 'ClientType', id: string, name: string, description?: string | null, organizationId: string, createdBy: string, industryId?: string | null, industryName?: string | null, clientType?: ClientTypeEnum | null, size?: ClientSizeType | null, website?: string | null, contactEmail?: string | null, contactName?: string | null, contactPhone?: string | null, isActive: boolean, totalLifetimeValue?: number | null, createdAt: string, updatedAt: string, metadata?: Record<string, any> | null, corporateNumber?: string | null, nameKana?: string | null, nameEnglish?: string | null, postalCode?: string | null, prefecture?: string | null, city?: string | null, streetAddress?: string | null, addressOutside?: string | null, corporateStatus?: string | null, corporateUpdateDate?: string | null, corporateCloseDate?: string | null, isAutoRegistered: boolean, dataQualityScore?: number | null, parentId?: string | null, projectCount: number, hasActiveProjects: boolean, displaySize: string, isEnterprise: boolean, fullAddress?: string | null, corporateStatusDisplay?: string | null, industry?: { __typename?: 'Industry', id: string, name: string, code: string } | null }> };

export type GetChildClientsQueryVariables = Exact<{
  parentId: Scalars['UUID']['input'];
}>;


export type GetChildClientsQuery = { __typename?: 'Query', childClients: Array<{ __typename?: 'ClientType', id: string, name: string, description?: string | null, organizationId: string, createdBy: string, industryId?: string | null, industryName?: string | null, clientType?: ClientTypeEnum | null, size?: ClientSizeType | null, website?: string | null, contactEmail?: string | null, contactName?: string | null, contactPhone?: string | null, isActive: boolean, totalLifetimeValue?: number | null, createdAt: string, updatedAt: string, metadata?: Record<string, any> | null, corporateNumber?: string | null, nameKana?: string | null, nameEnglish?: string | null, postalCode?: string | null, prefecture?: string | null, city?: string | null, streetAddress?: string | null, addressOutside?: string | null, corporateStatus?: string | null, corporateUpdateDate?: string | null, corporateCloseDate?: string | null, isAutoRegistered: boolean, dataQualityScore?: number | null, parentId?: string | null, projectCount: number, hasActiveProjects: boolean, displaySize: string, isEnterprise: boolean, fullAddress?: string | null, corporateStatusDisplay?: string | null, industry?: { __typename?: 'Industry', id: string, name: string, code: string } | null }> };

export type GetSearchCorporationsQueryVariables = Exact<{
  input: CorporateSearchInput;
}>;


export type GetSearchCorporationsQuery = { __typename?: 'Query', searchCorporations: { __typename?: 'CorporateSearchResult', success: boolean, totalCount: number, error?: string | null, results: Array<{ __typename?: 'CorporateInfo', corporateNumber: string, name: string, nameKana?: string | null, nameEn?: string | null, prefecture?: string | null, city?: string | null, streetAddress?: string | null, postalCode?: string | null, status?: string | null, closeDate?: string | null, closeReason?: string | null, updateDate?: string | null, changeDate?: string | null, kind?: string | null }> } };

export type CreateCompanyProfileMutationVariables = Exact<{
  input: CreateCompanyProfileInput;
}>;


export type CreateCompanyProfileMutation = { __typename?: 'Mutation', createCompanyProfile: { __typename?: 'CompanyProfileType', id: string, description?: string | null, organizationId: string, createdBy: string, organizationName: string, industryId?: string | null, size?: CompanySizeType | null, foundedDate?: any | null, employeeCount?: number | null, annualRevenue?: string | null, email?: string | null, phone?: string | null, website?: string | null, address?: string | null, corporateNumber?: string | null, nameKana?: string | null, nameEnglish?: string | null, postalCode?: string | null, prefecture?: string | null, city?: string | null, streetAddress?: string | null, addressOutside?: string | null, corporateStatus?: string | null, corporateUpdateDate?: string | null, corporateCloseDate?: string | null, businessContent?: string | null, strengths?: string | null, achievements?: string | null, targetMarket?: string | null, competitors?: string | null, status: CompanyProfileStatusType, dataQualityScore?: number | null, metadata?: Record<string, any> | null, createdAt: string, updatedAt: string, fullAddress?: string | null, isComplete: boolean, displaySize: string, displayStatus: string, corporateStatusDisplay?: string | null, completenessPercentage: number, industry?: { __typename?: 'Industry', id: string, name: string, code: string, description?: string | null, icon?: string | null, isActive: boolean, industryProfile: Record<string, any>, hasProfileData: boolean } | null } };

export type UpdateCompanyProfileMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: UpdateCompanyProfileInput;
}>;


export type UpdateCompanyProfileMutation = { __typename?: 'Mutation', updateCompanyProfile: { __typename?: 'CompanyProfileType', id: string, description?: string | null, organizationId: string, createdBy: string, organizationName: string, industryId?: string | null, size?: CompanySizeType | null, foundedDate?: any | null, employeeCount?: number | null, annualRevenue?: string | null, email?: string | null, phone?: string | null, website?: string | null, address?: string | null, corporateNumber?: string | null, nameKana?: string | null, nameEnglish?: string | null, postalCode?: string | null, prefecture?: string | null, city?: string | null, streetAddress?: string | null, addressOutside?: string | null, corporateStatus?: string | null, corporateUpdateDate?: string | null, corporateCloseDate?: string | null, businessContent?: string | null, strengths?: string | null, achievements?: string | null, targetMarket?: string | null, competitors?: string | null, status: CompanyProfileStatusType, dataQualityScore?: number | null, metadata?: Record<string, any> | null, createdAt: string, updatedAt: string, fullAddress?: string | null, isComplete: boolean, displaySize: string, displayStatus: string, corporateStatusDisplay?: string | null, completenessPercentage: number, industry?: { __typename?: 'Industry', id: string, name: string, code: string, description?: string | null, icon?: string | null, isActive: boolean, industryProfile: Record<string, any>, hasProfileData: boolean } | null } };

export type DeleteCompanyProfileMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteCompanyProfileMutation = { __typename?: 'Mutation', deleteCompanyProfile: boolean };

export type ResearchCompanyProfileMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResearchCompanyProfileMutation = { __typename?: 'Mutation', researchCompanyProfile: boolean };

export type GetCompanyProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompanyProfileQuery = { __typename?: 'Query', companyProfile?: { __typename?: 'CompanyProfileType', id: string, description?: string | null, organizationId: string, createdBy: string, organizationName: string, industryId?: string | null, size?: CompanySizeType | null, foundedDate?: any | null, employeeCount?: number | null, annualRevenue?: string | null, email?: string | null, phone?: string | null, website?: string | null, address?: string | null, corporateNumber?: string | null, nameKana?: string | null, nameEnglish?: string | null, postalCode?: string | null, prefecture?: string | null, city?: string | null, streetAddress?: string | null, addressOutside?: string | null, corporateStatus?: string | null, corporateUpdateDate?: string | null, corporateCloseDate?: string | null, businessContent?: string | null, strengths?: string | null, achievements?: string | null, targetMarket?: string | null, competitors?: string | null, status: CompanyProfileStatusType, dataQualityScore?: number | null, metadata?: Record<string, any> | null, createdAt: string, updatedAt: string, fullAddress?: string | null, isComplete: boolean, displaySize: string, displayStatus: string, corporateStatusDisplay?: string | null, completenessPercentage: number, industry?: { __typename?: 'Industry', id: string, name: string, code: string, description?: string | null, icon?: string | null, isActive: boolean, industryProfile: Record<string, any>, hasProfileData: boolean } | null } | null };

export type GetCompanyProfileByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetCompanyProfileByIdQuery = { __typename?: 'Query', companyProfileById?: { __typename?: 'CompanyProfileType', id: string, description?: string | null, organizationId: string, createdBy: string, organizationName: string, industryId?: string | null, size?: CompanySizeType | null, foundedDate?: any | null, employeeCount?: number | null, annualRevenue?: string | null, email?: string | null, phone?: string | null, website?: string | null, address?: string | null, corporateNumber?: string | null, nameKana?: string | null, nameEnglish?: string | null, postalCode?: string | null, prefecture?: string | null, city?: string | null, streetAddress?: string | null, addressOutside?: string | null, corporateStatus?: string | null, corporateUpdateDate?: string | null, corporateCloseDate?: string | null, businessContent?: string | null, strengths?: string | null, achievements?: string | null, targetMarket?: string | null, competitors?: string | null, status: CompanyProfileStatusType, dataQualityScore?: number | null, metadata?: Record<string, any> | null, createdAt: string, updatedAt: string, fullAddress?: string | null, isComplete: boolean, displaySize: string, displayStatus: string, corporateStatusDisplay?: string | null, completenessPercentage: number, industry?: { __typename?: 'Industry', id: string, name: string, code: string, description?: string | null, icon?: string | null, isActive: boolean, industryProfile: Record<string, any>, hasProfileData: boolean } | null } | null };

export type GetHasCompanyProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHasCompanyProfileQuery = { __typename?: 'Query', hasCompanyProfile: boolean };

export type GenerateUnifiedContentMutationVariables = Exact<{
  input: UnifiedContentGenerationInput;
}>;


export type GenerateUnifiedContentMutation = { __typename?: 'Mutation', generateUnifiedContent: { __typename?: 'UnifiedContentGenerationResult', success: boolean, taskId?: string | null, contentType: string, outputFormat: string, projectId: string, message?: string | null, error?: string | null, artifactId?: string | null, deliverableId?: string | null, fileUrl?: string | null, fileSize?: number | null, contentLength?: number | null, qualityScore?: number | null, processingTime?: number | null } };

export type GetUnifiedContentTaskStatusQueryVariables = Exact<{
  taskId: Scalars['String']['input'];
}>;


export type GetUnifiedContentTaskStatusQuery = { __typename?: 'Query', unifiedContentTaskStatus?: { __typename?: 'UnifiedContentTaskStatus', taskId: string, status: string, result?: Record<string, any> | null, error?: string | null, progress?: number | null, contentType?: string | null, outputFormat?: string | null, projectId?: string | null } | null };

export type GetContentGenerationHistoryQueryVariables = Exact<{
  filterInput?: InputMaybe<ContentGenerationFilterInput>;
  first?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
}>;


export type GetContentGenerationHistoryQuery = { __typename?: 'Query', contentGenerationHistory: { __typename?: 'ContentGenerationHistoryConnection', totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean, edges: Array<{ __typename?: 'ContentGenerationHistory', id: string, projectId: string, contentType: string, outputFormat: string, status: string, createdAt: string, completedAt?: string | null, processingTime?: number | null, qualityScore?: number | null, error?: string | null, artifactId?: string | null, deliverableId?: string | null, fileUrl?: string | null }> } };

export type ExecuteSitemapIntegrationFlowMutationVariables = Exact<{
  projectId: Scalars['UUID']['input'];
  sitemapData: Scalars['JSON']['input'];
  uiCompletionData?: InputMaybe<Scalars['JSON']['input']>;
  requirements?: InputMaybe<Scalars['JSON']['input']>;
  generateSystem?: Scalars['Boolean']['input'];
  selectedDeliverableId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ExecuteSitemapIntegrationFlowMutation = { __typename?: 'Mutation', executeSitemapIntegrationFlow: Record<string, any> };

export type ResearchIndustryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ResearchIndustryMutation = { __typename?: 'Mutation', researchIndustry: boolean };

export type PingMutationVariables = Exact<{ [key: string]: never; }>;


export type PingMutation = { __typename?: 'Mutation', ping: string };

export type ChangePasswordMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: boolean };

export type VerifyEmailMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
}>;


export type VerifyEmailMutation = { __typename?: 'Mutation', verifyEmail: boolean };

export type ResearchCompanyMutationVariables = Exact<{
  clientId: Scalars['UUID']['input'];
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResearchCompanyMutation = { __typename?: 'Mutation', researchCompany: boolean };

export type GenerateCompanyReportMutationVariables = Exact<{
  clientId: Scalars['UUID']['input'];
}>;


export type GenerateCompanyReportMutation = { __typename?: 'Mutation', generateCompanyReport: string };

export type CreateObserverPluginMutationVariables = Exact<{
  input: PluginCreateInput;
}>;


export type CreateObserverPluginMutation = { __typename?: 'Mutation', createObserverPlugin: { __typename?: 'PluginMutationResponse', success: boolean, message: string, plugin?: { __typename?: 'ObserverPlugin', id: string, name: string, code: string, description?: string | null, pluginType: string, configuration: Record<string, any>, isActive: boolean, version?: string | null, author?: string | null } | null } };

export type RequestDeviceCodeMutationVariables = Exact<{
  input: DeviceCodeInput;
}>;


export type RequestDeviceCodeMutation = { __typename?: 'Mutation', requestDeviceCode: { __typename?: 'DeviceCodeResponse', deviceCode: string, userCode: string, verificationUri: string, verificationUriComplete: string, expiresIn: number, interval: number } };

export type ChangeMyPasswordMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;


export type ChangeMyPasswordMutation = { __typename?: 'Mutation', changeMyPassword: { __typename?: 'LogoutResponse', success: boolean, message: string } };

export type SendVerificationEmailMutationVariables = Exact<{
  input: SendVerificationEmailInput;
}>;


export type SendVerificationEmailMutation = { __typename?: 'Mutation', sendVerificationEmail: { __typename?: 'EmailVerificationResponse', success: boolean, message: string } };

export type RequestPasswordResetMutationVariables = Exact<{
  input: RequestPasswordResetInput;
}>;


export type RequestPasswordResetMutation = { __typename?: 'Mutation', requestPasswordReset: { __typename?: 'PasswordResetResponse', success: boolean, message: string } };

export type StartGenerationDddMutationVariables = Exact<{
  artifactId: Scalars['UUID']['input'];
  generationParameters?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type StartGenerationDddMutation = { __typename?: 'Mutation', startGenerationDdd: { __typename?: 'ArtifactDDD', id: string, projectId: string, artifactType: string, title: string, description?: string | null, format: string, content?: string | null, fileUrl?: string | null, fileSize?: number | null, status: string, metadata?: Record<string, any> | null, createdBy: string, createdAt: string, generatedAt?: string | null, systemSpecData?: Record<string, any> | null, proposalMetadata?: { __typename?: 'ProposalMetadata', style?: string | null, includesDeliverables?: boolean | null, includesSitemap?: boolean | null, includesTechSpecs?: boolean | null, deliverablesCount?: number | null, sitemapPagesCount?: number | null, techComponentsCount?: number | null, estimatedReadingTime?: number | null, targetAudience?: string | null, totalContentLength?: number | null, dataSource?: string | null } | null } };

export type CompleteGenerationDddMutationVariables = Exact<{
  artifactId: Scalars['UUID']['input'];
  success: Scalars['Boolean']['input'];
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  fileSize?: InputMaybe<Scalars['Int']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
}>;


export type CompleteGenerationDddMutation = { __typename?: 'Mutation', completeGenerationDdd: { __typename?: 'ArtifactDDD', id: string, projectId: string, artifactType: string, title: string, description?: string | null, format: string, content?: string | null, fileUrl?: string | null, fileSize?: number | null, status: string, metadata?: Record<string, any> | null, createdBy: string, createdAt: string, generatedAt?: string | null, systemSpecData?: Record<string, any> | null, proposalMetadata?: { __typename?: 'ProposalMetadata', style?: string | null, includesDeliverables?: boolean | null, includesSitemap?: boolean | null, includesTechSpecs?: boolean | null, deliverablesCount?: number | null, sitemapPagesCount?: number | null, techComponentsCount?: number | null, estimatedReadingTime?: number | null, targetAudience?: string | null, totalContentLength?: number | null, dataSource?: string | null } | null } };

export type RetryGenerationDddMutationVariables = Exact<{
  artifactId: Scalars['UUID']['input'];
}>;


export type RetryGenerationDddMutation = { __typename?: 'Mutation', retryGenerationDdd: { __typename?: 'ArtifactDDD', id: string, projectId: string, artifactType: string, title: string, description?: string | null, format: string, content?: string | null, fileUrl?: string | null, fileSize?: number | null, status: string, metadata?: Record<string, any> | null, createdBy: string, createdAt: string, generatedAt?: string | null, systemSpecData?: Record<string, any> | null, proposalMetadata?: { __typename?: 'ProposalMetadata', style?: string | null, includesDeliverables?: boolean | null, includesSitemap?: boolean | null, includesTechSpecs?: boolean | null, deliverablesCount?: number | null, sitemapPagesCount?: number | null, techComponentsCount?: number | null, estimatedReadingTime?: number | null, targetAudience?: string | null, totalContentLength?: number | null, dataSource?: string | null } | null } };

export type UpdateLockedFieldsMutationVariables = Exact<{
  projectId: Scalars['UUID']['input'];
  lockedFields: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateLockedFieldsMutation = { __typename?: 'Mutation', updateLockedFields: boolean };

export type UpdateScopeMutationVariables = Exact<{
  scopeId: Scalars['UUID']['input'];
  input: UpdateScopeInput;
}>;


export type UpdateScopeMutation = { __typename?: 'Mutation', updateScope?: { __typename?: 'ScopeType', id: string, name: string, origin: ScopeOriginType, rationale?: string | null, searchQuery?: string | null, boostKeywords: Array<string>, analysisLens?: string | null, projectId?: string | null, viewId: string, focusAtomIds: Array<string>, createdAt: string, plan?: string | null, functionCandidates: Array<{ __typename?: 'FunctionCandidateType', name: string, category?: string | null, description?: string | null, priority?: string | null, source?: string | null }> } | null };

export type RemoveGroundedEntityMutationVariables = Exact<{
  projectId: Scalars['UUID']['input'];
  entityName: Scalars['String']['input'];
}>;


export type RemoveGroundedEntityMutation = { __typename?: 'Mutation', removeGroundedEntity: boolean };

export type RefineScopesWithAiMutationVariables = Exact<{
  projectId: Scalars['UUID']['input'];
  message: Scalars['String']['input'];
}>;


export type RefineScopesWithAiMutation = { __typename?: 'Mutation', refineScopesWithAi: { __typename?: 'ScopeRefinementResult', aiResponse: string, actions: Array<{ __typename?: 'ScopeRefinementAction', type: string, scopeName: string, reason: string }>, scopes: Array<{ __typename?: 'ScopeType', id: string, name: string, origin: ScopeOriginType, rationale?: string | null, searchQuery?: string | null, boostKeywords: Array<string>, analysisLens?: string | null, projectId?: string | null, viewId: string, focusAtomIds: Array<string>, createdAt: string, plan?: string | null, functionCandidates: Array<{ __typename?: 'FunctionCandidateType', name: string, category?: string | null, description?: string | null, priority?: string | null, source?: string | null }> }> } };

export type GeneratePageDesignsMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GeneratePageDesignsMutation = { __typename?: 'Mutation', generatePageDesigns: boolean };

export type DeletePageDesignsMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type DeletePageDesignsMutation = { __typename?: 'Mutation', deletePageDesigns: boolean };

export type StartDeploymentMutationVariables = Exact<{
  input: StartDeploymentInput;
}>;


export type StartDeploymentMutation = { __typename?: 'Mutation', startDeployment: { __typename?: 'StartDeploymentResult', success: boolean, deploymentId?: string | null, taskId?: string | null, error?: string | null } };

export type RetryDeploymentMutationVariables = Exact<{
  deploymentId: Scalars['String']['input'];
}>;


export type RetryDeploymentMutation = { __typename?: 'Mutation', retryDeployment: { __typename?: 'StartDeploymentResult', success: boolean, deploymentId?: string | null, taskId?: string | null, error?: string | null } };

export type RedeployDeploymentMutationVariables = Exact<{
  deploymentId: Scalars['String']['input'];
}>;


export type RedeployDeploymentMutation = { __typename?: 'Mutation', redeployDeployment: { __typename?: 'StartDeploymentResult', success: boolean, deploymentId?: string | null, taskId?: string | null, error?: string | null } };

export type DeleteDeploymentMutationVariables = Exact<{
  deploymentId: Scalars['String']['input'];
}>;


export type DeleteDeploymentMutation = { __typename?: 'Mutation', deleteDeployment: boolean };

export type SaveDeploymentConfigMutationVariables = Exact<{
  input: SaveDeploymentConfigInput;
}>;


export type SaveDeploymentConfigMutation = { __typename?: 'Mutation', saveDeploymentConfig: { __typename?: 'DeploymentConfigType', providerType: string, githubTokenSet: boolean, githubOwner?: string | null, githubRepoName?: string | null, vpsHost?: string | null, vpsPort: number, vpsUsername?: string | null, vpsAuthMethod: string, vpsPasswordSet: boolean, vpsSshKeySet: boolean, domain?: string | null } };

export type TestDeploymentConnectionMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type TestDeploymentConnectionMutation = { __typename?: 'Mutation', testDeploymentConnection: { __typename?: 'TestConnectionResult', success: boolean, message?: string | null } };

export type GetHelloQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetHelloQuery = { __typename?: 'Query', hello: string };

export type GetSearchAtomsQueryVariables = Exact<{
  query: Scalars['String']['input'];
  organizationId: Scalars['UUID']['input'];
  atomType?: InputMaybe<AtomTypeType>;
  limit?: Scalars['Int']['input'];
}>;


export type GetSearchAtomsQuery = { __typename?: 'Query', searchAtoms: Array<{ __typename?: 'AtomBaseType', id: string, title: string, fullContent?: string | null, contentFormat: string, sourceType: string, sourceId?: string | null, filePath?: string | null, fileType?: string | null, fileSize?: number | null, status: AtomStatusType, processingError?: string | null, processingProgress?: number | null, processedAt?: string | null, atomType: AtomTypeType, category?: string | null, tags: Array<string>, organizationId: string, clientId?: string | null, projectId?: string | null, industryId?: string | null, metaInfo?: Record<string, any> | null, isVectorized: boolean, embeddingModel?: string | null, viewCount: number, usageCount: number, qualityScore?: number | null, lastUsedAt?: string | null, createdBy: string, updatedBy?: string | null, createdAt: string, updatedAt: string }> };

export type GetObserverPluginsQueryVariables = Exact<{
  pluginType?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetObserverPluginsQuery = { __typename?: 'Query', observerPlugins: Array<{ __typename?: 'ObserverPlugin', id: string, name: string, code: string, description?: string | null, pluginType: string, configuration: Record<string, any>, isActive: boolean, version?: string | null, author?: string | null }> };

export type GetCollectedItemsQueryVariables = Exact<{
  sourceId: Scalars['UUID']['input'];
  filter?: InputMaybe<CollectedItemFilterInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
}>;


export type GetCollectedItemsQuery = { __typename?: 'Query', collectedItems: { __typename?: 'CollectedItemListGQL', totalCount: number, hasNextPage: boolean, hasPreviousPage: boolean, items: Array<{ __typename?: 'CollectedItemGQL', id: string, sourceId: string, entityType: AtomSourceEntityTypeEnum, entityId: string, title: string, content?: string | null, summary?: string | null, sourceUrl: string, publishedAt?: string | null, contentType?: string | null, categories: Array<string>, tags: Array<string>, contextAnalysis: Record<string, any>, relevanceScore: number, status: CollectedItemStatusEnum, processedAt?: string | null, atomId?: string | null, metadata: Record<string, any>, createdAt: string, updatedAt: string }> } };

export type GetScopeDetailQueryVariables = Exact<{
  scopeId: Scalars['UUID']['input'];
}>;


export type GetScopeDetailQuery = { __typename?: 'Query', scopeDetail?: { __typename?: 'ScopeType', id: string, name: string, origin: ScopeOriginType, rationale?: string | null, searchQuery?: string | null, boostKeywords: Array<string>, analysisLens?: string | null, projectId?: string | null, viewId: string, focusAtomIds: Array<string>, createdAt: string, plan?: string | null, functionCandidates: Array<{ __typename?: 'FunctionCandidateType', name: string, category?: string | null, description?: string | null, priority?: string | null, source?: string | null }> } | null };

export type GetViewDetailQueryVariables = Exact<{
  viewId: Scalars['UUID']['input'];
}>;


export type GetViewDetailQuery = { __typename?: 'Query', viewDetail?: { __typename?: 'ViewType', id: string, projectId: string, sourceType: string, analysisSummary: string, analysisResult?: Record<string, any> | null, sourceAtomIds: Array<string>, scopeId?: string | null, generatedAt: string } | null };

export type GetUiGenerationResultQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetUiGenerationResultQuery = { __typename?: 'Query', uiGenerationResult?: { __typename?: 'UIGenerationResult', success: boolean, projectPath: string, totalFiles: number, totalLines: number, qualityScore: number, generationTime: number, uiMockUrl?: string | null, errors: Array<string>, warnings: Array<string> } | null };

export type GetPageDesignsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetPageDesignsQuery = { __typename?: 'Query', pageDesigns: Array<{ __typename?: 'PageDesignType', id: string, projectId: string, pagePath: string, pageName: string, sectionName?: string | null, status: string, errorMessage?: string | null, createdAt?: string | null, updatedAt?: string | null }> };

export type GetPageDesignPreviewHtmlQueryVariables = Exact<{
  designId: Scalars['ID']['input'];
}>;


export type GetPageDesignPreviewHtmlQuery = { __typename?: 'Query', pageDesignPreviewHtml?: string | null };

export type GetDeploymentQueryVariables = Exact<{
  deploymentId: Scalars['String']['input'];
}>;


export type GetDeploymentQuery = { __typename?: 'Query', deployment?: { __typename?: 'DeploymentType', id: string, projectId: string, artifactId: string, createdBy: string, name: string, providerType: string, status: string, currentStage?: string | null, pipelineProgress?: Record<string, any> | null, liveUrl?: string | null, githubRepoUrl?: string | null, errorMessage?: string | null, retryCount: number, progressPercentage: number, createdAt?: string | null, startedAt?: string | null, completedAt?: string | null } | null };

export type GetLatestDeploymentQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetLatestDeploymentQuery = { __typename?: 'Query', latestDeployment?: { __typename?: 'DeploymentType', id: string, projectId: string, artifactId: string, createdBy: string, name: string, providerType: string, status: string, currentStage?: string | null, pipelineProgress?: Record<string, any> | null, liveUrl?: string | null, githubRepoUrl?: string | null, errorMessage?: string | null, retryCount: number, progressPercentage: number, createdAt?: string | null, startedAt?: string | null, completedAt?: string | null } | null };

export type GetDeploymentConfigQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetDeploymentConfigQuery = { __typename?: 'Query', deploymentConfig: { __typename?: 'DeploymentConfigType', providerType: string, githubTokenSet: boolean, githubOwner?: string | null, githubRepoName?: string | null, vpsHost?: string | null, vpsPort: number, vpsUsername?: string | null, vpsAuthMethod: string, vpsPasswordSet: boolean, vpsSshKeySet: boolean, domain?: string | null } };

export type GetApiCatalogByServiceNameQueryVariables = Exact<{
  serviceName: Scalars['String']['input'];
}>;


export type GetApiCatalogByServiceNameQuery = { __typename?: 'Query', apiCatalogByServiceName?: { __typename?: 'ApiCatalogType', id: string, organizationId: string, projectId?: string | null, serviceName: string, provider: string, apiVersion?: string | null, crawlStatus: CrawlStatusEnum, crawlError?: string | null, crawlStartedAt?: string | null, crawlCompletedAt?: string | null, implementationKnowledge?: Record<string, any> | null, groundingSources: Array<string>, documentationUrls: Array<string>, endpointCount: number, createdAt: string, updatedAt: string, apiOverview: { __typename?: 'ApiOverviewType', baseUrl: string, authType: string, authDetails: string, rateLimits: string, description: string }, endpoints: Array<{ __typename?: 'ApiEndpointType', method: string, path: string, description: string, parameters?: Record<string, any> | null, requestBody?: Record<string, any> | null, responseSchema?: Record<string, any> | null, authRequired: boolean, deprecated: boolean }>, verification?: { __typename?: 'VerificationResultType', status: string, confidenceScore: number, baseUrlVerified: boolean, baseUrlCorrect: string, authTypeVerified: boolean, authTypeCorrect: string, verificationSources: Array<string>, errorMessage: string, verifiedAt?: string | null, endpointVerdicts: Array<{ __typename?: 'EndpointVerdictType', method: string, path: string, exists: boolean, notes: string }> } | null } | null };

export type GetAvailableBcsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableBcsQuery = { __typename?: 'Query', availableBcs: Array<{ __typename?: 'BCCatalogEntryType', name: string, nameJa: string, entities: Array<string>, entityNamesJa: Array<string>, description: string }> };

export type GetAvailableScenesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableScenesQuery = { __typename?: 'Query', availableScenes: Array<{ __typename?: 'SceneOptionType', name: string, nameJa: string, description: string, industry: string, isPublic: boolean, isDefaultEnabled: boolean, bcNames: Array<string> }> };

export type GenerateProjectFromContextMutationVariables = Exact<{
  input: NlProjectFromContextInput;
}>;


export type GenerateProjectFromContextMutation = { __typename?: 'Mutation', generateProjectFromContext: { __typename?: 'NLProjectGenerationResult', success: boolean, projectName: string, projectNameJa: string, bcNames: Array<string>, dynamicBcNames: Array<string>, outputDir: string, totalFiles: number, generationTimeSeconds: number, error?: string | null, features: Array<{ __typename?: 'ExtractedFeatureType', name: string, description: string, category: string, priority: string, likelyBcMatch?: string | null }>, mapping: { __typename?: 'MappingResultType', matched: Array<{ __typename?: 'BCMatchType', bcName: string, confidence: number, matchedFeatures: Array<string>, reason: string }>, unmatchedFeatures: Array<{ __typename?: 'ExtractedFeatureType', name: string, description: string, category: string, priority: string, likelyBcMatch?: string | null }> } } };

export type GetGeneratedSystemsQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetGeneratedSystemsQuery = { __typename?: 'Query', generatedSystems: Array<{ __typename?: 'GeneratedSystemRecord', id: string, projectId?: string | null, systemName: string, systemNameJa: string, bcNames: Array<string>, dynamicBcNames: Array<string>, outputDir: string, totalFiles: number, generationTimeSeconds: number, backendUrl: string, adminUrl: string, frontendUrl: string, sysadminUrl: string, status: string, createdAt?: string | null, adminEmail: string, adminPassword: string, systemAdminEmail: string, systemAdminPassword: string }> };

export type GenerateProjectFromDescriptionMutationVariables = Exact<{
  input: NlProjectInput;
}>;


export type GenerateProjectFromDescriptionMutation = { __typename?: 'Mutation', generateProjectFromDescription: { __typename?: 'NLProjectGenerationResult', success: boolean, projectName: string, projectNameJa: string, bcNames: Array<string>, dynamicBcNames: Array<string>, outputDir: string, totalFiles: number, generationTimeSeconds: number, error?: string | null, features: Array<{ __typename?: 'ExtractedFeatureType', name: string, description: string, category: string, priority: string, likelyBcMatch?: string | null }>, mapping: { __typename?: 'MappingResultType', matched: Array<{ __typename?: 'BCMatchType', bcName: string, confidence: number, matchedFeatures: Array<string>, reason: string }>, unmatchedFeatures: Array<{ __typename?: 'ExtractedFeatureType', name: string, description: string, category: string, priority: string, likelyBcMatch?: string | null }> } } };

export type RegenerateFromSnapshotMutationVariables = Exact<{
  snapshotId: Scalars['ID']['input'];
  systemInstanceId: Scalars['ID']['input'];
}>;


export type RegenerateFromSnapshotMutation = { __typename?: 'Mutation', regenerateFromSnapshot: { __typename?: 'RegenerateFromSnapshotResult', success: boolean, snapshotId: string, systemInstanceId: string, bcSetLoaded: Array<string>, errorMessage?: string | null } };

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'OrganizationType', id: string, name: string, slug: string, domain?: string | null, description?: string | null, billingEmail?: string | null, billingAddress?: string | null, billingContact?: string | null, taxId?: string | null, planType: PlanType, maxUsers: number, maxClients: number, maxProjects: number, storageLimitGb: number, sharedKnowledgeEnabled: boolean, requireEmailVerification: boolean, isActive: boolean, isVerified: boolean, createdAt: string, updatedAt: string, isFreePlan: boolean, isEnterprisePlan: boolean, activeUserCount: number, activeProjectCount: number, storageUsageGb: number } };

export type UpdateOrganizationMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'OrganizationType', id: string, name: string, slug: string, domain?: string | null, description?: string | null, billingEmail?: string | null, billingAddress?: string | null, billingContact?: string | null, taxId?: string | null, planType: PlanType, maxUsers: number, maxClients: number, maxProjects: number, storageLimitGb: number, sharedKnowledgeEnabled: boolean, requireEmailVerification: boolean, isActive: boolean, isVerified: boolean, createdAt: string, updatedAt: string, isFreePlan: boolean, isEnterprisePlan: boolean, activeUserCount: number, activeProjectCount: number, storageUsageGb: number } };

export type UpgradeOrganizationPlanMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  planType: PlanType;
}>;


export type UpgradeOrganizationPlanMutation = { __typename?: 'Mutation', upgradeOrganizationPlan: { __typename?: 'OrganizationType', id: string, name: string, slug: string, domain?: string | null, description?: string | null, billingEmail?: string | null, billingAddress?: string | null, billingContact?: string | null, taxId?: string | null, planType: PlanType, maxUsers: number, maxClients: number, maxProjects: number, storageLimitGb: number, sharedKnowledgeEnabled: boolean, requireEmailVerification: boolean, isActive: boolean, isVerified: boolean, createdAt: string, updatedAt: string, isFreePlan: boolean, isEnterprisePlan: boolean, activeUserCount: number, activeProjectCount: number, storageUsageGb: number } };

export type VerifyOrganizationMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type VerifyOrganizationMutation = { __typename?: 'Mutation', verifyOrganization: boolean };

export type ChangeOrganizationStatusMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  status: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChangeOrganizationStatusMutation = { __typename?: 'Mutation', changeOrganizationStatus: boolean };

export type DeleteOrganizationMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteOrganizationMutation = { __typename?: 'Mutation', deleteOrganization: boolean };

export type TransferOrganizationOwnershipMutationVariables = Exact<{
  organizationId: Scalars['UUID']['input'];
  newOwnerId: Scalars['UUID']['input'];
}>;


export type TransferOrganizationOwnershipMutation = { __typename?: 'Mutation', transferOrganizationOwnership: { __typename?: 'TransferOwnershipResult', success: boolean, message: string, newOwner?: { __typename?: 'UserOrganizationType', userId: string, organizationId: string, role: OrganizationRoleType, joinedAt: string, invitedBy?: string | null } | null } };

export type GetOrganizationQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetOrganizationQuery = { __typename?: 'Query', organization?: { __typename?: 'OrganizationType', id: string, name: string, slug: string, domain?: string | null, description?: string | null, billingEmail?: string | null, billingAddress?: string | null, billingContact?: string | null, taxId?: string | null, planType: PlanType, maxUsers: number, maxClients: number, maxProjects: number, storageLimitGb: number, sharedKnowledgeEnabled: boolean, requireEmailVerification: boolean, isActive: boolean, isVerified: boolean, createdAt: string, updatedAt: string, isFreePlan: boolean, isEnterprisePlan: boolean, activeUserCount: number, activeProjectCount: number, storageUsageGb: number } | null };

export type GetOrganizationBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetOrganizationBySlugQuery = { __typename?: 'Query', organizationBySlug?: { __typename?: 'OrganizationType', id: string, name: string, slug: string, domain?: string | null, description?: string | null, billingEmail?: string | null, billingAddress?: string | null, billingContact?: string | null, taxId?: string | null, planType: PlanType, maxUsers: number, maxClients: number, maxProjects: number, storageLimitGb: number, sharedKnowledgeEnabled: boolean, requireEmailVerification: boolean, isActive: boolean, isVerified: boolean, createdAt: string, updatedAt: string, isFreePlan: boolean, isEnterprisePlan: boolean, activeUserCount: number, activeProjectCount: number, storageUsageGb: number } | null };

export type GetOrganizationsQueryVariables = Exact<{
  filter?: InputMaybe<OrganizationFilterInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
}>;


export type GetOrganizationsQuery = { __typename?: 'Query', organizations: { __typename?: 'OrganizationConnection', totalCount: number, edges: Array<{ __typename?: 'OrganizationEdge', cursor: string, node: { __typename?: 'OrganizationType', id: string, name: string, slug: string, domain?: string | null, description?: string | null, billingEmail?: string | null, billingAddress?: string | null, billingContact?: string | null, taxId?: string | null, planType: PlanType, maxUsers: number, maxClients: number, maxProjects: number, storageLimitGb: number, sharedKnowledgeEnabled: boolean, requireEmailVerification: boolean, isActive: boolean, isVerified: boolean, createdAt: string, updatedAt: string, isFreePlan: boolean, isEnterprisePlan: boolean, activeUserCount: number, activeProjectCount: number, storageUsageGb: number } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetOrganizationOwnerQueryVariables = Exact<{
  organizationId: Scalars['UUID']['input'];
}>;


export type GetOrganizationOwnerQuery = { __typename?: 'Query', organizationOwner?: { __typename?: 'UserOrganizationType', userId: string, organizationId: string, role: OrganizationRoleType, joinedAt: string, invitedBy?: string | null } | null };

export type GetSearchOrganizationsQueryVariables = Exact<{
  query: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<PlanType>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
}>;


export type GetSearchOrganizationsQuery = { __typename?: 'Query', searchOrganizations: { __typename?: 'OrganizationConnection', totalCount: number, edges: Array<{ __typename?: 'OrganizationEdge', cursor: string, node: { __typename?: 'OrganizationType', id: string, name: string, slug: string, domain?: string | null, description?: string | null, billingEmail?: string | null, billingAddress?: string | null, billingContact?: string | null, taxId?: string | null, planType: PlanType, maxUsers: number, maxClients: number, maxProjects: number, storageLimitGb: number, sharedKnowledgeEnabled: boolean, requireEmailVerification: boolean, isActive: boolean, isVerified: boolean, createdAt: string, updatedAt: string, isFreePlan: boolean, isEnterprisePlan: boolean, activeUserCount: number, activeProjectCount: number, storageUsageGb: number } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetPrismScopesQueryVariables = Exact<{
  projectId: Scalars['UUID']['input'];
}>;


export type GetPrismScopesQuery = { __typename?: 'Query', projectScopes: Array<{ __typename?: 'ScopeType', id: string, name: string, origin: ScopeOriginType, rationale?: string | null, searchQuery?: string | null, analysisLens?: string | null, plan?: string | null, boostKeywords: Array<string>, projectId?: string | null, viewId: string, focusAtomIds: Array<string>, createdAt: string, functionCandidates: Array<{ __typename?: 'FunctionCandidateType', name: string, category?: string | null, description?: string | null, priority?: string | null, source?: string | null }> }> };

export type GetPrismViewsQueryVariables = Exact<{
  projectId: Scalars['UUID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPrismViewsQuery = { __typename?: 'Query', projectViews: Array<{ __typename?: 'ViewType', id: string, projectId: string, sourceType: string, analysisSummary: string, analysisResult?: Record<string, any> | null, sourceAtomIds: Array<string>, scopeId?: string | null, generatedAt: string }> };

export type GetPrismScopeDetailQueryVariables = Exact<{
  scopeId: Scalars['UUID']['input'];
}>;


export type GetPrismScopeDetailQuery = { __typename?: 'Query', scopeDetail?: { __typename?: 'ScopeType', id: string, name: string, origin: ScopeOriginType, rationale?: string | null, searchQuery?: string | null, analysisLens?: string | null, plan?: string | null, boostKeywords: Array<string>, projectId?: string | null, viewId: string, focusAtomIds: Array<string>, createdAt: string, functionCandidates: Array<{ __typename?: 'FunctionCandidateType', name: string, category?: string | null, description?: string | null, priority?: string | null, source?: string | null }> } | null };

export type GenerateGeneralScopesMutationVariables = Exact<{
  projectId: Scalars['UUID']['input'];
}>;


export type GenerateGeneralScopesMutation = { __typename?: 'Mutation', generateGeneralScopes: Array<string> };

export type GetPrismOrientForProjectQueryVariables = Exact<{
  projectId: Scalars['UUID']['input'];
}>;


export type GetPrismOrientForProjectQuery = { __typename?: 'Query', orientForProject?: { __typename?: 'OrientType', id: string, projectId: string, summary: string, recommendations: Array<string>, confidence: number, modelUsed: string, generatedAt: string, userLockedFields: Array<string>, judgments: Array<{ __typename?: 'JudgmentType', aspect: string, assessment: string, severity: number, actionable: boolean }>, projectContext?: { __typename?: 'ProjectContextType', purpose: string, targetAudience: string, objectives: Array<string>, estimatedScale: string, additionalNotes: string } | null } | null };

export type GenerateOrientMutationVariables = Exact<{
  projectId: Scalars['UUID']['input'];
}>;


export type GenerateOrientMutation = { __typename?: 'Mutation', generateOrient: boolean };

export type DeleteScopeMutationVariables = Exact<{
  scopeId: Scalars['UUID']['input'];
}>;


export type DeleteScopeMutation = { __typename?: 'Mutation', deleteScope: boolean };

export type DeleteViewMutationVariables = Exact<{
  viewId: Scalars['UUID']['input'];
}>;


export type DeleteViewMutation = { __typename?: 'Mutation', deleteView: boolean };

export type CreateConsolidatedDeliverableWithAiMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  input: ConsolidatedDeliverableSuggestionInput;
}>;


export type CreateConsolidatedDeliverableWithAiMutation = { __typename?: 'Mutation', createConsolidatedDeliverableWithAi: string };

export type RegenerateSitemapForExistingDeliverableMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  input?: InputMaybe<GenerateConsolidatedSitemapInput>;
}>;


export type RegenerateSitemapForExistingDeliverableMutation = { __typename?: 'Mutation', regenerateSitemapForExistingDeliverable: { __typename?: 'ConsolidatedSitemapGenerationResult', success: boolean, totalPages: number, functionCategories: Array<string>, generationTimeMs: number, sitemapJson?: string | null, errors: Array<string>, warnings: Array<string> } };

export type CreateProjectDddMutationVariables = Exact<{
  input: CreateProjectInput;
}>;


export type CreateProjectDddMutation = { __typename?: 'Mutation', createProjectDdd: { __typename?: 'Project', id: string, name: string, description?: string | null, clientId?: string | null, organizationId: string, ownerId: string, groupId?: string | null, projectType: ProjectTypeEnum, status: ProjectStatusType, priority: ProjectPriorityType, developmentType?: DevelopmentTypeEnum | null, projectPhase?: ProjectPhaseType | null, progress: number, constitutionalFacts: Record<string, any>, constitutionalVersion: number, constitutionalApprovedBy?: string | null, constitutionalApprovedAt?: string | null, hasApprovedConstitution: boolean, contextAnalysis: Record<string, any>, contextAnalysisUpdatedAt?: string | null, settings: Record<string, any>, projectMetadata?: Record<string, any> | null, tags?: Array<string | null> | null, color?: string | null, isActive: boolean, isArchived: boolean, archivedAt?: string | null, isDeleted: boolean, deletedAt?: string | null, createdAt: string, updatedAt: string, isInProgress: boolean, isCompleted: boolean, canStart: boolean, systemInstanceId?: string | null, kind?: string | null, gitBranch?: string | null, prUrl?: string | null, prNumber?: number | null, promptEvolution: { __typename?: 'PromptEvolution', core: string, version: number, updatedAt: string, history: Record<string, any>, elements: { __typename?: 'PromptElements', needs: Array<{ __typename?: 'PromptNeed', id: string, content: string, category: string, priority: number, createdAt: string } | null>, seeds: Array<{ __typename?: 'PromptSeed', id: string, content: string, type: string, confidence: number, createdAt: string } | null>, wildIdeas: Array<{ __typename?: 'WildIdea', id: string, content: string, category: string, riskLevel: string, createdAt: string } | null> } }, progressInfo: { __typename?: 'ProjectProgress', progress: number, status: string }, constitutionalLaws: { __typename?: 'ConstitutionalLaws', needs: Array<string | null>, seeds: Array<string | null> } } };

export type UpdateProjectDddMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: UpdateProjectInput;
}>;


export type UpdateProjectDddMutation = { __typename?: 'Mutation', updateProjectDdd: { __typename?: 'Project', id: string, name: string, description?: string | null, clientId?: string | null, organizationId: string, ownerId: string, groupId?: string | null, projectType: ProjectTypeEnum, status: ProjectStatusType, priority: ProjectPriorityType, developmentType?: DevelopmentTypeEnum | null, projectPhase?: ProjectPhaseType | null, progress: number, constitutionalFacts: Record<string, any>, constitutionalVersion: number, constitutionalApprovedBy?: string | null, constitutionalApprovedAt?: string | null, hasApprovedConstitution: boolean, contextAnalysis: Record<string, any>, contextAnalysisUpdatedAt?: string | null, settings: Record<string, any>, projectMetadata?: Record<string, any> | null, tags?: Array<string | null> | null, color?: string | null, isActive: boolean, isArchived: boolean, archivedAt?: string | null, isDeleted: boolean, deletedAt?: string | null, createdAt: string, updatedAt: string, isInProgress: boolean, isCompleted: boolean, canStart: boolean, systemInstanceId?: string | null, kind?: string | null, gitBranch?: string | null, prUrl?: string | null, prNumber?: number | null, promptEvolution: { __typename?: 'PromptEvolution', core: string, version: number, updatedAt: string, history: Record<string, any>, elements: { __typename?: 'PromptElements', needs: Array<{ __typename?: 'PromptNeed', id: string, content: string, category: string, priority: number, createdAt: string } | null>, seeds: Array<{ __typename?: 'PromptSeed', id: string, content: string, type: string, confidence: number, createdAt: string } | null>, wildIdeas: Array<{ __typename?: 'WildIdea', id: string, content: string, category: string, riskLevel: string, createdAt: string } | null> } }, progressInfo: { __typename?: 'ProjectProgress', progress: number, status: string }, constitutionalLaws: { __typename?: 'ConstitutionalLaws', needs: Array<string | null>, seeds: Array<string | null> } } };

export type DeleteProjectDddMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteProjectDddMutation = { __typename?: 'Mutation', deleteProjectDdd: boolean };

export type RestoreProjectDddMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type RestoreProjectDddMutation = { __typename?: 'Mutation', restoreProjectDdd: boolean };

export type HardDeleteProjectDddMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type HardDeleteProjectDddMutation = { __typename?: 'Mutation', hardDeleteProjectDdd: { __typename?: 'HardDeleteProjectResult', success: boolean, projectId: string, cascadeSummary: string } };

export type UpdateConstitutionalFactsMutationVariables = Exact<{
  input: UpdateConstitutionalFactsInput;
}>;


export type UpdateConstitutionalFactsMutation = { __typename?: 'Mutation', updateConstitutionalFacts: { __typename?: 'ProjectConstitution', projectId: string, version: number, approvedBy?: string | null, approvedAt?: string | null, needsLaws: Array<string>, seedsLaws: Array<string>, lastAnalysisAt?: string | null, totalFactsCount: number, confirmedFactsCount: number, pendingFactsCount: number, facts: Array<{ __typename?: 'ConstitutionFactEntry', key: string, fact: { __typename?: 'ConstitutionFact', key: string, value: Record<string, any>, factType: ConstitutionFactType, sourceType: ConstitutionFactSource, sourceRef?: string | null, confidence: number, extractedAt?: string | null, notes?: string | null } }>, history: Array<{ __typename?: 'ConstitutionHistoryEntry', version: number, changedAt: string, changedBy: string, changes: Array<string>, factsSnapshot: Record<string, any>, reason?: string | null }> } };

export type ApproveConstitutionMutationVariables = Exact<{
  input: ApproveConstitutionInput;
}>;


export type ApproveConstitutionMutation = { __typename?: 'Mutation', approveConstitution: { __typename?: 'ProjectConstitution', projectId: string, version: number, approvedBy?: string | null, approvedAt?: string | null, needsLaws: Array<string>, seedsLaws: Array<string>, lastAnalysisAt?: string | null, totalFactsCount: number, confirmedFactsCount: number, pendingFactsCount: number, facts: Array<{ __typename?: 'ConstitutionFactEntry', key: string, fact: { __typename?: 'ConstitutionFact', key: string, value: Record<string, any>, factType: ConstitutionFactType, sourceType: ConstitutionFactSource, sourceRef?: string | null, confidence: number, extractedAt?: string | null, notes?: string | null } }>, history: Array<{ __typename?: 'ConstitutionHistoryEntry', version: number, changedAt: string, changedBy: string, changes: Array<string>, factsSnapshot: Record<string, any>, reason?: string | null }> } };

export type ApplyConstitutionCandidateMutationVariables = Exact<{
  input: ApplyConstitutionCandidateInput;
}>;


export type ApplyConstitutionCandidateMutation = { __typename?: 'Mutation', applyConstitutionCandidate: { __typename?: 'ProjectConstitution', projectId: string, version: number, approvedBy?: string | null, approvedAt?: string | null, needsLaws: Array<string>, seedsLaws: Array<string>, lastAnalysisAt?: string | null, totalFactsCount: number, confirmedFactsCount: number, pendingFactsCount: number, facts: Array<{ __typename?: 'ConstitutionFactEntry', key: string, fact: { __typename?: 'ConstitutionFact', key: string, value: Record<string, any>, factType: ConstitutionFactType, sourceType: ConstitutionFactSource, sourceRef?: string | null, confidence: number, extractedAt?: string | null, notes?: string | null } }>, history: Array<{ __typename?: 'ConstitutionHistoryEntry', version: number, changedAt: string, changedBy: string, changes: Array<string>, factsSnapshot: Record<string, any>, reason?: string | null }> } };

export type CreateProjectDeliverableFromSuggestionsMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  input: CreateProjectDeliverableInput;
}>;


export type CreateProjectDeliverableFromSuggestionsMutation = { __typename?: 'Mutation', createProjectDeliverableFromSuggestions: { __typename?: 'ProjectDeliverableType', id: string, projectId: string, name: string, description?: string | null, priority: string, enabledScenes: Array<string>, version: number, progress: number, estimatedHours?: number | null, actualHours?: number | null, createdBy: string, createdAt: string, updatedAt?: string | null, isCompleted: boolean, completionPercentage: number, bcCount: number, publicPageCount: number, adminPageCount: number, boundedContexts: Array<{ __typename?: 'BoundedContextType', name: string, nameJa: string, type: string, justification: string, integrationApi?: string | null, isFrozen: boolean, entityCount: number, dynamicSpec?: Record<string, any> | null, publishes: Array<{ __typename?: 'BCEventType', name: string, description: string, payloadFields: Array<string>, sourceBc?: string | null, action?: string | null }>, subscribes: Array<{ __typename?: 'BCEventType', name: string, description: string, payloadFields: Array<string>, sourceBc?: string | null, action?: string | null }>, refs: Array<{ __typename?: 'BCRefType', targetBc: string, targetEntity: string, rpc: string, listRpc?: string | null, purpose?: string | null, sourceField?: string | null }>, entities: Array<{ __typename?: 'DynamicEntitySummaryType', name: string, nameJa: string, fieldCount: number, keyFields: Array<string> }> }>, adminPages: Array<{ __typename?: 'AdminPageType', bc: string, entity: string, role: string, audience: string, enabledActions: Array<string>, labelJa?: string | null, description?: string | null }>, publicPages: Array<{ __typename?: 'PublicPageType', path: string, role: string, title: string, primaryBc?: string | null, primaryEntity?: string | null, secondaryBcs: Array<string>, displayFields: Array<string>, actions: Array<string>, audience: string, acceptance?: string | null, description?: string | null, requiresAuth: boolean }>, businessFlowStories: Array<{ __typename?: 'BusinessFlowStoryType', name: string, nameEn?: string | null, category: string, description?: string | null, priority: string, involvedBcs: Array<string>, steps: Array<{ __typename?: 'FlowStepType', order: number, actor: string, action: string, stepType: string, bc: string, entity?: string | null, pagePath?: string | null, isPublic: boolean, mutation?: string | null, query?: string | null, requiresAuth: boolean, triggerEvent?: string | null, triggerAction?: string | null, condition?: string | null, yesStep?: number | null, noStep?: number | null, notificationChannel?: string | null, description?: string | null }> }>, systemArchitecture?: { __typename?: 'SystemArchitectureType', architectureType: string, deploymentStrategy: string, componentCount: number, scalingConsiderations: Array<string>, componentsJson: string } | null } };

export type UpdateProjectDeliverableMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  input: UpdateProjectDeliverableInput;
}>;


export type UpdateProjectDeliverableMutation = { __typename?: 'Mutation', updateProjectDeliverable: { __typename?: 'ProjectDeliverableType', id: string, projectId: string, name: string, description?: string | null, priority: string, enabledScenes: Array<string>, version: number, progress: number, estimatedHours?: number | null, actualHours?: number | null, createdBy: string, createdAt: string, updatedAt?: string | null, isCompleted: boolean, completionPercentage: number, bcCount: number, publicPageCount: number, adminPageCount: number, boundedContexts: Array<{ __typename?: 'BoundedContextType', name: string, nameJa: string, type: string, justification: string, integrationApi?: string | null, isFrozen: boolean, entityCount: number, dynamicSpec?: Record<string, any> | null, publishes: Array<{ __typename?: 'BCEventType', name: string, description: string, payloadFields: Array<string>, sourceBc?: string | null, action?: string | null }>, subscribes: Array<{ __typename?: 'BCEventType', name: string, description: string, payloadFields: Array<string>, sourceBc?: string | null, action?: string | null }>, refs: Array<{ __typename?: 'BCRefType', targetBc: string, targetEntity: string, rpc: string, listRpc?: string | null, purpose?: string | null, sourceField?: string | null }>, entities: Array<{ __typename?: 'DynamicEntitySummaryType', name: string, nameJa: string, fieldCount: number, keyFields: Array<string> }> }>, adminPages: Array<{ __typename?: 'AdminPageType', bc: string, entity: string, role: string, audience: string, enabledActions: Array<string>, labelJa?: string | null, description?: string | null }>, publicPages: Array<{ __typename?: 'PublicPageType', path: string, role: string, title: string, primaryBc?: string | null, primaryEntity?: string | null, secondaryBcs: Array<string>, displayFields: Array<string>, actions: Array<string>, audience: string, acceptance?: string | null, description?: string | null, requiresAuth: boolean }>, businessFlowStories: Array<{ __typename?: 'BusinessFlowStoryType', name: string, nameEn?: string | null, category: string, description?: string | null, priority: string, involvedBcs: Array<string>, steps: Array<{ __typename?: 'FlowStepType', order: number, actor: string, action: string, stepType: string, bc: string, entity?: string | null, pagePath?: string | null, isPublic: boolean, mutation?: string | null, query?: string | null, requiresAuth: boolean, triggerEvent?: string | null, triggerAction?: string | null, condition?: string | null, yesStep?: number | null, noStep?: number | null, notificationChannel?: string | null, description?: string | null }> }>, systemArchitecture?: { __typename?: 'SystemArchitectureType', architectureType: string, deploymentStrategy: string, componentCount: number, scalingConsiderations: Array<string>, componentsJson: string } | null } };

export type CreateArtifactDddMutationVariables = Exact<{
  input: CreateArtifactDddInput;
}>;


export type CreateArtifactDddMutation = { __typename?: 'Mutation', createArtifactDdd: { __typename?: 'ArtifactDDD', id: string, projectId: string, artifactType: string, title: string, description?: string | null, format: string, content?: string | null, fileUrl?: string | null, fileSize?: number | null, status: string, metadata?: Record<string, any> | null, createdBy: string, createdAt: string, generatedAt?: string | null, systemSpecData?: Record<string, any> | null, proposalMetadata?: { __typename?: 'ProposalMetadata', style?: string | null, includesDeliverables?: boolean | null, includesSitemap?: boolean | null, includesTechSpecs?: boolean | null, deliverablesCount?: number | null, sitemapPagesCount?: number | null, techComponentsCount?: number | null, estimatedReadingTime?: number | null, targetAudience?: string | null, totalContentLength?: number | null, dataSource?: string | null } | null } };

export type UpdateArtifactDddMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  autoGenerationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateArtifactDddMutation = { __typename?: 'Mutation', updateArtifactDdd: { __typename?: 'ArtifactDDD', id: string, projectId: string, artifactType: string, title: string, description?: string | null, format: string, content?: string | null, fileUrl?: string | null, fileSize?: number | null, status: string, metadata?: Record<string, any> | null, createdBy: string, createdAt: string, generatedAt?: string | null, systemSpecData?: Record<string, any> | null, proposalMetadata?: { __typename?: 'ProposalMetadata', style?: string | null, includesDeliverables?: boolean | null, includesSitemap?: boolean | null, includesTechSpecs?: boolean | null, deliverablesCount?: number | null, sitemapPagesCount?: number | null, techComponentsCount?: number | null, estimatedReadingTime?: number | null, targetAudience?: string | null, totalContentLength?: number | null, dataSource?: string | null } | null } };

export type DeleteArtifactDddMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteArtifactDddMutation = { __typename?: 'Mutation', deleteArtifactDdd: boolean };

export type GenerateEnhancedProposalMutationVariables = Exact<{
  input: EnhancedProposalGenerationInput;
}>;


export type GenerateEnhancedProposalMutation = { __typename?: 'Mutation', generateEnhancedProposal: { __typename?: 'ArtifactDDD', id: string, projectId: string, artifactType: string, title: string, description?: string | null, format: string, content?: string | null, fileUrl?: string | null, fileSize?: number | null, status: string, metadata?: Record<string, any> | null, createdBy: string, createdAt: string, generatedAt?: string | null, systemSpecData?: Record<string, any> | null, proposalMetadata?: { __typename?: 'ProposalMetadata', style?: string | null, includesDeliverables?: boolean | null, includesSitemap?: boolean | null, includesTechSpecs?: boolean | null, deliverablesCount?: number | null, sitemapPagesCount?: number | null, techComponentsCount?: number | null, estimatedReadingTime?: number | null, targetAudience?: string | null, totalContentLength?: number | null, dataSource?: string | null } | null } };

export type DownloadArtifactAsPptxMutationVariables = Exact<{
  artifactId: Scalars['String']['input'];
  colorScheme?: InputMaybe<Scalars['String']['input']>;
}>;


export type DownloadArtifactAsPptxMutation = { __typename?: 'Mutation', downloadArtifactAsPptx: { __typename?: 'ArtifactDownloadResult', success: boolean, fileUrl?: string | null, fileSize?: number | null, error?: string | null } };

export type UpdateArtifactThemeMutationVariables = Exact<{
  artifactId: Scalars['String']['input'];
  colorScheme: Scalars['String']['input'];
}>;


export type UpdateArtifactThemeMutation = { __typename?: 'Mutation', updateArtifactTheme: { __typename?: 'ArtifactDownloadResult', success: boolean, fileUrl?: string | null, fileSize?: number | null, error?: string | null } };

export type ConvertSitemapToDeliverablesMutationVariables = Exact<{
  projectId: Scalars['UUID']['input'];
  sitemapData: Scalars['JSON']['input'];
  uiCompletionData?: InputMaybe<Scalars['JSON']['input']>;
  requirements?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type ConvertSitemapToDeliverablesMutation = { __typename?: 'Mutation', convertSitemapToDeliverables: Record<string, any> };

export type UpdateProjectSitemapMutationVariables = Exact<{
  projectId: Scalars['UUID']['input'];
  sitemapData: Scalars['JSON']['input'];
}>;


export type UpdateProjectSitemapMutation = { __typename?: 'Mutation', updateProjectSitemap: { __typename?: 'UpdateSitemapResponse', success: boolean, message?: string | null, updatedAt?: string | null, error?: string | null } };

export type CreateUiProjectMutationVariables = Exact<{
  input: CreateUiProjectInput;
}>;


export type CreateUiProjectMutation = { __typename?: 'Mutation', createUiProject: { __typename?: 'UIProject', id: string, name: string, description: string, createdAt: string, updatedAt: string, status: string, sitemap: string, pagesCount: number, generatedFilesCount: number, qualityScore: number, generationTime: number, uiMockUrl?: string | null, errors: Array<string>, warnings: Array<string> } };

export type UpdateUiProjectMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  input: UpdateUiProjectInput;
}>;


export type UpdateUiProjectMutation = { __typename?: 'Mutation', updateUiProject?: { __typename?: 'UIProject', id: string, name: string, description: string, createdAt: string, updatedAt: string, status: string, sitemap: string, pagesCount: number, generatedFilesCount: number, qualityScore: number, generationTime: number, uiMockUrl?: string | null, errors: Array<string>, warnings: Array<string> } | null };

export type DeleteUiProjectMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type DeleteUiProjectMutation = { __typename?: 'Mutation', deleteUiProject: boolean };

export type UpdateProjectContextMutationVariables = Exact<{
  projectId: Scalars['UUID']['input'];
  purpose?: InputMaybe<Scalars['String']['input']>;
  targetAudience?: InputMaybe<Scalars['String']['input']>;
  objectives?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  estimatedScale?: InputMaybe<Scalars['String']['input']>;
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateProjectContextMutation = { __typename?: 'Mutation', updateProjectContext: boolean };

export type GenerateDesignProposalsMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  referenceUrls?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GenerateDesignProposalsMutation = { __typename?: 'Mutation', generateDesignProposals: boolean };

export type SelectDesignProposalMutationVariables = Exact<{
  proposalId: Scalars['ID']['input'];
}>;


export type SelectDesignProposalMutation = { __typename?: 'Mutation', selectDesignProposal: boolean };

export type DeleteDesignProposalsMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type DeleteDesignProposalsMutation = { __typename?: 'Mutation', deleteDesignProposals: boolean };

export type GenerateStubArtifactMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GenerateStubArtifactMutation = { __typename?: 'Mutation', generateStubArtifact: { __typename?: 'GenerateStubArtifactResult', success: boolean, artifactId?: string | null, title?: string | null, fileCount: number, error?: string | null } };

export type GetProjectDddQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetProjectDddQuery = { __typename?: 'Query', projectDdd?: { __typename?: 'Project', id: string, name: string, description?: string | null, clientId?: string | null, organizationId: string, ownerId: string, groupId?: string | null, projectType: ProjectTypeEnum, status: ProjectStatusType, priority: ProjectPriorityType, developmentType?: DevelopmentTypeEnum | null, projectPhase?: ProjectPhaseType | null, progress: number, constitutionalFacts: Record<string, any>, constitutionalVersion: number, constitutionalApprovedBy?: string | null, constitutionalApprovedAt?: string | null, hasApprovedConstitution: boolean, contextAnalysis: Record<string, any>, contextAnalysisUpdatedAt?: string | null, settings: Record<string, any>, projectMetadata?: Record<string, any> | null, tags?: Array<string | null> | null, color?: string | null, isActive: boolean, isArchived: boolean, archivedAt?: string | null, isDeleted: boolean, deletedAt?: string | null, createdAt: string, updatedAt: string, isInProgress: boolean, isCompleted: boolean, canStart: boolean, systemInstanceId?: string | null, kind?: string | null, gitBranch?: string | null, prUrl?: string | null, prNumber?: number | null, promptEvolution: { __typename?: 'PromptEvolution', core: string, version: number, updatedAt: string, history: Record<string, any>, elements: { __typename?: 'PromptElements', needs: Array<{ __typename?: 'PromptNeed', id: string, content: string, category: string, priority: number, createdAt: string } | null>, seeds: Array<{ __typename?: 'PromptSeed', id: string, content: string, type: string, confidence: number, createdAt: string } | null>, wildIdeas: Array<{ __typename?: 'WildIdea', id: string, content: string, category: string, riskLevel: string, createdAt: string } | null> } }, progressInfo: { __typename?: 'ProjectProgress', progress: number, status: string }, constitutionalLaws: { __typename?: 'ConstitutionalLaws', needs: Array<string | null>, seeds: Array<string | null> } } | null };

export type GetProjectsDddQueryVariables = Exact<{
  organizationId: Scalars['UUID']['input'];
  status?: InputMaybe<ProjectStatusType>;
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
}>;


export type GetProjectsDddQuery = { __typename?: 'Query', projectsDdd: { __typename?: 'ProjectListResult', totalCount: number, page: number, pageSize: number, hasNextPage: boolean, hasPreviousPage: boolean, projects: Array<{ __typename?: 'Project', id: string, name: string, description?: string | null, clientId?: string | null, organizationId: string, ownerId: string, groupId?: string | null, projectType: ProjectTypeEnum, status: ProjectStatusType, priority: ProjectPriorityType, developmentType?: DevelopmentTypeEnum | null, projectPhase?: ProjectPhaseType | null, progress: number, constitutionalFacts: Record<string, any>, constitutionalVersion: number, constitutionalApprovedBy?: string | null, constitutionalApprovedAt?: string | null, hasApprovedConstitution: boolean, contextAnalysis: Record<string, any>, contextAnalysisUpdatedAt?: string | null, settings: Record<string, any>, projectMetadata?: Record<string, any> | null, tags?: Array<string | null> | null, color?: string | null, isActive: boolean, isArchived: boolean, archivedAt?: string | null, isDeleted: boolean, deletedAt?: string | null, createdAt: string, updatedAt: string, isInProgress: boolean, isCompleted: boolean, canStart: boolean, systemInstanceId?: string | null, kind?: string | null, gitBranch?: string | null, prUrl?: string | null, prNumber?: number | null, promptEvolution: { __typename?: 'PromptEvolution', core: string, version: number, updatedAt: string, history: Record<string, any> }, progressInfo: { __typename?: 'ProjectProgress', progress: number, status: string }, constitutionalLaws: { __typename?: 'ConstitutionalLaws', needs: Array<string | null>, seeds: Array<string | null> } }> } };

export type GetTrashedProjectsDddQueryVariables = Exact<{
  organizationId: Scalars['UUID']['input'];
  page?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
}>;


export type GetTrashedProjectsDddQuery = { __typename?: 'Query', trashedProjectsDdd: { __typename?: 'ProjectListResult', totalCount: number, page: number, pageSize: number, hasNextPage: boolean, hasPreviousPage: boolean, projects: Array<{ __typename?: 'Project', id: string, name: string, description?: string | null, clientId?: string | null, organizationId: string, ownerId: string, groupId?: string | null, projectType: ProjectTypeEnum, status: ProjectStatusType, priority: ProjectPriorityType, developmentType?: DevelopmentTypeEnum | null, projectPhase?: ProjectPhaseType | null, progress: number, constitutionalFacts: Record<string, any>, constitutionalVersion: number, constitutionalApprovedBy?: string | null, constitutionalApprovedAt?: string | null, hasApprovedConstitution: boolean, contextAnalysis: Record<string, any>, contextAnalysisUpdatedAt?: string | null, settings: Record<string, any>, projectMetadata?: Record<string, any> | null, tags?: Array<string | null> | null, color?: string | null, isActive: boolean, isArchived: boolean, archivedAt?: string | null, isDeleted: boolean, deletedAt?: string | null, createdAt: string, updatedAt: string, isInProgress: boolean, isCompleted: boolean, canStart: boolean, systemInstanceId?: string | null, kind?: string | null, gitBranch?: string | null, prUrl?: string | null, prNumber?: number | null, promptEvolution: { __typename?: 'PromptEvolution', core: string, version: number, updatedAt: string, history: Record<string, any> }, progressInfo: { __typename?: 'ProjectProgress', progress: number, status: string }, constitutionalLaws: { __typename?: 'ConstitutionalLaws', needs: Array<string | null>, seeds: Array<string | null> } }> } };

export type GetProjectConstitutionQueryVariables = Exact<{
  projectId: Scalars['UUID']['input'];
}>;


export type GetProjectConstitutionQuery = { __typename?: 'Query', projectConstitution: { __typename?: 'ProjectConstitution', projectId: string, version: number, approvedBy?: string | null, approvedAt?: string | null, needsLaws: Array<string>, seedsLaws: Array<string>, lastAnalysisAt?: string | null, totalFactsCount: number, confirmedFactsCount: number, pendingFactsCount: number, facts: Array<{ __typename?: 'ConstitutionFactEntry', key: string, fact: { __typename?: 'ConstitutionFact', key: string, value: Record<string, any>, factType: ConstitutionFactType, sourceType: ConstitutionFactSource, sourceRef?: string | null, confidence: number, extractedAt?: string | null, notes?: string | null } }>, history: Array<{ __typename?: 'ConstitutionHistoryEntry', version: number, changedAt: string, changedBy: string, changes: Array<string>, factsSnapshot: Record<string, any>, reason?: string | null }> } };

export type GetConstitutionCandidatesQueryVariables = Exact<{
  projectId: Scalars['UUID']['input'];
}>;


export type GetConstitutionCandidatesQuery = { __typename?: 'Query', constitutionCandidates: Array<{ __typename?: 'ConstitutionCandidate', id: string, factType: ConstitutionFactType, key: string, value: Record<string, any>, source: string, confidence: number, reasoning: string, extractedFrom: string, createdAt: string }> };

export type GetProjectDeliverableQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetProjectDeliverableQuery = { __typename?: 'Query', projectDeliverable?: { __typename?: 'ProjectDeliverableType', id: string, projectId: string, name: string, description?: string | null, priority: string, enabledScenes: Array<string>, version: number, progress: number, estimatedHours?: number | null, actualHours?: number | null, createdBy: string, createdAt: string, updatedAt?: string | null, isCompleted: boolean, completionPercentage: number, bcCount: number, publicPageCount: number, adminPageCount: number, boundedContexts: Array<{ __typename?: 'BoundedContextType', name: string, nameJa: string, type: string, justification: string, integrationApi?: string | null, isFrozen: boolean, entityCount: number, dynamicSpec?: Record<string, any> | null, publishes: Array<{ __typename?: 'BCEventType', name: string, description: string, payloadFields: Array<string>, sourceBc?: string | null, action?: string | null }>, subscribes: Array<{ __typename?: 'BCEventType', name: string, description: string, payloadFields: Array<string>, sourceBc?: string | null, action?: string | null }>, refs: Array<{ __typename?: 'BCRefType', targetBc: string, targetEntity: string, rpc: string, listRpc?: string | null, purpose?: string | null, sourceField?: string | null }>, entities: Array<{ __typename?: 'DynamicEntitySummaryType', name: string, nameJa: string, fieldCount: number, keyFields: Array<string> }> }>, adminPages: Array<{ __typename?: 'AdminPageType', bc: string, entity: string, role: string, audience: string, enabledActions: Array<string>, labelJa?: string | null, description?: string | null }>, publicPages: Array<{ __typename?: 'PublicPageType', path: string, role: string, title: string, primaryBc?: string | null, primaryEntity?: string | null, secondaryBcs: Array<string>, displayFields: Array<string>, actions: Array<string>, audience: string, acceptance?: string | null, description?: string | null, requiresAuth: boolean }>, businessFlowStories: Array<{ __typename?: 'BusinessFlowStoryType', name: string, nameEn?: string | null, category: string, description?: string | null, priority: string, involvedBcs: Array<string>, steps: Array<{ __typename?: 'FlowStepType', order: number, actor: string, action: string, stepType: string, bc: string, entity?: string | null, pagePath?: string | null, isPublic: boolean, mutation?: string | null, query?: string | null, requiresAuth: boolean, triggerEvent?: string | null, triggerAction?: string | null, condition?: string | null, yesStep?: number | null, noStep?: number | null, notificationChannel?: string | null, description?: string | null }> }>, systemArchitecture?: { __typename?: 'SystemArchitectureType', architectureType: string, deploymentStrategy: string, componentCount: number, scalingConsiderations: Array<string>, componentsJson: string } | null } | null };

export type GetProjectDeliverablesQueryVariables = Exact<{
  filter?: InputMaybe<ProjectDeliverableFilterInput>;
}>;


export type GetProjectDeliverablesQuery = { __typename?: 'Query', projectDeliverables: { __typename?: 'ProjectDeliverableListResult', totalCount: number, deliverables: Array<{ __typename?: 'ProjectDeliverableType', id: string, projectId: string, name: string, description?: string | null, priority: string, enabledScenes: Array<string>, version: number, progress: number, estimatedHours?: number | null, actualHours?: number | null, createdBy: string, createdAt: string, updatedAt?: string | null, isCompleted: boolean, completionPercentage: number, bcCount: number, publicPageCount: number, adminPageCount: number, boundedContexts: Array<{ __typename?: 'BoundedContextType', name: string, nameJa: string, type: string, justification: string, integrationApi?: string | null, isFrozen: boolean, entityCount: number, dynamicSpec?: Record<string, any> | null }>, adminPages: Array<{ __typename?: 'AdminPageType', bc: string, entity: string, role: string, audience: string, enabledActions: Array<string>, labelJa?: string | null, description?: string | null }>, publicPages: Array<{ __typename?: 'PublicPageType', path: string, role: string, title: string, primaryBc?: string | null, primaryEntity?: string | null, secondaryBcs: Array<string>, displayFields: Array<string>, actions: Array<string>, audience: string, acceptance?: string | null, description?: string | null, requiresAuth: boolean }>, businessFlowStories: Array<{ __typename?: 'BusinessFlowStoryType', name: string, nameEn?: string | null, category: string, description?: string | null, priority: string, involvedBcs: Array<string> }>, systemArchitecture?: { __typename?: 'SystemArchitectureType', architectureType: string, deploymentStrategy: string, componentCount: number, scalingConsiderations: Array<string>, componentsJson: string } | null }> } };

export type GetProjectAiProposalStatesQueryVariables = Exact<{
  projectIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetProjectAiProposalStatesQuery = { __typename?: 'Query', projectAiProposalStates: Array<{ __typename?: 'ProjectAiProposalState', projectId: string, hasProposal: boolean, bcCount: number, adminPageCount: number, publicPageCount: number, deliverableVersion?: number | null, lastUpdatedAt?: string | null }> };

export type GetProjectScopesQueryVariables = Exact<{
  projectId: Scalars['UUID']['input'];
}>;


export type GetProjectScopesQuery = { __typename?: 'Query', projectScopes: Array<{ __typename?: 'ScopeType', id: string, name: string, origin: ScopeOriginType, rationale?: string | null, searchQuery?: string | null, boostKeywords: Array<string>, analysisLens?: string | null, projectId?: string | null, viewId: string, focusAtomIds: Array<string>, createdAt: string, plan?: string | null, functionCandidates: Array<{ __typename?: 'FunctionCandidateType', name: string, category?: string | null, description?: string | null, priority?: string | null, source?: string | null }> }> };

export type GetProjectViewsQueryVariables = Exact<{
  projectId: Scalars['UUID']['input'];
  limit?: Scalars['Int']['input'];
}>;


export type GetProjectViewsQuery = { __typename?: 'Query', projectViews: Array<{ __typename?: 'ViewType', id: string, projectId: string, sourceType: string, analysisSummary: string, analysisResult?: Record<string, any> | null, sourceAtomIds: Array<string>, scopeId?: string | null, generatedAt: string }> };

export type GetOrientForProjectQueryVariables = Exact<{
  projectId: Scalars['UUID']['input'];
}>;


export type GetOrientForProjectQuery = { __typename?: 'Query', orientForProject?: { __typename?: 'OrientType', id: string, projectId: string, summary: string, recommendations: Array<string>, confidence: number, modelUsed: string, generatedAt: string, userLockedFields: Array<string>, judgments: Array<{ __typename?: 'JudgmentType', aspect: string, assessment: string, severity: number, actionable: boolean }>, projectContext?: { __typename?: 'ProjectContextType', purpose: string, targetAudience: string, objectives: Array<string>, estimatedScale: string, additionalNotes: string } | null } | null };

export type GetProjectGroundedEntitiesQueryVariables = Exact<{
  projectId: Scalars['UUID']['input'];
}>;


export type GetProjectGroundedEntitiesQuery = { __typename?: 'Query', projectGroundedEntities: Array<{ __typename?: 'GroundedEntityType', name: string, canonicalName?: string | null, entityType?: string | null, category?: string | null, description?: string | null, officialUrl?: string | null, providerCompany?: string | null, keyFeatures: Array<string>, technologyStack: Array<string>, integrationProtocols: Array<string>, industryRelevance?: string | null, confidence?: number | null, resolvedAt?: string | null, atomCount: number }> };

export type GetArtifactDddQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetArtifactDddQuery = { __typename?: 'Query', artifactDdd?: { __typename?: 'ArtifactDDD', id: string, projectId: string, artifactType: string, title: string, description?: string | null, format: string, content?: string | null, fileUrl?: string | null, fileSize?: number | null, status: string, metadata?: Record<string, any> | null, createdBy: string, createdAt: string, generatedAt?: string | null, systemSpecData?: Record<string, any> | null, proposalMetadata?: { __typename?: 'ProposalMetadata', style?: string | null, includesDeliverables?: boolean | null, includesSitemap?: boolean | null, includesTechSpecs?: boolean | null, deliverablesCount?: number | null, sitemapPagesCount?: number | null, techComponentsCount?: number | null, estimatedReadingTime?: number | null, targetAudience?: string | null, totalContentLength?: number | null, dataSource?: string | null } | null } | null };

export type GetArtifactsDddQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  artifactType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetArtifactsDddQuery = { __typename?: 'Query', artifactsDdd: Array<{ __typename?: 'ArtifactDDD', id: string, projectId: string, artifactType: string, title: string, description?: string | null, format: string, content?: string | null, fileUrl?: string | null, fileSize?: number | null, status: string, metadata?: Record<string, any> | null, createdBy: string, createdAt: string, generatedAt?: string | null, systemSpecData?: Record<string, any> | null, proposalMetadata?: { __typename?: 'ProposalMetadata', style?: string | null, includesDeliverables?: boolean | null, includesSitemap?: boolean | null, includesTechSpecs?: boolean | null, deliverablesCount?: number | null, sitemapPagesCount?: number | null, techComponentsCount?: number | null, estimatedReadingTime?: number | null, targetAudience?: string | null, totalContentLength?: number | null, dataSource?: string | null } | null }> };

export type GetProjectArtifactsDddQueryVariables = Exact<{
  projectId: Scalars['UUID']['input'];
  artifactType?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProjectArtifactsDddQuery = { __typename?: 'Query', projectArtifactsDdd: { __typename?: 'ArtifactDDDConnection', totalCount: number, edges: Array<{ __typename?: 'ArtifactDDDEdge', cursor: string, node: { __typename?: 'ArtifactDDD', id: string, projectId: string, artifactType: string, title: string, description?: string | null, format: string, content?: string | null, fileUrl?: string | null, fileSize?: number | null, status: string, metadata?: Record<string, any> | null, createdBy: string, createdAt: string, generatedAt?: string | null, systemSpecData?: Record<string, any> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetArtifactPreviewHtmlQueryVariables = Exact<{
  artifactId: Scalars['UUID']['input'];
  colorScheme?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetArtifactPreviewHtmlQuery = { __typename?: 'Query', artifactPreviewHtml?: string | null };

export type GetAvailableProposalsQueryVariables = Exact<{
  projectId: Scalars['UUID']['input'];
}>;


export type GetAvailableProposalsQuery = { __typename?: 'Query', availableProposals: Array<{ __typename?: 'ArtifactDDD', id: string, projectId: string, artifactType: string, title: string, description?: string | null, format: string, content?: string | null, fileUrl?: string | null, fileSize?: number | null, status: string, metadata?: Record<string, any> | null, createdBy: string, createdAt: string, generatedAt?: string | null, systemSpecData?: Record<string, any> | null, proposalMetadata?: { __typename?: 'ProposalMetadata', style?: string | null, includesDeliverables?: boolean | null, includesSitemap?: boolean | null, includesTechSpecs?: boolean | null, deliverablesCount?: number | null, sitemapPagesCount?: number | null, techComponentsCount?: number | null, estimatedReadingTime?: number | null, targetAudience?: string | null, totalContentLength?: number | null, dataSource?: string | null } | null }> };

export type GetUiProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUiProjectsQuery = { __typename?: 'Query', uiProjects: Array<{ __typename?: 'UIProjectListItem', id: string, name: string, description: string, status: string, pagesCount: number, qualityScore: number, createdAt: string, updatedAt: string }> };

export type GetUiProjectQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetUiProjectQuery = { __typename?: 'Query', uiProject?: { __typename?: 'UIProject', id: string, name: string, description: string, createdAt: string, updatedAt: string, status: string, sitemap: string, pagesCount: number, generatedFilesCount: number, qualityScore: number, generationTime: number, uiMockUrl?: string | null, errors: Array<string>, warnings: Array<string> } | null };

export type GetProposeProposalStructureQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  outputFormat?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetProposeProposalStructureQuery = { __typename?: 'Query', proposeProposalStructure: { __typename?: 'ProposalStructurePreviewType', proposalId: string, totalPages: number, sections: Array<{ __typename?: 'ProposedSectionType', sectionId: string, sectionTitle: string, required: boolean, pages: Array<{ __typename?: 'ProposedPageType', pageNumber: number, pageType: string, sectionId: string, sectionTitle: string, subsectionTitle?: string | null, contentType?: string | null, templateName?: string | null, targetLength?: number | null }> }> } };

export type GetArtifactProposalStructureQueryVariables = Exact<{
  artifactId: Scalars['String']['input'];
}>;


export type GetArtifactProposalStructureQuery = { __typename?: 'Query', artifactProposalStructure: { __typename?: 'ProposalStructurePreviewType', proposalId: string, totalPages: number, sections: Array<{ __typename?: 'ProposedSectionType', sectionId: string, sectionTitle: string, required: boolean, pages: Array<{ __typename?: 'ProposedPageType', pageNumber: number, pageType: string, sectionId: string, sectionTitle: string, subsectionTitle?: string | null, contentType?: string | null, templateName?: string | null, targetLength?: number | null }> }> } };

export type GetPreviewProjectIntegrationQueryVariables = Exact<{
  projectId: Scalars['UUID']['input'];
  systemInstanceId: Scalars['UUID']['input'];
}>;


export type GetPreviewProjectIntegrationQuery = { __typename?: 'Query', previewProjectIntegration?: { __typename?: 'IntegrationPreviewType', projectId: string, systemInstanceId: string, currentBcSet: Array<string>, proposedAdditions: Array<string>, actuallyAdded: Array<string>, alreadyInSet: Array<string>, resultingBcSet: Array<string>, regenNeeded: boolean, bcSummaries: Array<{ __typename?: 'BcSummaryType', bcName: string, nameJa?: string | null, entityCount: number, publishesEventCount: number, dependsOn: Array<string> }> } | null };

export type GetDesignProposalsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetDesignProposalsQuery = { __typename?: 'Query', designProposals: Array<{ __typename?: 'DesignProposalType', id: string, projectId: string, conceptName: string, conceptDescription?: string | null, designGuidelines?: Record<string, any> | null, referenceUrls?: Array<string> | null, status: string, isSelected: boolean, errorMessage?: string | null, createdAt?: string | null }> };

export type GetDesignProposalPreviewHtmlQueryVariables = Exact<{
  proposalId: Scalars['ID']['input'];
}>;


export type GetDesignProposalPreviewHtmlQuery = { __typename?: 'Query', designProposalPreviewHtml?: string | null };

export type GetDeploymentsByProjectQueryVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type GetDeploymentsByProjectQuery = { __typename?: 'Query', deploymentsByProject: { __typename?: 'DeploymentListType', totalCount: number, deployments: Array<{ __typename?: 'DeploymentType', id: string, projectId: string, artifactId: string, createdBy: string, name: string, providerType: string, status: string, currentStage?: string | null, pipelineProgress?: Record<string, any> | null, liveUrl?: string | null, githubRepoUrl?: string | null, errorMessage?: string | null, retryCount: number, progressPercentage: number, createdAt?: string | null, startedAt?: string | null, completedAt?: string | null }> } };

export type GenerateConsolidatedSitemapMutationVariables = Exact<{
  projectId: Scalars['String']['input'];
  input?: InputMaybe<GenerateConsolidatedSitemapInput>;
}>;


export type GenerateConsolidatedSitemapMutation = { __typename?: 'Mutation', generateConsolidatedSitemap: { __typename?: 'ConsolidatedSitemapGenerationResult', success: boolean, totalPages: number, functionCategories: Array<string>, generationTimeMs: number, sitemapJson?: string | null, errors: Array<string>, warnings: Array<string> } };

export type ConsolidatedDeliverableUpdatesSubscriptionVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type ConsolidatedDeliverableUpdatesSubscription = { __typename?: 'Subscription', consolidatedDeliverableUpdates: { __typename?: 'ConsolidatedDeliverableEvent', id: string, type: EventType, timestamp: string, traceId?: string | null, projectId: string, userId: string, taskId?: string | null, status?: string | null, progress?: number | null, errorMessage?: string | null, deliverableId?: string | null, deliverableName?: string | null, functionsCount?: number | null, projectAnalysis?: string | null, sitemapGenerated?: boolean | null, sitemapPages?: number | null, data?: Record<string, any> | null } };

export type UnifiedContentUpdatesSubscriptionVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type UnifiedContentUpdatesSubscription = { __typename?: 'Subscription', unifiedContentUpdates: { __typename?: 'UnifiedContentEvent', id: string, type: EventType, timestamp: string, traceId?: string | null, projectId: string, userId: string, taskId?: string | null, status?: string | null, progress?: number | null, errorMessage?: string | null, contentType?: string | null, outputFormat?: string | null, currentStep?: string | null, artifactId?: string | null, fileUrl?: string | null, fileSize?: number | null, data?: Record<string, any> | null } };

export type AtomProcessingUpdatesSubscriptionVariables = Exact<{
  projectId?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  atomId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AtomProcessingUpdatesSubscription = { __typename?: 'Subscription', atomProcessingUpdates: { __typename?: 'AtomEvent', id: string, type: EventType, timestamp: string, traceId?: string | null, atomId: string, projectId?: string | null, userId: string, title?: string | null, atomType?: string | null, status?: string | null, progress?: number | null, errorMessage?: string | null, extractionResult?: Record<string, any> | null, metadata?: Record<string, any> | null } };

export type ClientResearchUpdatesSubscriptionVariables = Exact<{
  clientId: Scalars['String']['input'];
}>;


export type ClientResearchUpdatesSubscription = { __typename?: 'Subscription', clientResearchUpdates: { __typename?: 'ClientResearchEvent', id: string, type: EventType, timestamp: string, traceId?: string | null, clientId: string, taskId?: string | null, status?: string | null, progress?: number | null, errorMessage?: string | null, clientName?: string | null, message?: string | null, data?: Record<string, any> | null } };

export type CompanyProfileResearchUpdatesSubscriptionVariables = Exact<{
  companyProfileId: Scalars['String']['input'];
}>;


export type CompanyProfileResearchUpdatesSubscription = { __typename?: 'Subscription', companyProfileResearchUpdates: { __typename?: 'CompanyProfileResearchEvent', id: string, type: EventType, timestamp: string, traceId?: string | null, companyProfileId: string, taskId?: string | null, status?: string | null, progress?: number | null, errorMessage?: string | null, companyName?: string | null, message?: string | null, data?: Record<string, any> | null } };

export type IndustryResearchUpdatesSubscriptionVariables = Exact<{
  industryId: Scalars['String']['input'];
}>;


export type IndustryResearchUpdatesSubscription = { __typename?: 'Subscription', industryResearchUpdates: { __typename?: 'IndustryResearchEvent', id: string, type: EventType, timestamp: string, traceId?: string | null, industryId: string, taskId?: string | null, status?: string | null, progress?: number | null, errorMessage?: string | null, industryName?: string | null, message?: string | null, data?: Record<string, any> | null } };

export type PrismScopeUpdatesSubscriptionVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type PrismScopeUpdatesSubscription = { __typename?: 'Subscription', prismScopeUpdates: { __typename?: 'PrismScopeEvent', id: string, type: EventType, timestamp: string, traceId?: string | null, projectId: string, taskId?: string | null, status?: string | null, progress?: number | null, errorMessage?: string | null, scopeCount?: number | null, message?: string | null, data?: Record<string, any> | null } };

export type ApiCrawlUpdatesSubscriptionVariables = Exact<{
  catalogId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ApiCrawlUpdatesSubscription = { __typename?: 'Subscription', apiCrawlUpdates: { __typename?: 'ApiCrawlEvent', id: string, type: EventType, timestamp: string, traceId?: string | null, catalogId: string, serviceName: string, status?: string | null, progress?: number | null, message?: string | null, errorMessage?: string | null, endpointCount?: number | null, taskId?: string | null, data?: Record<string, any> | null } };

export type PrismOrientUpdatesSubscriptionVariables = Exact<{
  projectId: Scalars['String']['input'];
}>;


export type PrismOrientUpdatesSubscription = { __typename?: 'Subscription', prismOrientUpdates: { __typename?: 'PrismOrientEvent', id: string, type: EventType, timestamp: string, traceId?: string | null, projectId: string, taskId?: string | null, status?: string | null, progress?: number | null, errorMessage?: string | null, orientId?: string | null, message?: string | null, data?: Record<string, any> | null } };

export type CreateSystemInstanceMutationVariables = Exact<{
  input: CreateSystemInstanceInput;
}>;


export type CreateSystemInstanceMutation = { __typename?: 'Mutation', createSystemInstance: { __typename?: 'SystemInstanceOperationResult', success: boolean, errorMessage?: string | null, instance?: { __typename?: 'SystemInstanceType', id: string, organizationId: string, clientId?: string | null, name: string, slug: string, isMain: boolean, outputPath: string, githubRepoName?: string | null, gitDefaultBranch: string, vpsHost?: string | null, vpsUser?: string | null, vpsDeploymentConfig?: Record<string, any> | null, portOffset: number, deploymentStatus: DeploymentStatusType, lastGeneratedAt?: string | null, lastDeployedAt?: string | null, archivedAt?: string | null, createdAt: string, updatedAt: string, hasGit: boolean, hasVps: boolean, isArchived: boolean, hasGithubToken: boolean, deployTarget: DeployTargetType, subdomainUrl?: string | null } | null } };

export type UpdateSystemInstanceMutationVariables = Exact<{
  input: UpdateSystemInstanceInput;
}>;


export type UpdateSystemInstanceMutation = { __typename?: 'Mutation', updateSystemInstance: { __typename?: 'SystemInstanceOperationResult', success: boolean, errorMessage?: string | null, instance?: { __typename?: 'SystemInstanceType', id: string, organizationId: string, clientId?: string | null, name: string, slug: string, isMain: boolean, outputPath: string, githubRepoName?: string | null, gitDefaultBranch: string, vpsHost?: string | null, vpsUser?: string | null, vpsDeploymentConfig?: Record<string, any> | null, portOffset: number, deploymentStatus: DeploymentStatusType, lastGeneratedAt?: string | null, lastDeployedAt?: string | null, archivedAt?: string | null, createdAt: string, updatedAt: string, hasGit: boolean, hasVps: boolean, isArchived: boolean, hasGithubToken: boolean, deployTarget: DeployTargetType, subdomainUrl?: string | null } | null } };

export type ArchiveSystemInstanceMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type ArchiveSystemInstanceMutation = { __typename?: 'Mutation', archiveSystemInstance: { __typename?: 'SystemInstanceOperationResult', success: boolean, errorMessage?: string | null, instance?: { __typename?: 'SystemInstanceType', id: string, organizationId: string, clientId?: string | null, name: string, slug: string, isMain: boolean, outputPath: string, githubRepoName?: string | null, gitDefaultBranch: string, vpsHost?: string | null, vpsUser?: string | null, vpsDeploymentConfig?: Record<string, any> | null, portOffset: number, deploymentStatus: DeploymentStatusType, lastGeneratedAt?: string | null, lastDeployedAt?: string | null, archivedAt?: string | null, createdAt: string, updatedAt: string, hasGit: boolean, hasVps: boolean, isArchived: boolean, hasGithubToken: boolean, deployTarget: DeployTargetType, subdomainUrl?: string | null } | null } };

export type DeploySystemInstanceLocalMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeploySystemInstanceLocalMutation = { __typename?: 'Mutation', deploySystemInstanceLocal: { __typename?: 'LocalHostDeployResult', success: boolean, systemInstanceId: string, subdomainUrl?: string | null, teardownCount: number, steps: Array<string>, errorMessage?: string | null } };

export type UnarchiveSystemInstanceMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type UnarchiveSystemInstanceMutation = { __typename?: 'Mutation', unarchiveSystemInstance: { __typename?: 'SystemInstanceOperationResult', success: boolean, errorMessage?: string | null, instance?: { __typename?: 'SystemInstanceType', id: string, organizationId: string, clientId?: string | null, name: string, slug: string, isMain: boolean, outputPath: string, githubRepoName?: string | null, gitDefaultBranch: string, vpsHost?: string | null, vpsUser?: string | null, vpsDeploymentConfig?: Record<string, any> | null, portOffset: number, deploymentStatus: DeploymentStatusType, lastGeneratedAt?: string | null, lastDeployedAt?: string | null, archivedAt?: string | null, createdAt: string, updatedAt: string, hasGit: boolean, hasVps: boolean, isArchived: boolean, hasGithubToken: boolean, deployTarget: DeployTargetType, subdomainUrl?: string | null } | null } };

export type SetAsMainSystemInstanceMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SetAsMainSystemInstanceMutation = { __typename?: 'Mutation', setAsMainSystemInstance: { __typename?: 'SystemInstanceOperationResult', success: boolean, errorMessage?: string | null, instance?: { __typename?: 'SystemInstanceType', id: string, organizationId: string, clientId?: string | null, name: string, slug: string, isMain: boolean, outputPath: string, githubRepoName?: string | null, gitDefaultBranch: string, vpsHost?: string | null, vpsUser?: string | null, vpsDeploymentConfig?: Record<string, any> | null, portOffset: number, deploymentStatus: DeploymentStatusType, lastGeneratedAt?: string | null, lastDeployedAt?: string | null, archivedAt?: string | null, createdAt: string, updatedAt: string, hasGit: boolean, hasVps: boolean, isArchived: boolean, hasGithubToken: boolean, deployTarget: DeployTargetType, subdomainUrl?: string | null } | null } };

export type MarkSystemInstanceGeneratedMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type MarkSystemInstanceGeneratedMutation = { __typename?: 'Mutation', markSystemInstanceGenerated: { __typename?: 'SystemInstanceOperationResult', success: boolean, errorMessage?: string | null, instance?: { __typename?: 'SystemInstanceType', id: string, organizationId: string, clientId?: string | null, name: string, slug: string, isMain: boolean, outputPath: string, githubRepoName?: string | null, gitDefaultBranch: string, vpsHost?: string | null, vpsUser?: string | null, vpsDeploymentConfig?: Record<string, any> | null, portOffset: number, deploymentStatus: DeploymentStatusType, lastGeneratedAt?: string | null, lastDeployedAt?: string | null, archivedAt?: string | null, createdAt: string, updatedAt: string, hasGit: boolean, hasVps: boolean, isArchived: boolean, hasGithubToken: boolean, deployTarget: DeployTargetType, subdomainUrl?: string | null } | null } };

export type MarkSystemInstancePushedMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type MarkSystemInstancePushedMutation = { __typename?: 'Mutation', markSystemInstancePushed: { __typename?: 'SystemInstanceOperationResult', success: boolean, errorMessage?: string | null, instance?: { __typename?: 'SystemInstanceType', id: string, organizationId: string, clientId?: string | null, name: string, slug: string, isMain: boolean, outputPath: string, githubRepoName?: string | null, gitDefaultBranch: string, vpsHost?: string | null, vpsUser?: string | null, vpsDeploymentConfig?: Record<string, any> | null, portOffset: number, deploymentStatus: DeploymentStatusType, lastGeneratedAt?: string | null, lastDeployedAt?: string | null, archivedAt?: string | null, createdAt: string, updatedAt: string, hasGit: boolean, hasVps: boolean, isArchived: boolean, hasGithubToken: boolean, deployTarget: DeployTargetType, subdomainUrl?: string | null } | null } };

export type MarkSystemInstanceRunningMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type MarkSystemInstanceRunningMutation = { __typename?: 'Mutation', markSystemInstanceRunning: { __typename?: 'SystemInstanceOperationResult', success: boolean, errorMessage?: string | null, instance?: { __typename?: 'SystemInstanceType', id: string, organizationId: string, clientId?: string | null, name: string, slug: string, isMain: boolean, outputPath: string, githubRepoName?: string | null, gitDefaultBranch: string, vpsHost?: string | null, vpsUser?: string | null, vpsDeploymentConfig?: Record<string, any> | null, portOffset: number, deploymentStatus: DeploymentStatusType, lastGeneratedAt?: string | null, lastDeployedAt?: string | null, archivedAt?: string | null, createdAt: string, updatedAt: string, hasGit: boolean, hasVps: boolean, isArchived: boolean, hasGithubToken: boolean, deployTarget: DeployTargetType, subdomainUrl?: string | null } | null } };

export type DeploySystemInstanceViaSshMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeploySystemInstanceViaSshMutation = { __typename?: 'Mutation', deploySystemInstanceViaSsh: { __typename?: 'SshDeployResult', success: boolean, errorMessage?: string | null, transferredBytes: number, elapsedSeconds: number, healthPassed: boolean, markedRunning: boolean, connected: boolean, transferred: boolean, composeUp: boolean, alembicAttempted: boolean, alembicSuccess: boolean, logTail: string } };

export type CheckSystemInstanceDeployStatusMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CheckSystemInstanceDeployStatusMutation = { __typename?: 'Mutation', checkSystemInstanceDeployStatus: { __typename?: 'DeployStatusResult', attempted: boolean, reason?: string | null, found: boolean, runId?: number | null, status?: string | null, conclusion?: string | null, htmlUrl?: string | null, headSha?: string | null, createdAt?: string | null, updatedAt?: string | null, markedRunning: boolean, error?: string | null } };

export type CreateGithubRepoForSystemInstanceMutationVariables = Exact<{
  input: CreateGithubRepoForSystemInstanceInput;
}>;


export type CreateGithubRepoForSystemInstanceMutation = { __typename?: 'Mutation', createGithubRepoForSystemInstance: { __typename?: 'CreateGithubRepoResult', success: boolean, repoUrl?: string | null, fullName?: string | null, githubRepoName?: string | null, errorMessage?: string | null } };

export type SetSystemInstanceVpsCredentialsMutationVariables = Exact<{
  input: SetVpsCredentialsInput;
}>;


export type SetSystemInstanceVpsCredentialsMutation = { __typename?: 'Mutation', setSystemInstanceVpsCredentials: { __typename?: 'SetVpsCredentialsResult', success: boolean, savedToDb: boolean, errorMessage?: string | null, githubSync?: { __typename?: 'GithubSecretSyncResult', attempted: boolean, reason?: string | null, allSuccess: boolean, setCount: number, skippedCount: number, entries: Array<{ __typename?: 'GithubSecretSyncEntry', secretName: string, success: boolean, error?: string | null }> } | null } };

export type GenerateSystemInstanceMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  dryRun?: Scalars['Boolean']['input'];
  force?: Scalars['Boolean']['input'];
}>;


export type GenerateSystemInstanceMutation = { __typename?: 'Mutation', generateSystemInstance: { __typename?: 'SystemGenerationResultGraphql', success: boolean, systemInstanceId: string, outputPath?: string | null, totalBcs: number, totalFiles: number, elapsedSeconds: number, capturedLog: string, errorMessage?: string | null, touchedBcs: Array<string>, isIncremental: boolean, gitCommitHash?: string | null, gitBranch?: string | null, gitError?: string | null, gitPushed: boolean, gitRemoteUrl?: string | null, gitPushError?: string | null, prUrl?: string | null, prNumber?: number | null, prError?: string | null } };

export type IntegrateProjectIntoSystemInstanceMutationVariables = Exact<{
  projectId: Scalars['UUID']['input'];
  systemInstanceId: Scalars['UUID']['input'];
}>;


export type IntegrateProjectIntoSystemInstanceMutation = { __typename?: 'Mutation', integrateProjectIntoSystemInstance: { __typename?: 'IntegrateProjectResultType', success: boolean, projectId?: string | null, systemInstanceId?: string | null, bcsAdded: Array<string>, newBcSet: Array<string>, regenNeeded: boolean, errorMessage?: string | null } };

export type GetHealthCheckQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHealthCheckQuery = { __typename?: 'Query', healthCheck: { __typename?: 'HealthCheck', status: string, version: string, timestamp: string } };

export type GetAnalysisCapabilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAnalysisCapabilitiesQuery = { __typename?: 'Query', analysisCapabilities: { __typename?: 'AnalysisCapabilities', version: string, capabilities: Record<string, any>, performance: Record<string, any> } };

export type GetSystemGenerationStatusQueryVariables = Exact<{
  taskId: Scalars['String']['input'];
}>;


export type GetSystemGenerationStatusQuery = { __typename?: 'Query', systemGenerationStatus: { __typename?: 'SystemGenerationStatusResponse', status: string, progress?: number | null, error?: string | null, result?: { __typename?: 'LegacySystemGenerationResult', totalLines: number, qualityScore: number, deploymentUrl?: string | null, metadata?: Record<string, any> | null, files: Array<{ __typename?: 'GenerationFile', path: string, type: string, lines: number, content?: string | null }> } | null } };

export type GetSystemInstanceQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetSystemInstanceQuery = { __typename?: 'Query', systemInstance?: { __typename?: 'SystemInstanceType', id: string, organizationId: string, clientId?: string | null, name: string, slug: string, isMain: boolean, outputPath: string, githubRepoName?: string | null, gitDefaultBranch: string, vpsHost?: string | null, vpsUser?: string | null, vpsDeploymentConfig?: Record<string, any> | null, portOffset: number, deploymentStatus: DeploymentStatusType, lastGeneratedAt?: string | null, lastDeployedAt?: string | null, archivedAt?: string | null, createdAt: string, updatedAt: string, hasGit: boolean, hasVps: boolean, isArchived: boolean, hasGithubToken: boolean, deployTarget: DeployTargetType, subdomainUrl?: string | null } | null };

export type GetSystemInstancesQueryVariables = Exact<{
  includeArchived?: Scalars['Boolean']['input'];
}>;


export type GetSystemInstancesQuery = { __typename?: 'Query', systemInstances: Array<{ __typename?: 'SystemInstanceType', id: string, organizationId: string, clientId?: string | null, name: string, slug: string, isMain: boolean, outputPath: string, githubRepoName?: string | null, gitDefaultBranch: string, vpsHost?: string | null, vpsUser?: string | null, vpsDeploymentConfig?: Record<string, any> | null, portOffset: number, deploymentStatus: DeploymentStatusType, lastGeneratedAt?: string | null, lastDeployedAt?: string | null, archivedAt?: string | null, createdAt: string, updatedAt: string, hasGit: boolean, hasVps: boolean, isArchived: boolean, hasGithubToken: boolean, deployTarget: DeployTargetType, subdomainUrl?: string | null }> };

export type GetMainSystemInstanceQueryVariables = Exact<{
  clientId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GetMainSystemInstanceQuery = { __typename?: 'Query', mainSystemInstance?: { __typename?: 'SystemInstanceType', id: string, organizationId: string, clientId?: string | null, name: string, slug: string, isMain: boolean, outputPath: string, githubRepoName?: string | null, gitDefaultBranch: string, vpsHost?: string | null, vpsUser?: string | null, vpsDeploymentConfig?: Record<string, any> | null, portOffset: number, deploymentStatus: DeploymentStatusType, lastGeneratedAt?: string | null, lastDeployedAt?: string | null, archivedAt?: string | null, createdAt: string, updatedAt: string, hasGit: boolean, hasVps: boolean, isArchived: boolean, hasGithubToken: boolean, deployTarget: DeployTargetType, subdomainUrl?: string | null } | null };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'UserType', id: string, email: string, username?: string | null, displayName: string, authProvider: AuthProviderType, avatarUrl?: string | null, bio?: string | null, timezone: string, locale: string, status: UserStatusType, isEmailVerified: boolean, createdAt: string, updatedAt: string, lastLoginAt?: string | null, loginCount: number, fullName: string, isActive: boolean, organizations: Array<{ __typename?: 'OrganizationType', id: string, name: string, slug: string, domain?: string | null, description?: string | null, billingEmail?: string | null, billingAddress?: string | null, billingContact?: string | null, taxId?: string | null, planType: PlanType, maxUsers: number, maxClients: number, maxProjects: number, storageLimitGb: number, sharedKnowledgeEnabled: boolean, requireEmailVerification: boolean, isActive: boolean, isVerified: boolean, createdAt: string, updatedAt: string, isFreePlan: boolean, isEnterprisePlan: boolean, activeUserCount: number, activeProjectCount: number, storageUsageGb: number }>, organization?: { __typename?: 'OrganizationType', id: string, name: string, slug: string, domain?: string | null, description?: string | null, billingEmail?: string | null, billingAddress?: string | null, billingContact?: string | null, taxId?: string | null, planType: PlanType, maxUsers: number, maxClients: number, maxProjects: number, storageLimitGb: number, sharedKnowledgeEnabled: boolean, requireEmailVerification: boolean, isActive: boolean, isVerified: boolean, createdAt: string, updatedAt: string, isFreePlan: boolean, isEnterprisePlan: boolean, activeUserCount: number, activeProjectCount: number, storageUsageGb: number } | null, ownedProjects: Array<{ __typename?: 'Project', id: string, name: string, description?: string | null, clientId?: string | null, organizationId: string, ownerId: string, groupId?: string | null, projectType: ProjectTypeEnum, status: ProjectStatusType, priority: ProjectPriorityType, developmentType?: DevelopmentTypeEnum | null, projectPhase?: ProjectPhaseType | null, progress: number, constitutionalFacts: Record<string, any>, constitutionalVersion: number, constitutionalApprovedBy?: string | null, constitutionalApprovedAt?: string | null, hasApprovedConstitution: boolean, contextAnalysis: Record<string, any>, contextAnalysisUpdatedAt?: string | null, settings: Record<string, any>, projectMetadata?: Record<string, any> | null, tags?: Array<string | null> | null, color?: string | null, isActive: boolean, isArchived: boolean, archivedAt?: string | null, isDeleted: boolean, deletedAt?: string | null, createdAt: string, updatedAt: string, isInProgress: boolean, isCompleted: boolean, canStart: boolean, systemInstanceId?: string | null, kind?: string | null, gitBranch?: string | null, prUrl?: string | null, prNumber?: number | null, promptEvolution: { __typename?: 'PromptEvolution', core: string, version: number, updatedAt: string, history: Record<string, any> }, progressInfo: { __typename?: 'ProjectProgress', progress: number, status: string }, constitutionalLaws: { __typename?: 'ConstitutionalLaws', needs: Array<string | null>, seeds: Array<string | null> } }> } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserType', id: string, email: string, username?: string | null, displayName: string, authProvider: AuthProviderType, avatarUrl?: string | null, bio?: string | null, timezone: string, locale: string, status: UserStatusType, isEmailVerified: boolean, createdAt: string, updatedAt: string, lastLoginAt?: string | null, loginCount: number, fullName: string, isActive: boolean, organizations: Array<{ __typename?: 'OrganizationType', id: string, name: string, slug: string, domain?: string | null, description?: string | null, billingEmail?: string | null, billingAddress?: string | null, billingContact?: string | null, taxId?: string | null, planType: PlanType, maxUsers: number, maxClients: number, maxProjects: number, storageLimitGb: number, sharedKnowledgeEnabled: boolean, requireEmailVerification: boolean, isActive: boolean, isVerified: boolean, createdAt: string, updatedAt: string, isFreePlan: boolean, isEnterprisePlan: boolean, activeUserCount: number, activeProjectCount: number, storageUsageGb: number }>, organization?: { __typename?: 'OrganizationType', id: string, name: string, slug: string, domain?: string | null, description?: string | null, billingEmail?: string | null, billingAddress?: string | null, billingContact?: string | null, taxId?: string | null, planType: PlanType, maxUsers: number, maxClients: number, maxProjects: number, storageLimitGb: number, sharedKnowledgeEnabled: boolean, requireEmailVerification: boolean, isActive: boolean, isVerified: boolean, createdAt: string, updatedAt: string, isFreePlan: boolean, isEnterprisePlan: boolean, activeUserCount: number, activeProjectCount: number, storageUsageGb: number } | null, ownedProjects: Array<{ __typename?: 'Project', id: string, name: string, description?: string | null, clientId?: string | null, organizationId: string, ownerId: string, groupId?: string | null, projectType: ProjectTypeEnum, status: ProjectStatusType, priority: ProjectPriorityType, developmentType?: DevelopmentTypeEnum | null, projectPhase?: ProjectPhaseType | null, progress: number, constitutionalFacts: Record<string, any>, constitutionalVersion: number, constitutionalApprovedBy?: string | null, constitutionalApprovedAt?: string | null, hasApprovedConstitution: boolean, contextAnalysis: Record<string, any>, contextAnalysisUpdatedAt?: string | null, settings: Record<string, any>, projectMetadata?: Record<string, any> | null, tags?: Array<string | null> | null, color?: string | null, isActive: boolean, isArchived: boolean, archivedAt?: string | null, isDeleted: boolean, deletedAt?: string | null, createdAt: string, updatedAt: string, isInProgress: boolean, isCompleted: boolean, canStart: boolean, systemInstanceId?: string | null, kind?: string | null, gitBranch?: string | null, prUrl?: string | null, prNumber?: number | null, promptEvolution: { __typename?: 'PromptEvolution', core: string, version: number, updatedAt: string, history: Record<string, any> }, progressInfo: { __typename?: 'ProjectProgress', progress: number, status: string }, constitutionalLaws: { __typename?: 'ConstitutionalLaws', needs: Array<string | null>, seeds: Array<string | null> } }> } };

export type ChangeUserStatusMutationVariables = Exact<{
  userId: Scalars['UUID']['input'];
  status: UserStatusType;
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChangeUserStatusMutation = { __typename?: 'Mutation', changeUserStatus: boolean };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: boolean };

export type HardDeleteUserMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type HardDeleteUserMutation = { __typename?: 'Mutation', hardDeleteUser: boolean };

export type RestoreUserMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type RestoreUserMutation = { __typename?: 'Mutation', restoreUser?: { __typename?: 'UserType', id: string, email: string, username?: string | null, displayName: string, authProvider: AuthProviderType, avatarUrl?: string | null, bio?: string | null, timezone: string, locale: string, status: UserStatusType, isEmailVerified: boolean, createdAt: string, updatedAt: string, lastLoginAt?: string | null, loginCount: number, fullName: string, isActive: boolean, organizations: Array<{ __typename?: 'OrganizationType', id: string, name: string, slug: string, domain?: string | null, description?: string | null, billingEmail?: string | null, billingAddress?: string | null, billingContact?: string | null, taxId?: string | null, planType: PlanType, maxUsers: number, maxClients: number, maxProjects: number, storageLimitGb: number, sharedKnowledgeEnabled: boolean, requireEmailVerification: boolean, isActive: boolean, isVerified: boolean, createdAt: string, updatedAt: string, isFreePlan: boolean, isEnterprisePlan: boolean, activeUserCount: number, activeProjectCount: number, storageUsageGb: number }>, organization?: { __typename?: 'OrganizationType', id: string, name: string, slug: string, domain?: string | null, description?: string | null, billingEmail?: string | null, billingAddress?: string | null, billingContact?: string | null, taxId?: string | null, planType: PlanType, maxUsers: number, maxClients: number, maxProjects: number, storageLimitGb: number, sharedKnowledgeEnabled: boolean, requireEmailVerification: boolean, isActive: boolean, isVerified: boolean, createdAt: string, updatedAt: string, isFreePlan: boolean, isEnterprisePlan: boolean, activeUserCount: number, activeProjectCount: number, storageUsageGb: number } | null, ownedProjects: Array<{ __typename?: 'Project', id: string, name: string, description?: string | null, clientId?: string | null, organizationId: string, ownerId: string, groupId?: string | null, projectType: ProjectTypeEnum, status: ProjectStatusType, priority: ProjectPriorityType, developmentType?: DevelopmentTypeEnum | null, projectPhase?: ProjectPhaseType | null, progress: number, constitutionalFacts: Record<string, any>, constitutionalVersion: number, constitutionalApprovedBy?: string | null, constitutionalApprovedAt?: string | null, hasApprovedConstitution: boolean, contextAnalysis: Record<string, any>, contextAnalysisUpdatedAt?: string | null, settings: Record<string, any>, projectMetadata?: Record<string, any> | null, tags?: Array<string | null> | null, color?: string | null, isActive: boolean, isArchived: boolean, archivedAt?: string | null, isDeleted: boolean, deletedAt?: string | null, createdAt: string, updatedAt: string, isInProgress: boolean, isCompleted: boolean, canStart: boolean, systemInstanceId?: string | null, kind?: string | null, gitBranch?: string | null, prUrl?: string | null, prNumber?: number | null, promptEvolution: { __typename?: 'PromptEvolution', core: string, version: number, updatedAt: string, history: Record<string, any> }, progressInfo: { __typename?: 'ProjectProgress', progress: number, status: string }, constitutionalLaws: { __typename?: 'ConstitutionalLaws', needs: Array<string | null>, seeds: Array<string | null> } }> } | null };

export type GetUserQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetUserQuery = { __typename?: 'Query', user?: { __typename?: 'UserType', id: string, email: string, username?: string | null, displayName: string, authProvider: AuthProviderType, avatarUrl?: string | null, bio?: string | null, timezone: string, locale: string, status: UserStatusType, isEmailVerified: boolean, createdAt: string, updatedAt: string, lastLoginAt?: string | null, loginCount: number, fullName: string, isActive: boolean, organizations: Array<{ __typename?: 'OrganizationType', id: string, name: string, slug: string, domain?: string | null, description?: string | null, billingEmail?: string | null, billingAddress?: string | null, billingContact?: string | null, taxId?: string | null, planType: PlanType, maxUsers: number, maxClients: number, maxProjects: number, storageLimitGb: number, sharedKnowledgeEnabled: boolean, requireEmailVerification: boolean, isActive: boolean, isVerified: boolean, createdAt: string, updatedAt: string, isFreePlan: boolean, isEnterprisePlan: boolean, activeUserCount: number, activeProjectCount: number, storageUsageGb: number }>, organization?: { __typename?: 'OrganizationType', id: string, name: string, slug: string, domain?: string | null, description?: string | null, billingEmail?: string | null, billingAddress?: string | null, billingContact?: string | null, taxId?: string | null, planType: PlanType, maxUsers: number, maxClients: number, maxProjects: number, storageLimitGb: number, sharedKnowledgeEnabled: boolean, requireEmailVerification: boolean, isActive: boolean, isVerified: boolean, createdAt: string, updatedAt: string, isFreePlan: boolean, isEnterprisePlan: boolean, activeUserCount: number, activeProjectCount: number, storageUsageGb: number } | null, ownedProjects: Array<{ __typename?: 'Project', id: string, name: string, description?: string | null, clientId?: string | null, organizationId: string, ownerId: string, groupId?: string | null, projectType: ProjectTypeEnum, status: ProjectStatusType, priority: ProjectPriorityType, developmentType?: DevelopmentTypeEnum | null, projectPhase?: ProjectPhaseType | null, progress: number, constitutionalFacts: Record<string, any>, constitutionalVersion: number, constitutionalApprovedBy?: string | null, constitutionalApprovedAt?: string | null, hasApprovedConstitution: boolean, contextAnalysis: Record<string, any>, contextAnalysisUpdatedAt?: string | null, settings: Record<string, any>, projectMetadata?: Record<string, any> | null, tags?: Array<string | null> | null, color?: string | null, isActive: boolean, isArchived: boolean, archivedAt?: string | null, isDeleted: boolean, deletedAt?: string | null, createdAt: string, updatedAt: string, isInProgress: boolean, isCompleted: boolean, canStart: boolean, systemInstanceId?: string | null, kind?: string | null, gitBranch?: string | null, prUrl?: string | null, prNumber?: number | null, promptEvolution: { __typename?: 'PromptEvolution', core: string, version: number, updatedAt: string, history: Record<string, any> }, progressInfo: { __typename?: 'ProjectProgress', progress: number, status: string }, constitutionalLaws: { __typename?: 'ConstitutionalLaws', needs: Array<string | null>, seeds: Array<string | null> } }> } | null };

export type GetUserByEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GetUserByEmailQuery = { __typename?: 'Query', userByEmail?: { __typename?: 'UserType', id: string, email: string, username?: string | null, displayName: string, authProvider: AuthProviderType, avatarUrl?: string | null, bio?: string | null, timezone: string, locale: string, status: UserStatusType, isEmailVerified: boolean, createdAt: string, updatedAt: string, lastLoginAt?: string | null, loginCount: number, fullName: string, isActive: boolean, organizations: Array<{ __typename?: 'OrganizationType', id: string, name: string, slug: string, domain?: string | null, description?: string | null, billingEmail?: string | null, billingAddress?: string | null, billingContact?: string | null, taxId?: string | null, planType: PlanType, maxUsers: number, maxClients: number, maxProjects: number, storageLimitGb: number, sharedKnowledgeEnabled: boolean, requireEmailVerification: boolean, isActive: boolean, isVerified: boolean, createdAt: string, updatedAt: string, isFreePlan: boolean, isEnterprisePlan: boolean, activeUserCount: number, activeProjectCount: number, storageUsageGb: number }>, organization?: { __typename?: 'OrganizationType', id: string, name: string, slug: string, domain?: string | null, description?: string | null, billingEmail?: string | null, billingAddress?: string | null, billingContact?: string | null, taxId?: string | null, planType: PlanType, maxUsers: number, maxClients: number, maxProjects: number, storageLimitGb: number, sharedKnowledgeEnabled: boolean, requireEmailVerification: boolean, isActive: boolean, isVerified: boolean, createdAt: string, updatedAt: string, isFreePlan: boolean, isEnterprisePlan: boolean, activeUserCount: number, activeProjectCount: number, storageUsageGb: number } | null, ownedProjects: Array<{ __typename?: 'Project', id: string, name: string, description?: string | null, clientId?: string | null, organizationId: string, ownerId: string, groupId?: string | null, projectType: ProjectTypeEnum, status: ProjectStatusType, priority: ProjectPriorityType, developmentType?: DevelopmentTypeEnum | null, projectPhase?: ProjectPhaseType | null, progress: number, constitutionalFacts: Record<string, any>, constitutionalVersion: number, constitutionalApprovedBy?: string | null, constitutionalApprovedAt?: string | null, hasApprovedConstitution: boolean, contextAnalysis: Record<string, any>, contextAnalysisUpdatedAt?: string | null, settings: Record<string, any>, projectMetadata?: Record<string, any> | null, tags?: Array<string | null> | null, color?: string | null, isActive: boolean, isArchived: boolean, archivedAt?: string | null, isDeleted: boolean, deletedAt?: string | null, createdAt: string, updatedAt: string, isInProgress: boolean, isCompleted: boolean, canStart: boolean, systemInstanceId?: string | null, kind?: string | null, gitBranch?: string | null, prUrl?: string | null, prNumber?: number | null, promptEvolution: { __typename?: 'PromptEvolution', core: string, version: number, updatedAt: string, history: Record<string, any> }, progressInfo: { __typename?: 'ProjectProgress', progress: number, status: string }, constitutionalLaws: { __typename?: 'ConstitutionalLaws', needs: Array<string | null>, seeds: Array<string | null> } }> } | null };

export type GetUserByUsernameQueryVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type GetUserByUsernameQuery = { __typename?: 'Query', userByUsername?: { __typename?: 'UserType', id: string, email: string, username?: string | null, displayName: string, authProvider: AuthProviderType, avatarUrl?: string | null, bio?: string | null, timezone: string, locale: string, status: UserStatusType, isEmailVerified: boolean, createdAt: string, updatedAt: string, lastLoginAt?: string | null, loginCount: number, fullName: string, isActive: boolean, organizations: Array<{ __typename?: 'OrganizationType', id: string, name: string, slug: string, domain?: string | null, description?: string | null, billingEmail?: string | null, billingAddress?: string | null, billingContact?: string | null, taxId?: string | null, planType: PlanType, maxUsers: number, maxClients: number, maxProjects: number, storageLimitGb: number, sharedKnowledgeEnabled: boolean, requireEmailVerification: boolean, isActive: boolean, isVerified: boolean, createdAt: string, updatedAt: string, isFreePlan: boolean, isEnterprisePlan: boolean, activeUserCount: number, activeProjectCount: number, storageUsageGb: number }>, organization?: { __typename?: 'OrganizationType', id: string, name: string, slug: string, domain?: string | null, description?: string | null, billingEmail?: string | null, billingAddress?: string | null, billingContact?: string | null, taxId?: string | null, planType: PlanType, maxUsers: number, maxClients: number, maxProjects: number, storageLimitGb: number, sharedKnowledgeEnabled: boolean, requireEmailVerification: boolean, isActive: boolean, isVerified: boolean, createdAt: string, updatedAt: string, isFreePlan: boolean, isEnterprisePlan: boolean, activeUserCount: number, activeProjectCount: number, storageUsageGb: number } | null, ownedProjects: Array<{ __typename?: 'Project', id: string, name: string, description?: string | null, clientId?: string | null, organizationId: string, ownerId: string, groupId?: string | null, projectType: ProjectTypeEnum, status: ProjectStatusType, priority: ProjectPriorityType, developmentType?: DevelopmentTypeEnum | null, projectPhase?: ProjectPhaseType | null, progress: number, constitutionalFacts: Record<string, any>, constitutionalVersion: number, constitutionalApprovedBy?: string | null, constitutionalApprovedAt?: string | null, hasApprovedConstitution: boolean, contextAnalysis: Record<string, any>, contextAnalysisUpdatedAt?: string | null, settings: Record<string, any>, projectMetadata?: Record<string, any> | null, tags?: Array<string | null> | null, color?: string | null, isActive: boolean, isArchived: boolean, archivedAt?: string | null, isDeleted: boolean, deletedAt?: string | null, createdAt: string, updatedAt: string, isInProgress: boolean, isCompleted: boolean, canStart: boolean, systemInstanceId?: string | null, kind?: string | null, gitBranch?: string | null, prUrl?: string | null, prNumber?: number | null, promptEvolution: { __typename?: 'PromptEvolution', core: string, version: number, updatedAt: string, history: Record<string, any> }, progressInfo: { __typename?: 'ProjectProgress', progress: number, status: string }, constitutionalLaws: { __typename?: 'ConstitutionalLaws', needs: Array<string | null>, seeds: Array<string | null> } }> } | null };

export type GetUsersQueryVariables = Exact<{
  filter?: InputMaybe<UserFilterInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
}>;


export type GetUsersQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', totalCount: number, edges: Array<{ __typename?: 'UserEdge', cursor: string, node: { __typename?: 'UserType', id: string, email: string, username?: string | null, displayName: string, authProvider: AuthProviderType, avatarUrl?: string | null, bio?: string | null, timezone: string, locale: string, status: UserStatusType, isEmailVerified: boolean, createdAt: string, updatedAt: string, lastLoginAt?: string | null, loginCount: number, fullName: string, isActive: boolean } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetSearchUsersQueryVariables = Exact<{
  query: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<UserStatusType>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
}>;


export type GetSearchUsersQuery = { __typename?: 'Query', searchUsers: { __typename?: 'UserConnection', totalCount: number, edges: Array<{ __typename?: 'UserEdge', cursor: string, node: { __typename?: 'UserType', id: string, email: string, username?: string | null, displayName: string, authProvider: AuthProviderType, avatarUrl?: string | null, bio?: string | null, timezone: string, locale: string, status: UserStatusType, isEmailVerified: boolean, createdAt: string, updatedAt: string, lastLoginAt?: string | null, loginCount: number, fullName: string, isActive: boolean } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetDeletedUsersQueryVariables = Exact<{
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
}>;


export type GetDeletedUsersQuery = { __typename?: 'Query', deletedUsers: { __typename?: 'UserConnection', totalCount: number, edges: Array<{ __typename?: 'UserEdge', cursor: string, node: { __typename?: 'UserType', id: string, email: string, username?: string | null, displayName: string, authProvider: AuthProviderType, avatarUrl?: string | null, bio?: string | null, timezone: string, locale: string, status: UserStatusType, isEmailVerified: boolean, createdAt: string, updatedAt: string, lastLoginAt?: string | null, loginCount: number, fullName: string, isActive: boolean } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GetMyOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyOrganizationsQuery = { __typename?: 'Query', myOrganizations: Array<{ __typename?: 'OrganizationType', id: string, name: string, slug: string, domain?: string | null, description?: string | null, billingEmail?: string | null, billingAddress?: string | null, billingContact?: string | null, taxId?: string | null, planType: PlanType, maxUsers: number, maxClients: number, maxProjects: number, storageLimitGb: number, sharedKnowledgeEnabled: boolean, requireEmailVerification: boolean, isActive: boolean, isVerified: boolean, createdAt: string, updatedAt: string, isFreePlan: boolean, isEnterprisePlan: boolean, activeUserCount: number, activeProjectCount: number, storageUsageGb: number }> };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me?: { __typename?: 'AuthUser', id: string, email: string, username?: string | null, displayName: string, isActive: boolean, isSuperuser: boolean, organizationId?: string | null, organizationRole?: string | null, organizationName?: string | null, createdAt?: string | null, updatedAt?: string | null } | null };

export type GetConsolidatedTaskStatusQueryVariables = Exact<{
  taskId: Scalars['String']['input'];
}>;


export type GetConsolidatedTaskStatusQuery = { __typename?: 'Query', consolidatedTaskStatus: { __typename?: 'ConsolidatedTaskStatus', taskId: string, status: string, result?: string | null, error?: string | null, startedAt?: string | null, completedAt?: string | null, progress?: number | null } };


export const CreateAiAdvisorSessionDocument = gql`
    mutation CreateAiAdvisorSession($input: CreateAIAdvisorSessionInput!) {
  createAiAdvisorSession(input: $input) {
    success
    session {
      id
      projectId
      userId
      organizationId
      clientId
      meetingStatus
      projectType
      status
      title
      currentPhase
      phaseFlow
      progressPercentage
      context
      analysisResult
      createdAt
      updatedAt
      completedAt
    }
    initialMessage {
      id
      sessionId
      role
      content
      phase
      orderIndex
      suggestions
      extractedInfo
      actionTaken
      createdAt
    }
    errorMessage
  }
}
    `;
export type CreateAiAdvisorSessionMutationFn = Apollo.MutationFunction<CreateAiAdvisorSessionMutation, CreateAiAdvisorSessionMutationVariables>;

/**
 * __useCreateAiAdvisorSessionMutation__
 *
 * To run a mutation, you first call `useCreateAiAdvisorSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAiAdvisorSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAiAdvisorSessionMutation, { data, loading, error }] = useCreateAiAdvisorSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAiAdvisorSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateAiAdvisorSessionMutation, CreateAiAdvisorSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAiAdvisorSessionMutation, CreateAiAdvisorSessionMutationVariables>(CreateAiAdvisorSessionDocument, options);
      }
export type CreateAiAdvisorSessionMutationHookResult = ReturnType<typeof useCreateAiAdvisorSessionMutation>;
export type CreateAiAdvisorSessionMutationResult = Apollo.MutationResult<CreateAiAdvisorSessionMutation>;
export type CreateAiAdvisorSessionMutationOptions = Apollo.BaseMutationOptions<CreateAiAdvisorSessionMutation, CreateAiAdvisorSessionMutationVariables>;
export const SendAiAdvisorMessageDocument = gql`
    mutation SendAiAdvisorMessage($input: SendAIAdvisorMessageInput!) {
  sendAiAdvisorMessage(input: $input) {
    success
    userMessage {
      id
      sessionId
      role
      content
      phase
      orderIndex
      suggestions
      extractedInfo
      actionTaken
      createdAt
    }
    assistantMessage {
      id
      sessionId
      role
      content
      phase
      orderIndex
      suggestions
      extractedInfo
      actionTaken
      createdAt
    }
    phaseChanged
    newPhase
    sessionCompleted
    errorMessage
  }
}
    `;
export type SendAiAdvisorMessageMutationFn = Apollo.MutationFunction<SendAiAdvisorMessageMutation, SendAiAdvisorMessageMutationVariables>;

/**
 * __useSendAiAdvisorMessageMutation__
 *
 * To run a mutation, you first call `useSendAiAdvisorMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAiAdvisorMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAiAdvisorMessageMutation, { data, loading, error }] = useSendAiAdvisorMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendAiAdvisorMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendAiAdvisorMessageMutation, SendAiAdvisorMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendAiAdvisorMessageMutation, SendAiAdvisorMessageMutationVariables>(SendAiAdvisorMessageDocument, options);
      }
export type SendAiAdvisorMessageMutationHookResult = ReturnType<typeof useSendAiAdvisorMessageMutation>;
export type SendAiAdvisorMessageMutationResult = Apollo.MutationResult<SendAiAdvisorMessageMutation>;
export type SendAiAdvisorMessageMutationOptions = Apollo.BaseMutationOptions<SendAiAdvisorMessageMutation, SendAiAdvisorMessageMutationVariables>;
export const CompleteAiAdvisorSessionDocument = gql`
    mutation CompleteAiAdvisorSession($input: CompleteAIAdvisorSessionInput!) {
  completeAiAdvisorSession(input: $input) {
    success
    session {
      id
      projectId
      userId
      organizationId
      clientId
      meetingStatus
      projectType
      status
      title
      currentPhase
      phaseFlow
      progressPercentage
      context
      analysisResult
      createdAt
      updatedAt
      completedAt
    }
    generatedTitle
    errorMessage
  }
}
    `;
export type CompleteAiAdvisorSessionMutationFn = Apollo.MutationFunction<CompleteAiAdvisorSessionMutation, CompleteAiAdvisorSessionMutationVariables>;

/**
 * __useCompleteAiAdvisorSessionMutation__
 *
 * To run a mutation, you first call `useCompleteAiAdvisorSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteAiAdvisorSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeAiAdvisorSessionMutation, { data, loading, error }] = useCompleteAiAdvisorSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteAiAdvisorSessionMutation(baseOptions?: Apollo.MutationHookOptions<CompleteAiAdvisorSessionMutation, CompleteAiAdvisorSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteAiAdvisorSessionMutation, CompleteAiAdvisorSessionMutationVariables>(CompleteAiAdvisorSessionDocument, options);
      }
export type CompleteAiAdvisorSessionMutationHookResult = ReturnType<typeof useCompleteAiAdvisorSessionMutation>;
export type CompleteAiAdvisorSessionMutationResult = Apollo.MutationResult<CompleteAiAdvisorSessionMutation>;
export type CompleteAiAdvisorSessionMutationOptions = Apollo.BaseMutationOptions<CompleteAiAdvisorSessionMutation, CompleteAiAdvisorSessionMutationVariables>;
export const ConvertAiAdvisorSessionToPrismDocument = gql`
    mutation ConvertAiAdvisorSessionToPrism($input: ConvertSessionToPrismInput!) {
  convertAiAdvisorSessionToPrism(input: $input) {
    success
    atomCount
    scopeCount
    viewCount
    session {
      id
      projectId
      userId
      organizationId
      clientId
      meetingStatus
      projectType
      status
      title
      currentPhase
      phaseFlow
      progressPercentage
      context
      analysisResult
      createdAt
      updatedAt
      completedAt
    }
    errorMessage
  }
}
    `;
export type ConvertAiAdvisorSessionToPrismMutationFn = Apollo.MutationFunction<ConvertAiAdvisorSessionToPrismMutation, ConvertAiAdvisorSessionToPrismMutationVariables>;

/**
 * __useConvertAiAdvisorSessionToPrismMutation__
 *
 * To run a mutation, you first call `useConvertAiAdvisorSessionToPrismMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertAiAdvisorSessionToPrismMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertAiAdvisorSessionToPrismMutation, { data, loading, error }] = useConvertAiAdvisorSessionToPrismMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConvertAiAdvisorSessionToPrismMutation(baseOptions?: Apollo.MutationHookOptions<ConvertAiAdvisorSessionToPrismMutation, ConvertAiAdvisorSessionToPrismMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConvertAiAdvisorSessionToPrismMutation, ConvertAiAdvisorSessionToPrismMutationVariables>(ConvertAiAdvisorSessionToPrismDocument, options);
      }
export type ConvertAiAdvisorSessionToPrismMutationHookResult = ReturnType<typeof useConvertAiAdvisorSessionToPrismMutation>;
export type ConvertAiAdvisorSessionToPrismMutationResult = Apollo.MutationResult<ConvertAiAdvisorSessionToPrismMutation>;
export type ConvertAiAdvisorSessionToPrismMutationOptions = Apollo.BaseMutationOptions<ConvertAiAdvisorSessionToPrismMutation, ConvertAiAdvisorSessionToPrismMutationVariables>;
export const RunAiAdvisorAnalysisDocument = gql`
    mutation RunAiAdvisorAnalysis($sessionId: String!) {
  runAiAdvisorAnalysis(sessionId: $sessionId) {
    success
    facts
    insights
    emotions
    summary
    errorMessage
  }
}
    `;
export type RunAiAdvisorAnalysisMutationFn = Apollo.MutationFunction<RunAiAdvisorAnalysisMutation, RunAiAdvisorAnalysisMutationVariables>;

/**
 * __useRunAiAdvisorAnalysisMutation__
 *
 * To run a mutation, you first call `useRunAiAdvisorAnalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunAiAdvisorAnalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runAiAdvisorAnalysisMutation, { data, loading, error }] = useRunAiAdvisorAnalysisMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useRunAiAdvisorAnalysisMutation(baseOptions?: Apollo.MutationHookOptions<RunAiAdvisorAnalysisMutation, RunAiAdvisorAnalysisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunAiAdvisorAnalysisMutation, RunAiAdvisorAnalysisMutationVariables>(RunAiAdvisorAnalysisDocument, options);
      }
export type RunAiAdvisorAnalysisMutationHookResult = ReturnType<typeof useRunAiAdvisorAnalysisMutation>;
export type RunAiAdvisorAnalysisMutationResult = Apollo.MutationResult<RunAiAdvisorAnalysisMutation>;
export type RunAiAdvisorAnalysisMutationOptions = Apollo.BaseMutationOptions<RunAiAdvisorAnalysisMutation, RunAiAdvisorAnalysisMutationVariables>;
export const GetAiAdvisorSessionDocument = gql`
    query GetAiAdvisorSession($sessionId: String!) {
  aiAdvisorSession(sessionId: $sessionId) {
    id
    projectId
    userId
    organizationId
    clientId
    meetingStatus
    projectType
    status
    title
    currentPhase
    phaseFlow
    progressPercentage
    context
    analysisResult
    createdAt
    updatedAt
    completedAt
  }
}
    `;

/**
 * __useGetAiAdvisorSessionQuery__
 *
 * To run a query within a React component, call `useGetAiAdvisorSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiAdvisorSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiAdvisorSessionQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGetAiAdvisorSessionQuery(baseOptions: Apollo.QueryHookOptions<GetAiAdvisorSessionQuery, GetAiAdvisorSessionQueryVariables> & ({ variables: GetAiAdvisorSessionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiAdvisorSessionQuery, GetAiAdvisorSessionQueryVariables>(GetAiAdvisorSessionDocument, options);
      }
export function useGetAiAdvisorSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiAdvisorSessionQuery, GetAiAdvisorSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiAdvisorSessionQuery, GetAiAdvisorSessionQueryVariables>(GetAiAdvisorSessionDocument, options);
        }
// @ts-ignore
export function useGetAiAdvisorSessionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAiAdvisorSessionQuery, GetAiAdvisorSessionQueryVariables>): Apollo.UseSuspenseQueryResult<GetAiAdvisorSessionQuery, GetAiAdvisorSessionQueryVariables>;
export function useGetAiAdvisorSessionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAiAdvisorSessionQuery, GetAiAdvisorSessionQueryVariables>): Apollo.UseSuspenseQueryResult<GetAiAdvisorSessionQuery | undefined, GetAiAdvisorSessionQueryVariables>;
export function useGetAiAdvisorSessionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAiAdvisorSessionQuery, GetAiAdvisorSessionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAiAdvisorSessionQuery, GetAiAdvisorSessionQueryVariables>(GetAiAdvisorSessionDocument, options);
        }
export type GetAiAdvisorSessionQueryHookResult = ReturnType<typeof useGetAiAdvisorSessionQuery>;
export type GetAiAdvisorSessionLazyQueryHookResult = ReturnType<typeof useGetAiAdvisorSessionLazyQuery>;
export type GetAiAdvisorSessionSuspenseQueryHookResult = ReturnType<typeof useGetAiAdvisorSessionSuspenseQuery>;
export type GetAiAdvisorSessionQueryResult = Apollo.QueryResult<GetAiAdvisorSessionQuery, GetAiAdvisorSessionQueryVariables>;
export const GetAiAdvisorSessionsDocument = gql`
    query GetAiAdvisorSessions($projectId: String!, $status: String = null) {
  aiAdvisorSessions(projectId: $projectId, status: $status) {
    id
    projectId
    title
    status
    meetingStatus
    projectType
    currentPhase
    progressPercentage
    messageCount
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetAiAdvisorSessionsQuery__
 *
 * To run a query within a React component, call `useGetAiAdvisorSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiAdvisorSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiAdvisorSessionsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetAiAdvisorSessionsQuery(baseOptions: Apollo.QueryHookOptions<GetAiAdvisorSessionsQuery, GetAiAdvisorSessionsQueryVariables> & ({ variables: GetAiAdvisorSessionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiAdvisorSessionsQuery, GetAiAdvisorSessionsQueryVariables>(GetAiAdvisorSessionsDocument, options);
      }
export function useGetAiAdvisorSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiAdvisorSessionsQuery, GetAiAdvisorSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiAdvisorSessionsQuery, GetAiAdvisorSessionsQueryVariables>(GetAiAdvisorSessionsDocument, options);
        }
// @ts-ignore
export function useGetAiAdvisorSessionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAiAdvisorSessionsQuery, GetAiAdvisorSessionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAiAdvisorSessionsQuery, GetAiAdvisorSessionsQueryVariables>;
export function useGetAiAdvisorSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAiAdvisorSessionsQuery, GetAiAdvisorSessionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAiAdvisorSessionsQuery | undefined, GetAiAdvisorSessionsQueryVariables>;
export function useGetAiAdvisorSessionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAiAdvisorSessionsQuery, GetAiAdvisorSessionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAiAdvisorSessionsQuery, GetAiAdvisorSessionsQueryVariables>(GetAiAdvisorSessionsDocument, options);
        }
export type GetAiAdvisorSessionsQueryHookResult = ReturnType<typeof useGetAiAdvisorSessionsQuery>;
export type GetAiAdvisorSessionsLazyQueryHookResult = ReturnType<typeof useGetAiAdvisorSessionsLazyQuery>;
export type GetAiAdvisorSessionsSuspenseQueryHookResult = ReturnType<typeof useGetAiAdvisorSessionsSuspenseQuery>;
export type GetAiAdvisorSessionsQueryResult = Apollo.QueryResult<GetAiAdvisorSessionsQuery, GetAiAdvisorSessionsQueryVariables>;
export const GetAiAdvisorMessagesDocument = gql`
    query GetAiAdvisorMessages($sessionId: String!) {
  aiAdvisorMessages(sessionId: $sessionId) {
    id
    sessionId
    role
    content
    phase
    orderIndex
    suggestions
    extractedInfo
    actionTaken
    createdAt
  }
}
    `;

/**
 * __useGetAiAdvisorMessagesQuery__
 *
 * To run a query within a React component, call `useGetAiAdvisorMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiAdvisorMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiAdvisorMessagesQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useGetAiAdvisorMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetAiAdvisorMessagesQuery, GetAiAdvisorMessagesQueryVariables> & ({ variables: GetAiAdvisorMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAiAdvisorMessagesQuery, GetAiAdvisorMessagesQueryVariables>(GetAiAdvisorMessagesDocument, options);
      }
export function useGetAiAdvisorMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAiAdvisorMessagesQuery, GetAiAdvisorMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAiAdvisorMessagesQuery, GetAiAdvisorMessagesQueryVariables>(GetAiAdvisorMessagesDocument, options);
        }
// @ts-ignore
export function useGetAiAdvisorMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAiAdvisorMessagesQuery, GetAiAdvisorMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAiAdvisorMessagesQuery, GetAiAdvisorMessagesQueryVariables>;
export function useGetAiAdvisorMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAiAdvisorMessagesQuery, GetAiAdvisorMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAiAdvisorMessagesQuery | undefined, GetAiAdvisorMessagesQueryVariables>;
export function useGetAiAdvisorMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAiAdvisorMessagesQuery, GetAiAdvisorMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAiAdvisorMessagesQuery, GetAiAdvisorMessagesQueryVariables>(GetAiAdvisorMessagesDocument, options);
        }
export type GetAiAdvisorMessagesQueryHookResult = ReturnType<typeof useGetAiAdvisorMessagesQuery>;
export type GetAiAdvisorMessagesLazyQueryHookResult = ReturnType<typeof useGetAiAdvisorMessagesLazyQuery>;
export type GetAiAdvisorMessagesSuspenseQueryHookResult = ReturnType<typeof useGetAiAdvisorMessagesSuspenseQuery>;
export type GetAiAdvisorMessagesQueryResult = Apollo.QueryResult<GetAiAdvisorMessagesQuery, GetAiAdvisorMessagesQueryVariables>;
export const RunContextAnalysisDocument = gql`
    mutation RunContextAnalysis($projectId: UUID!, $options: AnalysisOptions = null) {
  runContextAnalysis(projectId: $projectId, options: $options) {
    content
    analyzedAt
    facts {
      count
      items {
        content
        type
        confidence
        metadata
      }
    }
    abstracts {
      count
      items {
        content
        type
        importance
        confidence
        reasoning
      }
    }
    emotions {
      count
      overallSentiment
      teamMorale
      emotionalTrends
      items {
        content
        polarity
        intensity
        emotionType
        designOpportunity
        confidence
        subjectivity
        empathy
        motivation
        culturalWeight
        stressIndicator
        motivationFactor
        extractedIntent
      }
      fluctuations {
        surfaceEmotion
        temporalPattern
        intensityVariance
        contextCoherence
        underlyingPatterns
      }
    }
    perspectives {
      count
      primaryPerspective
      gaps
      alignments
      items {
        viewpoint
        observations
        concerns
        priorities
        recommendations
        confidence
        metadata
        hiddenMessages
        alignmentWithOthers
        underlyingConcerns
        trustIndicators
        gaps
        conflicts
      }
    }
    ideals {
      count
      items {
        content
        type
        achievability
        timeframe
        currentGap
        requiredElements
        emotionalDrivers
        confidence
      }
    }
    crossLayerAnalysis
    metaPerspective {
      surfaceAnalysis
      fluctuationAnalysis
      deepQuestions
      hiddenNeeds
      contextualInsights
      creativeSolutions
      confidence
    }
    summary {
      totalItemsExtracted
      layersAnalyzed
      keyFindings
    }
    processingTimeSeconds
    confidence
  }
}
    `;
export type RunContextAnalysisMutationFn = Apollo.MutationFunction<RunContextAnalysisMutation, RunContextAnalysisMutationVariables>;

/**
 * __useRunContextAnalysisMutation__
 *
 * To run a mutation, you first call `useRunContextAnalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunContextAnalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runContextAnalysisMutation, { data, loading, error }] = useRunContextAnalysisMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useRunContextAnalysisMutation(baseOptions?: Apollo.MutationHookOptions<RunContextAnalysisMutation, RunContextAnalysisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunContextAnalysisMutation, RunContextAnalysisMutationVariables>(RunContextAnalysisDocument, options);
      }
export type RunContextAnalysisMutationHookResult = ReturnType<typeof useRunContextAnalysisMutation>;
export type RunContextAnalysisMutationResult = Apollo.MutationResult<RunContextAnalysisMutation>;
export type RunContextAnalysisMutationOptions = Apollo.BaseMutationOptions<RunContextAnalysisMutation, RunContextAnalysisMutationVariables>;
export const AnalyzeSitemapDocument = gql`
    mutation AnalyzeSitemap($sitemapJson: String!) {
  analyzeSitemap(sitemapJson: $sitemapJson) {
    id
    name
    description
    pageType
    layout
    hasHeader
    hasFooter
    hasSidebar
    targetUsers
    mainPurpose
    keyFeatures
    businessLogic
    llmGenerated
    completionLevel
    createdAt
  }
}
    `;
export type AnalyzeSitemapMutationFn = Apollo.MutationFunction<AnalyzeSitemapMutation, AnalyzeSitemapMutationVariables>;

/**
 * __useAnalyzeSitemapMutation__
 *
 * To run a mutation, you first call `useAnalyzeSitemapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyzeSitemapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyzeSitemapMutation, { data, loading, error }] = useAnalyzeSitemapMutation({
 *   variables: {
 *      sitemapJson: // value for 'sitemapJson'
 *   },
 * });
 */
export function useAnalyzeSitemapMutation(baseOptions?: Apollo.MutationHookOptions<AnalyzeSitemapMutation, AnalyzeSitemapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnalyzeSitemapMutation, AnalyzeSitemapMutationVariables>(AnalyzeSitemapDocument, options);
      }
export type AnalyzeSitemapMutationHookResult = ReturnType<typeof useAnalyzeSitemapMutation>;
export type AnalyzeSitemapMutationResult = Apollo.MutationResult<AnalyzeSitemapMutation>;
export type AnalyzeSitemapMutationOptions = Apollo.BaseMutationOptions<AnalyzeSitemapMutation, AnalyzeSitemapMutationVariables>;
export const GetAnalyzeTextWithContextDocument = gql`
    query GetAnalyzeTextWithContext($content: String!, $speakerContext: SpeakerContextInput = null, $options: AnalysisOptions = null, $personas: [PersonaInput!] = null) {
  analyzeTextWithContext(
    content: $content
    speakerContext: $speakerContext
    options: $options
    personas: $personas
  ) {
    content
    analyzedAt
    facts {
      count
      items {
        content
        type
        confidence
        metadata
      }
    }
    abstracts {
      count
      items {
        content
        type
        importance
        confidence
        reasoning
      }
    }
    emotions {
      count
      overallSentiment
      teamMorale
      emotionalTrends
      items {
        content
        polarity
        intensity
        emotionType
        designOpportunity
        confidence
        subjectivity
        empathy
        motivation
        culturalWeight
        stressIndicator
        motivationFactor
        extractedIntent
      }
      fluctuations {
        surfaceEmotion
        temporalPattern
        intensityVariance
        contextCoherence
        underlyingPatterns
      }
    }
    perspectives {
      count
      primaryPerspective
      gaps
      alignments
      items {
        viewpoint
        observations
        concerns
        priorities
        recommendations
        confidence
        metadata
        hiddenMessages
        alignmentWithOthers
        underlyingConcerns
        trustIndicators
        gaps
        conflicts
      }
    }
    ideals {
      count
      items {
        content
        type
        achievability
        timeframe
        currentGap
        requiredElements
        emotionalDrivers
        confidence
      }
    }
    crossLayerAnalysis
    metaPerspective {
      surfaceAnalysis
      fluctuationAnalysis
      deepQuestions
      hiddenNeeds
      contextualInsights
      creativeSolutions
      confidence
    }
    summary {
      totalItemsExtracted
      layersAnalyzed
      keyFindings
    }
    processingTimeSeconds
    confidence
  }
}
    `;

/**
 * __useGetAnalyzeTextWithContextQuery__
 *
 * To run a query within a React component, call `useGetAnalyzeTextWithContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyzeTextWithContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyzeTextWithContextQuery({
 *   variables: {
 *      content: // value for 'content'
 *      speakerContext: // value for 'speakerContext'
 *      options: // value for 'options'
 *      personas: // value for 'personas'
 *   },
 * });
 */
export function useGetAnalyzeTextWithContextQuery(baseOptions: Apollo.QueryHookOptions<GetAnalyzeTextWithContextQuery, GetAnalyzeTextWithContextQueryVariables> & ({ variables: GetAnalyzeTextWithContextQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyzeTextWithContextQuery, GetAnalyzeTextWithContextQueryVariables>(GetAnalyzeTextWithContextDocument, options);
      }
export function useGetAnalyzeTextWithContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyzeTextWithContextQuery, GetAnalyzeTextWithContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyzeTextWithContextQuery, GetAnalyzeTextWithContextQueryVariables>(GetAnalyzeTextWithContextDocument, options);
        }
// @ts-ignore
export function useGetAnalyzeTextWithContextSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnalyzeTextWithContextQuery, GetAnalyzeTextWithContextQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnalyzeTextWithContextQuery, GetAnalyzeTextWithContextQueryVariables>;
export function useGetAnalyzeTextWithContextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalyzeTextWithContextQuery, GetAnalyzeTextWithContextQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnalyzeTextWithContextQuery | undefined, GetAnalyzeTextWithContextQueryVariables>;
export function useGetAnalyzeTextWithContextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalyzeTextWithContextQuery, GetAnalyzeTextWithContextQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnalyzeTextWithContextQuery, GetAnalyzeTextWithContextQueryVariables>(GetAnalyzeTextWithContextDocument, options);
        }
export type GetAnalyzeTextWithContextQueryHookResult = ReturnType<typeof useGetAnalyzeTextWithContextQuery>;
export type GetAnalyzeTextWithContextLazyQueryHookResult = ReturnType<typeof useGetAnalyzeTextWithContextLazyQuery>;
export type GetAnalyzeTextWithContextSuspenseQueryHookResult = ReturnType<typeof useGetAnalyzeTextWithContextSuspenseQuery>;
export type GetAnalyzeTextWithContextQueryResult = Apollo.QueryResult<GetAnalyzeTextWithContextQuery, GetAnalyzeTextWithContextQueryVariables>;
export const GetAnalyzeStakeholdersDocument = gql`
    query GetAnalyzeStakeholders($content: String!) {
  analyzeStakeholders(content: $content) {
    stakeholders {
      id
      name
      type
      role
      resources
      challenges
      goals
      capabilities
      constraints
      relationships
      influenceLevel
      interestLevel
    }
    perspectives {
      name
      role
      type
      concerns
      interests
      textEvidence
      confidence
    }
    synergies {
      id
      type
      participants
      description
      mechanism
      benefits
      implementationSteps
      feasibility
      impact
      risks
    }
    designInsights {
      perspective
      rationale
      evidenceFromText
      requirements
      expectedImpact
      priority
      implementationNotes
    }
    relationshipsGraph
    recommendations
  }
}
    `;

/**
 * __useGetAnalyzeStakeholdersQuery__
 *
 * To run a query within a React component, call `useGetAnalyzeStakeholdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyzeStakeholdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyzeStakeholdersQuery({
 *   variables: {
 *      content: // value for 'content'
 *   },
 * });
 */
export function useGetAnalyzeStakeholdersQuery(baseOptions: Apollo.QueryHookOptions<GetAnalyzeStakeholdersQuery, GetAnalyzeStakeholdersQueryVariables> & ({ variables: GetAnalyzeStakeholdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyzeStakeholdersQuery, GetAnalyzeStakeholdersQueryVariables>(GetAnalyzeStakeholdersDocument, options);
      }
export function useGetAnalyzeStakeholdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyzeStakeholdersQuery, GetAnalyzeStakeholdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyzeStakeholdersQuery, GetAnalyzeStakeholdersQueryVariables>(GetAnalyzeStakeholdersDocument, options);
        }
// @ts-ignore
export function useGetAnalyzeStakeholdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnalyzeStakeholdersQuery, GetAnalyzeStakeholdersQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnalyzeStakeholdersQuery, GetAnalyzeStakeholdersQueryVariables>;
export function useGetAnalyzeStakeholdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalyzeStakeholdersQuery, GetAnalyzeStakeholdersQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnalyzeStakeholdersQuery | undefined, GetAnalyzeStakeholdersQueryVariables>;
export function useGetAnalyzeStakeholdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalyzeStakeholdersQuery, GetAnalyzeStakeholdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnalyzeStakeholdersQuery, GetAnalyzeStakeholdersQueryVariables>(GetAnalyzeStakeholdersDocument, options);
        }
export type GetAnalyzeStakeholdersQueryHookResult = ReturnType<typeof useGetAnalyzeStakeholdersQuery>;
export type GetAnalyzeStakeholdersLazyQueryHookResult = ReturnType<typeof useGetAnalyzeStakeholdersLazyQuery>;
export type GetAnalyzeStakeholdersSuspenseQueryHookResult = ReturnType<typeof useGetAnalyzeStakeholdersSuspenseQuery>;
export type GetAnalyzeStakeholdersQueryResult = Apollo.QueryResult<GetAnalyzeStakeholdersQuery, GetAnalyzeStakeholdersQueryVariables>;
export const GetAnalyzeBatchDocument = gql`
    query GetAnalyzeBatch($contents: [String!]!, $options: AnalysisOptions = null) {
  analyzeBatch(contents: $contents, options: $options) {
    content
    analyzedAt
    facts {
      count
      items {
        content
        type
        confidence
        metadata
      }
    }
    abstracts {
      count
      items {
        content
        type
        importance
        confidence
        reasoning
      }
    }
    emotions {
      count
      overallSentiment
      teamMorale
      emotionalTrends
      items {
        content
        polarity
        intensity
        emotionType
        designOpportunity
        confidence
        subjectivity
        empathy
        motivation
        culturalWeight
        stressIndicator
        motivationFactor
        extractedIntent
      }
      fluctuations {
        surfaceEmotion
        temporalPattern
        intensityVariance
        contextCoherence
        underlyingPatterns
      }
    }
    perspectives {
      count
      primaryPerspective
      gaps
      alignments
      items {
        viewpoint
        observations
        concerns
        priorities
        recommendations
        confidence
        metadata
        hiddenMessages
        alignmentWithOthers
        underlyingConcerns
        trustIndicators
        gaps
        conflicts
      }
    }
    ideals {
      count
      items {
        content
        type
        achievability
        timeframe
        currentGap
        requiredElements
        emotionalDrivers
        confidence
      }
    }
    crossLayerAnalysis
    metaPerspective {
      surfaceAnalysis
      fluctuationAnalysis
      deepQuestions
      hiddenNeeds
      contextualInsights
      creativeSolutions
      confidence
    }
    summary {
      totalItemsExtracted
      layersAnalyzed
      keyFindings
    }
    processingTimeSeconds
    confidence
  }
}
    `;

/**
 * __useGetAnalyzeBatchQuery__
 *
 * To run a query within a React component, call `useGetAnalyzeBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyzeBatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyzeBatchQuery({
 *   variables: {
 *      contents: // value for 'contents'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetAnalyzeBatchQuery(baseOptions: Apollo.QueryHookOptions<GetAnalyzeBatchQuery, GetAnalyzeBatchQueryVariables> & ({ variables: GetAnalyzeBatchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyzeBatchQuery, GetAnalyzeBatchQueryVariables>(GetAnalyzeBatchDocument, options);
      }
export function useGetAnalyzeBatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyzeBatchQuery, GetAnalyzeBatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyzeBatchQuery, GetAnalyzeBatchQueryVariables>(GetAnalyzeBatchDocument, options);
        }
// @ts-ignore
export function useGetAnalyzeBatchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnalyzeBatchQuery, GetAnalyzeBatchQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnalyzeBatchQuery, GetAnalyzeBatchQueryVariables>;
export function useGetAnalyzeBatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalyzeBatchQuery, GetAnalyzeBatchQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnalyzeBatchQuery | undefined, GetAnalyzeBatchQueryVariables>;
export function useGetAnalyzeBatchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalyzeBatchQuery, GetAnalyzeBatchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnalyzeBatchQuery, GetAnalyzeBatchQueryVariables>(GetAnalyzeBatchDocument, options);
        }
export type GetAnalyzeBatchQueryHookResult = ReturnType<typeof useGetAnalyzeBatchQuery>;
export type GetAnalyzeBatchLazyQueryHookResult = ReturnType<typeof useGetAnalyzeBatchLazyQuery>;
export type GetAnalyzeBatchSuspenseQueryHookResult = ReturnType<typeof useGetAnalyzeBatchSuspenseQuery>;
export type GetAnalyzeBatchQueryResult = Apollo.QueryResult<GetAnalyzeBatchQuery, GetAnalyzeBatchQueryVariables>;
export const GetCompareTextsDocument = gql`
    query GetCompareTexts($content1: String!, $content2: String!, $options: AnalysisOptions = null) {
  compareTexts(content1: $content1, content2: $content2, options: $options) {
    analysis1 {
      content
      analyzedAt
      crossLayerAnalysis
      processingTimeSeconds
      confidence
      facts {
        count
      }
      abstracts {
        count
      }
      emotions {
        count
        overallSentiment
        teamMorale
        emotionalTrends
      }
      perspectives {
        count
        primaryPerspective
        gaps
        alignments
      }
      ideals {
        count
      }
      metaPerspective {
        surfaceAnalysis
        fluctuationAnalysis
        deepQuestions
        hiddenNeeds
        contextualInsights
        creativeSolutions
        confidence
      }
      summary {
        totalItemsExtracted
        layersAnalyzed
        keyFindings
      }
    }
    analysis2 {
      content
      analyzedAt
      crossLayerAnalysis
      processingTimeSeconds
      confidence
      facts {
        count
      }
      abstracts {
        count
      }
      emotions {
        count
        overallSentiment
        teamMorale
        emotionalTrends
      }
      perspectives {
        count
        primaryPerspective
        gaps
        alignments
      }
      ideals {
        count
      }
      metaPerspective {
        surfaceAnalysis
        fluctuationAnalysis
        deepQuestions
        hiddenNeeds
        contextualInsights
        creativeSolutions
        confidence
      }
      summary {
        totalItemsExtracted
        layersAnalyzed
        keyFindings
      }
    }
    comparison {
      emotionShift
      perspectiveAlignment
      factConsistency
      abstractSimilarity
    }
  }
}
    `;

/**
 * __useGetCompareTextsQuery__
 *
 * To run a query within a React component, call `useGetCompareTextsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompareTextsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompareTextsQuery({
 *   variables: {
 *      content1: // value for 'content1'
 *      content2: // value for 'content2'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetCompareTextsQuery(baseOptions: Apollo.QueryHookOptions<GetCompareTextsQuery, GetCompareTextsQueryVariables> & ({ variables: GetCompareTextsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompareTextsQuery, GetCompareTextsQueryVariables>(GetCompareTextsDocument, options);
      }
export function useGetCompareTextsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompareTextsQuery, GetCompareTextsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompareTextsQuery, GetCompareTextsQueryVariables>(GetCompareTextsDocument, options);
        }
// @ts-ignore
export function useGetCompareTextsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompareTextsQuery, GetCompareTextsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompareTextsQuery, GetCompareTextsQueryVariables>;
export function useGetCompareTextsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompareTextsQuery, GetCompareTextsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompareTextsQuery | undefined, GetCompareTextsQueryVariables>;
export function useGetCompareTextsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompareTextsQuery, GetCompareTextsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompareTextsQuery, GetCompareTextsQueryVariables>(GetCompareTextsDocument, options);
        }
export type GetCompareTextsQueryHookResult = ReturnType<typeof useGetCompareTextsQuery>;
export type GetCompareTextsLazyQueryHookResult = ReturnType<typeof useGetCompareTextsLazyQuery>;
export type GetCompareTextsSuspenseQueryHookResult = ReturnType<typeof useGetCompareTextsSuspenseQuery>;
export type GetCompareTextsQueryResult = Apollo.QueryResult<GetCompareTextsQuery, GetCompareTextsQueryVariables>;
export const GetContextAnalysisResultDocument = gql`
    query GetContextAnalysisResult($projectId: UUID!) {
  contextAnalysisResult(projectId: $projectId) {
    content
    analyzedAt
    facts {
      count
      items {
        content
        type
        confidence
        metadata
      }
    }
    abstracts {
      count
      items {
        content
        type
        importance
        confidence
        reasoning
      }
    }
    emotions {
      count
      overallSentiment
      teamMorale
      emotionalTrends
      items {
        content
        polarity
        intensity
        emotionType
        designOpportunity
        confidence
        subjectivity
        empathy
        motivation
        culturalWeight
        stressIndicator
        motivationFactor
        extractedIntent
      }
      fluctuations {
        surfaceEmotion
        temporalPattern
        intensityVariance
        contextCoherence
        underlyingPatterns
      }
    }
    perspectives {
      count
      primaryPerspective
      gaps
      alignments
      items {
        viewpoint
        observations
        concerns
        priorities
        recommendations
        confidence
        metadata
        hiddenMessages
        alignmentWithOthers
        underlyingConcerns
        trustIndicators
        gaps
        conflicts
      }
    }
    ideals {
      count
      items {
        content
        type
        achievability
        timeframe
        currentGap
        requiredElements
        emotionalDrivers
        confidence
      }
    }
    crossLayerAnalysis
    metaPerspective {
      surfaceAnalysis
      fluctuationAnalysis
      deepQuestions
      hiddenNeeds
      contextualInsights
      creativeSolutions
      confidence
    }
    summary {
      totalItemsExtracted
      layersAnalyzed
      keyFindings
    }
    processingTimeSeconds
    confidence
  }
}
    `;

/**
 * __useGetContextAnalysisResultQuery__
 *
 * To run a query within a React component, call `useGetContextAnalysisResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContextAnalysisResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContextAnalysisResultQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetContextAnalysisResultQuery(baseOptions: Apollo.QueryHookOptions<GetContextAnalysisResultQuery, GetContextAnalysisResultQueryVariables> & ({ variables: GetContextAnalysisResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContextAnalysisResultQuery, GetContextAnalysisResultQueryVariables>(GetContextAnalysisResultDocument, options);
      }
export function useGetContextAnalysisResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContextAnalysisResultQuery, GetContextAnalysisResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContextAnalysisResultQuery, GetContextAnalysisResultQueryVariables>(GetContextAnalysisResultDocument, options);
        }
// @ts-ignore
export function useGetContextAnalysisResultSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContextAnalysisResultQuery, GetContextAnalysisResultQueryVariables>): Apollo.UseSuspenseQueryResult<GetContextAnalysisResultQuery, GetContextAnalysisResultQueryVariables>;
export function useGetContextAnalysisResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContextAnalysisResultQuery, GetContextAnalysisResultQueryVariables>): Apollo.UseSuspenseQueryResult<GetContextAnalysisResultQuery | undefined, GetContextAnalysisResultQueryVariables>;
export function useGetContextAnalysisResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContextAnalysisResultQuery, GetContextAnalysisResultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContextAnalysisResultQuery, GetContextAnalysisResultQueryVariables>(GetContextAnalysisResultDocument, options);
        }
export type GetContextAnalysisResultQueryHookResult = ReturnType<typeof useGetContextAnalysisResultQuery>;
export type GetContextAnalysisResultLazyQueryHookResult = ReturnType<typeof useGetContextAnalysisResultLazyQuery>;
export type GetContextAnalysisResultSuspenseQueryHookResult = ReturnType<typeof useGetContextAnalysisResultSuspenseQuery>;
export type GetContextAnalysisResultQueryResult = Apollo.QueryResult<GetContextAnalysisResultQuery, GetContextAnalysisResultQueryVariables>;
export const GetApiCatalogsDocument = gql`
    query GetApiCatalogs($projectId: String, $limit: Int = 100, $offset: Int = 0) {
  apiCatalogs(projectId: $projectId, limit: $limit, offset: $offset) {
    id
    organizationId
    projectId
    serviceName
    provider
    apiVersion
    crawlStatus
    crawlError
    crawlStartedAt
    crawlCompletedAt
    apiOverview {
      baseUrl
      authType
      authDetails
      rateLimits
      description
    }
    endpoints {
      method
      path
      description
      parameters
      requestBody
      responseSchema
      authRequired
      deprecated
    }
    implementationKnowledge
    groundingSources
    documentationUrls
    endpointCount
    verification {
      status
      confidenceScore
      baseUrlVerified
      baseUrlCorrect
      authTypeVerified
      authTypeCorrect
      endpointVerdicts {
        method
        path
        exists
        notes
      }
      verificationSources
      errorMessage
      verifiedAt
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetApiCatalogsQuery__
 *
 * To run a query within a React component, call `useGetApiCatalogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiCatalogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiCatalogsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetApiCatalogsQuery(baseOptions?: Apollo.QueryHookOptions<GetApiCatalogsQuery, GetApiCatalogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApiCatalogsQuery, GetApiCatalogsQueryVariables>(GetApiCatalogsDocument, options);
      }
export function useGetApiCatalogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApiCatalogsQuery, GetApiCatalogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApiCatalogsQuery, GetApiCatalogsQueryVariables>(GetApiCatalogsDocument, options);
        }
// @ts-ignore
export function useGetApiCatalogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApiCatalogsQuery, GetApiCatalogsQueryVariables>): Apollo.UseSuspenseQueryResult<GetApiCatalogsQuery, GetApiCatalogsQueryVariables>;
export function useGetApiCatalogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApiCatalogsQuery, GetApiCatalogsQueryVariables>): Apollo.UseSuspenseQueryResult<GetApiCatalogsQuery | undefined, GetApiCatalogsQueryVariables>;
export function useGetApiCatalogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApiCatalogsQuery, GetApiCatalogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApiCatalogsQuery, GetApiCatalogsQueryVariables>(GetApiCatalogsDocument, options);
        }
export type GetApiCatalogsQueryHookResult = ReturnType<typeof useGetApiCatalogsQuery>;
export type GetApiCatalogsLazyQueryHookResult = ReturnType<typeof useGetApiCatalogsLazyQuery>;
export type GetApiCatalogsSuspenseQueryHookResult = ReturnType<typeof useGetApiCatalogsSuspenseQuery>;
export type GetApiCatalogsQueryResult = Apollo.QueryResult<GetApiCatalogsQuery, GetApiCatalogsQueryVariables>;
export const GetApiCatalogDocument = gql`
    query GetApiCatalog($id: UUID!) {
  apiCatalog(id: $id) {
    id
    organizationId
    projectId
    serviceName
    provider
    apiVersion
    crawlStatus
    crawlError
    crawlStartedAt
    crawlCompletedAt
    apiOverview {
      baseUrl
      authType
      authDetails
      rateLimits
      description
    }
    endpoints {
      method
      path
      description
      parameters
      requestBody
      responseSchema
      authRequired
      deprecated
    }
    implementationKnowledge
    groundingSources
    documentationUrls
    endpointCount
    verification {
      status
      confidenceScore
      baseUrlVerified
      baseUrlCorrect
      authTypeVerified
      authTypeCorrect
      endpointVerdicts {
        method
        path
        exists
        notes
      }
      verificationSources
      errorMessage
      verifiedAt
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetApiCatalogQuery__
 *
 * To run a query within a React component, call `useGetApiCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiCatalogQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetApiCatalogQuery(baseOptions: Apollo.QueryHookOptions<GetApiCatalogQuery, GetApiCatalogQueryVariables> & ({ variables: GetApiCatalogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApiCatalogQuery, GetApiCatalogQueryVariables>(GetApiCatalogDocument, options);
      }
export function useGetApiCatalogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApiCatalogQuery, GetApiCatalogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApiCatalogQuery, GetApiCatalogQueryVariables>(GetApiCatalogDocument, options);
        }
// @ts-ignore
export function useGetApiCatalogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApiCatalogQuery, GetApiCatalogQueryVariables>): Apollo.UseSuspenseQueryResult<GetApiCatalogQuery, GetApiCatalogQueryVariables>;
export function useGetApiCatalogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApiCatalogQuery, GetApiCatalogQueryVariables>): Apollo.UseSuspenseQueryResult<GetApiCatalogQuery | undefined, GetApiCatalogQueryVariables>;
export function useGetApiCatalogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApiCatalogQuery, GetApiCatalogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApiCatalogQuery, GetApiCatalogQueryVariables>(GetApiCatalogDocument, options);
        }
export type GetApiCatalogQueryHookResult = ReturnType<typeof useGetApiCatalogQuery>;
export type GetApiCatalogLazyQueryHookResult = ReturnType<typeof useGetApiCatalogLazyQuery>;
export type GetApiCatalogSuspenseQueryHookResult = ReturnType<typeof useGetApiCatalogSuspenseQuery>;
export type GetApiCatalogQueryResult = Apollo.QueryResult<GetApiCatalogQuery, GetApiCatalogQueryVariables>;
export const RequestApiCrawlDocument = gql`
    mutation RequestApiCrawl($input: RequestApiCrawlInput!) {
  requestApiCrawl(input: $input) {
    catalogId
    taskId
  }
}
    `;
export type RequestApiCrawlMutationFn = Apollo.MutationFunction<RequestApiCrawlMutation, RequestApiCrawlMutationVariables>;

/**
 * __useRequestApiCrawlMutation__
 *
 * To run a mutation, you first call `useRequestApiCrawlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestApiCrawlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestApiCrawlMutation, { data, loading, error }] = useRequestApiCrawlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestApiCrawlMutation(baseOptions?: Apollo.MutationHookOptions<RequestApiCrawlMutation, RequestApiCrawlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestApiCrawlMutation, RequestApiCrawlMutationVariables>(RequestApiCrawlDocument, options);
      }
export type RequestApiCrawlMutationHookResult = ReturnType<typeof useRequestApiCrawlMutation>;
export type RequestApiCrawlMutationResult = Apollo.MutationResult<RequestApiCrawlMutation>;
export type RequestApiCrawlMutationOptions = Apollo.BaseMutationOptions<RequestApiCrawlMutation, RequestApiCrawlMutationVariables>;
export const RetryApiCrawlDocument = gql`
    mutation RetryApiCrawl($catalogId: UUID!, $documentationUrls: [String!]) {
  retryApiCrawl(catalogId: $catalogId, documentationUrls: $documentationUrls) {
    catalogId
    taskId
  }
}
    `;
export type RetryApiCrawlMutationFn = Apollo.MutationFunction<RetryApiCrawlMutation, RetryApiCrawlMutationVariables>;

/**
 * __useRetryApiCrawlMutation__
 *
 * To run a mutation, you first call `useRetryApiCrawlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryApiCrawlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryApiCrawlMutation, { data, loading, error }] = useRetryApiCrawlMutation({
 *   variables: {
 *      catalogId: // value for 'catalogId'
 *      documentationUrls: // value for 'documentationUrls'
 *   },
 * });
 */
export function useRetryApiCrawlMutation(baseOptions?: Apollo.MutationHookOptions<RetryApiCrawlMutation, RetryApiCrawlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryApiCrawlMutation, RetryApiCrawlMutationVariables>(RetryApiCrawlDocument, options);
      }
export type RetryApiCrawlMutationHookResult = ReturnType<typeof useRetryApiCrawlMutation>;
export type RetryApiCrawlMutationResult = Apollo.MutationResult<RetryApiCrawlMutation>;
export type RetryApiCrawlMutationOptions = Apollo.BaseMutationOptions<RetryApiCrawlMutation, RetryApiCrawlMutationVariables>;
export const DeleteApiCatalogDocument = gql`
    mutation DeleteApiCatalog($catalogId: UUID!) {
  deleteApiCatalog(catalogId: $catalogId)
}
    `;
export type DeleteApiCatalogMutationFn = Apollo.MutationFunction<DeleteApiCatalogMutation, DeleteApiCatalogMutationVariables>;

/**
 * __useDeleteApiCatalogMutation__
 *
 * To run a mutation, you first call `useDeleteApiCatalogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApiCatalogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApiCatalogMutation, { data, loading, error }] = useDeleteApiCatalogMutation({
 *   variables: {
 *      catalogId: // value for 'catalogId'
 *   },
 * });
 */
export function useDeleteApiCatalogMutation(baseOptions?: Apollo.MutationHookOptions<DeleteApiCatalogMutation, DeleteApiCatalogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteApiCatalogMutation, DeleteApiCatalogMutationVariables>(DeleteApiCatalogDocument, options);
      }
export type DeleteApiCatalogMutationHookResult = ReturnType<typeof useDeleteApiCatalogMutation>;
export type DeleteApiCatalogMutationResult = Apollo.MutationResult<DeleteApiCatalogMutation>;
export type DeleteApiCatalogMutationOptions = Apollo.BaseMutationOptions<DeleteApiCatalogMutation, DeleteApiCatalogMutationVariables>;
export const CreateAtomDocument = gql`
    mutation CreateAtom($input: CreateAtomInput!) {
  createAtom(input: $input) {
    id
    title
    fullContent
    contentFormat
    sourceType
    sourceId
    filePath
    fileType
    fileSize
    status
    processingError
    processingProgress
    processedAt
    atomType
    category
    tags
    organizationId
    clientId
    projectId
    industryId
    metaInfo
    isVectorized
    embeddingModel
    viewCount
    usageCount
    qualityScore
    lastUsedAt
    createdBy
    updatedBy
    createdAt
    updatedAt
  }
}
    `;
export type CreateAtomMutationFn = Apollo.MutationFunction<CreateAtomMutation, CreateAtomMutationVariables>;

/**
 * __useCreateAtomMutation__
 *
 * To run a mutation, you first call `useCreateAtomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAtomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAtomMutation, { data, loading, error }] = useCreateAtomMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAtomMutation(baseOptions?: Apollo.MutationHookOptions<CreateAtomMutation, CreateAtomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAtomMutation, CreateAtomMutationVariables>(CreateAtomDocument, options);
      }
export type CreateAtomMutationHookResult = ReturnType<typeof useCreateAtomMutation>;
export type CreateAtomMutationResult = Apollo.MutationResult<CreateAtomMutation>;
export type CreateAtomMutationOptions = Apollo.BaseMutationOptions<CreateAtomMutation, CreateAtomMutationVariables>;
export const UpdateAtomDocument = gql`
    mutation UpdateAtom($id: UUID!, $input: UpdateAtomInput!) {
  updateAtom(id: $id, input: $input) {
    id
    title
    fullContent
    contentFormat
    sourceType
    sourceId
    filePath
    fileType
    fileSize
    status
    processingError
    processingProgress
    processedAt
    atomType
    category
    tags
    organizationId
    clientId
    projectId
    industryId
    metaInfo
    isVectorized
    embeddingModel
    viewCount
    usageCount
    qualityScore
    lastUsedAt
    createdBy
    updatedBy
    createdAt
    updatedAt
  }
}
    `;
export type UpdateAtomMutationFn = Apollo.MutationFunction<UpdateAtomMutation, UpdateAtomMutationVariables>;

/**
 * __useUpdateAtomMutation__
 *
 * To run a mutation, you first call `useUpdateAtomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAtomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAtomMutation, { data, loading, error }] = useUpdateAtomMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAtomMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAtomMutation, UpdateAtomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAtomMutation, UpdateAtomMutationVariables>(UpdateAtomDocument, options);
      }
export type UpdateAtomMutationHookResult = ReturnType<typeof useUpdateAtomMutation>;
export type UpdateAtomMutationResult = Apollo.MutationResult<UpdateAtomMutation>;
export type UpdateAtomMutationOptions = Apollo.BaseMutationOptions<UpdateAtomMutation, UpdateAtomMutationVariables>;
export const DeleteAtomDocument = gql`
    mutation DeleteAtom($id: UUID!) {
  deleteAtom(id: $id)
}
    `;
export type DeleteAtomMutationFn = Apollo.MutationFunction<DeleteAtomMutation, DeleteAtomMutationVariables>;

/**
 * __useDeleteAtomMutation__
 *
 * To run a mutation, you first call `useDeleteAtomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAtomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAtomMutation, { data, loading, error }] = useDeleteAtomMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAtomMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAtomMutation, DeleteAtomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAtomMutation, DeleteAtomMutationVariables>(DeleteAtomDocument, options);
      }
export type DeleteAtomMutationHookResult = ReturnType<typeof useDeleteAtomMutation>;
export type DeleteAtomMutationResult = Apollo.MutationResult<DeleteAtomMutation>;
export type DeleteAtomMutationOptions = Apollo.BaseMutationOptions<DeleteAtomMutation, DeleteAtomMutationVariables>;
export const StartAtomProcessingDocument = gql`
    mutation StartAtomProcessing($atomId: UUID!, $taskId: UUID = null) {
  startAtomProcessing(atomId: $atomId, taskId: $taskId)
}
    `;
export type StartAtomProcessingMutationFn = Apollo.MutationFunction<StartAtomProcessingMutation, StartAtomProcessingMutationVariables>;

/**
 * __useStartAtomProcessingMutation__
 *
 * To run a mutation, you first call `useStartAtomProcessingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartAtomProcessingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startAtomProcessingMutation, { data, loading, error }] = useStartAtomProcessingMutation({
 *   variables: {
 *      atomId: // value for 'atomId'
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useStartAtomProcessingMutation(baseOptions?: Apollo.MutationHookOptions<StartAtomProcessingMutation, StartAtomProcessingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartAtomProcessingMutation, StartAtomProcessingMutationVariables>(StartAtomProcessingDocument, options);
      }
export type StartAtomProcessingMutationHookResult = ReturnType<typeof useStartAtomProcessingMutation>;
export type StartAtomProcessingMutationResult = Apollo.MutationResult<StartAtomProcessingMutation>;
export type StartAtomProcessingMutationOptions = Apollo.BaseMutationOptions<StartAtomProcessingMutation, StartAtomProcessingMutationVariables>;
export const UpdateAtomProgressDocument = gql`
    mutation UpdateAtomProgress($atomId: UUID!, $percentage: Float!, $message: String = null) {
  updateAtomProgress(atomId: $atomId, percentage: $percentage, message: $message)
}
    `;
export type UpdateAtomProgressMutationFn = Apollo.MutationFunction<UpdateAtomProgressMutation, UpdateAtomProgressMutationVariables>;

/**
 * __useUpdateAtomProgressMutation__
 *
 * To run a mutation, you first call `useUpdateAtomProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAtomProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAtomProgressMutation, { data, loading, error }] = useUpdateAtomProgressMutation({
 *   variables: {
 *      atomId: // value for 'atomId'
 *      percentage: // value for 'percentage'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useUpdateAtomProgressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAtomProgressMutation, UpdateAtomProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAtomProgressMutation, UpdateAtomProgressMutationVariables>(UpdateAtomProgressDocument, options);
      }
export type UpdateAtomProgressMutationHookResult = ReturnType<typeof useUpdateAtomProgressMutation>;
export type UpdateAtomProgressMutationResult = Apollo.MutationResult<UpdateAtomProgressMutation>;
export type UpdateAtomProgressMutationOptions = Apollo.BaseMutationOptions<UpdateAtomProgressMutation, UpdateAtomProgressMutationVariables>;
export const CompleteAtomProcessingDocument = gql`
    mutation CompleteAtomProcessing($atomId: UUID!, $extractedContent: String = null, $extractedTags: [String!] = null, $processingTimeMs: Int = null) {
  completeAtomProcessing(
    atomId: $atomId
    extractedContent: $extractedContent
    extractedTags: $extractedTags
    processingTimeMs: $processingTimeMs
  )
}
    `;
export type CompleteAtomProcessingMutationFn = Apollo.MutationFunction<CompleteAtomProcessingMutation, CompleteAtomProcessingMutationVariables>;

/**
 * __useCompleteAtomProcessingMutation__
 *
 * To run a mutation, you first call `useCompleteAtomProcessingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteAtomProcessingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeAtomProcessingMutation, { data, loading, error }] = useCompleteAtomProcessingMutation({
 *   variables: {
 *      atomId: // value for 'atomId'
 *      extractedContent: // value for 'extractedContent'
 *      extractedTags: // value for 'extractedTags'
 *      processingTimeMs: // value for 'processingTimeMs'
 *   },
 * });
 */
export function useCompleteAtomProcessingMutation(baseOptions?: Apollo.MutationHookOptions<CompleteAtomProcessingMutation, CompleteAtomProcessingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteAtomProcessingMutation, CompleteAtomProcessingMutationVariables>(CompleteAtomProcessingDocument, options);
      }
export type CompleteAtomProcessingMutationHookResult = ReturnType<typeof useCompleteAtomProcessingMutation>;
export type CompleteAtomProcessingMutationResult = Apollo.MutationResult<CompleteAtomProcessingMutation>;
export type CompleteAtomProcessingMutationOptions = Apollo.BaseMutationOptions<CompleteAtomProcessingMutation, CompleteAtomProcessingMutationVariables>;
export const FailAtomProcessingDocument = gql`
    mutation FailAtomProcessing($atomId: UUID!, $errorMessage: String!, $errorCode: String = null) {
  failAtomProcessing(
    atomId: $atomId
    errorMessage: $errorMessage
    errorCode: $errorCode
  )
}
    `;
export type FailAtomProcessingMutationFn = Apollo.MutationFunction<FailAtomProcessingMutation, FailAtomProcessingMutationVariables>;

/**
 * __useFailAtomProcessingMutation__
 *
 * To run a mutation, you first call `useFailAtomProcessingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFailAtomProcessingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [failAtomProcessingMutation, { data, loading, error }] = useFailAtomProcessingMutation({
 *   variables: {
 *      atomId: // value for 'atomId'
 *      errorMessage: // value for 'errorMessage'
 *      errorCode: // value for 'errorCode'
 *   },
 * });
 */
export function useFailAtomProcessingMutation(baseOptions?: Apollo.MutationHookOptions<FailAtomProcessingMutation, FailAtomProcessingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FailAtomProcessingMutation, FailAtomProcessingMutationVariables>(FailAtomProcessingDocument, options);
      }
export type FailAtomProcessingMutationHookResult = ReturnType<typeof useFailAtomProcessingMutation>;
export type FailAtomProcessingMutationResult = Apollo.MutationResult<FailAtomProcessingMutation>;
export type FailAtomProcessingMutationOptions = Apollo.BaseMutationOptions<FailAtomProcessingMutation, FailAtomProcessingMutationVariables>;
export const RetryAtomProcessingDocument = gql`
    mutation RetryAtomProcessing($atomId: UUID!) {
  retryAtomProcessing(atomId: $atomId)
}
    `;
export type RetryAtomProcessingMutationFn = Apollo.MutationFunction<RetryAtomProcessingMutation, RetryAtomProcessingMutationVariables>;

/**
 * __useRetryAtomProcessingMutation__
 *
 * To run a mutation, you first call `useRetryAtomProcessingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryAtomProcessingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryAtomProcessingMutation, { data, loading, error }] = useRetryAtomProcessingMutation({
 *   variables: {
 *      atomId: // value for 'atomId'
 *   },
 * });
 */
export function useRetryAtomProcessingMutation(baseOptions?: Apollo.MutationHookOptions<RetryAtomProcessingMutation, RetryAtomProcessingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryAtomProcessingMutation, RetryAtomProcessingMutationVariables>(RetryAtomProcessingDocument, options);
      }
export type RetryAtomProcessingMutationHookResult = ReturnType<typeof useRetryAtomProcessingMutation>;
export type RetryAtomProcessingMutationResult = Apollo.MutationResult<RetryAtomProcessingMutation>;
export type RetryAtomProcessingMutationOptions = Apollo.BaseMutationOptions<RetryAtomProcessingMutation, RetryAtomProcessingMutationVariables>;
export const RetryFailedAtomDocument = gql`
    mutation RetryFailedAtom($atomId: UUID!) {
  retryFailedAtom(atomId: $atomId) {
    success
    atom {
      id
      title
      fullContent
      contentFormat
      sourceType
      sourceId
      filePath
      fileType
      fileSize
      status
      processingError
      processingProgress
      processedAt
      atomType
      category
      tags
      organizationId
      clientId
      projectId
      industryId
      metaInfo
      isVectorized
      embeddingModel
      viewCount
      usageCount
      qualityScore
      lastUsedAt
      createdBy
      updatedBy
      createdAt
      updatedAt
    }
    errorMessage
    processingTimeMs
    extractedMetadata
    taskId
  }
}
    `;
export type RetryFailedAtomMutationFn = Apollo.MutationFunction<RetryFailedAtomMutation, RetryFailedAtomMutationVariables>;

/**
 * __useRetryFailedAtomMutation__
 *
 * To run a mutation, you first call `useRetryFailedAtomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryFailedAtomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryFailedAtomMutation, { data, loading, error }] = useRetryFailedAtomMutation({
 *   variables: {
 *      atomId: // value for 'atomId'
 *   },
 * });
 */
export function useRetryFailedAtomMutation(baseOptions?: Apollo.MutationHookOptions<RetryFailedAtomMutation, RetryFailedAtomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryFailedAtomMutation, RetryFailedAtomMutationVariables>(RetryFailedAtomDocument, options);
      }
export type RetryFailedAtomMutationHookResult = ReturnType<typeof useRetryFailedAtomMutation>;
export type RetryFailedAtomMutationResult = Apollo.MutationResult<RetryFailedAtomMutation>;
export type RetryFailedAtomMutationOptions = Apollo.BaseMutationOptions<RetryFailedAtomMutation, RetryFailedAtomMutationVariables>;
export const MarkAtomVectorizedDocument = gql`
    mutation MarkAtomVectorized($atomId: UUID!, $embeddingModel: String!, $vectorDimension: Int!, $processingTimeMs: Int = null) {
  markAtomVectorized(
    atomId: $atomId
    embeddingModel: $embeddingModel
    vectorDimension: $vectorDimension
    processingTimeMs: $processingTimeMs
  )
}
    `;
export type MarkAtomVectorizedMutationFn = Apollo.MutationFunction<MarkAtomVectorizedMutation, MarkAtomVectorizedMutationVariables>;

/**
 * __useMarkAtomVectorizedMutation__
 *
 * To run a mutation, you first call `useMarkAtomVectorizedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAtomVectorizedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAtomVectorizedMutation, { data, loading, error }] = useMarkAtomVectorizedMutation({
 *   variables: {
 *      atomId: // value for 'atomId'
 *      embeddingModel: // value for 'embeddingModel'
 *      vectorDimension: // value for 'vectorDimension'
 *      processingTimeMs: // value for 'processingTimeMs'
 *   },
 * });
 */
export function useMarkAtomVectorizedMutation(baseOptions?: Apollo.MutationHookOptions<MarkAtomVectorizedMutation, MarkAtomVectorizedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAtomVectorizedMutation, MarkAtomVectorizedMutationVariables>(MarkAtomVectorizedDocument, options);
      }
export type MarkAtomVectorizedMutationHookResult = ReturnType<typeof useMarkAtomVectorizedMutation>;
export type MarkAtomVectorizedMutationResult = Apollo.MutationResult<MarkAtomVectorizedMutation>;
export type MarkAtomVectorizedMutationOptions = Apollo.BaseMutationOptions<MarkAtomVectorizedMutation, MarkAtomVectorizedMutationVariables>;
export const CreateAtomFromSourceDocument = gql`
    mutation CreateAtomFromSource($input: CreateAtomFromSourceInput!) {
  createAtomFromSource(input: $input) {
    success
    atom {
      id
      title
      fullContent
      contentFormat
      sourceType
      sourceId
      filePath
      fileType
      fileSize
      status
      processingError
      processingProgress
      processedAt
      atomType
      category
      tags
      organizationId
      clientId
      projectId
      industryId
      metaInfo
      isVectorized
      embeddingModel
      viewCount
      usageCount
      qualityScore
      lastUsedAt
      createdBy
      updatedBy
      createdAt
      updatedAt
    }
    errorMessage
    processingTimeMs
    extractedMetadata
    taskId
  }
}
    `;
export type CreateAtomFromSourceMutationFn = Apollo.MutationFunction<CreateAtomFromSourceMutation, CreateAtomFromSourceMutationVariables>;

/**
 * __useCreateAtomFromSourceMutation__
 *
 * To run a mutation, you first call `useCreateAtomFromSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAtomFromSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAtomFromSourceMutation, { data, loading, error }] = useCreateAtomFromSourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAtomFromSourceMutation(baseOptions?: Apollo.MutationHookOptions<CreateAtomFromSourceMutation, CreateAtomFromSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAtomFromSourceMutation, CreateAtomFromSourceMutationVariables>(CreateAtomFromSourceDocument, options);
      }
export type CreateAtomFromSourceMutationHookResult = ReturnType<typeof useCreateAtomFromSourceMutation>;
export type CreateAtomFromSourceMutationResult = Apollo.MutationResult<CreateAtomFromSourceMutation>;
export type CreateAtomFromSourceMutationOptions = Apollo.BaseMutationOptions<CreateAtomFromSourceMutation, CreateAtomFromSourceMutationVariables>;
export const CreateIndustryDddDocument = gql`
    mutation CreateIndustryDdd($input: CreateIndustryInput!) {
  createIndustryDdd(input: $input) {
    id
    name
    code
    description
    isActive
    icon
    industryProfile
    metadata
    createdAt
    updatedAt
    organizationUuid
  }
}
    `;
export type CreateIndustryDddMutationFn = Apollo.MutationFunction<CreateIndustryDddMutation, CreateIndustryDddMutationVariables>;

/**
 * __useCreateIndustryDddMutation__
 *
 * To run a mutation, you first call `useCreateIndustryDddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIndustryDddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIndustryDddMutation, { data, loading, error }] = useCreateIndustryDddMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIndustryDddMutation(baseOptions?: Apollo.MutationHookOptions<CreateIndustryDddMutation, CreateIndustryDddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIndustryDddMutation, CreateIndustryDddMutationVariables>(CreateIndustryDddDocument, options);
      }
export type CreateIndustryDddMutationHookResult = ReturnType<typeof useCreateIndustryDddMutation>;
export type CreateIndustryDddMutationResult = Apollo.MutationResult<CreateIndustryDddMutation>;
export type CreateIndustryDddMutationOptions = Apollo.BaseMutationOptions<CreateIndustryDddMutation, CreateIndustryDddMutationVariables>;
export const UpdateIndustryDddDocument = gql`
    mutation UpdateIndustryDdd($input: UpdateIndustryInput!) {
  updateIndustryDdd(input: $input) {
    id
    name
    code
    description
    isActive
    icon
    industryProfile
    metadata
    createdAt
    updatedAt
    organizationUuid
  }
}
    `;
export type UpdateIndustryDddMutationFn = Apollo.MutationFunction<UpdateIndustryDddMutation, UpdateIndustryDddMutationVariables>;

/**
 * __useUpdateIndustryDddMutation__
 *
 * To run a mutation, you first call `useUpdateIndustryDddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIndustryDddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIndustryDddMutation, { data, loading, error }] = useUpdateIndustryDddMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIndustryDddMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIndustryDddMutation, UpdateIndustryDddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIndustryDddMutation, UpdateIndustryDddMutationVariables>(UpdateIndustryDddDocument, options);
      }
export type UpdateIndustryDddMutationHookResult = ReturnType<typeof useUpdateIndustryDddMutation>;
export type UpdateIndustryDddMutationResult = Apollo.MutationResult<UpdateIndustryDddMutation>;
export type UpdateIndustryDddMutationOptions = Apollo.BaseMutationOptions<UpdateIndustryDddMutation, UpdateIndustryDddMutationVariables>;
export const ActivateIndustryDddDocument = gql`
    mutation ActivateIndustryDdd($id: UUID!) {
  activateIndustryDdd(id: $id) {
    id
    name
    code
    description
    isActive
    icon
    industryProfile
    metadata
    createdAt
    updatedAt
    organizationUuid
  }
}
    `;
export type ActivateIndustryDddMutationFn = Apollo.MutationFunction<ActivateIndustryDddMutation, ActivateIndustryDddMutationVariables>;

/**
 * __useActivateIndustryDddMutation__
 *
 * To run a mutation, you first call `useActivateIndustryDddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateIndustryDddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateIndustryDddMutation, { data, loading, error }] = useActivateIndustryDddMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateIndustryDddMutation(baseOptions?: Apollo.MutationHookOptions<ActivateIndustryDddMutation, ActivateIndustryDddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateIndustryDddMutation, ActivateIndustryDddMutationVariables>(ActivateIndustryDddDocument, options);
      }
export type ActivateIndustryDddMutationHookResult = ReturnType<typeof useActivateIndustryDddMutation>;
export type ActivateIndustryDddMutationResult = Apollo.MutationResult<ActivateIndustryDddMutation>;
export type ActivateIndustryDddMutationOptions = Apollo.BaseMutationOptions<ActivateIndustryDddMutation, ActivateIndustryDddMutationVariables>;
export const DeactivateIndustryDddDocument = gql`
    mutation DeactivateIndustryDdd($id: UUID!) {
  deactivateIndustryDdd(id: $id) {
    id
    name
    code
    description
    isActive
    icon
    industryProfile
    metadata
    createdAt
    updatedAt
    organizationUuid
  }
}
    `;
export type DeactivateIndustryDddMutationFn = Apollo.MutationFunction<DeactivateIndustryDddMutation, DeactivateIndustryDddMutationVariables>;

/**
 * __useDeactivateIndustryDddMutation__
 *
 * To run a mutation, you first call `useDeactivateIndustryDddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateIndustryDddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateIndustryDddMutation, { data, loading, error }] = useDeactivateIndustryDddMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateIndustryDddMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateIndustryDddMutation, DeactivateIndustryDddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateIndustryDddMutation, DeactivateIndustryDddMutationVariables>(DeactivateIndustryDddDocument, options);
      }
export type DeactivateIndustryDddMutationHookResult = ReturnType<typeof useDeactivateIndustryDddMutation>;
export type DeactivateIndustryDddMutationResult = Apollo.MutationResult<DeactivateIndustryDddMutation>;
export type DeactivateIndustryDddMutationOptions = Apollo.BaseMutationOptions<DeactivateIndustryDddMutation, DeactivateIndustryDddMutationVariables>;
export const DeleteIndustryDddDocument = gql`
    mutation DeleteIndustryDdd($id: UUID!) {
  deleteIndustryDdd(id: $id)
}
    `;
export type DeleteIndustryDddMutationFn = Apollo.MutationFunction<DeleteIndustryDddMutation, DeleteIndustryDddMutationVariables>;

/**
 * __useDeleteIndustryDddMutation__
 *
 * To run a mutation, you first call `useDeleteIndustryDddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIndustryDddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIndustryDddMutation, { data, loading, error }] = useDeleteIndustryDddMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIndustryDddMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIndustryDddMutation, DeleteIndustryDddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIndustryDddMutation, DeleteIndustryDddMutationVariables>(DeleteIndustryDddDocument, options);
      }
export type DeleteIndustryDddMutationHookResult = ReturnType<typeof useDeleteIndustryDddMutation>;
export type DeleteIndustryDddMutationResult = Apollo.MutationResult<DeleteIndustryDddMutation>;
export type DeleteIndustryDddMutationOptions = Apollo.BaseMutationOptions<DeleteIndustryDddMutation, DeleteIndustryDddMutationVariables>;
export const CreateIndustryDocument = gql`
    mutation CreateIndustry($input: CreateIndustryInput!) {
  createIndustry(input: $input) {
    id
    name
    code
    description
    isActive
    icon
    industryProfile
    metadata
    createdAt
    updatedAt
    organizationUuid
  }
}
    `;
export type CreateIndustryMutationFn = Apollo.MutationFunction<CreateIndustryMutation, CreateIndustryMutationVariables>;

/**
 * __useCreateIndustryMutation__
 *
 * To run a mutation, you first call `useCreateIndustryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIndustryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIndustryMutation, { data, loading, error }] = useCreateIndustryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIndustryMutation(baseOptions?: Apollo.MutationHookOptions<CreateIndustryMutation, CreateIndustryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIndustryMutation, CreateIndustryMutationVariables>(CreateIndustryDocument, options);
      }
export type CreateIndustryMutationHookResult = ReturnType<typeof useCreateIndustryMutation>;
export type CreateIndustryMutationResult = Apollo.MutationResult<CreateIndustryMutation>;
export type CreateIndustryMutationOptions = Apollo.BaseMutationOptions<CreateIndustryMutation, CreateIndustryMutationVariables>;
export const UpdateIndustryDocument = gql`
    mutation UpdateIndustry($input: UpdateIndustryInput!) {
  updateIndustry(input: $input) {
    id
    name
    code
    description
    isActive
    icon
    industryProfile
    metadata
    createdAt
    updatedAt
    organizationUuid
  }
}
    `;
export type UpdateIndustryMutationFn = Apollo.MutationFunction<UpdateIndustryMutation, UpdateIndustryMutationVariables>;

/**
 * __useUpdateIndustryMutation__
 *
 * To run a mutation, you first call `useUpdateIndustryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIndustryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIndustryMutation, { data, loading, error }] = useUpdateIndustryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIndustryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIndustryMutation, UpdateIndustryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIndustryMutation, UpdateIndustryMutationVariables>(UpdateIndustryDocument, options);
      }
export type UpdateIndustryMutationHookResult = ReturnType<typeof useUpdateIndustryMutation>;
export type UpdateIndustryMutationResult = Apollo.MutationResult<UpdateIndustryMutation>;
export type UpdateIndustryMutationOptions = Apollo.BaseMutationOptions<UpdateIndustryMutation, UpdateIndustryMutationVariables>;
export const ActivateIndustryDocument = gql`
    mutation ActivateIndustry($id: UUID!) {
  activateIndustry(id: $id) {
    id
    name
    code
    description
    isActive
    icon
    industryProfile
    metadata
    createdAt
    updatedAt
    organizationUuid
  }
}
    `;
export type ActivateIndustryMutationFn = Apollo.MutationFunction<ActivateIndustryMutation, ActivateIndustryMutationVariables>;

/**
 * __useActivateIndustryMutation__
 *
 * To run a mutation, you first call `useActivateIndustryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateIndustryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateIndustryMutation, { data, loading, error }] = useActivateIndustryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateIndustryMutation(baseOptions?: Apollo.MutationHookOptions<ActivateIndustryMutation, ActivateIndustryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateIndustryMutation, ActivateIndustryMutationVariables>(ActivateIndustryDocument, options);
      }
export type ActivateIndustryMutationHookResult = ReturnType<typeof useActivateIndustryMutation>;
export type ActivateIndustryMutationResult = Apollo.MutationResult<ActivateIndustryMutation>;
export type ActivateIndustryMutationOptions = Apollo.BaseMutationOptions<ActivateIndustryMutation, ActivateIndustryMutationVariables>;
export const DeactivateIndustryDocument = gql`
    mutation DeactivateIndustry($id: UUID!) {
  deactivateIndustry(id: $id) {
    id
    name
    code
    description
    isActive
    icon
    industryProfile
    metadata
    createdAt
    updatedAt
    organizationUuid
  }
}
    `;
export type DeactivateIndustryMutationFn = Apollo.MutationFunction<DeactivateIndustryMutation, DeactivateIndustryMutationVariables>;

/**
 * __useDeactivateIndustryMutation__
 *
 * To run a mutation, you first call `useDeactivateIndustryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateIndustryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateIndustryMutation, { data, loading, error }] = useDeactivateIndustryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateIndustryMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateIndustryMutation, DeactivateIndustryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateIndustryMutation, DeactivateIndustryMutationVariables>(DeactivateIndustryDocument, options);
      }
export type DeactivateIndustryMutationHookResult = ReturnType<typeof useDeactivateIndustryMutation>;
export type DeactivateIndustryMutationResult = Apollo.MutationResult<DeactivateIndustryMutation>;
export type DeactivateIndustryMutationOptions = Apollo.BaseMutationOptions<DeactivateIndustryMutation, DeactivateIndustryMutationVariables>;
export const DeleteIndustryDocument = gql`
    mutation DeleteIndustry($id: UUID!) {
  deleteIndustry(id: $id)
}
    `;
export type DeleteIndustryMutationFn = Apollo.MutationFunction<DeleteIndustryMutation, DeleteIndustryMutationVariables>;

/**
 * __useDeleteIndustryMutation__
 *
 * To run a mutation, you first call `useDeleteIndustryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIndustryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIndustryMutation, { data, loading, error }] = useDeleteIndustryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIndustryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIndustryMutation, DeleteIndustryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIndustryMutation, DeleteIndustryMutationVariables>(DeleteIndustryDocument, options);
      }
export type DeleteIndustryMutationHookResult = ReturnType<typeof useDeleteIndustryMutation>;
export type DeleteIndustryMutationResult = Apollo.MutationResult<DeleteIndustryMutation>;
export type DeleteIndustryMutationOptions = Apollo.BaseMutationOptions<DeleteIndustryMutation, DeleteIndustryMutationVariables>;
export const CreateIndustryCategoryDocument = gql`
    mutation CreateIndustryCategory($input: IndustryCategoryCreateInput!) {
  createIndustryCategory(input: $input) {
    success
    message
    category {
      id
      name
      code
      parentId
      displayOrder
      subcategories {
        id
        name
        code
        parentId
        displayOrder
      }
    }
  }
}
    `;
export type CreateIndustryCategoryMutationFn = Apollo.MutationFunction<CreateIndustryCategoryMutation, CreateIndustryCategoryMutationVariables>;

/**
 * __useCreateIndustryCategoryMutation__
 *
 * To run a mutation, you first call `useCreateIndustryCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIndustryCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIndustryCategoryMutation, { data, loading, error }] = useCreateIndustryCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIndustryCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateIndustryCategoryMutation, CreateIndustryCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIndustryCategoryMutation, CreateIndustryCategoryMutationVariables>(CreateIndustryCategoryDocument, options);
      }
export type CreateIndustryCategoryMutationHookResult = ReturnType<typeof useCreateIndustryCategoryMutation>;
export type CreateIndustryCategoryMutationResult = Apollo.MutationResult<CreateIndustryCategoryMutation>;
export type CreateIndustryCategoryMutationOptions = Apollo.BaseMutationOptions<CreateIndustryCategoryMutation, CreateIndustryCategoryMutationVariables>;
export const UpdateIndustryCategoryDocument = gql`
    mutation UpdateIndustryCategory($id: UUID!, $input: IndustryCategoryUpdateInput!) {
  updateIndustryCategory(id: $id, input: $input) {
    success
    message
    category {
      id
      name
      code
      parentId
      displayOrder
      subcategories {
        id
        name
        code
        parentId
        displayOrder
      }
    }
  }
}
    `;
export type UpdateIndustryCategoryMutationFn = Apollo.MutationFunction<UpdateIndustryCategoryMutation, UpdateIndustryCategoryMutationVariables>;

/**
 * __useUpdateIndustryCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateIndustryCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIndustryCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIndustryCategoryMutation, { data, loading, error }] = useUpdateIndustryCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIndustryCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIndustryCategoryMutation, UpdateIndustryCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIndustryCategoryMutation, UpdateIndustryCategoryMutationVariables>(UpdateIndustryCategoryDocument, options);
      }
export type UpdateIndustryCategoryMutationHookResult = ReturnType<typeof useUpdateIndustryCategoryMutation>;
export type UpdateIndustryCategoryMutationResult = Apollo.MutationResult<UpdateIndustryCategoryMutation>;
export type UpdateIndustryCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateIndustryCategoryMutation, UpdateIndustryCategoryMutationVariables>;
export const DeleteIndustryCategoryDocument = gql`
    mutation DeleteIndustryCategory($id: UUID!) {
  deleteIndustryCategory(id: $id) {
    success
    message
    category {
      id
      name
      code
      parentId
      displayOrder
      subcategories {
        id
        name
        code
        parentId
        displayOrder
      }
    }
  }
}
    `;
export type DeleteIndustryCategoryMutationFn = Apollo.MutationFunction<DeleteIndustryCategoryMutation, DeleteIndustryCategoryMutationVariables>;

/**
 * __useDeleteIndustryCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteIndustryCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIndustryCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIndustryCategoryMutation, { data, loading, error }] = useDeleteIndustryCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIndustryCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIndustryCategoryMutation, DeleteIndustryCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIndustryCategoryMutation, DeleteIndustryCategoryMutationVariables>(DeleteIndustryCategoryDocument, options);
      }
export type DeleteIndustryCategoryMutationHookResult = ReturnType<typeof useDeleteIndustryCategoryMutation>;
export type DeleteIndustryCategoryMutationResult = Apollo.MutationResult<DeleteIndustryCategoryMutation>;
export type DeleteIndustryCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteIndustryCategoryMutation, DeleteIndustryCategoryMutationVariables>;
export const AttachPluginToIndustryDocument = gql`
    mutation AttachPluginToIndustry($industryId: UUID!, $pluginId: UUID!, $configuration: JSON = null, $priority: Int! = 0) {
  attachPluginToIndustry(
    industryId: $industryId
    pluginId: $pluginId
    configuration: $configuration
    priority: $priority
  ) {
    success
    message
    industry {
      id
      name
      code
      description
      icon
      isActive
      industryProfile
      hasProfileData
      categories {
        id
        name
        code
        parentId
        displayOrder
      }
    }
  }
}
    `;
export type AttachPluginToIndustryMutationFn = Apollo.MutationFunction<AttachPluginToIndustryMutation, AttachPluginToIndustryMutationVariables>;

/**
 * __useAttachPluginToIndustryMutation__
 *
 * To run a mutation, you first call `useAttachPluginToIndustryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachPluginToIndustryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachPluginToIndustryMutation, { data, loading, error }] = useAttachPluginToIndustryMutation({
 *   variables: {
 *      industryId: // value for 'industryId'
 *      pluginId: // value for 'pluginId'
 *      configuration: // value for 'configuration'
 *      priority: // value for 'priority'
 *   },
 * });
 */
export function useAttachPluginToIndustryMutation(baseOptions?: Apollo.MutationHookOptions<AttachPluginToIndustryMutation, AttachPluginToIndustryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttachPluginToIndustryMutation, AttachPluginToIndustryMutationVariables>(AttachPluginToIndustryDocument, options);
      }
export type AttachPluginToIndustryMutationHookResult = ReturnType<typeof useAttachPluginToIndustryMutation>;
export type AttachPluginToIndustryMutationResult = Apollo.MutationResult<AttachPluginToIndustryMutation>;
export type AttachPluginToIndustryMutationOptions = Apollo.BaseMutationOptions<AttachPluginToIndustryMutation, AttachPluginToIndustryMutationVariables>;
export const CreateAtomSourceDocument = gql`
    mutation CreateAtomSource($input: CreateAtomSourceInput!) {
  createAtomSource(input: $input) {
    success
    message
    source {
      id
      organizationId
      entityType
      entityId
      sourceType
      sourceName
      sourceUrl
      sourceConfig
      isActive
      collectionFrequency
      lastCollectedAt
      nextCollectionAt
      contentFilters
      languageCode
      status
      metadata
      createdAt
      updatedAt
    }
  }
}
    `;
export type CreateAtomSourceMutationFn = Apollo.MutationFunction<CreateAtomSourceMutation, CreateAtomSourceMutationVariables>;

/**
 * __useCreateAtomSourceMutation__
 *
 * To run a mutation, you first call `useCreateAtomSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAtomSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAtomSourceMutation, { data, loading, error }] = useCreateAtomSourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAtomSourceMutation(baseOptions?: Apollo.MutationHookOptions<CreateAtomSourceMutation, CreateAtomSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAtomSourceMutation, CreateAtomSourceMutationVariables>(CreateAtomSourceDocument, options);
      }
export type CreateAtomSourceMutationHookResult = ReturnType<typeof useCreateAtomSourceMutation>;
export type CreateAtomSourceMutationResult = Apollo.MutationResult<CreateAtomSourceMutation>;
export type CreateAtomSourceMutationOptions = Apollo.BaseMutationOptions<CreateAtomSourceMutation, CreateAtomSourceMutationVariables>;
export const UpdateAtomSourceDocument = gql`
    mutation UpdateAtomSource($input: UpdateAtomSourceInput!) {
  updateAtomSource(input: $input) {
    success
    message
    source {
      id
      organizationId
      entityType
      entityId
      sourceType
      sourceName
      sourceUrl
      sourceConfig
      isActive
      collectionFrequency
      lastCollectedAt
      nextCollectionAt
      contentFilters
      languageCode
      status
      metadata
      createdAt
      updatedAt
    }
  }
}
    `;
export type UpdateAtomSourceMutationFn = Apollo.MutationFunction<UpdateAtomSourceMutation, UpdateAtomSourceMutationVariables>;

/**
 * __useUpdateAtomSourceMutation__
 *
 * To run a mutation, you first call `useUpdateAtomSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAtomSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAtomSourceMutation, { data, loading, error }] = useUpdateAtomSourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAtomSourceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAtomSourceMutation, UpdateAtomSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAtomSourceMutation, UpdateAtomSourceMutationVariables>(UpdateAtomSourceDocument, options);
      }
export type UpdateAtomSourceMutationHookResult = ReturnType<typeof useUpdateAtomSourceMutation>;
export type UpdateAtomSourceMutationResult = Apollo.MutationResult<UpdateAtomSourceMutation>;
export type UpdateAtomSourceMutationOptions = Apollo.BaseMutationOptions<UpdateAtomSourceMutation, UpdateAtomSourceMutationVariables>;
export const ActivateAtomSourceDocument = gql`
    mutation ActivateAtomSource($id: UUID!) {
  activateAtomSource(id: $id) {
    success
    message
    source {
      id
      organizationId
      entityType
      entityId
      sourceType
      sourceName
      sourceUrl
      sourceConfig
      isActive
      collectionFrequency
      lastCollectedAt
      nextCollectionAt
      contentFilters
      languageCode
      status
      metadata
      createdAt
      updatedAt
    }
  }
}
    `;
export type ActivateAtomSourceMutationFn = Apollo.MutationFunction<ActivateAtomSourceMutation, ActivateAtomSourceMutationVariables>;

/**
 * __useActivateAtomSourceMutation__
 *
 * To run a mutation, you first call `useActivateAtomSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateAtomSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateAtomSourceMutation, { data, loading, error }] = useActivateAtomSourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateAtomSourceMutation(baseOptions?: Apollo.MutationHookOptions<ActivateAtomSourceMutation, ActivateAtomSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateAtomSourceMutation, ActivateAtomSourceMutationVariables>(ActivateAtomSourceDocument, options);
      }
export type ActivateAtomSourceMutationHookResult = ReturnType<typeof useActivateAtomSourceMutation>;
export type ActivateAtomSourceMutationResult = Apollo.MutationResult<ActivateAtomSourceMutation>;
export type ActivateAtomSourceMutationOptions = Apollo.BaseMutationOptions<ActivateAtomSourceMutation, ActivateAtomSourceMutationVariables>;
export const DeactivateAtomSourceDocument = gql`
    mutation DeactivateAtomSource($id: UUID!, $reason: String = null) {
  deactivateAtomSource(id: $id, reason: $reason) {
    success
    message
    source {
      id
      organizationId
      entityType
      entityId
      sourceType
      sourceName
      sourceUrl
      sourceConfig
      isActive
      collectionFrequency
      lastCollectedAt
      nextCollectionAt
      contentFilters
      languageCode
      status
      metadata
      createdAt
      updatedAt
    }
  }
}
    `;
export type DeactivateAtomSourceMutationFn = Apollo.MutationFunction<DeactivateAtomSourceMutation, DeactivateAtomSourceMutationVariables>;

/**
 * __useDeactivateAtomSourceMutation__
 *
 * To run a mutation, you first call `useDeactivateAtomSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateAtomSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateAtomSourceMutation, { data, loading, error }] = useDeactivateAtomSourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useDeactivateAtomSourceMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateAtomSourceMutation, DeactivateAtomSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateAtomSourceMutation, DeactivateAtomSourceMutationVariables>(DeactivateAtomSourceDocument, options);
      }
export type DeactivateAtomSourceMutationHookResult = ReturnType<typeof useDeactivateAtomSourceMutation>;
export type DeactivateAtomSourceMutationResult = Apollo.MutationResult<DeactivateAtomSourceMutation>;
export type DeactivateAtomSourceMutationOptions = Apollo.BaseMutationOptions<DeactivateAtomSourceMutation, DeactivateAtomSourceMutationVariables>;
export const DeleteAtomSourceDocument = gql`
    mutation DeleteAtomSource($id: UUID!) {
  deleteAtomSource(id: $id) {
    success
    message
    source {
      id
      organizationId
      entityType
      entityId
      sourceType
      sourceName
      sourceUrl
      sourceConfig
      isActive
      collectionFrequency
      lastCollectedAt
      nextCollectionAt
      contentFilters
      languageCode
      status
      metadata
      createdAt
      updatedAt
    }
  }
}
    `;
export type DeleteAtomSourceMutationFn = Apollo.MutationFunction<DeleteAtomSourceMutation, DeleteAtomSourceMutationVariables>;

/**
 * __useDeleteAtomSourceMutation__
 *
 * To run a mutation, you first call `useDeleteAtomSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAtomSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAtomSourceMutation, { data, loading, error }] = useDeleteAtomSourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAtomSourceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAtomSourceMutation, DeleteAtomSourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAtomSourceMutation, DeleteAtomSourceMutationVariables>(DeleteAtomSourceDocument, options);
      }
export type DeleteAtomSourceMutationHookResult = ReturnType<typeof useDeleteAtomSourceMutation>;
export type DeleteAtomSourceMutationResult = Apollo.MutationResult<DeleteAtomSourceMutation>;
export type DeleteAtomSourceMutationOptions = Apollo.BaseMutationOptions<DeleteAtomSourceMutation, DeleteAtomSourceMutationVariables>;
export const TriggerAtomCollectionDocument = gql`
    mutation TriggerAtomCollection($sourceId: UUID!, $maxItems: Int! = 10) {
  triggerAtomCollection(sourceId: $sourceId, maxItems: $maxItems) {
    success
    message
    source {
      id
      organizationId
      entityType
      entityId
      sourceType
      sourceName
      sourceUrl
      sourceConfig
      isActive
      collectionFrequency
      lastCollectedAt
      nextCollectionAt
      contentFilters
      languageCode
      status
      metadata
      createdAt
      updatedAt
    }
  }
}
    `;
export type TriggerAtomCollectionMutationFn = Apollo.MutationFunction<TriggerAtomCollectionMutation, TriggerAtomCollectionMutationVariables>;

/**
 * __useTriggerAtomCollectionMutation__
 *
 * To run a mutation, you first call `useTriggerAtomCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerAtomCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerAtomCollectionMutation, { data, loading, error }] = useTriggerAtomCollectionMutation({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      maxItems: // value for 'maxItems'
 *   },
 * });
 */
export function useTriggerAtomCollectionMutation(baseOptions?: Apollo.MutationHookOptions<TriggerAtomCollectionMutation, TriggerAtomCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerAtomCollectionMutation, TriggerAtomCollectionMutationVariables>(TriggerAtomCollectionDocument, options);
      }
export type TriggerAtomCollectionMutationHookResult = ReturnType<typeof useTriggerAtomCollectionMutation>;
export type TriggerAtomCollectionMutationResult = Apollo.MutationResult<TriggerAtomCollectionMutation>;
export type TriggerAtomCollectionMutationOptions = Apollo.BaseMutationOptions<TriggerAtomCollectionMutation, TriggerAtomCollectionMutationVariables>;
export const GetAtomDocument = gql`
    query GetAtom($id: UUID!) {
  atom(id: $id) {
    id
    title
    fullContent
    contentFormat
    sourceType
    sourceId
    filePath
    fileType
    fileSize
    status
    processingError
    processingProgress
    processedAt
    atomType
    category
    tags
    organizationId
    clientId
    projectId
    industryId
    metaInfo
    isVectorized
    embeddingModel
    viewCount
    usageCount
    qualityScore
    lastUsedAt
    createdBy
    updatedBy
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetAtomQuery__
 *
 * To run a query within a React component, call `useGetAtomQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAtomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAtomQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAtomQuery(baseOptions: Apollo.QueryHookOptions<GetAtomQuery, GetAtomQueryVariables> & ({ variables: GetAtomQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAtomQuery, GetAtomQueryVariables>(GetAtomDocument, options);
      }
export function useGetAtomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAtomQuery, GetAtomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAtomQuery, GetAtomQueryVariables>(GetAtomDocument, options);
        }
// @ts-ignore
export function useGetAtomSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAtomQuery, GetAtomQueryVariables>): Apollo.UseSuspenseQueryResult<GetAtomQuery, GetAtomQueryVariables>;
export function useGetAtomSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAtomQuery, GetAtomQueryVariables>): Apollo.UseSuspenseQueryResult<GetAtomQuery | undefined, GetAtomQueryVariables>;
export function useGetAtomSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAtomQuery, GetAtomQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAtomQuery, GetAtomQueryVariables>(GetAtomDocument, options);
        }
export type GetAtomQueryHookResult = ReturnType<typeof useGetAtomQuery>;
export type GetAtomLazyQueryHookResult = ReturnType<typeof useGetAtomLazyQuery>;
export type GetAtomSuspenseQueryHookResult = ReturnType<typeof useGetAtomSuspenseQuery>;
export type GetAtomQueryResult = Apollo.QueryResult<GetAtomQuery, GetAtomQueryVariables>;
export const GetAtomsDocument = gql`
    query GetAtoms($filter: AtomFilterInput = null, $limit: Int! = 50, $offset: Int! = 0) {
  atoms(filter: $filter, limit: $limit, offset: $offset) {
    edges {
      cursor
      node {
        id
        title
        fullContent
        contentFormat
        sourceType
        sourceId
        filePath
        fileType
        fileSize
        status
        processingError
        processingProgress
        processedAt
        atomType
        category
        tags
        organizationId
        clientId
        projectId
        industryId
        metaInfo
        isVectorized
        embeddingModel
        viewCount
        usageCount
        qualityScore
        lastUsedAt
        createdBy
        updatedBy
        createdAt
        updatedAt
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetAtomsQuery__
 *
 * To run a query within a React component, call `useGetAtomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAtomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAtomsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetAtomsQuery(baseOptions?: Apollo.QueryHookOptions<GetAtomsQuery, GetAtomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAtomsQuery, GetAtomsQueryVariables>(GetAtomsDocument, options);
      }
export function useGetAtomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAtomsQuery, GetAtomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAtomsQuery, GetAtomsQueryVariables>(GetAtomsDocument, options);
        }
// @ts-ignore
export function useGetAtomsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAtomsQuery, GetAtomsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAtomsQuery, GetAtomsQueryVariables>;
export function useGetAtomsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAtomsQuery, GetAtomsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAtomsQuery | undefined, GetAtomsQueryVariables>;
export function useGetAtomsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAtomsQuery, GetAtomsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAtomsQuery, GetAtomsQueryVariables>(GetAtomsDocument, options);
        }
export type GetAtomsQueryHookResult = ReturnType<typeof useGetAtomsQuery>;
export type GetAtomsLazyQueryHookResult = ReturnType<typeof useGetAtomsLazyQuery>;
export type GetAtomsSuspenseQueryHookResult = ReturnType<typeof useGetAtomsSuspenseQuery>;
export type GetAtomsQueryResult = Apollo.QueryResult<GetAtomsQuery, GetAtomsQueryVariables>;
export const SearchAtomsDocument = gql`
    query SearchAtoms($query: String!, $organizationId: UUID!, $atomType: AtomTypeType = null, $limit: Int! = 20) {
  searchAtoms(
    query: $query
    organizationId: $organizationId
    atomType: $atomType
    limit: $limit
  ) {
    id
    title
    fullContent
    contentFormat
    sourceType
    sourceId
    filePath
    fileType
    fileSize
    status
    processingError
    processingProgress
    processedAt
    atomType
    category
    tags
    organizationId
    clientId
    projectId
    industryId
    metaInfo
    isVectorized
    embeddingModel
    viewCount
    usageCount
    qualityScore
    lastUsedAt
    createdBy
    updatedBy
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useSearchAtomsQuery__
 *
 * To run a query within a React component, call `useSearchAtomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAtomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAtomsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      organizationId: // value for 'organizationId'
 *      atomType: // value for 'atomType'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchAtomsQuery(baseOptions: Apollo.QueryHookOptions<SearchAtomsQuery, SearchAtomsQueryVariables> & ({ variables: SearchAtomsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAtomsQuery, SearchAtomsQueryVariables>(SearchAtomsDocument, options);
      }
export function useSearchAtomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAtomsQuery, SearchAtomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAtomsQuery, SearchAtomsQueryVariables>(SearchAtomsDocument, options);
        }
// @ts-ignore
export function useSearchAtomsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchAtomsQuery, SearchAtomsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchAtomsQuery, SearchAtomsQueryVariables>;
export function useSearchAtomsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchAtomsQuery, SearchAtomsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchAtomsQuery | undefined, SearchAtomsQueryVariables>;
export function useSearchAtomsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchAtomsQuery, SearchAtomsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchAtomsQuery, SearchAtomsQueryVariables>(SearchAtomsDocument, options);
        }
export type SearchAtomsQueryHookResult = ReturnType<typeof useSearchAtomsQuery>;
export type SearchAtomsLazyQueryHookResult = ReturnType<typeof useSearchAtomsLazyQuery>;
export type SearchAtomsSuspenseQueryHookResult = ReturnType<typeof useSearchAtomsSuspenseQuery>;
export type SearchAtomsQueryResult = Apollo.QueryResult<SearchAtomsQuery, SearchAtomsQueryVariables>;
export const GetAtomStatsDocument = gql`
    query GetAtomStats($organizationId: UUID!) {
  atomStats(organizationId: $organizationId)
}
    `;

/**
 * __useGetAtomStatsQuery__
 *
 * To run a query within a React component, call `useGetAtomStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAtomStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAtomStatsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetAtomStatsQuery(baseOptions: Apollo.QueryHookOptions<GetAtomStatsQuery, GetAtomStatsQueryVariables> & ({ variables: GetAtomStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAtomStatsQuery, GetAtomStatsQueryVariables>(GetAtomStatsDocument, options);
      }
export function useGetAtomStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAtomStatsQuery, GetAtomStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAtomStatsQuery, GetAtomStatsQueryVariables>(GetAtomStatsDocument, options);
        }
// @ts-ignore
export function useGetAtomStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAtomStatsQuery, GetAtomStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAtomStatsQuery, GetAtomStatsQueryVariables>;
export function useGetAtomStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAtomStatsQuery, GetAtomStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAtomStatsQuery | undefined, GetAtomStatsQueryVariables>;
export function useGetAtomStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAtomStatsQuery, GetAtomStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAtomStatsQuery, GetAtomStatsQueryVariables>(GetAtomStatsDocument, options);
        }
export type GetAtomStatsQueryHookResult = ReturnType<typeof useGetAtomStatsQuery>;
export type GetAtomStatsLazyQueryHookResult = ReturnType<typeof useGetAtomStatsLazyQuery>;
export type GetAtomStatsSuspenseQueryHookResult = ReturnType<typeof useGetAtomStatsSuspenseQuery>;
export type GetAtomStatsQueryResult = Apollo.QueryResult<GetAtomStatsQuery, GetAtomStatsQueryVariables>;
export const GetPendingAtomsDocument = gql`
    query GetPendingAtoms($organizationId: UUID = null, $limit: Int! = 10) {
  pendingAtoms(organizationId: $organizationId, limit: $limit) {
    id
    title
    fullContent
    contentFormat
    sourceType
    sourceId
    filePath
    fileType
    fileSize
    status
    processingError
    processingProgress
    processedAt
    atomType
    category
    tags
    organizationId
    clientId
    projectId
    industryId
    metaInfo
    isVectorized
    embeddingModel
    viewCount
    usageCount
    qualityScore
    lastUsedAt
    createdBy
    updatedBy
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetPendingAtomsQuery__
 *
 * To run a query within a React component, call `useGetPendingAtomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingAtomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingAtomsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPendingAtomsQuery(baseOptions?: Apollo.QueryHookOptions<GetPendingAtomsQuery, GetPendingAtomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingAtomsQuery, GetPendingAtomsQueryVariables>(GetPendingAtomsDocument, options);
      }
export function useGetPendingAtomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingAtomsQuery, GetPendingAtomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingAtomsQuery, GetPendingAtomsQueryVariables>(GetPendingAtomsDocument, options);
        }
// @ts-ignore
export function useGetPendingAtomsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPendingAtomsQuery, GetPendingAtomsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPendingAtomsQuery, GetPendingAtomsQueryVariables>;
export function useGetPendingAtomsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPendingAtomsQuery, GetPendingAtomsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPendingAtomsQuery | undefined, GetPendingAtomsQueryVariables>;
export function useGetPendingAtomsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPendingAtomsQuery, GetPendingAtomsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPendingAtomsQuery, GetPendingAtomsQueryVariables>(GetPendingAtomsDocument, options);
        }
export type GetPendingAtomsQueryHookResult = ReturnType<typeof useGetPendingAtomsQuery>;
export type GetPendingAtomsLazyQueryHookResult = ReturnType<typeof useGetPendingAtomsLazyQuery>;
export type GetPendingAtomsSuspenseQueryHookResult = ReturnType<typeof useGetPendingAtomsSuspenseQuery>;
export type GetPendingAtomsQueryResult = Apollo.QueryResult<GetPendingAtomsQuery, GetPendingAtomsQueryVariables>;
export const GetAtomTaskStatusDocument = gql`
    query GetAtomTaskStatus($atomId: UUID!) {
  atomTaskStatus(atomId: $atomId) {
    atomId
    taskId
    status
    progress
    errorMessage
    updatedAt
    taskResult
  }
}
    `;

/**
 * __useGetAtomTaskStatusQuery__
 *
 * To run a query within a React component, call `useGetAtomTaskStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAtomTaskStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAtomTaskStatusQuery({
 *   variables: {
 *      atomId: // value for 'atomId'
 *   },
 * });
 */
export function useGetAtomTaskStatusQuery(baseOptions: Apollo.QueryHookOptions<GetAtomTaskStatusQuery, GetAtomTaskStatusQueryVariables> & ({ variables: GetAtomTaskStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAtomTaskStatusQuery, GetAtomTaskStatusQueryVariables>(GetAtomTaskStatusDocument, options);
      }
export function useGetAtomTaskStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAtomTaskStatusQuery, GetAtomTaskStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAtomTaskStatusQuery, GetAtomTaskStatusQueryVariables>(GetAtomTaskStatusDocument, options);
        }
// @ts-ignore
export function useGetAtomTaskStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAtomTaskStatusQuery, GetAtomTaskStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetAtomTaskStatusQuery, GetAtomTaskStatusQueryVariables>;
export function useGetAtomTaskStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAtomTaskStatusQuery, GetAtomTaskStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetAtomTaskStatusQuery | undefined, GetAtomTaskStatusQueryVariables>;
export function useGetAtomTaskStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAtomTaskStatusQuery, GetAtomTaskStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAtomTaskStatusQuery, GetAtomTaskStatusQueryVariables>(GetAtomTaskStatusDocument, options);
        }
export type GetAtomTaskStatusQueryHookResult = ReturnType<typeof useGetAtomTaskStatusQuery>;
export type GetAtomTaskStatusLazyQueryHookResult = ReturnType<typeof useGetAtomTaskStatusLazyQuery>;
export type GetAtomTaskStatusSuspenseQueryHookResult = ReturnType<typeof useGetAtomTaskStatusSuspenseQuery>;
export type GetAtomTaskStatusQueryResult = Apollo.QueryResult<GetAtomTaskStatusQuery, GetAtomTaskStatusQueryVariables>;
export const GetIndustryDddDocument = gql`
    query GetIndustryDdd($id: UUID!) {
  industryDdd(id: $id) {
    id
    name
    code
    description
    isActive
    icon
    industryProfile
    metadata
    createdAt
    updatedAt
    organizationUuid
  }
}
    `;

/**
 * __useGetIndustryDddQuery__
 *
 * To run a query within a React component, call `useGetIndustryDddQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndustryDddQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndustryDddQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetIndustryDddQuery(baseOptions: Apollo.QueryHookOptions<GetIndustryDddQuery, GetIndustryDddQueryVariables> & ({ variables: GetIndustryDddQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIndustryDddQuery, GetIndustryDddQueryVariables>(GetIndustryDddDocument, options);
      }
export function useGetIndustryDddLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIndustryDddQuery, GetIndustryDddQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIndustryDddQuery, GetIndustryDddQueryVariables>(GetIndustryDddDocument, options);
        }
// @ts-ignore
export function useGetIndustryDddSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIndustryDddQuery, GetIndustryDddQueryVariables>): Apollo.UseSuspenseQueryResult<GetIndustryDddQuery, GetIndustryDddQueryVariables>;
export function useGetIndustryDddSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndustryDddQuery, GetIndustryDddQueryVariables>): Apollo.UseSuspenseQueryResult<GetIndustryDddQuery | undefined, GetIndustryDddQueryVariables>;
export function useGetIndustryDddSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndustryDddQuery, GetIndustryDddQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIndustryDddQuery, GetIndustryDddQueryVariables>(GetIndustryDddDocument, options);
        }
export type GetIndustryDddQueryHookResult = ReturnType<typeof useGetIndustryDddQuery>;
export type GetIndustryDddLazyQueryHookResult = ReturnType<typeof useGetIndustryDddLazyQuery>;
export type GetIndustryDddSuspenseQueryHookResult = ReturnType<typeof useGetIndustryDddSuspenseQuery>;
export type GetIndustryDddQueryResult = Apollo.QueryResult<GetIndustryDddQuery, GetIndustryDddQueryVariables>;
export const GetIndustryByCodeDddDocument = gql`
    query GetIndustryByCodeDdd($code: String!) {
  industryByCodeDdd(code: $code) {
    id
    name
    code
    description
    isActive
    icon
    industryProfile
    metadata
    createdAt
    updatedAt
    organizationUuid
  }
}
    `;

/**
 * __useGetIndustryByCodeDddQuery__
 *
 * To run a query within a React component, call `useGetIndustryByCodeDddQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndustryByCodeDddQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndustryByCodeDddQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetIndustryByCodeDddQuery(baseOptions: Apollo.QueryHookOptions<GetIndustryByCodeDddQuery, GetIndustryByCodeDddQueryVariables> & ({ variables: GetIndustryByCodeDddQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIndustryByCodeDddQuery, GetIndustryByCodeDddQueryVariables>(GetIndustryByCodeDddDocument, options);
      }
export function useGetIndustryByCodeDddLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIndustryByCodeDddQuery, GetIndustryByCodeDddQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIndustryByCodeDddQuery, GetIndustryByCodeDddQueryVariables>(GetIndustryByCodeDddDocument, options);
        }
// @ts-ignore
export function useGetIndustryByCodeDddSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIndustryByCodeDddQuery, GetIndustryByCodeDddQueryVariables>): Apollo.UseSuspenseQueryResult<GetIndustryByCodeDddQuery, GetIndustryByCodeDddQueryVariables>;
export function useGetIndustryByCodeDddSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndustryByCodeDddQuery, GetIndustryByCodeDddQueryVariables>): Apollo.UseSuspenseQueryResult<GetIndustryByCodeDddQuery | undefined, GetIndustryByCodeDddQueryVariables>;
export function useGetIndustryByCodeDddSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndustryByCodeDddQuery, GetIndustryByCodeDddQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIndustryByCodeDddQuery, GetIndustryByCodeDddQueryVariables>(GetIndustryByCodeDddDocument, options);
        }
export type GetIndustryByCodeDddQueryHookResult = ReturnType<typeof useGetIndustryByCodeDddQuery>;
export type GetIndustryByCodeDddLazyQueryHookResult = ReturnType<typeof useGetIndustryByCodeDddLazyQuery>;
export type GetIndustryByCodeDddSuspenseQueryHookResult = ReturnType<typeof useGetIndustryByCodeDddSuspenseQuery>;
export type GetIndustryByCodeDddQueryResult = Apollo.QueryResult<GetIndustryByCodeDddQuery, GetIndustryByCodeDddQueryVariables>;
export const GetIndustriesDddDocument = gql`
    query GetIndustriesDdd($filter: IndustryFilterInput = null, $limit: Int! = 50, $offset: Int! = 0) {
  industriesDdd(filter: $filter, limit: $limit, offset: $offset) {
    edges {
      cursor
      node {
        id
        name
        code
        description
        isActive
        icon
        industryProfile
        metadata
        createdAt
        updatedAt
        organizationUuid
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetIndustriesDddQuery__
 *
 * To run a query within a React component, call `useGetIndustriesDddQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndustriesDddQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndustriesDddQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetIndustriesDddQuery(baseOptions?: Apollo.QueryHookOptions<GetIndustriesDddQuery, GetIndustriesDddQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIndustriesDddQuery, GetIndustriesDddQueryVariables>(GetIndustriesDddDocument, options);
      }
export function useGetIndustriesDddLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIndustriesDddQuery, GetIndustriesDddQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIndustriesDddQuery, GetIndustriesDddQueryVariables>(GetIndustriesDddDocument, options);
        }
// @ts-ignore
export function useGetIndustriesDddSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIndustriesDddQuery, GetIndustriesDddQueryVariables>): Apollo.UseSuspenseQueryResult<GetIndustriesDddQuery, GetIndustriesDddQueryVariables>;
export function useGetIndustriesDddSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndustriesDddQuery, GetIndustriesDddQueryVariables>): Apollo.UseSuspenseQueryResult<GetIndustriesDddQuery | undefined, GetIndustriesDddQueryVariables>;
export function useGetIndustriesDddSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndustriesDddQuery, GetIndustriesDddQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIndustriesDddQuery, GetIndustriesDddQueryVariables>(GetIndustriesDddDocument, options);
        }
export type GetIndustriesDddQueryHookResult = ReturnType<typeof useGetIndustriesDddQuery>;
export type GetIndustriesDddLazyQueryHookResult = ReturnType<typeof useGetIndustriesDddLazyQuery>;
export type GetIndustriesDddSuspenseQueryHookResult = ReturnType<typeof useGetIndustriesDddSuspenseQuery>;
export type GetIndustriesDddQueryResult = Apollo.QueryResult<GetIndustriesDddQuery, GetIndustriesDddQueryVariables>;
export const GetIndustriesDocument = gql`
    query GetIndustries($search: String = null, $categoryId: UUID = null, $isActive: Boolean = null, $limit: Int! = 50, $offset: Int! = 0) {
  industries(
    search: $search
    categoryId: $categoryId
    isActive: $isActive
    limit: $limit
    offset: $offset
  ) {
    id
    name
    code
    description
    icon
    isActive
    industryProfile
    categories {
      id
      name
      code
      parentId
      displayOrder
      subcategories {
        id
        name
        code
        parentId
        displayOrder
      }
    }
    hasProfileData
  }
}
    `;

/**
 * __useGetIndustriesQuery__
 *
 * To run a query within a React component, call `useGetIndustriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndustriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndustriesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      categoryId: // value for 'categoryId'
 *      isActive: // value for 'isActive'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetIndustriesQuery(baseOptions?: Apollo.QueryHookOptions<GetIndustriesQuery, GetIndustriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIndustriesQuery, GetIndustriesQueryVariables>(GetIndustriesDocument, options);
      }
export function useGetIndustriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIndustriesQuery, GetIndustriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIndustriesQuery, GetIndustriesQueryVariables>(GetIndustriesDocument, options);
        }
// @ts-ignore
export function useGetIndustriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIndustriesQuery, GetIndustriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetIndustriesQuery, GetIndustriesQueryVariables>;
export function useGetIndustriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndustriesQuery, GetIndustriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetIndustriesQuery | undefined, GetIndustriesQueryVariables>;
export function useGetIndustriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndustriesQuery, GetIndustriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIndustriesQuery, GetIndustriesQueryVariables>(GetIndustriesDocument, options);
        }
export type GetIndustriesQueryHookResult = ReturnType<typeof useGetIndustriesQuery>;
export type GetIndustriesLazyQueryHookResult = ReturnType<typeof useGetIndustriesLazyQuery>;
export type GetIndustriesSuspenseQueryHookResult = ReturnType<typeof useGetIndustriesSuspenseQuery>;
export type GetIndustriesQueryResult = Apollo.QueryResult<GetIndustriesQuery, GetIndustriesQueryVariables>;
export const GetIndustryDocument = gql`
    query GetIndustry($id: UUID!) {
  industry(id: $id) {
    id
    name
    code
    description
    icon
    isActive
    industryProfile
    categories {
      id
      name
      code
      parentId
      displayOrder
      subcategories {
        id
        name
        code
        parentId
        displayOrder
      }
    }
    hasProfileData
  }
}
    `;

/**
 * __useGetIndustryQuery__
 *
 * To run a query within a React component, call `useGetIndustryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndustryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndustryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetIndustryQuery(baseOptions: Apollo.QueryHookOptions<GetIndustryQuery, GetIndustryQueryVariables> & ({ variables: GetIndustryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIndustryQuery, GetIndustryQueryVariables>(GetIndustryDocument, options);
      }
export function useGetIndustryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIndustryQuery, GetIndustryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIndustryQuery, GetIndustryQueryVariables>(GetIndustryDocument, options);
        }
// @ts-ignore
export function useGetIndustrySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIndustryQuery, GetIndustryQueryVariables>): Apollo.UseSuspenseQueryResult<GetIndustryQuery, GetIndustryQueryVariables>;
export function useGetIndustrySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndustryQuery, GetIndustryQueryVariables>): Apollo.UseSuspenseQueryResult<GetIndustryQuery | undefined, GetIndustryQueryVariables>;
export function useGetIndustrySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndustryQuery, GetIndustryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIndustryQuery, GetIndustryQueryVariables>(GetIndustryDocument, options);
        }
export type GetIndustryQueryHookResult = ReturnType<typeof useGetIndustryQuery>;
export type GetIndustryLazyQueryHookResult = ReturnType<typeof useGetIndustryLazyQuery>;
export type GetIndustrySuspenseQueryHookResult = ReturnType<typeof useGetIndustrySuspenseQuery>;
export type GetIndustryQueryResult = Apollo.QueryResult<GetIndustryQuery, GetIndustryQueryVariables>;
export const GetIndustryByCodeDocument = gql`
    query GetIndustryByCode($code: String!) {
  industryByCode(code: $code) {
    id
    name
    code
    description
    icon
    isActive
    industryProfile
    categories {
      id
      name
      code
      parentId
      displayOrder
      subcategories {
        id
        name
        code
        parentId
        displayOrder
      }
    }
    hasProfileData
  }
}
    `;

/**
 * __useGetIndustryByCodeQuery__
 *
 * To run a query within a React component, call `useGetIndustryByCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndustryByCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndustryByCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetIndustryByCodeQuery(baseOptions: Apollo.QueryHookOptions<GetIndustryByCodeQuery, GetIndustryByCodeQueryVariables> & ({ variables: GetIndustryByCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIndustryByCodeQuery, GetIndustryByCodeQueryVariables>(GetIndustryByCodeDocument, options);
      }
export function useGetIndustryByCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIndustryByCodeQuery, GetIndustryByCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIndustryByCodeQuery, GetIndustryByCodeQueryVariables>(GetIndustryByCodeDocument, options);
        }
// @ts-ignore
export function useGetIndustryByCodeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIndustryByCodeQuery, GetIndustryByCodeQueryVariables>): Apollo.UseSuspenseQueryResult<GetIndustryByCodeQuery, GetIndustryByCodeQueryVariables>;
export function useGetIndustryByCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndustryByCodeQuery, GetIndustryByCodeQueryVariables>): Apollo.UseSuspenseQueryResult<GetIndustryByCodeQuery | undefined, GetIndustryByCodeQueryVariables>;
export function useGetIndustryByCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndustryByCodeQuery, GetIndustryByCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIndustryByCodeQuery, GetIndustryByCodeQueryVariables>(GetIndustryByCodeDocument, options);
        }
export type GetIndustryByCodeQueryHookResult = ReturnType<typeof useGetIndustryByCodeQuery>;
export type GetIndustryByCodeLazyQueryHookResult = ReturnType<typeof useGetIndustryByCodeLazyQuery>;
export type GetIndustryByCodeSuspenseQueryHookResult = ReturnType<typeof useGetIndustryByCodeSuspenseQuery>;
export type GetIndustryByCodeQueryResult = Apollo.QueryResult<GetIndustryByCodeQuery, GetIndustryByCodeQueryVariables>;
export const GetIndustryCategoriesDocument = gql`
    query GetIndustryCategories($parentId: UUID = null) {
  industryCategories(parentId: $parentId) {
    id
    name
    code
    parentId
    displayOrder
    subcategories {
      id
      name
      code
      parentId
      displayOrder
      subcategories {
        id
        name
        code
        parentId
        displayOrder
      }
    }
  }
}
    `;

/**
 * __useGetIndustryCategoriesQuery__
 *
 * To run a query within a React component, call `useGetIndustryCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndustryCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndustryCategoriesQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useGetIndustryCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetIndustryCategoriesQuery, GetIndustryCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIndustryCategoriesQuery, GetIndustryCategoriesQueryVariables>(GetIndustryCategoriesDocument, options);
      }
export function useGetIndustryCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIndustryCategoriesQuery, GetIndustryCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIndustryCategoriesQuery, GetIndustryCategoriesQueryVariables>(GetIndustryCategoriesDocument, options);
        }
// @ts-ignore
export function useGetIndustryCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIndustryCategoriesQuery, GetIndustryCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetIndustryCategoriesQuery, GetIndustryCategoriesQueryVariables>;
export function useGetIndustryCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndustryCategoriesQuery, GetIndustryCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetIndustryCategoriesQuery | undefined, GetIndustryCategoriesQueryVariables>;
export function useGetIndustryCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndustryCategoriesQuery, GetIndustryCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIndustryCategoriesQuery, GetIndustryCategoriesQueryVariables>(GetIndustryCategoriesDocument, options);
        }
export type GetIndustryCategoriesQueryHookResult = ReturnType<typeof useGetIndustryCategoriesQuery>;
export type GetIndustryCategoriesLazyQueryHookResult = ReturnType<typeof useGetIndustryCategoriesLazyQuery>;
export type GetIndustryCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetIndustryCategoriesSuspenseQuery>;
export type GetIndustryCategoriesQueryResult = Apollo.QueryResult<GetIndustryCategoriesQuery, GetIndustryCategoriesQueryVariables>;
export const GetIndustryStatsDocument = gql`
    query GetIndustryStats {
  industryStats {
    totalIndustries
    activeIndustries
    inactiveIndustries
  }
}
    `;

/**
 * __useGetIndustryStatsQuery__
 *
 * To run a query within a React component, call `useGetIndustryStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndustryStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndustryStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIndustryStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetIndustryStatsQuery, GetIndustryStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIndustryStatsQuery, GetIndustryStatsQueryVariables>(GetIndustryStatsDocument, options);
      }
export function useGetIndustryStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIndustryStatsQuery, GetIndustryStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIndustryStatsQuery, GetIndustryStatsQueryVariables>(GetIndustryStatsDocument, options);
        }
// @ts-ignore
export function useGetIndustryStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIndustryStatsQuery, GetIndustryStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetIndustryStatsQuery, GetIndustryStatsQueryVariables>;
export function useGetIndustryStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndustryStatsQuery, GetIndustryStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetIndustryStatsQuery | undefined, GetIndustryStatsQueryVariables>;
export function useGetIndustryStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndustryStatsQuery, GetIndustryStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIndustryStatsQuery, GetIndustryStatsQueryVariables>(GetIndustryStatsDocument, options);
        }
export type GetIndustryStatsQueryHookResult = ReturnType<typeof useGetIndustryStatsQuery>;
export type GetIndustryStatsLazyQueryHookResult = ReturnType<typeof useGetIndustryStatsLazyQuery>;
export type GetIndustryStatsSuspenseQueryHookResult = ReturnType<typeof useGetIndustryStatsSuspenseQuery>;
export type GetIndustryStatsQueryResult = Apollo.QueryResult<GetIndustryStatsQuery, GetIndustryStatsQueryVariables>;
export const GetIndustryStatsDddDocument = gql`
    query GetIndustryStatsDdd {
  industryStatsDdd {
    totalIndustries
    activeIndustries
    inactiveIndustries
  }
}
    `;

/**
 * __useGetIndustryStatsDddQuery__
 *
 * To run a query within a React component, call `useGetIndustryStatsDddQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndustryStatsDddQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndustryStatsDddQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIndustryStatsDddQuery(baseOptions?: Apollo.QueryHookOptions<GetIndustryStatsDddQuery, GetIndustryStatsDddQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIndustryStatsDddQuery, GetIndustryStatsDddQueryVariables>(GetIndustryStatsDddDocument, options);
      }
export function useGetIndustryStatsDddLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIndustryStatsDddQuery, GetIndustryStatsDddQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIndustryStatsDddQuery, GetIndustryStatsDddQueryVariables>(GetIndustryStatsDddDocument, options);
        }
// @ts-ignore
export function useGetIndustryStatsDddSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIndustryStatsDddQuery, GetIndustryStatsDddQueryVariables>): Apollo.UseSuspenseQueryResult<GetIndustryStatsDddQuery, GetIndustryStatsDddQueryVariables>;
export function useGetIndustryStatsDddSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndustryStatsDddQuery, GetIndustryStatsDddQueryVariables>): Apollo.UseSuspenseQueryResult<GetIndustryStatsDddQuery | undefined, GetIndustryStatsDddQueryVariables>;
export function useGetIndustryStatsDddSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndustryStatsDddQuery, GetIndustryStatsDddQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIndustryStatsDddQuery, GetIndustryStatsDddQueryVariables>(GetIndustryStatsDddDocument, options);
        }
export type GetIndustryStatsDddQueryHookResult = ReturnType<typeof useGetIndustryStatsDddQuery>;
export type GetIndustryStatsDddLazyQueryHookResult = ReturnType<typeof useGetIndustryStatsDddLazyQuery>;
export type GetIndustryStatsDddSuspenseQueryHookResult = ReturnType<typeof useGetIndustryStatsDddSuspenseQuery>;
export type GetIndustryStatsDddQueryResult = Apollo.QueryResult<GetIndustryStatsDddQuery, GetIndustryStatsDddQueryVariables>;
export const GetAtomSourceDocument = gql`
    query GetAtomSource($id: UUID!) {
  atomSource(id: $id) {
    id
    organizationId
    entityType
    entityId
    sourceType
    sourceName
    sourceUrl
    sourceConfig
    isActive
    collectionFrequency
    lastCollectedAt
    nextCollectionAt
    contentFilters
    languageCode
    status
    metadata
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetAtomSourceQuery__
 *
 * To run a query within a React component, call `useGetAtomSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAtomSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAtomSourceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAtomSourceQuery(baseOptions: Apollo.QueryHookOptions<GetAtomSourceQuery, GetAtomSourceQueryVariables> & ({ variables: GetAtomSourceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAtomSourceQuery, GetAtomSourceQueryVariables>(GetAtomSourceDocument, options);
      }
export function useGetAtomSourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAtomSourceQuery, GetAtomSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAtomSourceQuery, GetAtomSourceQueryVariables>(GetAtomSourceDocument, options);
        }
// @ts-ignore
export function useGetAtomSourceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAtomSourceQuery, GetAtomSourceQueryVariables>): Apollo.UseSuspenseQueryResult<GetAtomSourceQuery, GetAtomSourceQueryVariables>;
export function useGetAtomSourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAtomSourceQuery, GetAtomSourceQueryVariables>): Apollo.UseSuspenseQueryResult<GetAtomSourceQuery | undefined, GetAtomSourceQueryVariables>;
export function useGetAtomSourceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAtomSourceQuery, GetAtomSourceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAtomSourceQuery, GetAtomSourceQueryVariables>(GetAtomSourceDocument, options);
        }
export type GetAtomSourceQueryHookResult = ReturnType<typeof useGetAtomSourceQuery>;
export type GetAtomSourceLazyQueryHookResult = ReturnType<typeof useGetAtomSourceLazyQuery>;
export type GetAtomSourceSuspenseQueryHookResult = ReturnType<typeof useGetAtomSourceSuspenseQuery>;
export type GetAtomSourceQueryResult = Apollo.QueryResult<GetAtomSourceQuery, GetAtomSourceQueryVariables>;
export const GetAtomSourcesDocument = gql`
    query GetAtomSources($entityType: AtomSourceEntityTypeEnum = null, $entityId: UUID = null, $filter: AtomSourceFilterInput = null, $limit: Int! = 50, $offset: Int! = 0) {
  atomSources(
    entityType: $entityType
    entityId: $entityId
    filter: $filter
    limit: $limit
    offset: $offset
  ) {
    sources {
      id
      organizationId
      entityType
      entityId
      sourceType
      sourceName
      sourceUrl
      sourceConfig
      isActive
      collectionFrequency
      lastCollectedAt
      nextCollectionAt
      contentFilters
      languageCode
      status
      metadata
      createdAt
      updatedAt
    }
    totalCount
    hasNextPage
    hasPreviousPage
  }
}
    `;

/**
 * __useGetAtomSourcesQuery__
 *
 * To run a query within a React component, call `useGetAtomSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAtomSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAtomSourcesQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      entityId: // value for 'entityId'
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetAtomSourcesQuery(baseOptions?: Apollo.QueryHookOptions<GetAtomSourcesQuery, GetAtomSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAtomSourcesQuery, GetAtomSourcesQueryVariables>(GetAtomSourcesDocument, options);
      }
export function useGetAtomSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAtomSourcesQuery, GetAtomSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAtomSourcesQuery, GetAtomSourcesQueryVariables>(GetAtomSourcesDocument, options);
        }
// @ts-ignore
export function useGetAtomSourcesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAtomSourcesQuery, GetAtomSourcesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAtomSourcesQuery, GetAtomSourcesQueryVariables>;
export function useGetAtomSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAtomSourcesQuery, GetAtomSourcesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAtomSourcesQuery | undefined, GetAtomSourcesQueryVariables>;
export function useGetAtomSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAtomSourcesQuery, GetAtomSourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAtomSourcesQuery, GetAtomSourcesQueryVariables>(GetAtomSourcesDocument, options);
        }
export type GetAtomSourcesQueryHookResult = ReturnType<typeof useGetAtomSourcesQuery>;
export type GetAtomSourcesLazyQueryHookResult = ReturnType<typeof useGetAtomSourcesLazyQuery>;
export type GetAtomSourcesSuspenseQueryHookResult = ReturnType<typeof useGetAtomSourcesSuspenseQuery>;
export type GetAtomSourcesQueryResult = Apollo.QueryResult<GetAtomSourcesQuery, GetAtomSourcesQueryVariables>;
export const GetAtomSourceStatsDocument = gql`
    query GetAtomSourceStats {
  atomSourceStats {
    totalSources
    activeSources
    inactiveSources
    errorSources
    byEntityType
    bySourceType
  }
}
    `;

/**
 * __useGetAtomSourceStatsQuery__
 *
 * To run a query within a React component, call `useGetAtomSourceStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAtomSourceStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAtomSourceStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAtomSourceStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetAtomSourceStatsQuery, GetAtomSourceStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAtomSourceStatsQuery, GetAtomSourceStatsQueryVariables>(GetAtomSourceStatsDocument, options);
      }
export function useGetAtomSourceStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAtomSourceStatsQuery, GetAtomSourceStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAtomSourceStatsQuery, GetAtomSourceStatsQueryVariables>(GetAtomSourceStatsDocument, options);
        }
// @ts-ignore
export function useGetAtomSourceStatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAtomSourceStatsQuery, GetAtomSourceStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAtomSourceStatsQuery, GetAtomSourceStatsQueryVariables>;
export function useGetAtomSourceStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAtomSourceStatsQuery, GetAtomSourceStatsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAtomSourceStatsQuery | undefined, GetAtomSourceStatsQueryVariables>;
export function useGetAtomSourceStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAtomSourceStatsQuery, GetAtomSourceStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAtomSourceStatsQuery, GetAtomSourceStatsQueryVariables>(GetAtomSourceStatsDocument, options);
        }
export type GetAtomSourceStatsQueryHookResult = ReturnType<typeof useGetAtomSourceStatsQuery>;
export type GetAtomSourceStatsLazyQueryHookResult = ReturnType<typeof useGetAtomSourceStatsLazyQuery>;
export type GetAtomSourceStatsSuspenseQueryHookResult = ReturnType<typeof useGetAtomSourceStatsSuspenseQuery>;
export type GetAtomSourceStatsQueryResult = Apollo.QueryResult<GetAtomSourceStatsQuery, GetAtomSourceStatsQueryVariables>;
export const AutoRegisterClientDocument = gql`
    mutation AutoRegisterClient($input: AutoRegisterClientInput!) {
  autoRegisterClient(input: $input) {
    id
    name
    description
    organizationId
    createdBy
    industryId
    industry {
      id
      name
      code
    }
    industryName
    clientType
    size
    website
    contactEmail
    contactName
    contactPhone
    isActive
    totalLifetimeValue
    createdAt
    updatedAt
    metadata
    corporateNumber
    nameKana
    nameEnglish
    postalCode
    prefecture
    city
    streetAddress
    addressOutside
    corporateStatus
    corporateUpdateDate
    corporateCloseDate
    isAutoRegistered
    dataQualityScore
    parentId
    projectCount
    hasActiveProjects
    displaySize
    isEnterprise
    fullAddress
    corporateStatusDisplay
  }
}
    `;
export type AutoRegisterClientMutationFn = Apollo.MutationFunction<AutoRegisterClientMutation, AutoRegisterClientMutationVariables>;

/**
 * __useAutoRegisterClientMutation__
 *
 * To run a mutation, you first call `useAutoRegisterClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutoRegisterClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [autoRegisterClientMutation, { data, loading, error }] = useAutoRegisterClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAutoRegisterClientMutation(baseOptions?: Apollo.MutationHookOptions<AutoRegisterClientMutation, AutoRegisterClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AutoRegisterClientMutation, AutoRegisterClientMutationVariables>(AutoRegisterClientDocument, options);
      }
export type AutoRegisterClientMutationHookResult = ReturnType<typeof useAutoRegisterClientMutation>;
export type AutoRegisterClientMutationResult = Apollo.MutationResult<AutoRegisterClientMutation>;
export type AutoRegisterClientMutationOptions = Apollo.BaseMutationOptions<AutoRegisterClientMutation, AutoRegisterClientMutationVariables>;
export const LoginDocument = gql`
    mutation Login($input: LoginInput!) {
  login(input: $input) {
    success
    message
    user {
      id
      email
      username
      displayName
      isActive
      isSuperuser
      organizationId
      organizationRole
      organizationName
      createdAt
      updatedAt
    }
    csrfToken
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LoginJwtDocument = gql`
    mutation LoginJwt($input: JWTLoginInput!) {
  loginJwt(input: $input) {
    accessToken
    tokenType
    expiresIn
    refreshToken
    scope
    idToken
  }
}
    `;
export type LoginJwtMutationFn = Apollo.MutationFunction<LoginJwtMutation, LoginJwtMutationVariables>;

/**
 * __useLoginJwtMutation__
 *
 * To run a mutation, you first call `useLoginJwtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginJwtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginJwtMutation, { data, loading, error }] = useLoginJwtMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginJwtMutation(baseOptions?: Apollo.MutationHookOptions<LoginJwtMutation, LoginJwtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginJwtMutation, LoginJwtMutationVariables>(LoginJwtDocument, options);
      }
export type LoginJwtMutationHookResult = ReturnType<typeof useLoginJwtMutation>;
export type LoginJwtMutationResult = Apollo.MutationResult<LoginJwtMutation>;
export type LoginJwtMutationOptions = Apollo.BaseMutationOptions<LoginJwtMutation, LoginJwtMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation RefreshToken($input: RefreshTokenInput!) {
  refreshToken(input: $input) {
    accessToken
    tokenType
    expiresIn
    refreshToken
    scope
    idToken
  }
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const RequestTokenDocument = gql`
    mutation RequestToken($input: TokenRequestInput!) {
  requestToken(input: $input) {
    accessToken
    tokenType
    expiresIn
    refreshToken
    scope
    idToken
  }
}
    `;
export type RequestTokenMutationFn = Apollo.MutationFunction<RequestTokenMutation, RequestTokenMutationVariables>;

/**
 * __useRequestTokenMutation__
 *
 * To run a mutation, you first call `useRequestTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestTokenMutation, { data, loading, error }] = useRequestTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestTokenMutation(baseOptions?: Apollo.MutationHookOptions<RequestTokenMutation, RequestTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestTokenMutation, RequestTokenMutationVariables>(RequestTokenDocument, options);
      }
export type RequestTokenMutationHookResult = ReturnType<typeof useRequestTokenMutation>;
export type RequestTokenMutationResult = Apollo.MutationResult<RequestTokenMutation>;
export type RequestTokenMutationOptions = Apollo.BaseMutationOptions<RequestTokenMutation, RequestTokenMutationVariables>;
export const RevokeTokenDocument = gql`
    mutation RevokeToken($input: TokenRevocationInput!) {
  revokeToken(input: $input) {
    success
    message
  }
}
    `;
export type RevokeTokenMutationFn = Apollo.MutationFunction<RevokeTokenMutation, RevokeTokenMutationVariables>;

/**
 * __useRevokeTokenMutation__
 *
 * To run a mutation, you first call `useRevokeTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeTokenMutation, { data, loading, error }] = useRevokeTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokeTokenMutation(baseOptions?: Apollo.MutationHookOptions<RevokeTokenMutation, RevokeTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeTokenMutation, RevokeTokenMutationVariables>(RevokeTokenDocument, options);
      }
export type RevokeTokenMutationHookResult = ReturnType<typeof useRevokeTokenMutation>;
export type RevokeTokenMutationResult = Apollo.MutationResult<RevokeTokenMutation>;
export type RevokeTokenMutationOptions = Apollo.BaseMutationOptions<RevokeTokenMutation, RevokeTokenMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout {
    success
    message
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const VerifyEmailWithTokenDocument = gql`
    mutation VerifyEmailWithToken($input: VerifyEmailInput!) {
  verifyEmailWithToken(input: $input) {
    success
    message
  }
}
    `;
export type VerifyEmailWithTokenMutationFn = Apollo.MutationFunction<VerifyEmailWithTokenMutation, VerifyEmailWithTokenMutationVariables>;

/**
 * __useVerifyEmailWithTokenMutation__
 *
 * To run a mutation, you first call `useVerifyEmailWithTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailWithTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailWithTokenMutation, { data, loading, error }] = useVerifyEmailWithTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyEmailWithTokenMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailWithTokenMutation, VerifyEmailWithTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyEmailWithTokenMutation, VerifyEmailWithTokenMutationVariables>(VerifyEmailWithTokenDocument, options);
      }
export type VerifyEmailWithTokenMutationHookResult = ReturnType<typeof useVerifyEmailWithTokenMutation>;
export type VerifyEmailWithTokenMutationResult = Apollo.MutationResult<VerifyEmailWithTokenMutation>;
export type VerifyEmailWithTokenMutationOptions = Apollo.BaseMutationOptions<VerifyEmailWithTokenMutation, VerifyEmailWithTokenMutationVariables>;
export const ResetPasswordWithTokenDocument = gql`
    mutation ResetPasswordWithToken($input: ResetPasswordInput!) {
  resetPasswordWithToken(input: $input) {
    success
    message
  }
}
    `;
export type ResetPasswordWithTokenMutationFn = Apollo.MutationFunction<ResetPasswordWithTokenMutation, ResetPasswordWithTokenMutationVariables>;

/**
 * __useResetPasswordWithTokenMutation__
 *
 * To run a mutation, you first call `useResetPasswordWithTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordWithTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordWithTokenMutation, { data, loading, error }] = useResetPasswordWithTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordWithTokenMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordWithTokenMutation, ResetPasswordWithTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordWithTokenMutation, ResetPasswordWithTokenMutationVariables>(ResetPasswordWithTokenDocument, options);
      }
export type ResetPasswordWithTokenMutationHookResult = ReturnType<typeof useResetPasswordWithTokenMutation>;
export type ResetPasswordWithTokenMutationResult = Apollo.MutationResult<ResetPasswordWithTokenMutation>;
export type ResetPasswordWithTokenMutationOptions = Apollo.BaseMutationOptions<ResetPasswordWithTokenMutation, ResetPasswordWithTokenMutationVariables>;
export const SetSystemInstanceGithubTokenDocument = gql`
    mutation SetSystemInstanceGithubToken($input: SetSystemInstanceGithubTokenInput!) {
  setSystemInstanceGithubToken(input: $input) {
    success
    hasToken
    errorMessage
  }
}
    `;
export type SetSystemInstanceGithubTokenMutationFn = Apollo.MutationFunction<SetSystemInstanceGithubTokenMutation, SetSystemInstanceGithubTokenMutationVariables>;

/**
 * __useSetSystemInstanceGithubTokenMutation__
 *
 * To run a mutation, you first call `useSetSystemInstanceGithubTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSystemInstanceGithubTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSystemInstanceGithubTokenMutation, { data, loading, error }] = useSetSystemInstanceGithubTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetSystemInstanceGithubTokenMutation(baseOptions?: Apollo.MutationHookOptions<SetSystemInstanceGithubTokenMutation, SetSystemInstanceGithubTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSystemInstanceGithubTokenMutation, SetSystemInstanceGithubTokenMutationVariables>(SetSystemInstanceGithubTokenDocument, options);
      }
export type SetSystemInstanceGithubTokenMutationHookResult = ReturnType<typeof useSetSystemInstanceGithubTokenMutation>;
export type SetSystemInstanceGithubTokenMutationResult = Apollo.MutationResult<SetSystemInstanceGithubTokenMutation>;
export type SetSystemInstanceGithubTokenMutationOptions = Apollo.BaseMutationOptions<SetSystemInstanceGithubTokenMutation, SetSystemInstanceGithubTokenMutationVariables>;
export const GetSessionInfoDocument = gql`
    query GetSessionInfo {
  sessionInfo {
    sessionId
    createdAt
    lastActivity
    userId
    authenticated
    csrfToken
  }
}
    `;

/**
 * __useGetSessionInfoQuery__
 *
 * To run a query within a React component, call `useGetSessionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSessionInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetSessionInfoQuery, GetSessionInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSessionInfoQuery, GetSessionInfoQueryVariables>(GetSessionInfoDocument, options);
      }
export function useGetSessionInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSessionInfoQuery, GetSessionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSessionInfoQuery, GetSessionInfoQueryVariables>(GetSessionInfoDocument, options);
        }
// @ts-ignore
export function useGetSessionInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSessionInfoQuery, GetSessionInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetSessionInfoQuery, GetSessionInfoQueryVariables>;
export function useGetSessionInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSessionInfoQuery, GetSessionInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetSessionInfoQuery | undefined, GetSessionInfoQueryVariables>;
export function useGetSessionInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSessionInfoQuery, GetSessionInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSessionInfoQuery, GetSessionInfoQueryVariables>(GetSessionInfoDocument, options);
        }
export type GetSessionInfoQueryHookResult = ReturnType<typeof useGetSessionInfoQuery>;
export type GetSessionInfoLazyQueryHookResult = ReturnType<typeof useGetSessionInfoLazyQuery>;
export type GetSessionInfoSuspenseQueryHookResult = ReturnType<typeof useGetSessionInfoSuspenseQuery>;
export type GetSessionInfoQueryResult = Apollo.QueryResult<GetSessionInfoQuery, GetSessionInfoQueryVariables>;
export const GetIntrospectTokenDocument = gql`
    query GetIntrospectToken($input: TokenIntrospectionInput!) {
  introspectToken(input: $input) {
    active
    scope
    clientId
    username
    exp
    iat
    sub
    aud
    iss
    jti
    tokenType
  }
}
    `;

/**
 * __useGetIntrospectTokenQuery__
 *
 * To run a query within a React component, call `useGetIntrospectTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntrospectTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntrospectTokenQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetIntrospectTokenQuery(baseOptions: Apollo.QueryHookOptions<GetIntrospectTokenQuery, GetIntrospectTokenQueryVariables> & ({ variables: GetIntrospectTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntrospectTokenQuery, GetIntrospectTokenQueryVariables>(GetIntrospectTokenDocument, options);
      }
export function useGetIntrospectTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntrospectTokenQuery, GetIntrospectTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntrospectTokenQuery, GetIntrospectTokenQueryVariables>(GetIntrospectTokenDocument, options);
        }
// @ts-ignore
export function useGetIntrospectTokenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIntrospectTokenQuery, GetIntrospectTokenQueryVariables>): Apollo.UseSuspenseQueryResult<GetIntrospectTokenQuery, GetIntrospectTokenQueryVariables>;
export function useGetIntrospectTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIntrospectTokenQuery, GetIntrospectTokenQueryVariables>): Apollo.UseSuspenseQueryResult<GetIntrospectTokenQuery | undefined, GetIntrospectTokenQueryVariables>;
export function useGetIntrospectTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIntrospectTokenQuery, GetIntrospectTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIntrospectTokenQuery, GetIntrospectTokenQueryVariables>(GetIntrospectTokenDocument, options);
        }
export type GetIntrospectTokenQueryHookResult = ReturnType<typeof useGetIntrospectTokenQuery>;
export type GetIntrospectTokenLazyQueryHookResult = ReturnType<typeof useGetIntrospectTokenLazyQuery>;
export type GetIntrospectTokenSuspenseQueryHookResult = ReturnType<typeof useGetIntrospectTokenSuspenseQuery>;
export type GetIntrospectTokenQueryResult = Apollo.QueryResult<GetIntrospectTokenQuery, GetIntrospectTokenQueryVariables>;
export const CreateClientDocument = gql`
    mutation CreateClient($input: CreateClientInput!) {
  createClient(input: $input) {
    id
    name
    description
    organizationId
    createdBy
    industryId
    industry {
      id
      name
      code
    }
    industryName
    clientType
    size
    website
    contactEmail
    contactName
    contactPhone
    isActive
    totalLifetimeValue
    createdAt
    updatedAt
    metadata
    corporateNumber
    nameKana
    nameEnglish
    postalCode
    prefecture
    city
    streetAddress
    addressOutside
    corporateStatus
    corporateUpdateDate
    corporateCloseDate
    isAutoRegistered
    dataQualityScore
    parentId
    projectCount
    hasActiveProjects
    displaySize
    isEnterprise
    fullAddress
    corporateStatusDisplay
  }
}
    `;
export type CreateClientMutationFn = Apollo.MutationFunction<CreateClientMutation, CreateClientMutationVariables>;

/**
 * __useCreateClientMutation__
 *
 * To run a mutation, you first call `useCreateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientMutation, { data, loading, error }] = useCreateClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClientMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientMutation, CreateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientMutation, CreateClientMutationVariables>(CreateClientDocument, options);
      }
export type CreateClientMutationHookResult = ReturnType<typeof useCreateClientMutation>;
export type CreateClientMutationResult = Apollo.MutationResult<CreateClientMutation>;
export type CreateClientMutationOptions = Apollo.BaseMutationOptions<CreateClientMutation, CreateClientMutationVariables>;
export const UpdateClientDocument = gql`
    mutation UpdateClient($id: UUID!, $input: UpdateClientInput!) {
  updateClient(id: $id, input: $input) {
    id
    name
    description
    organizationId
    createdBy
    industryId
    industry {
      id
      name
      code
    }
    industryName
    clientType
    size
    website
    contactEmail
    contactName
    contactPhone
    isActive
    totalLifetimeValue
    createdAt
    updatedAt
    metadata
    corporateNumber
    nameKana
    nameEnglish
    postalCode
    prefecture
    city
    streetAddress
    addressOutside
    corporateStatus
    corporateUpdateDate
    corporateCloseDate
    isAutoRegistered
    dataQualityScore
    parentId
    projectCount
    hasActiveProjects
    displaySize
    isEnterprise
    fullAddress
    corporateStatusDisplay
  }
}
    `;
export type UpdateClientMutationFn = Apollo.MutationFunction<UpdateClientMutation, UpdateClientMutationVariables>;

/**
 * __useUpdateClientMutation__
 *
 * To run a mutation, you first call `useUpdateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientMutation, { data, loading, error }] = useUpdateClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientMutation, UpdateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientMutation, UpdateClientMutationVariables>(UpdateClientDocument, options);
      }
export type UpdateClientMutationHookResult = ReturnType<typeof useUpdateClientMutation>;
export type UpdateClientMutationResult = Apollo.MutationResult<UpdateClientMutation>;
export type UpdateClientMutationOptions = Apollo.BaseMutationOptions<UpdateClientMutation, UpdateClientMutationVariables>;
export const UpdateClientContactDocument = gql`
    mutation UpdateClientContact($id: UUID!, $email: String = null, $name: String = null, $phone: String = null) {
  updateClientContact(id: $id, email: $email, name: $name, phone: $phone) {
    id
    name
    description
    organizationId
    createdBy
    industryId
    industry {
      id
      name
      code
    }
    industryName
    clientType
    size
    website
    contactEmail
    contactName
    contactPhone
    isActive
    totalLifetimeValue
    createdAt
    updatedAt
    metadata
    corporateNumber
    nameKana
    nameEnglish
    postalCode
    prefecture
    city
    streetAddress
    addressOutside
    corporateStatus
    corporateUpdateDate
    corporateCloseDate
    isAutoRegistered
    dataQualityScore
    parentId
    projectCount
    hasActiveProjects
    displaySize
    isEnterprise
    fullAddress
    corporateStatusDisplay
  }
}
    `;
export type UpdateClientContactMutationFn = Apollo.MutationFunction<UpdateClientContactMutation, UpdateClientContactMutationVariables>;

/**
 * __useUpdateClientContactMutation__
 *
 * To run a mutation, you first call `useUpdateClientContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientContactMutation, { data, loading, error }] = useUpdateClientContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *      name: // value for 'name'
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useUpdateClientContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientContactMutation, UpdateClientContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientContactMutation, UpdateClientContactMutationVariables>(UpdateClientContactDocument, options);
      }
export type UpdateClientContactMutationHookResult = ReturnType<typeof useUpdateClientContactMutation>;
export type UpdateClientContactMutationResult = Apollo.MutationResult<UpdateClientContactMutation>;
export type UpdateClientContactMutationOptions = Apollo.BaseMutationOptions<UpdateClientContactMutation, UpdateClientContactMutationVariables>;
export const ArchiveClientDocument = gql`
    mutation ArchiveClient($id: UUID!) {
  archiveClient(id: $id) {
    id
    name
    description
    organizationId
    createdBy
    industryId
    industry {
      id
      name
      code
    }
    industryName
    clientType
    size
    website
    contactEmail
    contactName
    contactPhone
    isActive
    totalLifetimeValue
    createdAt
    updatedAt
    metadata
    corporateNumber
    nameKana
    nameEnglish
    postalCode
    prefecture
    city
    streetAddress
    addressOutside
    corporateStatus
    corporateUpdateDate
    corporateCloseDate
    isAutoRegistered
    dataQualityScore
    parentId
    projectCount
    hasActiveProjects
    displaySize
    isEnterprise
    fullAddress
    corporateStatusDisplay
  }
}
    `;
export type ArchiveClientMutationFn = Apollo.MutationFunction<ArchiveClientMutation, ArchiveClientMutationVariables>;

/**
 * __useArchiveClientMutation__
 *
 * To run a mutation, you first call `useArchiveClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveClientMutation, { data, loading, error }] = useArchiveClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveClientMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveClientMutation, ArchiveClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveClientMutation, ArchiveClientMutationVariables>(ArchiveClientDocument, options);
      }
export type ArchiveClientMutationHookResult = ReturnType<typeof useArchiveClientMutation>;
export type ArchiveClientMutationResult = Apollo.MutationResult<ArchiveClientMutation>;
export type ArchiveClientMutationOptions = Apollo.BaseMutationOptions<ArchiveClientMutation, ArchiveClientMutationVariables>;
export const UnarchiveClientDocument = gql`
    mutation UnarchiveClient($id: UUID!) {
  unarchiveClient(id: $id) {
    id
    name
    description
    organizationId
    createdBy
    industryId
    industry {
      id
      name
      code
    }
    industryName
    clientType
    size
    website
    contactEmail
    contactName
    contactPhone
    isActive
    totalLifetimeValue
    createdAt
    updatedAt
    metadata
    corporateNumber
    nameKana
    nameEnglish
    postalCode
    prefecture
    city
    streetAddress
    addressOutside
    corporateStatus
    corporateUpdateDate
    corporateCloseDate
    isAutoRegistered
    dataQualityScore
    parentId
    projectCount
    hasActiveProjects
    displaySize
    isEnterprise
    fullAddress
    corporateStatusDisplay
  }
}
    `;
export type UnarchiveClientMutationFn = Apollo.MutationFunction<UnarchiveClientMutation, UnarchiveClientMutationVariables>;

/**
 * __useUnarchiveClientMutation__
 *
 * To run a mutation, you first call `useUnarchiveClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveClientMutation, { data, loading, error }] = useUnarchiveClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnarchiveClientMutation(baseOptions?: Apollo.MutationHookOptions<UnarchiveClientMutation, UnarchiveClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnarchiveClientMutation, UnarchiveClientMutationVariables>(UnarchiveClientDocument, options);
      }
export type UnarchiveClientMutationHookResult = ReturnType<typeof useUnarchiveClientMutation>;
export type UnarchiveClientMutationResult = Apollo.MutationResult<UnarchiveClientMutation>;
export type UnarchiveClientMutationOptions = Apollo.BaseMutationOptions<UnarchiveClientMutation, UnarchiveClientMutationVariables>;
export const DeleteClientDocument = gql`
    mutation DeleteClient($id: UUID!) {
  deleteClient(id: $id)
}
    `;
export type DeleteClientMutationFn = Apollo.MutationFunction<DeleteClientMutation, DeleteClientMutationVariables>;

/**
 * __useDeleteClientMutation__
 *
 * To run a mutation, you first call `useDeleteClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientMutation, { data, loading, error }] = useDeleteClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClientMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientMutation, DeleteClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientMutation, DeleteClientMutationVariables>(DeleteClientDocument, options);
      }
export type DeleteClientMutationHookResult = ReturnType<typeof useDeleteClientMutation>;
export type DeleteClientMutationResult = Apollo.MutationResult<DeleteClientMutation>;
export type DeleteClientMutationOptions = Apollo.BaseMutationOptions<DeleteClientMutation, DeleteClientMutationVariables>;
export const GetClientDocument = gql`
    query GetClient($id: UUID!) {
  client(id: $id) {
    id
    name
    description
    organizationId
    createdBy
    industryId
    industry {
      id
      name
      code
    }
    industryName
    clientType
    size
    website
    contactEmail
    contactName
    contactPhone
    isActive
    totalLifetimeValue
    createdAt
    updatedAt
    metadata
    corporateNumber
    nameKana
    nameEnglish
    postalCode
    prefecture
    city
    streetAddress
    addressOutside
    corporateStatus
    corporateUpdateDate
    corporateCloseDate
    isAutoRegistered
    dataQualityScore
    parentId
    projectCount
    hasActiveProjects
    displaySize
    isEnterprise
    fullAddress
    corporateStatusDisplay
  }
}
    `;

/**
 * __useGetClientQuery__
 *
 * To run a query within a React component, call `useGetClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientQuery(baseOptions: Apollo.QueryHookOptions<GetClientQuery, GetClientQueryVariables> & ({ variables: GetClientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
      }
export function useGetClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
        }
// @ts-ignore
export function useGetClientSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientQuery, GetClientQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientQuery, GetClientQueryVariables>;
export function useGetClientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientQuery, GetClientQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientQuery | undefined, GetClientQueryVariables>;
export function useGetClientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
        }
export type GetClientQueryHookResult = ReturnType<typeof useGetClientQuery>;
export type GetClientLazyQueryHookResult = ReturnType<typeof useGetClientLazyQuery>;
export type GetClientSuspenseQueryHookResult = ReturnType<typeof useGetClientSuspenseQuery>;
export type GetClientQueryResult = Apollo.QueryResult<GetClientQuery, GetClientQueryVariables>;
export const GetClientsDocument = gql`
    query GetClients($filter: ClientFilterInput = null, $limit: Int! = 20, $offset: Int! = 0) {
  clients(filter: $filter, limit: $limit, offset: $offset) {
    edges {
      cursor
      node {
        id
        name
        description
        organizationId
        createdBy
        industryId
        industryName
        clientType
        size
        website
        contactEmail
        contactName
        contactPhone
        isActive
        totalLifetimeValue
        createdAt
        updatedAt
        metadata
        corporateNumber
        nameKana
        nameEnglish
        postalCode
        prefecture
        city
        streetAddress
        addressOutside
        corporateStatus
        corporateUpdateDate
        corporateCloseDate
        isAutoRegistered
        dataQualityScore
        parentId
        projectCount
        hasActiveProjects
        displaySize
        isEnterprise
        fullAddress
        corporateStatusDisplay
        industry {
          id
          name
          code
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetClientsQuery__
 *
 * To run a query within a React component, call `useGetClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetClientsQuery(baseOptions?: Apollo.QueryHookOptions<GetClientsQuery, GetClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, options);
      }
export function useGetClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsQuery, GetClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, options);
        }
// @ts-ignore
export function useGetClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientsQuery, GetClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientsQuery, GetClientsQueryVariables>;
export function useGetClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientsQuery, GetClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientsQuery | undefined, GetClientsQueryVariables>;
export function useGetClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientsQuery, GetClientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, options);
        }
export type GetClientsQueryHookResult = ReturnType<typeof useGetClientsQuery>;
export type GetClientsLazyQueryHookResult = ReturnType<typeof useGetClientsLazyQuery>;
export type GetClientsSuspenseQueryHookResult = ReturnType<typeof useGetClientsSuspenseQuery>;
export type GetClientsQueryResult = Apollo.QueryResult<GetClientsQuery, GetClientsQueryVariables>;
export const GetOrganizationClientsDocument = gql`
    query GetOrganizationClients($organizationId: UUID!, $isActive: Boolean = true) {
  organizationClients(organizationId: $organizationId, isActive: $isActive) {
    id
    name
    description
    organizationId
    createdBy
    industryId
    industry {
      id
      name
      code
    }
    industryName
    clientType
    size
    website
    contactEmail
    contactName
    contactPhone
    isActive
    totalLifetimeValue
    createdAt
    updatedAt
    metadata
    corporateNumber
    nameKana
    nameEnglish
    postalCode
    prefecture
    city
    streetAddress
    addressOutside
    corporateStatus
    corporateUpdateDate
    corporateCloseDate
    isAutoRegistered
    dataQualityScore
    parentId
    projectCount
    hasActiveProjects
    displaySize
    isEnterprise
    fullAddress
    corporateStatusDisplay
  }
}
    `;

/**
 * __useGetOrganizationClientsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationClientsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useGetOrganizationClientsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationClientsQuery, GetOrganizationClientsQueryVariables> & ({ variables: GetOrganizationClientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationClientsQuery, GetOrganizationClientsQueryVariables>(GetOrganizationClientsDocument, options);
      }
export function useGetOrganizationClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationClientsQuery, GetOrganizationClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationClientsQuery, GetOrganizationClientsQueryVariables>(GetOrganizationClientsDocument, options);
        }
// @ts-ignore
export function useGetOrganizationClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationClientsQuery, GetOrganizationClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationClientsQuery, GetOrganizationClientsQueryVariables>;
export function useGetOrganizationClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationClientsQuery, GetOrganizationClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationClientsQuery | undefined, GetOrganizationClientsQueryVariables>;
export function useGetOrganizationClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationClientsQuery, GetOrganizationClientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationClientsQuery, GetOrganizationClientsQueryVariables>(GetOrganizationClientsDocument, options);
        }
export type GetOrganizationClientsQueryHookResult = ReturnType<typeof useGetOrganizationClientsQuery>;
export type GetOrganizationClientsLazyQueryHookResult = ReturnType<typeof useGetOrganizationClientsLazyQuery>;
export type GetOrganizationClientsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationClientsSuspenseQuery>;
export type GetOrganizationClientsQueryResult = Apollo.QueryResult<GetOrganizationClientsQuery, GetOrganizationClientsQueryVariables>;
export const GetChildClientsDocument = gql`
    query GetChildClients($parentId: UUID!) {
  childClients(parentId: $parentId) {
    id
    name
    description
    organizationId
    createdBy
    industryId
    industry {
      id
      name
      code
    }
    industryName
    clientType
    size
    website
    contactEmail
    contactName
    contactPhone
    isActive
    totalLifetimeValue
    createdAt
    updatedAt
    metadata
    corporateNumber
    nameKana
    nameEnglish
    postalCode
    prefecture
    city
    streetAddress
    addressOutside
    corporateStatus
    corporateUpdateDate
    corporateCloseDate
    isAutoRegistered
    dataQualityScore
    parentId
    projectCount
    hasActiveProjects
    displaySize
    isEnterprise
    fullAddress
    corporateStatusDisplay
  }
}
    `;

/**
 * __useGetChildClientsQuery__
 *
 * To run a query within a React component, call `useGetChildClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChildClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChildClientsQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useGetChildClientsQuery(baseOptions: Apollo.QueryHookOptions<GetChildClientsQuery, GetChildClientsQueryVariables> & ({ variables: GetChildClientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChildClientsQuery, GetChildClientsQueryVariables>(GetChildClientsDocument, options);
      }
export function useGetChildClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChildClientsQuery, GetChildClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChildClientsQuery, GetChildClientsQueryVariables>(GetChildClientsDocument, options);
        }
// @ts-ignore
export function useGetChildClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChildClientsQuery, GetChildClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetChildClientsQuery, GetChildClientsQueryVariables>;
export function useGetChildClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChildClientsQuery, GetChildClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetChildClientsQuery | undefined, GetChildClientsQueryVariables>;
export function useGetChildClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChildClientsQuery, GetChildClientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChildClientsQuery, GetChildClientsQueryVariables>(GetChildClientsDocument, options);
        }
export type GetChildClientsQueryHookResult = ReturnType<typeof useGetChildClientsQuery>;
export type GetChildClientsLazyQueryHookResult = ReturnType<typeof useGetChildClientsLazyQuery>;
export type GetChildClientsSuspenseQueryHookResult = ReturnType<typeof useGetChildClientsSuspenseQuery>;
export type GetChildClientsQueryResult = Apollo.QueryResult<GetChildClientsQuery, GetChildClientsQueryVariables>;
export const GetSearchCorporationsDocument = gql`
    query GetSearchCorporations($input: CorporateSearchInput!) {
  searchCorporations(input: $input) {
    success
    results {
      corporateNumber
      name
      nameKana
      nameEn
      prefecture
      city
      streetAddress
      postalCode
      status
      closeDate
      closeReason
      updateDate
      changeDate
      kind
    }
    totalCount
    error
  }
}
    `;

/**
 * __useGetSearchCorporationsQuery__
 *
 * To run a query within a React component, call `useGetSearchCorporationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchCorporationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchCorporationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSearchCorporationsQuery(baseOptions: Apollo.QueryHookOptions<GetSearchCorporationsQuery, GetSearchCorporationsQueryVariables> & ({ variables: GetSearchCorporationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchCorporationsQuery, GetSearchCorporationsQueryVariables>(GetSearchCorporationsDocument, options);
      }
export function useGetSearchCorporationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchCorporationsQuery, GetSearchCorporationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchCorporationsQuery, GetSearchCorporationsQueryVariables>(GetSearchCorporationsDocument, options);
        }
// @ts-ignore
export function useGetSearchCorporationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSearchCorporationsQuery, GetSearchCorporationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSearchCorporationsQuery, GetSearchCorporationsQueryVariables>;
export function useGetSearchCorporationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchCorporationsQuery, GetSearchCorporationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSearchCorporationsQuery | undefined, GetSearchCorporationsQueryVariables>;
export function useGetSearchCorporationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchCorporationsQuery, GetSearchCorporationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchCorporationsQuery, GetSearchCorporationsQueryVariables>(GetSearchCorporationsDocument, options);
        }
export type GetSearchCorporationsQueryHookResult = ReturnType<typeof useGetSearchCorporationsQuery>;
export type GetSearchCorporationsLazyQueryHookResult = ReturnType<typeof useGetSearchCorporationsLazyQuery>;
export type GetSearchCorporationsSuspenseQueryHookResult = ReturnType<typeof useGetSearchCorporationsSuspenseQuery>;
export type GetSearchCorporationsQueryResult = Apollo.QueryResult<GetSearchCorporationsQuery, GetSearchCorporationsQueryVariables>;
export const CreateCompanyProfileDocument = gql`
    mutation CreateCompanyProfile($input: CreateCompanyProfileInput!) {
  createCompanyProfile(input: $input) {
    id
    description
    organizationId
    createdBy
    organizationName
    industryId
    industry {
      id
      name
      code
      description
      icon
      isActive
      industryProfile
      hasProfileData
    }
    size
    foundedDate
    employeeCount
    annualRevenue
    email
    phone
    website
    address
    corporateNumber
    nameKana
    nameEnglish
    postalCode
    prefecture
    city
    streetAddress
    addressOutside
    corporateStatus
    corporateUpdateDate
    corporateCloseDate
    businessContent
    strengths
    achievements
    targetMarket
    competitors
    status
    dataQualityScore
    metadata
    createdAt
    updatedAt
    fullAddress
    isComplete
    displaySize
    displayStatus
    corporateStatusDisplay
    completenessPercentage
  }
}
    `;
export type CreateCompanyProfileMutationFn = Apollo.MutationFunction<CreateCompanyProfileMutation, CreateCompanyProfileMutationVariables>;

/**
 * __useCreateCompanyProfileMutation__
 *
 * To run a mutation, you first call `useCreateCompanyProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyProfileMutation, { data, loading, error }] = useCreateCompanyProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompanyProfileMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyProfileMutation, CreateCompanyProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyProfileMutation, CreateCompanyProfileMutationVariables>(CreateCompanyProfileDocument, options);
      }
export type CreateCompanyProfileMutationHookResult = ReturnType<typeof useCreateCompanyProfileMutation>;
export type CreateCompanyProfileMutationResult = Apollo.MutationResult<CreateCompanyProfileMutation>;
export type CreateCompanyProfileMutationOptions = Apollo.BaseMutationOptions<CreateCompanyProfileMutation, CreateCompanyProfileMutationVariables>;
export const UpdateCompanyProfileDocument = gql`
    mutation UpdateCompanyProfile($id: UUID!, $input: UpdateCompanyProfileInput!) {
  updateCompanyProfile(id: $id, input: $input) {
    id
    description
    organizationId
    createdBy
    organizationName
    industryId
    industry {
      id
      name
      code
      description
      icon
      isActive
      industryProfile
      hasProfileData
    }
    size
    foundedDate
    employeeCount
    annualRevenue
    email
    phone
    website
    address
    corporateNumber
    nameKana
    nameEnglish
    postalCode
    prefecture
    city
    streetAddress
    addressOutside
    corporateStatus
    corporateUpdateDate
    corporateCloseDate
    businessContent
    strengths
    achievements
    targetMarket
    competitors
    status
    dataQualityScore
    metadata
    createdAt
    updatedAt
    fullAddress
    isComplete
    displaySize
    displayStatus
    corporateStatusDisplay
    completenessPercentage
  }
}
    `;
export type UpdateCompanyProfileMutationFn = Apollo.MutationFunction<UpdateCompanyProfileMutation, UpdateCompanyProfileMutationVariables>;

/**
 * __useUpdateCompanyProfileMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyProfileMutation, { data, loading, error }] = useUpdateCompanyProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyProfileMutation, UpdateCompanyProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyProfileMutation, UpdateCompanyProfileMutationVariables>(UpdateCompanyProfileDocument, options);
      }
export type UpdateCompanyProfileMutationHookResult = ReturnType<typeof useUpdateCompanyProfileMutation>;
export type UpdateCompanyProfileMutationResult = Apollo.MutationResult<UpdateCompanyProfileMutation>;
export type UpdateCompanyProfileMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyProfileMutation, UpdateCompanyProfileMutationVariables>;
export const DeleteCompanyProfileDocument = gql`
    mutation DeleteCompanyProfile($id: UUID!) {
  deleteCompanyProfile(id: $id)
}
    `;
export type DeleteCompanyProfileMutationFn = Apollo.MutationFunction<DeleteCompanyProfileMutation, DeleteCompanyProfileMutationVariables>;

/**
 * __useDeleteCompanyProfileMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyProfileMutation, { data, loading, error }] = useDeleteCompanyProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCompanyProfileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyProfileMutation, DeleteCompanyProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyProfileMutation, DeleteCompanyProfileMutationVariables>(DeleteCompanyProfileDocument, options);
      }
export type DeleteCompanyProfileMutationHookResult = ReturnType<typeof useDeleteCompanyProfileMutation>;
export type DeleteCompanyProfileMutationResult = Apollo.MutationResult<DeleteCompanyProfileMutation>;
export type DeleteCompanyProfileMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyProfileMutation, DeleteCompanyProfileMutationVariables>;
export const ResearchCompanyProfileDocument = gql`
    mutation ResearchCompanyProfile($id: UUID!, $websiteUrl: String = null) {
  researchCompanyProfile(id: $id, websiteUrl: $websiteUrl)
}
    `;
export type ResearchCompanyProfileMutationFn = Apollo.MutationFunction<ResearchCompanyProfileMutation, ResearchCompanyProfileMutationVariables>;

/**
 * __useResearchCompanyProfileMutation__
 *
 * To run a mutation, you first call `useResearchCompanyProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResearchCompanyProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [researchCompanyProfileMutation, { data, loading, error }] = useResearchCompanyProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      websiteUrl: // value for 'websiteUrl'
 *   },
 * });
 */
export function useResearchCompanyProfileMutation(baseOptions?: Apollo.MutationHookOptions<ResearchCompanyProfileMutation, ResearchCompanyProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResearchCompanyProfileMutation, ResearchCompanyProfileMutationVariables>(ResearchCompanyProfileDocument, options);
      }
export type ResearchCompanyProfileMutationHookResult = ReturnType<typeof useResearchCompanyProfileMutation>;
export type ResearchCompanyProfileMutationResult = Apollo.MutationResult<ResearchCompanyProfileMutation>;
export type ResearchCompanyProfileMutationOptions = Apollo.BaseMutationOptions<ResearchCompanyProfileMutation, ResearchCompanyProfileMutationVariables>;
export const GetCompanyProfileDocument = gql`
    query GetCompanyProfile {
  companyProfile {
    id
    description
    organizationId
    createdBy
    organizationName
    industryId
    industry {
      id
      name
      code
      description
      icon
      isActive
      industryProfile
      hasProfileData
    }
    size
    foundedDate
    employeeCount
    annualRevenue
    email
    phone
    website
    address
    corporateNumber
    nameKana
    nameEnglish
    postalCode
    prefecture
    city
    streetAddress
    addressOutside
    corporateStatus
    corporateUpdateDate
    corporateCloseDate
    businessContent
    strengths
    achievements
    targetMarket
    competitors
    status
    dataQualityScore
    metadata
    createdAt
    updatedAt
    fullAddress
    isComplete
    displaySize
    displayStatus
    corporateStatusDisplay
    completenessPercentage
  }
}
    `;

/**
 * __useGetCompanyProfileQuery__
 *
 * To run a query within a React component, call `useGetCompanyProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompanyProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyProfileQuery, GetCompanyProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyProfileQuery, GetCompanyProfileQueryVariables>(GetCompanyProfileDocument, options);
      }
export function useGetCompanyProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyProfileQuery, GetCompanyProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyProfileQuery, GetCompanyProfileQueryVariables>(GetCompanyProfileDocument, options);
        }
// @ts-ignore
export function useGetCompanyProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyProfileQuery, GetCompanyProfileQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyProfileQuery, GetCompanyProfileQueryVariables>;
export function useGetCompanyProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyProfileQuery, GetCompanyProfileQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyProfileQuery | undefined, GetCompanyProfileQueryVariables>;
export function useGetCompanyProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyProfileQuery, GetCompanyProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyProfileQuery, GetCompanyProfileQueryVariables>(GetCompanyProfileDocument, options);
        }
export type GetCompanyProfileQueryHookResult = ReturnType<typeof useGetCompanyProfileQuery>;
export type GetCompanyProfileLazyQueryHookResult = ReturnType<typeof useGetCompanyProfileLazyQuery>;
export type GetCompanyProfileSuspenseQueryHookResult = ReturnType<typeof useGetCompanyProfileSuspenseQuery>;
export type GetCompanyProfileQueryResult = Apollo.QueryResult<GetCompanyProfileQuery, GetCompanyProfileQueryVariables>;
export const GetCompanyProfileByIdDocument = gql`
    query GetCompanyProfileById($id: UUID!) {
  companyProfileById(id: $id) {
    id
    description
    organizationId
    createdBy
    organizationName
    industryId
    industry {
      id
      name
      code
      description
      icon
      isActive
      industryProfile
      hasProfileData
    }
    size
    foundedDate
    employeeCount
    annualRevenue
    email
    phone
    website
    address
    corporateNumber
    nameKana
    nameEnglish
    postalCode
    prefecture
    city
    streetAddress
    addressOutside
    corporateStatus
    corporateUpdateDate
    corporateCloseDate
    businessContent
    strengths
    achievements
    targetMarket
    competitors
    status
    dataQualityScore
    metadata
    createdAt
    updatedAt
    fullAddress
    isComplete
    displaySize
    displayStatus
    corporateStatusDisplay
    completenessPercentage
  }
}
    `;

/**
 * __useGetCompanyProfileByIdQuery__
 *
 * To run a query within a React component, call `useGetCompanyProfileByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyProfileByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyProfileByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyProfileByIdQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyProfileByIdQuery, GetCompanyProfileByIdQueryVariables> & ({ variables: GetCompanyProfileByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyProfileByIdQuery, GetCompanyProfileByIdQueryVariables>(GetCompanyProfileByIdDocument, options);
      }
export function useGetCompanyProfileByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyProfileByIdQuery, GetCompanyProfileByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyProfileByIdQuery, GetCompanyProfileByIdQueryVariables>(GetCompanyProfileByIdDocument, options);
        }
// @ts-ignore
export function useGetCompanyProfileByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyProfileByIdQuery, GetCompanyProfileByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyProfileByIdQuery, GetCompanyProfileByIdQueryVariables>;
export function useGetCompanyProfileByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyProfileByIdQuery, GetCompanyProfileByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyProfileByIdQuery | undefined, GetCompanyProfileByIdQueryVariables>;
export function useGetCompanyProfileByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyProfileByIdQuery, GetCompanyProfileByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyProfileByIdQuery, GetCompanyProfileByIdQueryVariables>(GetCompanyProfileByIdDocument, options);
        }
export type GetCompanyProfileByIdQueryHookResult = ReturnType<typeof useGetCompanyProfileByIdQuery>;
export type GetCompanyProfileByIdLazyQueryHookResult = ReturnType<typeof useGetCompanyProfileByIdLazyQuery>;
export type GetCompanyProfileByIdSuspenseQueryHookResult = ReturnType<typeof useGetCompanyProfileByIdSuspenseQuery>;
export type GetCompanyProfileByIdQueryResult = Apollo.QueryResult<GetCompanyProfileByIdQuery, GetCompanyProfileByIdQueryVariables>;
export const GetHasCompanyProfileDocument = gql`
    query GetHasCompanyProfile {
  hasCompanyProfile
}
    `;

/**
 * __useGetHasCompanyProfileQuery__
 *
 * To run a query within a React component, call `useGetHasCompanyProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHasCompanyProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHasCompanyProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHasCompanyProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetHasCompanyProfileQuery, GetHasCompanyProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHasCompanyProfileQuery, GetHasCompanyProfileQueryVariables>(GetHasCompanyProfileDocument, options);
      }
export function useGetHasCompanyProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHasCompanyProfileQuery, GetHasCompanyProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHasCompanyProfileQuery, GetHasCompanyProfileQueryVariables>(GetHasCompanyProfileDocument, options);
        }
// @ts-ignore
export function useGetHasCompanyProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHasCompanyProfileQuery, GetHasCompanyProfileQueryVariables>): Apollo.UseSuspenseQueryResult<GetHasCompanyProfileQuery, GetHasCompanyProfileQueryVariables>;
export function useGetHasCompanyProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHasCompanyProfileQuery, GetHasCompanyProfileQueryVariables>): Apollo.UseSuspenseQueryResult<GetHasCompanyProfileQuery | undefined, GetHasCompanyProfileQueryVariables>;
export function useGetHasCompanyProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHasCompanyProfileQuery, GetHasCompanyProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHasCompanyProfileQuery, GetHasCompanyProfileQueryVariables>(GetHasCompanyProfileDocument, options);
        }
export type GetHasCompanyProfileQueryHookResult = ReturnType<typeof useGetHasCompanyProfileQuery>;
export type GetHasCompanyProfileLazyQueryHookResult = ReturnType<typeof useGetHasCompanyProfileLazyQuery>;
export type GetHasCompanyProfileSuspenseQueryHookResult = ReturnType<typeof useGetHasCompanyProfileSuspenseQuery>;
export type GetHasCompanyProfileQueryResult = Apollo.QueryResult<GetHasCompanyProfileQuery, GetHasCompanyProfileQueryVariables>;
export const GenerateUnifiedContentDocument = gql`
    mutation GenerateUnifiedContent($input: UnifiedContentGenerationInput!) {
  generateUnifiedContent(input: $input) {
    success
    taskId
    contentType
    outputFormat
    projectId
    message
    error
    artifactId
    deliverableId
    fileUrl
    fileSize
    contentLength
    qualityScore
    processingTime
  }
}
    `;
export type GenerateUnifiedContentMutationFn = Apollo.MutationFunction<GenerateUnifiedContentMutation, GenerateUnifiedContentMutationVariables>;

/**
 * __useGenerateUnifiedContentMutation__
 *
 * To run a mutation, you first call `useGenerateUnifiedContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUnifiedContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUnifiedContentMutation, { data, loading, error }] = useGenerateUnifiedContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateUnifiedContentMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUnifiedContentMutation, GenerateUnifiedContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUnifiedContentMutation, GenerateUnifiedContentMutationVariables>(GenerateUnifiedContentDocument, options);
      }
export type GenerateUnifiedContentMutationHookResult = ReturnType<typeof useGenerateUnifiedContentMutation>;
export type GenerateUnifiedContentMutationResult = Apollo.MutationResult<GenerateUnifiedContentMutation>;
export type GenerateUnifiedContentMutationOptions = Apollo.BaseMutationOptions<GenerateUnifiedContentMutation, GenerateUnifiedContentMutationVariables>;
export const GetUnifiedContentTaskStatusDocument = gql`
    query GetUnifiedContentTaskStatus($taskId: String!) {
  unifiedContentTaskStatus(taskId: $taskId) {
    taskId
    status
    result
    error
    progress
    contentType
    outputFormat
    projectId
  }
}
    `;

/**
 * __useGetUnifiedContentTaskStatusQuery__
 *
 * To run a query within a React component, call `useGetUnifiedContentTaskStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnifiedContentTaskStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnifiedContentTaskStatusQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetUnifiedContentTaskStatusQuery(baseOptions: Apollo.QueryHookOptions<GetUnifiedContentTaskStatusQuery, GetUnifiedContentTaskStatusQueryVariables> & ({ variables: GetUnifiedContentTaskStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnifiedContentTaskStatusQuery, GetUnifiedContentTaskStatusQueryVariables>(GetUnifiedContentTaskStatusDocument, options);
      }
export function useGetUnifiedContentTaskStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnifiedContentTaskStatusQuery, GetUnifiedContentTaskStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnifiedContentTaskStatusQuery, GetUnifiedContentTaskStatusQueryVariables>(GetUnifiedContentTaskStatusDocument, options);
        }
// @ts-ignore
export function useGetUnifiedContentTaskStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUnifiedContentTaskStatusQuery, GetUnifiedContentTaskStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnifiedContentTaskStatusQuery, GetUnifiedContentTaskStatusQueryVariables>;
export function useGetUnifiedContentTaskStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnifiedContentTaskStatusQuery, GetUnifiedContentTaskStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnifiedContentTaskStatusQuery | undefined, GetUnifiedContentTaskStatusQueryVariables>;
export function useGetUnifiedContentTaskStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnifiedContentTaskStatusQuery, GetUnifiedContentTaskStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnifiedContentTaskStatusQuery, GetUnifiedContentTaskStatusQueryVariables>(GetUnifiedContentTaskStatusDocument, options);
        }
export type GetUnifiedContentTaskStatusQueryHookResult = ReturnType<typeof useGetUnifiedContentTaskStatusQuery>;
export type GetUnifiedContentTaskStatusLazyQueryHookResult = ReturnType<typeof useGetUnifiedContentTaskStatusLazyQuery>;
export type GetUnifiedContentTaskStatusSuspenseQueryHookResult = ReturnType<typeof useGetUnifiedContentTaskStatusSuspenseQuery>;
export type GetUnifiedContentTaskStatusQueryResult = Apollo.QueryResult<GetUnifiedContentTaskStatusQuery, GetUnifiedContentTaskStatusQueryVariables>;
export const GetContentGenerationHistoryDocument = gql`
    query GetContentGenerationHistory($filterInput: ContentGenerationFilterInput = null, $first: Int! = 20, $offset: Int! = 0) {
  contentGenerationHistory(
    filterInput: $filterInput
    first: $first
    offset: $offset
  ) {
    edges {
      id
      projectId
      contentType
      outputFormat
      status
      createdAt
      completedAt
      processingTime
      qualityScore
      error
      artifactId
      deliverableId
      fileUrl
    }
    totalCount
    hasNextPage
    hasPreviousPage
  }
}
    `;

/**
 * __useGetContentGenerationHistoryQuery__
 *
 * To run a query within a React component, call `useGetContentGenerationHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentGenerationHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentGenerationHistoryQuery({
 *   variables: {
 *      filterInput: // value for 'filterInput'
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetContentGenerationHistoryQuery(baseOptions?: Apollo.QueryHookOptions<GetContentGenerationHistoryQuery, GetContentGenerationHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentGenerationHistoryQuery, GetContentGenerationHistoryQueryVariables>(GetContentGenerationHistoryDocument, options);
      }
export function useGetContentGenerationHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentGenerationHistoryQuery, GetContentGenerationHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentGenerationHistoryQuery, GetContentGenerationHistoryQueryVariables>(GetContentGenerationHistoryDocument, options);
        }
// @ts-ignore
export function useGetContentGenerationHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContentGenerationHistoryQuery, GetContentGenerationHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetContentGenerationHistoryQuery, GetContentGenerationHistoryQueryVariables>;
export function useGetContentGenerationHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentGenerationHistoryQuery, GetContentGenerationHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetContentGenerationHistoryQuery | undefined, GetContentGenerationHistoryQueryVariables>;
export function useGetContentGenerationHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentGenerationHistoryQuery, GetContentGenerationHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentGenerationHistoryQuery, GetContentGenerationHistoryQueryVariables>(GetContentGenerationHistoryDocument, options);
        }
export type GetContentGenerationHistoryQueryHookResult = ReturnType<typeof useGetContentGenerationHistoryQuery>;
export type GetContentGenerationHistoryLazyQueryHookResult = ReturnType<typeof useGetContentGenerationHistoryLazyQuery>;
export type GetContentGenerationHistorySuspenseQueryHookResult = ReturnType<typeof useGetContentGenerationHistorySuspenseQuery>;
export type GetContentGenerationHistoryQueryResult = Apollo.QueryResult<GetContentGenerationHistoryQuery, GetContentGenerationHistoryQueryVariables>;
export const ExecuteSitemapIntegrationFlowDocument = gql`
    mutation ExecuteSitemapIntegrationFlow($projectId: UUID!, $sitemapData: JSON!, $uiCompletionData: JSON = null, $requirements: JSON = null, $generateSystem: Boolean! = false, $selectedDeliverableId: String = null) {
  executeSitemapIntegrationFlow(
    projectId: $projectId
    sitemapData: $sitemapData
    uiCompletionData: $uiCompletionData
    requirements: $requirements
    generateSystem: $generateSystem
    selectedDeliverableId: $selectedDeliverableId
  )
}
    `;
export type ExecuteSitemapIntegrationFlowMutationFn = Apollo.MutationFunction<ExecuteSitemapIntegrationFlowMutation, ExecuteSitemapIntegrationFlowMutationVariables>;

/**
 * __useExecuteSitemapIntegrationFlowMutation__
 *
 * To run a mutation, you first call `useExecuteSitemapIntegrationFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteSitemapIntegrationFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeSitemapIntegrationFlowMutation, { data, loading, error }] = useExecuteSitemapIntegrationFlowMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      sitemapData: // value for 'sitemapData'
 *      uiCompletionData: // value for 'uiCompletionData'
 *      requirements: // value for 'requirements'
 *      generateSystem: // value for 'generateSystem'
 *      selectedDeliverableId: // value for 'selectedDeliverableId'
 *   },
 * });
 */
export function useExecuteSitemapIntegrationFlowMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteSitemapIntegrationFlowMutation, ExecuteSitemapIntegrationFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteSitemapIntegrationFlowMutation, ExecuteSitemapIntegrationFlowMutationVariables>(ExecuteSitemapIntegrationFlowDocument, options);
      }
export type ExecuteSitemapIntegrationFlowMutationHookResult = ReturnType<typeof useExecuteSitemapIntegrationFlowMutation>;
export type ExecuteSitemapIntegrationFlowMutationResult = Apollo.MutationResult<ExecuteSitemapIntegrationFlowMutation>;
export type ExecuteSitemapIntegrationFlowMutationOptions = Apollo.BaseMutationOptions<ExecuteSitemapIntegrationFlowMutation, ExecuteSitemapIntegrationFlowMutationVariables>;
export const ResearchIndustryDocument = gql`
    mutation ResearchIndustry($id: ID!) {
  researchIndustry(id: $id)
}
    `;
export type ResearchIndustryMutationFn = Apollo.MutationFunction<ResearchIndustryMutation, ResearchIndustryMutationVariables>;

/**
 * __useResearchIndustryMutation__
 *
 * To run a mutation, you first call `useResearchIndustryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResearchIndustryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [researchIndustryMutation, { data, loading, error }] = useResearchIndustryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResearchIndustryMutation(baseOptions?: Apollo.MutationHookOptions<ResearchIndustryMutation, ResearchIndustryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResearchIndustryMutation, ResearchIndustryMutationVariables>(ResearchIndustryDocument, options);
      }
export type ResearchIndustryMutationHookResult = ReturnType<typeof useResearchIndustryMutation>;
export type ResearchIndustryMutationResult = Apollo.MutationResult<ResearchIndustryMutation>;
export type ResearchIndustryMutationOptions = Apollo.BaseMutationOptions<ResearchIndustryMutation, ResearchIndustryMutationVariables>;
export const PingDocument = gql`
    mutation Ping {
  ping
}
    `;
export type PingMutationFn = Apollo.MutationFunction<PingMutation, PingMutationVariables>;

/**
 * __usePingMutation__
 *
 * To run a mutation, you first call `usePingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pingMutation, { data, loading, error }] = usePingMutation({
 *   variables: {
 *   },
 * });
 */
export function usePingMutation(baseOptions?: Apollo.MutationHookOptions<PingMutation, PingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PingMutation, PingMutationVariables>(PingDocument, options);
      }
export type PingMutationHookResult = ReturnType<typeof usePingMutation>;
export type PingMutationResult = Apollo.MutationResult<PingMutation>;
export type PingMutationOptions = Apollo.BaseMutationOptions<PingMutation, PingMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($userId: UUID!, $currentPassword: String!, $newPassword: String!) {
  changePassword(
    userId: $userId
    currentPassword: $currentPassword
    newPassword: $newPassword
  )
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      currentPassword: // value for 'currentPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const VerifyEmailDocument = gql`
    mutation VerifyEmail($userId: UUID!) {
  verifyEmail(userId: $userId)
}
    `;
export type VerifyEmailMutationFn = Apollo.MutationFunction<VerifyEmailMutation, VerifyEmailMutationVariables>;

/**
 * __useVerifyEmailMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMutation, { data, loading, error }] = useVerifyEmailMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailMutation, VerifyEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyEmailMutation, VerifyEmailMutationVariables>(VerifyEmailDocument, options);
      }
export type VerifyEmailMutationHookResult = ReturnType<typeof useVerifyEmailMutation>;
export type VerifyEmailMutationResult = Apollo.MutationResult<VerifyEmailMutation>;
export type VerifyEmailMutationOptions = Apollo.BaseMutationOptions<VerifyEmailMutation, VerifyEmailMutationVariables>;
export const ResearchCompanyDocument = gql`
    mutation ResearchCompany($clientId: UUID!, $websiteUrl: String = null) {
  researchCompany(clientId: $clientId, websiteUrl: $websiteUrl)
}
    `;
export type ResearchCompanyMutationFn = Apollo.MutationFunction<ResearchCompanyMutation, ResearchCompanyMutationVariables>;

/**
 * __useResearchCompanyMutation__
 *
 * To run a mutation, you first call `useResearchCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResearchCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [researchCompanyMutation, { data, loading, error }] = useResearchCompanyMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      websiteUrl: // value for 'websiteUrl'
 *   },
 * });
 */
export function useResearchCompanyMutation(baseOptions?: Apollo.MutationHookOptions<ResearchCompanyMutation, ResearchCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResearchCompanyMutation, ResearchCompanyMutationVariables>(ResearchCompanyDocument, options);
      }
export type ResearchCompanyMutationHookResult = ReturnType<typeof useResearchCompanyMutation>;
export type ResearchCompanyMutationResult = Apollo.MutationResult<ResearchCompanyMutation>;
export type ResearchCompanyMutationOptions = Apollo.BaseMutationOptions<ResearchCompanyMutation, ResearchCompanyMutationVariables>;
export const GenerateCompanyReportDocument = gql`
    mutation GenerateCompanyReport($clientId: UUID!) {
  generateCompanyReport(clientId: $clientId)
}
    `;
export type GenerateCompanyReportMutationFn = Apollo.MutationFunction<GenerateCompanyReportMutation, GenerateCompanyReportMutationVariables>;

/**
 * __useGenerateCompanyReportMutation__
 *
 * To run a mutation, you first call `useGenerateCompanyReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateCompanyReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateCompanyReportMutation, { data, loading, error }] = useGenerateCompanyReportMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGenerateCompanyReportMutation(baseOptions?: Apollo.MutationHookOptions<GenerateCompanyReportMutation, GenerateCompanyReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateCompanyReportMutation, GenerateCompanyReportMutationVariables>(GenerateCompanyReportDocument, options);
      }
export type GenerateCompanyReportMutationHookResult = ReturnType<typeof useGenerateCompanyReportMutation>;
export type GenerateCompanyReportMutationResult = Apollo.MutationResult<GenerateCompanyReportMutation>;
export type GenerateCompanyReportMutationOptions = Apollo.BaseMutationOptions<GenerateCompanyReportMutation, GenerateCompanyReportMutationVariables>;
export const CreateObserverPluginDocument = gql`
    mutation CreateObserverPlugin($input: PluginCreateInput!) {
  createObserverPlugin(input: $input) {
    success
    message
    plugin {
      id
      name
      code
      description
      pluginType
      configuration
      isActive
      version
      author
    }
  }
}
    `;
export type CreateObserverPluginMutationFn = Apollo.MutationFunction<CreateObserverPluginMutation, CreateObserverPluginMutationVariables>;

/**
 * __useCreateObserverPluginMutation__
 *
 * To run a mutation, you first call `useCreateObserverPluginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateObserverPluginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createObserverPluginMutation, { data, loading, error }] = useCreateObserverPluginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateObserverPluginMutation(baseOptions?: Apollo.MutationHookOptions<CreateObserverPluginMutation, CreateObserverPluginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateObserverPluginMutation, CreateObserverPluginMutationVariables>(CreateObserverPluginDocument, options);
      }
export type CreateObserverPluginMutationHookResult = ReturnType<typeof useCreateObserverPluginMutation>;
export type CreateObserverPluginMutationResult = Apollo.MutationResult<CreateObserverPluginMutation>;
export type CreateObserverPluginMutationOptions = Apollo.BaseMutationOptions<CreateObserverPluginMutation, CreateObserverPluginMutationVariables>;
export const RequestDeviceCodeDocument = gql`
    mutation RequestDeviceCode($input: DeviceCodeInput!) {
  requestDeviceCode(input: $input) {
    deviceCode
    userCode
    verificationUri
    verificationUriComplete
    expiresIn
    interval
  }
}
    `;
export type RequestDeviceCodeMutationFn = Apollo.MutationFunction<RequestDeviceCodeMutation, RequestDeviceCodeMutationVariables>;

/**
 * __useRequestDeviceCodeMutation__
 *
 * To run a mutation, you first call `useRequestDeviceCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestDeviceCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestDeviceCodeMutation, { data, loading, error }] = useRequestDeviceCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestDeviceCodeMutation(baseOptions?: Apollo.MutationHookOptions<RequestDeviceCodeMutation, RequestDeviceCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestDeviceCodeMutation, RequestDeviceCodeMutationVariables>(RequestDeviceCodeDocument, options);
      }
export type RequestDeviceCodeMutationHookResult = ReturnType<typeof useRequestDeviceCodeMutation>;
export type RequestDeviceCodeMutationResult = Apollo.MutationResult<RequestDeviceCodeMutation>;
export type RequestDeviceCodeMutationOptions = Apollo.BaseMutationOptions<RequestDeviceCodeMutation, RequestDeviceCodeMutationVariables>;
export const ChangeMyPasswordDocument = gql`
    mutation ChangeMyPassword($input: ChangePasswordInput!) {
  changeMyPassword(input: $input) {
    success
    message
  }
}
    `;
export type ChangeMyPasswordMutationFn = Apollo.MutationFunction<ChangeMyPasswordMutation, ChangeMyPasswordMutationVariables>;

/**
 * __useChangeMyPasswordMutation__
 *
 * To run a mutation, you first call `useChangeMyPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeMyPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeMyPasswordMutation, { data, loading, error }] = useChangeMyPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeMyPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangeMyPasswordMutation, ChangeMyPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeMyPasswordMutation, ChangeMyPasswordMutationVariables>(ChangeMyPasswordDocument, options);
      }
export type ChangeMyPasswordMutationHookResult = ReturnType<typeof useChangeMyPasswordMutation>;
export type ChangeMyPasswordMutationResult = Apollo.MutationResult<ChangeMyPasswordMutation>;
export type ChangeMyPasswordMutationOptions = Apollo.BaseMutationOptions<ChangeMyPasswordMutation, ChangeMyPasswordMutationVariables>;
export const SendVerificationEmailDocument = gql`
    mutation SendVerificationEmail($input: SendVerificationEmailInput!) {
  sendVerificationEmail(input: $input) {
    success
    message
  }
}
    `;
export type SendVerificationEmailMutationFn = Apollo.MutationFunction<SendVerificationEmailMutation, SendVerificationEmailMutationVariables>;

/**
 * __useSendVerificationEmailMutation__
 *
 * To run a mutation, you first call `useSendVerificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendVerificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendVerificationEmailMutation, { data, loading, error }] = useSendVerificationEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendVerificationEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendVerificationEmailMutation, SendVerificationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendVerificationEmailMutation, SendVerificationEmailMutationVariables>(SendVerificationEmailDocument, options);
      }
export type SendVerificationEmailMutationHookResult = ReturnType<typeof useSendVerificationEmailMutation>;
export type SendVerificationEmailMutationResult = Apollo.MutationResult<SendVerificationEmailMutation>;
export type SendVerificationEmailMutationOptions = Apollo.BaseMutationOptions<SendVerificationEmailMutation, SendVerificationEmailMutationVariables>;
export const RequestPasswordResetDocument = gql`
    mutation RequestPasswordReset($input: RequestPasswordResetInput!) {
  requestPasswordReset(input: $input) {
    success
    message
  }
}
    `;
export type RequestPasswordResetMutationFn = Apollo.MutationFunction<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;

/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetMutation, { data, loading, error }] = useRequestPasswordResetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>(RequestPasswordResetDocument, options);
      }
export type RequestPasswordResetMutationHookResult = ReturnType<typeof useRequestPasswordResetMutation>;
export type RequestPasswordResetMutationResult = Apollo.MutationResult<RequestPasswordResetMutation>;
export type RequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;
export const StartGenerationDddDocument = gql`
    mutation StartGenerationDdd($artifactId: UUID!, $generationParameters: JSON = null) {
  startGenerationDdd(
    artifactId: $artifactId
    generationParameters: $generationParameters
  ) {
    id
    projectId
    artifactType
    title
    description
    format
    content
    fileUrl
    fileSize
    status
    metadata
    createdBy
    createdAt
    generatedAt
    systemSpecData
    proposalMetadata {
      style
      includesDeliverables
      includesSitemap
      includesTechSpecs
      deliverablesCount
      sitemapPagesCount
      techComponentsCount
      estimatedReadingTime
      targetAudience
      totalContentLength
      dataSource
    }
  }
}
    `;
export type StartGenerationDddMutationFn = Apollo.MutationFunction<StartGenerationDddMutation, StartGenerationDddMutationVariables>;

/**
 * __useStartGenerationDddMutation__
 *
 * To run a mutation, you first call `useStartGenerationDddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartGenerationDddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startGenerationDddMutation, { data, loading, error }] = useStartGenerationDddMutation({
 *   variables: {
 *      artifactId: // value for 'artifactId'
 *      generationParameters: // value for 'generationParameters'
 *   },
 * });
 */
export function useStartGenerationDddMutation(baseOptions?: Apollo.MutationHookOptions<StartGenerationDddMutation, StartGenerationDddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartGenerationDddMutation, StartGenerationDddMutationVariables>(StartGenerationDddDocument, options);
      }
export type StartGenerationDddMutationHookResult = ReturnType<typeof useStartGenerationDddMutation>;
export type StartGenerationDddMutationResult = Apollo.MutationResult<StartGenerationDddMutation>;
export type StartGenerationDddMutationOptions = Apollo.BaseMutationOptions<StartGenerationDddMutation, StartGenerationDddMutationVariables>;
export const CompleteGenerationDddDocument = gql`
    mutation CompleteGenerationDdd($artifactId: UUID!, $success: Boolean!, $fileUrl: String = null, $fileSize: Int = null, $errorMessage: String = null) {
  completeGenerationDdd(
    artifactId: $artifactId
    success: $success
    fileUrl: $fileUrl
    fileSize: $fileSize
    errorMessage: $errorMessage
  ) {
    id
    projectId
    artifactType
    title
    description
    format
    content
    fileUrl
    fileSize
    status
    metadata
    createdBy
    createdAt
    generatedAt
    systemSpecData
    proposalMetadata {
      style
      includesDeliverables
      includesSitemap
      includesTechSpecs
      deliverablesCount
      sitemapPagesCount
      techComponentsCount
      estimatedReadingTime
      targetAudience
      totalContentLength
      dataSource
    }
  }
}
    `;
export type CompleteGenerationDddMutationFn = Apollo.MutationFunction<CompleteGenerationDddMutation, CompleteGenerationDddMutationVariables>;

/**
 * __useCompleteGenerationDddMutation__
 *
 * To run a mutation, you first call `useCompleteGenerationDddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteGenerationDddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeGenerationDddMutation, { data, loading, error }] = useCompleteGenerationDddMutation({
 *   variables: {
 *      artifactId: // value for 'artifactId'
 *      success: // value for 'success'
 *      fileUrl: // value for 'fileUrl'
 *      fileSize: // value for 'fileSize'
 *      errorMessage: // value for 'errorMessage'
 *   },
 * });
 */
export function useCompleteGenerationDddMutation(baseOptions?: Apollo.MutationHookOptions<CompleteGenerationDddMutation, CompleteGenerationDddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteGenerationDddMutation, CompleteGenerationDddMutationVariables>(CompleteGenerationDddDocument, options);
      }
export type CompleteGenerationDddMutationHookResult = ReturnType<typeof useCompleteGenerationDddMutation>;
export type CompleteGenerationDddMutationResult = Apollo.MutationResult<CompleteGenerationDddMutation>;
export type CompleteGenerationDddMutationOptions = Apollo.BaseMutationOptions<CompleteGenerationDddMutation, CompleteGenerationDddMutationVariables>;
export const RetryGenerationDddDocument = gql`
    mutation RetryGenerationDdd($artifactId: UUID!) {
  retryGenerationDdd(artifactId: $artifactId) {
    id
    projectId
    artifactType
    title
    description
    format
    content
    fileUrl
    fileSize
    status
    metadata
    createdBy
    createdAt
    generatedAt
    systemSpecData
    proposalMetadata {
      style
      includesDeliverables
      includesSitemap
      includesTechSpecs
      deliverablesCount
      sitemapPagesCount
      techComponentsCount
      estimatedReadingTime
      targetAudience
      totalContentLength
      dataSource
    }
  }
}
    `;
export type RetryGenerationDddMutationFn = Apollo.MutationFunction<RetryGenerationDddMutation, RetryGenerationDddMutationVariables>;

/**
 * __useRetryGenerationDddMutation__
 *
 * To run a mutation, you first call `useRetryGenerationDddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryGenerationDddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryGenerationDddMutation, { data, loading, error }] = useRetryGenerationDddMutation({
 *   variables: {
 *      artifactId: // value for 'artifactId'
 *   },
 * });
 */
export function useRetryGenerationDddMutation(baseOptions?: Apollo.MutationHookOptions<RetryGenerationDddMutation, RetryGenerationDddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryGenerationDddMutation, RetryGenerationDddMutationVariables>(RetryGenerationDddDocument, options);
      }
export type RetryGenerationDddMutationHookResult = ReturnType<typeof useRetryGenerationDddMutation>;
export type RetryGenerationDddMutationResult = Apollo.MutationResult<RetryGenerationDddMutation>;
export type RetryGenerationDddMutationOptions = Apollo.BaseMutationOptions<RetryGenerationDddMutation, RetryGenerationDddMutationVariables>;
export const UpdateLockedFieldsDocument = gql`
    mutation UpdateLockedFields($projectId: UUID!, $lockedFields: [String!]!) {
  updateLockedFields(projectId: $projectId, lockedFields: $lockedFields)
}
    `;
export type UpdateLockedFieldsMutationFn = Apollo.MutationFunction<UpdateLockedFieldsMutation, UpdateLockedFieldsMutationVariables>;

/**
 * __useUpdateLockedFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateLockedFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLockedFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLockedFieldsMutation, { data, loading, error }] = useUpdateLockedFieldsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      lockedFields: // value for 'lockedFields'
 *   },
 * });
 */
export function useUpdateLockedFieldsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLockedFieldsMutation, UpdateLockedFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLockedFieldsMutation, UpdateLockedFieldsMutationVariables>(UpdateLockedFieldsDocument, options);
      }
export type UpdateLockedFieldsMutationHookResult = ReturnType<typeof useUpdateLockedFieldsMutation>;
export type UpdateLockedFieldsMutationResult = Apollo.MutationResult<UpdateLockedFieldsMutation>;
export type UpdateLockedFieldsMutationOptions = Apollo.BaseMutationOptions<UpdateLockedFieldsMutation, UpdateLockedFieldsMutationVariables>;
export const UpdateScopeDocument = gql`
    mutation UpdateScope($scopeId: UUID!, $input: UpdateScopeInput!) {
  updateScope(scopeId: $scopeId, input: $input) {
    id
    name
    origin
    rationale
    searchQuery
    boostKeywords
    analysisLens
    projectId
    viewId
    focusAtomIds
    createdAt
    plan
    functionCandidates {
      name
      category
      description
      priority
      source
    }
  }
}
    `;
export type UpdateScopeMutationFn = Apollo.MutationFunction<UpdateScopeMutation, UpdateScopeMutationVariables>;

/**
 * __useUpdateScopeMutation__
 *
 * To run a mutation, you first call `useUpdateScopeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScopeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScopeMutation, { data, loading, error }] = useUpdateScopeMutation({
 *   variables: {
 *      scopeId: // value for 'scopeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScopeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScopeMutation, UpdateScopeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScopeMutation, UpdateScopeMutationVariables>(UpdateScopeDocument, options);
      }
export type UpdateScopeMutationHookResult = ReturnType<typeof useUpdateScopeMutation>;
export type UpdateScopeMutationResult = Apollo.MutationResult<UpdateScopeMutation>;
export type UpdateScopeMutationOptions = Apollo.BaseMutationOptions<UpdateScopeMutation, UpdateScopeMutationVariables>;
export const RemoveGroundedEntityDocument = gql`
    mutation RemoveGroundedEntity($projectId: UUID!, $entityName: String!) {
  removeGroundedEntity(projectId: $projectId, entityName: $entityName)
}
    `;
export type RemoveGroundedEntityMutationFn = Apollo.MutationFunction<RemoveGroundedEntityMutation, RemoveGroundedEntityMutationVariables>;

/**
 * __useRemoveGroundedEntityMutation__
 *
 * To run a mutation, you first call `useRemoveGroundedEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGroundedEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGroundedEntityMutation, { data, loading, error }] = useRemoveGroundedEntityMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      entityName: // value for 'entityName'
 *   },
 * });
 */
export function useRemoveGroundedEntityMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGroundedEntityMutation, RemoveGroundedEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveGroundedEntityMutation, RemoveGroundedEntityMutationVariables>(RemoveGroundedEntityDocument, options);
      }
export type RemoveGroundedEntityMutationHookResult = ReturnType<typeof useRemoveGroundedEntityMutation>;
export type RemoveGroundedEntityMutationResult = Apollo.MutationResult<RemoveGroundedEntityMutation>;
export type RemoveGroundedEntityMutationOptions = Apollo.BaseMutationOptions<RemoveGroundedEntityMutation, RemoveGroundedEntityMutationVariables>;
export const RefineScopesWithAiDocument = gql`
    mutation RefineScopesWithAi($projectId: UUID!, $message: String!) {
  refineScopesWithAi(projectId: $projectId, message: $message) {
    aiResponse
    actions {
      type
      scopeName
      reason
    }
    scopes {
      id
      name
      origin
      rationale
      searchQuery
      boostKeywords
      analysisLens
      projectId
      viewId
      focusAtomIds
      createdAt
      plan
      functionCandidates {
        name
        category
        description
        priority
        source
      }
    }
  }
}
    `;
export type RefineScopesWithAiMutationFn = Apollo.MutationFunction<RefineScopesWithAiMutation, RefineScopesWithAiMutationVariables>;

/**
 * __useRefineScopesWithAiMutation__
 *
 * To run a mutation, you first call `useRefineScopesWithAiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefineScopesWithAiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refineScopesWithAiMutation, { data, loading, error }] = useRefineScopesWithAiMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useRefineScopesWithAiMutation(baseOptions?: Apollo.MutationHookOptions<RefineScopesWithAiMutation, RefineScopesWithAiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefineScopesWithAiMutation, RefineScopesWithAiMutationVariables>(RefineScopesWithAiDocument, options);
      }
export type RefineScopesWithAiMutationHookResult = ReturnType<typeof useRefineScopesWithAiMutation>;
export type RefineScopesWithAiMutationResult = Apollo.MutationResult<RefineScopesWithAiMutation>;
export type RefineScopesWithAiMutationOptions = Apollo.BaseMutationOptions<RefineScopesWithAiMutation, RefineScopesWithAiMutationVariables>;
export const GeneratePageDesignsDocument = gql`
    mutation GeneratePageDesigns($projectId: ID!) {
  generatePageDesigns(projectId: $projectId)
}
    `;
export type GeneratePageDesignsMutationFn = Apollo.MutationFunction<GeneratePageDesignsMutation, GeneratePageDesignsMutationVariables>;

/**
 * __useGeneratePageDesignsMutation__
 *
 * To run a mutation, you first call `useGeneratePageDesignsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePageDesignsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePageDesignsMutation, { data, loading, error }] = useGeneratePageDesignsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGeneratePageDesignsMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePageDesignsMutation, GeneratePageDesignsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePageDesignsMutation, GeneratePageDesignsMutationVariables>(GeneratePageDesignsDocument, options);
      }
export type GeneratePageDesignsMutationHookResult = ReturnType<typeof useGeneratePageDesignsMutation>;
export type GeneratePageDesignsMutationResult = Apollo.MutationResult<GeneratePageDesignsMutation>;
export type GeneratePageDesignsMutationOptions = Apollo.BaseMutationOptions<GeneratePageDesignsMutation, GeneratePageDesignsMutationVariables>;
export const DeletePageDesignsDocument = gql`
    mutation DeletePageDesigns($projectId: ID!) {
  deletePageDesigns(projectId: $projectId)
}
    `;
export type DeletePageDesignsMutationFn = Apollo.MutationFunction<DeletePageDesignsMutation, DeletePageDesignsMutationVariables>;

/**
 * __useDeletePageDesignsMutation__
 *
 * To run a mutation, you first call `useDeletePageDesignsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePageDesignsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePageDesignsMutation, { data, loading, error }] = useDeletePageDesignsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDeletePageDesignsMutation(baseOptions?: Apollo.MutationHookOptions<DeletePageDesignsMutation, DeletePageDesignsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePageDesignsMutation, DeletePageDesignsMutationVariables>(DeletePageDesignsDocument, options);
      }
export type DeletePageDesignsMutationHookResult = ReturnType<typeof useDeletePageDesignsMutation>;
export type DeletePageDesignsMutationResult = Apollo.MutationResult<DeletePageDesignsMutation>;
export type DeletePageDesignsMutationOptions = Apollo.BaseMutationOptions<DeletePageDesignsMutation, DeletePageDesignsMutationVariables>;
export const StartDeploymentDocument = gql`
    mutation StartDeployment($input: StartDeploymentInput!) {
  startDeployment(input: $input) {
    success
    deploymentId
    taskId
    error
  }
}
    `;
export type StartDeploymentMutationFn = Apollo.MutationFunction<StartDeploymentMutation, StartDeploymentMutationVariables>;

/**
 * __useStartDeploymentMutation__
 *
 * To run a mutation, you first call `useStartDeploymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartDeploymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startDeploymentMutation, { data, loading, error }] = useStartDeploymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartDeploymentMutation(baseOptions?: Apollo.MutationHookOptions<StartDeploymentMutation, StartDeploymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartDeploymentMutation, StartDeploymentMutationVariables>(StartDeploymentDocument, options);
      }
export type StartDeploymentMutationHookResult = ReturnType<typeof useStartDeploymentMutation>;
export type StartDeploymentMutationResult = Apollo.MutationResult<StartDeploymentMutation>;
export type StartDeploymentMutationOptions = Apollo.BaseMutationOptions<StartDeploymentMutation, StartDeploymentMutationVariables>;
export const RetryDeploymentDocument = gql`
    mutation RetryDeployment($deploymentId: String!) {
  retryDeployment(deploymentId: $deploymentId) {
    success
    deploymentId
    taskId
    error
  }
}
    `;
export type RetryDeploymentMutationFn = Apollo.MutationFunction<RetryDeploymentMutation, RetryDeploymentMutationVariables>;

/**
 * __useRetryDeploymentMutation__
 *
 * To run a mutation, you first call `useRetryDeploymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryDeploymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryDeploymentMutation, { data, loading, error }] = useRetryDeploymentMutation({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *   },
 * });
 */
export function useRetryDeploymentMutation(baseOptions?: Apollo.MutationHookOptions<RetryDeploymentMutation, RetryDeploymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryDeploymentMutation, RetryDeploymentMutationVariables>(RetryDeploymentDocument, options);
      }
export type RetryDeploymentMutationHookResult = ReturnType<typeof useRetryDeploymentMutation>;
export type RetryDeploymentMutationResult = Apollo.MutationResult<RetryDeploymentMutation>;
export type RetryDeploymentMutationOptions = Apollo.BaseMutationOptions<RetryDeploymentMutation, RetryDeploymentMutationVariables>;
export const RedeployDeploymentDocument = gql`
    mutation RedeployDeployment($deploymentId: String!) {
  redeployDeployment(deploymentId: $deploymentId) {
    success
    deploymentId
    taskId
    error
  }
}
    `;
export type RedeployDeploymentMutationFn = Apollo.MutationFunction<RedeployDeploymentMutation, RedeployDeploymentMutationVariables>;

/**
 * __useRedeployDeploymentMutation__
 *
 * To run a mutation, you first call `useRedeployDeploymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeployDeploymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeployDeploymentMutation, { data, loading, error }] = useRedeployDeploymentMutation({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *   },
 * });
 */
export function useRedeployDeploymentMutation(baseOptions?: Apollo.MutationHookOptions<RedeployDeploymentMutation, RedeployDeploymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedeployDeploymentMutation, RedeployDeploymentMutationVariables>(RedeployDeploymentDocument, options);
      }
export type RedeployDeploymentMutationHookResult = ReturnType<typeof useRedeployDeploymentMutation>;
export type RedeployDeploymentMutationResult = Apollo.MutationResult<RedeployDeploymentMutation>;
export type RedeployDeploymentMutationOptions = Apollo.BaseMutationOptions<RedeployDeploymentMutation, RedeployDeploymentMutationVariables>;
export const DeleteDeploymentDocument = gql`
    mutation DeleteDeployment($deploymentId: String!) {
  deleteDeployment(deploymentId: $deploymentId)
}
    `;
export type DeleteDeploymentMutationFn = Apollo.MutationFunction<DeleteDeploymentMutation, DeleteDeploymentMutationVariables>;

/**
 * __useDeleteDeploymentMutation__
 *
 * To run a mutation, you first call `useDeleteDeploymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeploymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeploymentMutation, { data, loading, error }] = useDeleteDeploymentMutation({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *   },
 * });
 */
export function useDeleteDeploymentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDeploymentMutation, DeleteDeploymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDeploymentMutation, DeleteDeploymentMutationVariables>(DeleteDeploymentDocument, options);
      }
export type DeleteDeploymentMutationHookResult = ReturnType<typeof useDeleteDeploymentMutation>;
export type DeleteDeploymentMutationResult = Apollo.MutationResult<DeleteDeploymentMutation>;
export type DeleteDeploymentMutationOptions = Apollo.BaseMutationOptions<DeleteDeploymentMutation, DeleteDeploymentMutationVariables>;
export const SaveDeploymentConfigDocument = gql`
    mutation SaveDeploymentConfig($input: SaveDeploymentConfigInput!) {
  saveDeploymentConfig(input: $input) {
    providerType
    githubTokenSet
    githubOwner
    githubRepoName
    vpsHost
    vpsPort
    vpsUsername
    vpsAuthMethod
    vpsPasswordSet
    vpsSshKeySet
    domain
  }
}
    `;
export type SaveDeploymentConfigMutationFn = Apollo.MutationFunction<SaveDeploymentConfigMutation, SaveDeploymentConfigMutationVariables>;

/**
 * __useSaveDeploymentConfigMutation__
 *
 * To run a mutation, you first call `useSaveDeploymentConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDeploymentConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDeploymentConfigMutation, { data, loading, error }] = useSaveDeploymentConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDeploymentConfigMutation(baseOptions?: Apollo.MutationHookOptions<SaveDeploymentConfigMutation, SaveDeploymentConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDeploymentConfigMutation, SaveDeploymentConfigMutationVariables>(SaveDeploymentConfigDocument, options);
      }
export type SaveDeploymentConfigMutationHookResult = ReturnType<typeof useSaveDeploymentConfigMutation>;
export type SaveDeploymentConfigMutationResult = Apollo.MutationResult<SaveDeploymentConfigMutation>;
export type SaveDeploymentConfigMutationOptions = Apollo.BaseMutationOptions<SaveDeploymentConfigMutation, SaveDeploymentConfigMutationVariables>;
export const TestDeploymentConnectionDocument = gql`
    mutation TestDeploymentConnection($projectId: String!) {
  testDeploymentConnection(projectId: $projectId) {
    success
    message
  }
}
    `;
export type TestDeploymentConnectionMutationFn = Apollo.MutationFunction<TestDeploymentConnectionMutation, TestDeploymentConnectionMutationVariables>;

/**
 * __useTestDeploymentConnectionMutation__
 *
 * To run a mutation, you first call `useTestDeploymentConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestDeploymentConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testDeploymentConnectionMutation, { data, loading, error }] = useTestDeploymentConnectionMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useTestDeploymentConnectionMutation(baseOptions?: Apollo.MutationHookOptions<TestDeploymentConnectionMutation, TestDeploymentConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TestDeploymentConnectionMutation, TestDeploymentConnectionMutationVariables>(TestDeploymentConnectionDocument, options);
      }
export type TestDeploymentConnectionMutationHookResult = ReturnType<typeof useTestDeploymentConnectionMutation>;
export type TestDeploymentConnectionMutationResult = Apollo.MutationResult<TestDeploymentConnectionMutation>;
export type TestDeploymentConnectionMutationOptions = Apollo.BaseMutationOptions<TestDeploymentConnectionMutation, TestDeploymentConnectionMutationVariables>;
export const GetHelloDocument = gql`
    query GetHello($name: String = null) {
  hello(name: $name)
}
    `;

/**
 * __useGetHelloQuery__
 *
 * To run a query within a React component, call `useGetHelloQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHelloQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHelloQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetHelloQuery(baseOptions?: Apollo.QueryHookOptions<GetHelloQuery, GetHelloQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHelloQuery, GetHelloQueryVariables>(GetHelloDocument, options);
      }
export function useGetHelloLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHelloQuery, GetHelloQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHelloQuery, GetHelloQueryVariables>(GetHelloDocument, options);
        }
// @ts-ignore
export function useGetHelloSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHelloQuery, GetHelloQueryVariables>): Apollo.UseSuspenseQueryResult<GetHelloQuery, GetHelloQueryVariables>;
export function useGetHelloSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHelloQuery, GetHelloQueryVariables>): Apollo.UseSuspenseQueryResult<GetHelloQuery | undefined, GetHelloQueryVariables>;
export function useGetHelloSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHelloQuery, GetHelloQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHelloQuery, GetHelloQueryVariables>(GetHelloDocument, options);
        }
export type GetHelloQueryHookResult = ReturnType<typeof useGetHelloQuery>;
export type GetHelloLazyQueryHookResult = ReturnType<typeof useGetHelloLazyQuery>;
export type GetHelloSuspenseQueryHookResult = ReturnType<typeof useGetHelloSuspenseQuery>;
export type GetHelloQueryResult = Apollo.QueryResult<GetHelloQuery, GetHelloQueryVariables>;
export const GetSearchAtomsDocument = gql`
    query GetSearchAtoms($query: String!, $organizationId: UUID!, $atomType: AtomTypeType = null, $limit: Int! = 20) {
  searchAtoms(
    query: $query
    organizationId: $organizationId
    atomType: $atomType
    limit: $limit
  ) {
    id
    title
    fullContent
    contentFormat
    sourceType
    sourceId
    filePath
    fileType
    fileSize
    status
    processingError
    processingProgress
    processedAt
    atomType
    category
    tags
    organizationId
    clientId
    projectId
    industryId
    metaInfo
    isVectorized
    embeddingModel
    viewCount
    usageCount
    qualityScore
    lastUsedAt
    createdBy
    updatedBy
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetSearchAtomsQuery__
 *
 * To run a query within a React component, call `useGetSearchAtomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchAtomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchAtomsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      organizationId: // value for 'organizationId'
 *      atomType: // value for 'atomType'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSearchAtomsQuery(baseOptions: Apollo.QueryHookOptions<GetSearchAtomsQuery, GetSearchAtomsQueryVariables> & ({ variables: GetSearchAtomsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchAtomsQuery, GetSearchAtomsQueryVariables>(GetSearchAtomsDocument, options);
      }
export function useGetSearchAtomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchAtomsQuery, GetSearchAtomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchAtomsQuery, GetSearchAtomsQueryVariables>(GetSearchAtomsDocument, options);
        }
// @ts-ignore
export function useGetSearchAtomsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSearchAtomsQuery, GetSearchAtomsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSearchAtomsQuery, GetSearchAtomsQueryVariables>;
export function useGetSearchAtomsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchAtomsQuery, GetSearchAtomsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSearchAtomsQuery | undefined, GetSearchAtomsQueryVariables>;
export function useGetSearchAtomsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchAtomsQuery, GetSearchAtomsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchAtomsQuery, GetSearchAtomsQueryVariables>(GetSearchAtomsDocument, options);
        }
export type GetSearchAtomsQueryHookResult = ReturnType<typeof useGetSearchAtomsQuery>;
export type GetSearchAtomsLazyQueryHookResult = ReturnType<typeof useGetSearchAtomsLazyQuery>;
export type GetSearchAtomsSuspenseQueryHookResult = ReturnType<typeof useGetSearchAtomsSuspenseQuery>;
export type GetSearchAtomsQueryResult = Apollo.QueryResult<GetSearchAtomsQuery, GetSearchAtomsQueryVariables>;
export const GetObserverPluginsDocument = gql`
    query GetObserverPlugins($pluginType: String = null, $isActive: Boolean = null) {
  observerPlugins(pluginType: $pluginType, isActive: $isActive) {
    id
    name
    code
    description
    pluginType
    configuration
    isActive
    version
    author
  }
}
    `;

/**
 * __useGetObserverPluginsQuery__
 *
 * To run a query within a React component, call `useGetObserverPluginsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetObserverPluginsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetObserverPluginsQuery({
 *   variables: {
 *      pluginType: // value for 'pluginType'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useGetObserverPluginsQuery(baseOptions?: Apollo.QueryHookOptions<GetObserverPluginsQuery, GetObserverPluginsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetObserverPluginsQuery, GetObserverPluginsQueryVariables>(GetObserverPluginsDocument, options);
      }
export function useGetObserverPluginsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetObserverPluginsQuery, GetObserverPluginsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetObserverPluginsQuery, GetObserverPluginsQueryVariables>(GetObserverPluginsDocument, options);
        }
// @ts-ignore
export function useGetObserverPluginsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetObserverPluginsQuery, GetObserverPluginsQueryVariables>): Apollo.UseSuspenseQueryResult<GetObserverPluginsQuery, GetObserverPluginsQueryVariables>;
export function useGetObserverPluginsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetObserverPluginsQuery, GetObserverPluginsQueryVariables>): Apollo.UseSuspenseQueryResult<GetObserverPluginsQuery | undefined, GetObserverPluginsQueryVariables>;
export function useGetObserverPluginsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetObserverPluginsQuery, GetObserverPluginsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetObserverPluginsQuery, GetObserverPluginsQueryVariables>(GetObserverPluginsDocument, options);
        }
export type GetObserverPluginsQueryHookResult = ReturnType<typeof useGetObserverPluginsQuery>;
export type GetObserverPluginsLazyQueryHookResult = ReturnType<typeof useGetObserverPluginsLazyQuery>;
export type GetObserverPluginsSuspenseQueryHookResult = ReturnType<typeof useGetObserverPluginsSuspenseQuery>;
export type GetObserverPluginsQueryResult = Apollo.QueryResult<GetObserverPluginsQuery, GetObserverPluginsQueryVariables>;
export const GetCollectedItemsDocument = gql`
    query GetCollectedItems($sourceId: UUID!, $filter: CollectedItemFilterInput = null, $limit: Int! = 50, $offset: Int! = 0) {
  collectedItems(
    sourceId: $sourceId
    filter: $filter
    limit: $limit
    offset: $offset
  ) {
    items {
      id
      sourceId
      entityType
      entityId
      title
      content
      summary
      sourceUrl
      publishedAt
      contentType
      categories
      tags
      contextAnalysis
      relevanceScore
      status
      processedAt
      atomId
      metadata
      createdAt
      updatedAt
    }
    totalCount
    hasNextPage
    hasPreviousPage
  }
}
    `;

/**
 * __useGetCollectedItemsQuery__
 *
 * To run a query within a React component, call `useGetCollectedItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectedItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectedItemsQuery({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetCollectedItemsQuery(baseOptions: Apollo.QueryHookOptions<GetCollectedItemsQuery, GetCollectedItemsQueryVariables> & ({ variables: GetCollectedItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCollectedItemsQuery, GetCollectedItemsQueryVariables>(GetCollectedItemsDocument, options);
      }
export function useGetCollectedItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCollectedItemsQuery, GetCollectedItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCollectedItemsQuery, GetCollectedItemsQueryVariables>(GetCollectedItemsDocument, options);
        }
// @ts-ignore
export function useGetCollectedItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCollectedItemsQuery, GetCollectedItemsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCollectedItemsQuery, GetCollectedItemsQueryVariables>;
export function useGetCollectedItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCollectedItemsQuery, GetCollectedItemsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCollectedItemsQuery | undefined, GetCollectedItemsQueryVariables>;
export function useGetCollectedItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCollectedItemsQuery, GetCollectedItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCollectedItemsQuery, GetCollectedItemsQueryVariables>(GetCollectedItemsDocument, options);
        }
export type GetCollectedItemsQueryHookResult = ReturnType<typeof useGetCollectedItemsQuery>;
export type GetCollectedItemsLazyQueryHookResult = ReturnType<typeof useGetCollectedItemsLazyQuery>;
export type GetCollectedItemsSuspenseQueryHookResult = ReturnType<typeof useGetCollectedItemsSuspenseQuery>;
export type GetCollectedItemsQueryResult = Apollo.QueryResult<GetCollectedItemsQuery, GetCollectedItemsQueryVariables>;
export const GetScopeDetailDocument = gql`
    query GetScopeDetail($scopeId: UUID!) {
  scopeDetail(scopeId: $scopeId) {
    id
    name
    origin
    rationale
    searchQuery
    boostKeywords
    analysisLens
    projectId
    viewId
    focusAtomIds
    createdAt
    plan
    functionCandidates {
      name
      category
      description
      priority
      source
    }
  }
}
    `;

/**
 * __useGetScopeDetailQuery__
 *
 * To run a query within a React component, call `useGetScopeDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScopeDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScopeDetailQuery({
 *   variables: {
 *      scopeId: // value for 'scopeId'
 *   },
 * });
 */
export function useGetScopeDetailQuery(baseOptions: Apollo.QueryHookOptions<GetScopeDetailQuery, GetScopeDetailQueryVariables> & ({ variables: GetScopeDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScopeDetailQuery, GetScopeDetailQueryVariables>(GetScopeDetailDocument, options);
      }
export function useGetScopeDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScopeDetailQuery, GetScopeDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScopeDetailQuery, GetScopeDetailQueryVariables>(GetScopeDetailDocument, options);
        }
// @ts-ignore
export function useGetScopeDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetScopeDetailQuery, GetScopeDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetScopeDetailQuery, GetScopeDetailQueryVariables>;
export function useGetScopeDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetScopeDetailQuery, GetScopeDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetScopeDetailQuery | undefined, GetScopeDetailQueryVariables>;
export function useGetScopeDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetScopeDetailQuery, GetScopeDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetScopeDetailQuery, GetScopeDetailQueryVariables>(GetScopeDetailDocument, options);
        }
export type GetScopeDetailQueryHookResult = ReturnType<typeof useGetScopeDetailQuery>;
export type GetScopeDetailLazyQueryHookResult = ReturnType<typeof useGetScopeDetailLazyQuery>;
export type GetScopeDetailSuspenseQueryHookResult = ReturnType<typeof useGetScopeDetailSuspenseQuery>;
export type GetScopeDetailQueryResult = Apollo.QueryResult<GetScopeDetailQuery, GetScopeDetailQueryVariables>;
export const GetViewDetailDocument = gql`
    query GetViewDetail($viewId: UUID!) {
  viewDetail(viewId: $viewId) {
    id
    projectId
    sourceType
    analysisSummary
    analysisResult
    sourceAtomIds
    scopeId
    generatedAt
  }
}
    `;

/**
 * __useGetViewDetailQuery__
 *
 * To run a query within a React component, call `useGetViewDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewDetailQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *   },
 * });
 */
export function useGetViewDetailQuery(baseOptions: Apollo.QueryHookOptions<GetViewDetailQuery, GetViewDetailQueryVariables> & ({ variables: GetViewDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetViewDetailQuery, GetViewDetailQueryVariables>(GetViewDetailDocument, options);
      }
export function useGetViewDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetViewDetailQuery, GetViewDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetViewDetailQuery, GetViewDetailQueryVariables>(GetViewDetailDocument, options);
        }
// @ts-ignore
export function useGetViewDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetViewDetailQuery, GetViewDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetViewDetailQuery, GetViewDetailQueryVariables>;
export function useGetViewDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetViewDetailQuery, GetViewDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetViewDetailQuery | undefined, GetViewDetailQueryVariables>;
export function useGetViewDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetViewDetailQuery, GetViewDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetViewDetailQuery, GetViewDetailQueryVariables>(GetViewDetailDocument, options);
        }
export type GetViewDetailQueryHookResult = ReturnType<typeof useGetViewDetailQuery>;
export type GetViewDetailLazyQueryHookResult = ReturnType<typeof useGetViewDetailLazyQuery>;
export type GetViewDetailSuspenseQueryHookResult = ReturnType<typeof useGetViewDetailSuspenseQuery>;
export type GetViewDetailQueryResult = Apollo.QueryResult<GetViewDetailQuery, GetViewDetailQueryVariables>;
export const GetUiGenerationResultDocument = gql`
    query GetUiGenerationResult($projectId: String!) {
  uiGenerationResult(projectId: $projectId) {
    success
    projectPath
    totalFiles
    totalLines
    qualityScore
    generationTime
    uiMockUrl
    errors
    warnings
  }
}
    `;

/**
 * __useGetUiGenerationResultQuery__
 *
 * To run a query within a React component, call `useGetUiGenerationResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUiGenerationResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUiGenerationResultQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetUiGenerationResultQuery(baseOptions: Apollo.QueryHookOptions<GetUiGenerationResultQuery, GetUiGenerationResultQueryVariables> & ({ variables: GetUiGenerationResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUiGenerationResultQuery, GetUiGenerationResultQueryVariables>(GetUiGenerationResultDocument, options);
      }
export function useGetUiGenerationResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUiGenerationResultQuery, GetUiGenerationResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUiGenerationResultQuery, GetUiGenerationResultQueryVariables>(GetUiGenerationResultDocument, options);
        }
// @ts-ignore
export function useGetUiGenerationResultSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUiGenerationResultQuery, GetUiGenerationResultQueryVariables>): Apollo.UseSuspenseQueryResult<GetUiGenerationResultQuery, GetUiGenerationResultQueryVariables>;
export function useGetUiGenerationResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUiGenerationResultQuery, GetUiGenerationResultQueryVariables>): Apollo.UseSuspenseQueryResult<GetUiGenerationResultQuery | undefined, GetUiGenerationResultQueryVariables>;
export function useGetUiGenerationResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUiGenerationResultQuery, GetUiGenerationResultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUiGenerationResultQuery, GetUiGenerationResultQueryVariables>(GetUiGenerationResultDocument, options);
        }
export type GetUiGenerationResultQueryHookResult = ReturnType<typeof useGetUiGenerationResultQuery>;
export type GetUiGenerationResultLazyQueryHookResult = ReturnType<typeof useGetUiGenerationResultLazyQuery>;
export type GetUiGenerationResultSuspenseQueryHookResult = ReturnType<typeof useGetUiGenerationResultSuspenseQuery>;
export type GetUiGenerationResultQueryResult = Apollo.QueryResult<GetUiGenerationResultQuery, GetUiGenerationResultQueryVariables>;
export const GetPageDesignsDocument = gql`
    query GetPageDesigns($projectId: ID!) {
  pageDesigns(projectId: $projectId) {
    id
    projectId
    pagePath
    pageName
    sectionName
    status
    errorMessage
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetPageDesignsQuery__
 *
 * To run a query within a React component, call `useGetPageDesignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageDesignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageDesignsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetPageDesignsQuery(baseOptions: Apollo.QueryHookOptions<GetPageDesignsQuery, GetPageDesignsQueryVariables> & ({ variables: GetPageDesignsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageDesignsQuery, GetPageDesignsQueryVariables>(GetPageDesignsDocument, options);
      }
export function useGetPageDesignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageDesignsQuery, GetPageDesignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageDesignsQuery, GetPageDesignsQueryVariables>(GetPageDesignsDocument, options);
        }
// @ts-ignore
export function useGetPageDesignsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPageDesignsQuery, GetPageDesignsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPageDesignsQuery, GetPageDesignsQueryVariables>;
export function useGetPageDesignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPageDesignsQuery, GetPageDesignsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPageDesignsQuery | undefined, GetPageDesignsQueryVariables>;
export function useGetPageDesignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPageDesignsQuery, GetPageDesignsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPageDesignsQuery, GetPageDesignsQueryVariables>(GetPageDesignsDocument, options);
        }
export type GetPageDesignsQueryHookResult = ReturnType<typeof useGetPageDesignsQuery>;
export type GetPageDesignsLazyQueryHookResult = ReturnType<typeof useGetPageDesignsLazyQuery>;
export type GetPageDesignsSuspenseQueryHookResult = ReturnType<typeof useGetPageDesignsSuspenseQuery>;
export type GetPageDesignsQueryResult = Apollo.QueryResult<GetPageDesignsQuery, GetPageDesignsQueryVariables>;
export const GetPageDesignPreviewHtmlDocument = gql`
    query GetPageDesignPreviewHtml($designId: ID!) {
  pageDesignPreviewHtml(designId: $designId)
}
    `;

/**
 * __useGetPageDesignPreviewHtmlQuery__
 *
 * To run a query within a React component, call `useGetPageDesignPreviewHtmlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageDesignPreviewHtmlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageDesignPreviewHtmlQuery({
 *   variables: {
 *      designId: // value for 'designId'
 *   },
 * });
 */
export function useGetPageDesignPreviewHtmlQuery(baseOptions: Apollo.QueryHookOptions<GetPageDesignPreviewHtmlQuery, GetPageDesignPreviewHtmlQueryVariables> & ({ variables: GetPageDesignPreviewHtmlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageDesignPreviewHtmlQuery, GetPageDesignPreviewHtmlQueryVariables>(GetPageDesignPreviewHtmlDocument, options);
      }
export function useGetPageDesignPreviewHtmlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageDesignPreviewHtmlQuery, GetPageDesignPreviewHtmlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageDesignPreviewHtmlQuery, GetPageDesignPreviewHtmlQueryVariables>(GetPageDesignPreviewHtmlDocument, options);
        }
// @ts-ignore
export function useGetPageDesignPreviewHtmlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPageDesignPreviewHtmlQuery, GetPageDesignPreviewHtmlQueryVariables>): Apollo.UseSuspenseQueryResult<GetPageDesignPreviewHtmlQuery, GetPageDesignPreviewHtmlQueryVariables>;
export function useGetPageDesignPreviewHtmlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPageDesignPreviewHtmlQuery, GetPageDesignPreviewHtmlQueryVariables>): Apollo.UseSuspenseQueryResult<GetPageDesignPreviewHtmlQuery | undefined, GetPageDesignPreviewHtmlQueryVariables>;
export function useGetPageDesignPreviewHtmlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPageDesignPreviewHtmlQuery, GetPageDesignPreviewHtmlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPageDesignPreviewHtmlQuery, GetPageDesignPreviewHtmlQueryVariables>(GetPageDesignPreviewHtmlDocument, options);
        }
export type GetPageDesignPreviewHtmlQueryHookResult = ReturnType<typeof useGetPageDesignPreviewHtmlQuery>;
export type GetPageDesignPreviewHtmlLazyQueryHookResult = ReturnType<typeof useGetPageDesignPreviewHtmlLazyQuery>;
export type GetPageDesignPreviewHtmlSuspenseQueryHookResult = ReturnType<typeof useGetPageDesignPreviewHtmlSuspenseQuery>;
export type GetPageDesignPreviewHtmlQueryResult = Apollo.QueryResult<GetPageDesignPreviewHtmlQuery, GetPageDesignPreviewHtmlQueryVariables>;
export const GetDeploymentDocument = gql`
    query GetDeployment($deploymentId: String!) {
  deployment(deploymentId: $deploymentId) {
    id
    projectId
    artifactId
    createdBy
    name
    providerType
    status
    currentStage
    pipelineProgress
    liveUrl
    githubRepoUrl
    errorMessage
    retryCount
    progressPercentage
    createdAt
    startedAt
    completedAt
  }
}
    `;

/**
 * __useGetDeploymentQuery__
 *
 * To run a query within a React component, call `useGetDeploymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeploymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeploymentQuery({
 *   variables: {
 *      deploymentId: // value for 'deploymentId'
 *   },
 * });
 */
export function useGetDeploymentQuery(baseOptions: Apollo.QueryHookOptions<GetDeploymentQuery, GetDeploymentQueryVariables> & ({ variables: GetDeploymentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeploymentQuery, GetDeploymentQueryVariables>(GetDeploymentDocument, options);
      }
export function useGetDeploymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeploymentQuery, GetDeploymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeploymentQuery, GetDeploymentQueryVariables>(GetDeploymentDocument, options);
        }
// @ts-ignore
export function useGetDeploymentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDeploymentQuery, GetDeploymentQueryVariables>): Apollo.UseSuspenseQueryResult<GetDeploymentQuery, GetDeploymentQueryVariables>;
export function useGetDeploymentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeploymentQuery, GetDeploymentQueryVariables>): Apollo.UseSuspenseQueryResult<GetDeploymentQuery | undefined, GetDeploymentQueryVariables>;
export function useGetDeploymentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeploymentQuery, GetDeploymentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDeploymentQuery, GetDeploymentQueryVariables>(GetDeploymentDocument, options);
        }
export type GetDeploymentQueryHookResult = ReturnType<typeof useGetDeploymentQuery>;
export type GetDeploymentLazyQueryHookResult = ReturnType<typeof useGetDeploymentLazyQuery>;
export type GetDeploymentSuspenseQueryHookResult = ReturnType<typeof useGetDeploymentSuspenseQuery>;
export type GetDeploymentQueryResult = Apollo.QueryResult<GetDeploymentQuery, GetDeploymentQueryVariables>;
export const GetLatestDeploymentDocument = gql`
    query GetLatestDeployment($projectId: String!) {
  latestDeployment(projectId: $projectId) {
    id
    projectId
    artifactId
    createdBy
    name
    providerType
    status
    currentStage
    pipelineProgress
    liveUrl
    githubRepoUrl
    errorMessage
    retryCount
    progressPercentage
    createdAt
    startedAt
    completedAt
  }
}
    `;

/**
 * __useGetLatestDeploymentQuery__
 *
 * To run a query within a React component, call `useGetLatestDeploymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestDeploymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestDeploymentQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetLatestDeploymentQuery(baseOptions: Apollo.QueryHookOptions<GetLatestDeploymentQuery, GetLatestDeploymentQueryVariables> & ({ variables: GetLatestDeploymentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestDeploymentQuery, GetLatestDeploymentQueryVariables>(GetLatestDeploymentDocument, options);
      }
export function useGetLatestDeploymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestDeploymentQuery, GetLatestDeploymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestDeploymentQuery, GetLatestDeploymentQueryVariables>(GetLatestDeploymentDocument, options);
        }
// @ts-ignore
export function useGetLatestDeploymentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLatestDeploymentQuery, GetLatestDeploymentQueryVariables>): Apollo.UseSuspenseQueryResult<GetLatestDeploymentQuery, GetLatestDeploymentQueryVariables>;
export function useGetLatestDeploymentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLatestDeploymentQuery, GetLatestDeploymentQueryVariables>): Apollo.UseSuspenseQueryResult<GetLatestDeploymentQuery | undefined, GetLatestDeploymentQueryVariables>;
export function useGetLatestDeploymentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLatestDeploymentQuery, GetLatestDeploymentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLatestDeploymentQuery, GetLatestDeploymentQueryVariables>(GetLatestDeploymentDocument, options);
        }
export type GetLatestDeploymentQueryHookResult = ReturnType<typeof useGetLatestDeploymentQuery>;
export type GetLatestDeploymentLazyQueryHookResult = ReturnType<typeof useGetLatestDeploymentLazyQuery>;
export type GetLatestDeploymentSuspenseQueryHookResult = ReturnType<typeof useGetLatestDeploymentSuspenseQuery>;
export type GetLatestDeploymentQueryResult = Apollo.QueryResult<GetLatestDeploymentQuery, GetLatestDeploymentQueryVariables>;
export const GetDeploymentConfigDocument = gql`
    query GetDeploymentConfig($projectId: String!) {
  deploymentConfig(projectId: $projectId) {
    providerType
    githubTokenSet
    githubOwner
    githubRepoName
    vpsHost
    vpsPort
    vpsUsername
    vpsAuthMethod
    vpsPasswordSet
    vpsSshKeySet
    domain
  }
}
    `;

/**
 * __useGetDeploymentConfigQuery__
 *
 * To run a query within a React component, call `useGetDeploymentConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeploymentConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeploymentConfigQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetDeploymentConfigQuery(baseOptions: Apollo.QueryHookOptions<GetDeploymentConfigQuery, GetDeploymentConfigQueryVariables> & ({ variables: GetDeploymentConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeploymentConfigQuery, GetDeploymentConfigQueryVariables>(GetDeploymentConfigDocument, options);
      }
export function useGetDeploymentConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeploymentConfigQuery, GetDeploymentConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeploymentConfigQuery, GetDeploymentConfigQueryVariables>(GetDeploymentConfigDocument, options);
        }
// @ts-ignore
export function useGetDeploymentConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDeploymentConfigQuery, GetDeploymentConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetDeploymentConfigQuery, GetDeploymentConfigQueryVariables>;
export function useGetDeploymentConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeploymentConfigQuery, GetDeploymentConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetDeploymentConfigQuery | undefined, GetDeploymentConfigQueryVariables>;
export function useGetDeploymentConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeploymentConfigQuery, GetDeploymentConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDeploymentConfigQuery, GetDeploymentConfigQueryVariables>(GetDeploymentConfigDocument, options);
        }
export type GetDeploymentConfigQueryHookResult = ReturnType<typeof useGetDeploymentConfigQuery>;
export type GetDeploymentConfigLazyQueryHookResult = ReturnType<typeof useGetDeploymentConfigLazyQuery>;
export type GetDeploymentConfigSuspenseQueryHookResult = ReturnType<typeof useGetDeploymentConfigSuspenseQuery>;
export type GetDeploymentConfigQueryResult = Apollo.QueryResult<GetDeploymentConfigQuery, GetDeploymentConfigQueryVariables>;
export const GetApiCatalogByServiceNameDocument = gql`
    query GetApiCatalogByServiceName($serviceName: String!) {
  apiCatalogByServiceName(serviceName: $serviceName) {
    id
    organizationId
    projectId
    serviceName
    provider
    apiVersion
    crawlStatus
    crawlError
    crawlStartedAt
    crawlCompletedAt
    apiOverview {
      baseUrl
      authType
      authDetails
      rateLimits
      description
    }
    endpoints {
      method
      path
      description
      parameters
      requestBody
      responseSchema
      authRequired
      deprecated
    }
    implementationKnowledge
    groundingSources
    documentationUrls
    endpointCount
    verification {
      status
      confidenceScore
      baseUrlVerified
      baseUrlCorrect
      authTypeVerified
      authTypeCorrect
      verificationSources
      errorMessage
      verifiedAt
      endpointVerdicts {
        method
        path
        exists
        notes
      }
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetApiCatalogByServiceNameQuery__
 *
 * To run a query within a React component, call `useGetApiCatalogByServiceNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiCatalogByServiceNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiCatalogByServiceNameQuery({
 *   variables: {
 *      serviceName: // value for 'serviceName'
 *   },
 * });
 */
export function useGetApiCatalogByServiceNameQuery(baseOptions: Apollo.QueryHookOptions<GetApiCatalogByServiceNameQuery, GetApiCatalogByServiceNameQueryVariables> & ({ variables: GetApiCatalogByServiceNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApiCatalogByServiceNameQuery, GetApiCatalogByServiceNameQueryVariables>(GetApiCatalogByServiceNameDocument, options);
      }
export function useGetApiCatalogByServiceNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApiCatalogByServiceNameQuery, GetApiCatalogByServiceNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApiCatalogByServiceNameQuery, GetApiCatalogByServiceNameQueryVariables>(GetApiCatalogByServiceNameDocument, options);
        }
// @ts-ignore
export function useGetApiCatalogByServiceNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetApiCatalogByServiceNameQuery, GetApiCatalogByServiceNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetApiCatalogByServiceNameQuery, GetApiCatalogByServiceNameQueryVariables>;
export function useGetApiCatalogByServiceNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApiCatalogByServiceNameQuery, GetApiCatalogByServiceNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetApiCatalogByServiceNameQuery | undefined, GetApiCatalogByServiceNameQueryVariables>;
export function useGetApiCatalogByServiceNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetApiCatalogByServiceNameQuery, GetApiCatalogByServiceNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetApiCatalogByServiceNameQuery, GetApiCatalogByServiceNameQueryVariables>(GetApiCatalogByServiceNameDocument, options);
        }
export type GetApiCatalogByServiceNameQueryHookResult = ReturnType<typeof useGetApiCatalogByServiceNameQuery>;
export type GetApiCatalogByServiceNameLazyQueryHookResult = ReturnType<typeof useGetApiCatalogByServiceNameLazyQuery>;
export type GetApiCatalogByServiceNameSuspenseQueryHookResult = ReturnType<typeof useGetApiCatalogByServiceNameSuspenseQuery>;
export type GetApiCatalogByServiceNameQueryResult = Apollo.QueryResult<GetApiCatalogByServiceNameQuery, GetApiCatalogByServiceNameQueryVariables>;
export const GetAvailableBcsDocument = gql`
    query GetAvailableBcs {
  availableBcs {
    name
    nameJa
    entities
    entityNamesJa
    description
  }
}
    `;

/**
 * __useGetAvailableBcsQuery__
 *
 * To run a query within a React component, call `useGetAvailableBcsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableBcsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableBcsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableBcsQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableBcsQuery, GetAvailableBcsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableBcsQuery, GetAvailableBcsQueryVariables>(GetAvailableBcsDocument, options);
      }
export function useGetAvailableBcsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableBcsQuery, GetAvailableBcsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableBcsQuery, GetAvailableBcsQueryVariables>(GetAvailableBcsDocument, options);
        }
// @ts-ignore
export function useGetAvailableBcsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAvailableBcsQuery, GetAvailableBcsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAvailableBcsQuery, GetAvailableBcsQueryVariables>;
export function useGetAvailableBcsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableBcsQuery, GetAvailableBcsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAvailableBcsQuery | undefined, GetAvailableBcsQueryVariables>;
export function useGetAvailableBcsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableBcsQuery, GetAvailableBcsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableBcsQuery, GetAvailableBcsQueryVariables>(GetAvailableBcsDocument, options);
        }
export type GetAvailableBcsQueryHookResult = ReturnType<typeof useGetAvailableBcsQuery>;
export type GetAvailableBcsLazyQueryHookResult = ReturnType<typeof useGetAvailableBcsLazyQuery>;
export type GetAvailableBcsSuspenseQueryHookResult = ReturnType<typeof useGetAvailableBcsSuspenseQuery>;
export type GetAvailableBcsQueryResult = Apollo.QueryResult<GetAvailableBcsQuery, GetAvailableBcsQueryVariables>;
export const GetAvailableScenesDocument = gql`
    query GetAvailableScenes {
  availableScenes {
    name
    nameJa
    description
    industry
    isPublic
    isDefaultEnabled
    bcNames
  }
}
    `;

/**
 * __useGetAvailableScenesQuery__
 *
 * To run a query within a React component, call `useGetAvailableScenesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableScenesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableScenesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableScenesQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableScenesQuery, GetAvailableScenesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableScenesQuery, GetAvailableScenesQueryVariables>(GetAvailableScenesDocument, options);
      }
export function useGetAvailableScenesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableScenesQuery, GetAvailableScenesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableScenesQuery, GetAvailableScenesQueryVariables>(GetAvailableScenesDocument, options);
        }
// @ts-ignore
export function useGetAvailableScenesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAvailableScenesQuery, GetAvailableScenesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAvailableScenesQuery, GetAvailableScenesQueryVariables>;
export function useGetAvailableScenesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableScenesQuery, GetAvailableScenesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAvailableScenesQuery | undefined, GetAvailableScenesQueryVariables>;
export function useGetAvailableScenesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableScenesQuery, GetAvailableScenesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableScenesQuery, GetAvailableScenesQueryVariables>(GetAvailableScenesDocument, options);
        }
export type GetAvailableScenesQueryHookResult = ReturnType<typeof useGetAvailableScenesQuery>;
export type GetAvailableScenesLazyQueryHookResult = ReturnType<typeof useGetAvailableScenesLazyQuery>;
export type GetAvailableScenesSuspenseQueryHookResult = ReturnType<typeof useGetAvailableScenesSuspenseQuery>;
export type GetAvailableScenesQueryResult = Apollo.QueryResult<GetAvailableScenesQuery, GetAvailableScenesQueryVariables>;
export const GenerateProjectFromContextDocument = gql`
    mutation GenerateProjectFromContext($input: NLProjectFromContextInput!) {
  generateProjectFromContext(input: $input) {
    success
    projectName
    projectNameJa
    bcNames
    dynamicBcNames
    features {
      name
      description
      category
      priority
      likelyBcMatch
    }
    mapping {
      matched {
        bcName
        confidence
        matchedFeatures
        reason
      }
      unmatchedFeatures {
        name
        description
        category
        priority
        likelyBcMatch
      }
    }
    outputDir
    totalFiles
    generationTimeSeconds
    error
  }
}
    `;
export type GenerateProjectFromContextMutationFn = Apollo.MutationFunction<GenerateProjectFromContextMutation, GenerateProjectFromContextMutationVariables>;

/**
 * __useGenerateProjectFromContextMutation__
 *
 * To run a mutation, you first call `useGenerateProjectFromContextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateProjectFromContextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateProjectFromContextMutation, { data, loading, error }] = useGenerateProjectFromContextMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateProjectFromContextMutation(baseOptions?: Apollo.MutationHookOptions<GenerateProjectFromContextMutation, GenerateProjectFromContextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateProjectFromContextMutation, GenerateProjectFromContextMutationVariables>(GenerateProjectFromContextDocument, options);
      }
export type GenerateProjectFromContextMutationHookResult = ReturnType<typeof useGenerateProjectFromContextMutation>;
export type GenerateProjectFromContextMutationResult = Apollo.MutationResult<GenerateProjectFromContextMutation>;
export type GenerateProjectFromContextMutationOptions = Apollo.BaseMutationOptions<GenerateProjectFromContextMutation, GenerateProjectFromContextMutationVariables>;
export const GetGeneratedSystemsDocument = gql`
    query GetGeneratedSystems($projectId: String) {
  generatedSystems(projectId: $projectId) {
    id
    projectId
    systemName
    systemNameJa
    bcNames
    dynamicBcNames
    outputDir
    totalFiles
    generationTimeSeconds
    backendUrl
    adminUrl
    frontendUrl
    sysadminUrl
    status
    createdAt
    adminEmail
    adminPassword
    systemAdminEmail
    systemAdminPassword
  }
}
    `;

/**
 * __useGetGeneratedSystemsQuery__
 *
 * To run a query within a React component, call `useGetGeneratedSystemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneratedSystemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeneratedSystemsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetGeneratedSystemsQuery(baseOptions?: Apollo.QueryHookOptions<GetGeneratedSystemsQuery, GetGeneratedSystemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeneratedSystemsQuery, GetGeneratedSystemsQueryVariables>(GetGeneratedSystemsDocument, options);
      }
export function useGetGeneratedSystemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGeneratedSystemsQuery, GetGeneratedSystemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeneratedSystemsQuery, GetGeneratedSystemsQueryVariables>(GetGeneratedSystemsDocument, options);
        }
// @ts-ignore
export function useGetGeneratedSystemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGeneratedSystemsQuery, GetGeneratedSystemsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGeneratedSystemsQuery, GetGeneratedSystemsQueryVariables>;
export function useGetGeneratedSystemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGeneratedSystemsQuery, GetGeneratedSystemsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGeneratedSystemsQuery | undefined, GetGeneratedSystemsQueryVariables>;
export function useGetGeneratedSystemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGeneratedSystemsQuery, GetGeneratedSystemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGeneratedSystemsQuery, GetGeneratedSystemsQueryVariables>(GetGeneratedSystemsDocument, options);
        }
export type GetGeneratedSystemsQueryHookResult = ReturnType<typeof useGetGeneratedSystemsQuery>;
export type GetGeneratedSystemsLazyQueryHookResult = ReturnType<typeof useGetGeneratedSystemsLazyQuery>;
export type GetGeneratedSystemsSuspenseQueryHookResult = ReturnType<typeof useGetGeneratedSystemsSuspenseQuery>;
export type GetGeneratedSystemsQueryResult = Apollo.QueryResult<GetGeneratedSystemsQuery, GetGeneratedSystemsQueryVariables>;
export const GenerateProjectFromDescriptionDocument = gql`
    mutation GenerateProjectFromDescription($input: NLProjectInput!) {
  generateProjectFromDescription(input: $input) {
    success
    projectName
    projectNameJa
    bcNames
    dynamicBcNames
    features {
      name
      description
      category
      priority
      likelyBcMatch
    }
    mapping {
      matched {
        bcName
        confidence
        matchedFeatures
        reason
      }
      unmatchedFeatures {
        name
        description
        category
        priority
        likelyBcMatch
      }
    }
    outputDir
    totalFiles
    generationTimeSeconds
    error
  }
}
    `;
export type GenerateProjectFromDescriptionMutationFn = Apollo.MutationFunction<GenerateProjectFromDescriptionMutation, GenerateProjectFromDescriptionMutationVariables>;

/**
 * __useGenerateProjectFromDescriptionMutation__
 *
 * To run a mutation, you first call `useGenerateProjectFromDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateProjectFromDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateProjectFromDescriptionMutation, { data, loading, error }] = useGenerateProjectFromDescriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateProjectFromDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<GenerateProjectFromDescriptionMutation, GenerateProjectFromDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateProjectFromDescriptionMutation, GenerateProjectFromDescriptionMutationVariables>(GenerateProjectFromDescriptionDocument, options);
      }
export type GenerateProjectFromDescriptionMutationHookResult = ReturnType<typeof useGenerateProjectFromDescriptionMutation>;
export type GenerateProjectFromDescriptionMutationResult = Apollo.MutationResult<GenerateProjectFromDescriptionMutation>;
export type GenerateProjectFromDescriptionMutationOptions = Apollo.BaseMutationOptions<GenerateProjectFromDescriptionMutation, GenerateProjectFromDescriptionMutationVariables>;
export const RegenerateFromSnapshotDocument = gql`
    mutation RegenerateFromSnapshot($snapshotId: ID!, $systemInstanceId: ID!) {
  regenerateFromSnapshot(
    snapshotId: $snapshotId
    systemInstanceId: $systemInstanceId
  ) {
    success
    snapshotId
    systemInstanceId
    bcSetLoaded
    errorMessage
  }
}
    `;
export type RegenerateFromSnapshotMutationFn = Apollo.MutationFunction<RegenerateFromSnapshotMutation, RegenerateFromSnapshotMutationVariables>;

/**
 * __useRegenerateFromSnapshotMutation__
 *
 * To run a mutation, you first call `useRegenerateFromSnapshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateFromSnapshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateFromSnapshotMutation, { data, loading, error }] = useRegenerateFromSnapshotMutation({
 *   variables: {
 *      snapshotId: // value for 'snapshotId'
 *      systemInstanceId: // value for 'systemInstanceId'
 *   },
 * });
 */
export function useRegenerateFromSnapshotMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateFromSnapshotMutation, RegenerateFromSnapshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateFromSnapshotMutation, RegenerateFromSnapshotMutationVariables>(RegenerateFromSnapshotDocument, options);
      }
export type RegenerateFromSnapshotMutationHookResult = ReturnType<typeof useRegenerateFromSnapshotMutation>;
export type RegenerateFromSnapshotMutationResult = Apollo.MutationResult<RegenerateFromSnapshotMutation>;
export type RegenerateFromSnapshotMutationOptions = Apollo.BaseMutationOptions<RegenerateFromSnapshotMutation, RegenerateFromSnapshotMutationVariables>;
export const CreateOrganizationDocument = gql`
    mutation CreateOrganization($input: CreateOrganizationInput!) {
  createOrganization(input: $input) {
    id
    name
    slug
    domain
    description
    billingEmail
    billingAddress
    billingContact
    taxId
    planType
    maxUsers
    maxClients
    maxProjects
    storageLimitGb
    sharedKnowledgeEnabled
    requireEmailVerification
    isActive
    isVerified
    createdAt
    updatedAt
    isFreePlan
    isEnterprisePlan
    activeUserCount
    activeProjectCount
    storageUsageGb
  }
}
    `;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation UpdateOrganization($id: UUID!, $input: UpdateOrganizationInput!) {
  updateOrganization(id: $id, input: $input) {
    id
    name
    slug
    domain
    description
    billingEmail
    billingAddress
    billingContact
    taxId
    planType
    maxUsers
    maxClients
    maxProjects
    storageLimitGb
    sharedKnowledgeEnabled
    requireEmailVerification
    isActive
    isVerified
    createdAt
    updatedAt
    isFreePlan
    isEnterprisePlan
    activeUserCount
    activeProjectCount
    storageUsageGb
  }
}
    `;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const UpgradeOrganizationPlanDocument = gql`
    mutation UpgradeOrganizationPlan($id: UUID!, $planType: PlanType!) {
  upgradeOrganizationPlan(id: $id, planType: $planType) {
    id
    name
    slug
    domain
    description
    billingEmail
    billingAddress
    billingContact
    taxId
    planType
    maxUsers
    maxClients
    maxProjects
    storageLimitGb
    sharedKnowledgeEnabled
    requireEmailVerification
    isActive
    isVerified
    createdAt
    updatedAt
    isFreePlan
    isEnterprisePlan
    activeUserCount
    activeProjectCount
    storageUsageGb
  }
}
    `;
export type UpgradeOrganizationPlanMutationFn = Apollo.MutationFunction<UpgradeOrganizationPlanMutation, UpgradeOrganizationPlanMutationVariables>;

/**
 * __useUpgradeOrganizationPlanMutation__
 *
 * To run a mutation, you first call `useUpgradeOrganizationPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeOrganizationPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeOrganizationPlanMutation, { data, loading, error }] = useUpgradeOrganizationPlanMutation({
 *   variables: {
 *      id: // value for 'id'
 *      planType: // value for 'planType'
 *   },
 * });
 */
export function useUpgradeOrganizationPlanMutation(baseOptions?: Apollo.MutationHookOptions<UpgradeOrganizationPlanMutation, UpgradeOrganizationPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpgradeOrganizationPlanMutation, UpgradeOrganizationPlanMutationVariables>(UpgradeOrganizationPlanDocument, options);
      }
export type UpgradeOrganizationPlanMutationHookResult = ReturnType<typeof useUpgradeOrganizationPlanMutation>;
export type UpgradeOrganizationPlanMutationResult = Apollo.MutationResult<UpgradeOrganizationPlanMutation>;
export type UpgradeOrganizationPlanMutationOptions = Apollo.BaseMutationOptions<UpgradeOrganizationPlanMutation, UpgradeOrganizationPlanMutationVariables>;
export const VerifyOrganizationDocument = gql`
    mutation VerifyOrganization($id: UUID!) {
  verifyOrganization(id: $id)
}
    `;
export type VerifyOrganizationMutationFn = Apollo.MutationFunction<VerifyOrganizationMutation, VerifyOrganizationMutationVariables>;

/**
 * __useVerifyOrganizationMutation__
 *
 * To run a mutation, you first call `useVerifyOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyOrganizationMutation, { data, loading, error }] = useVerifyOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVerifyOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<VerifyOrganizationMutation, VerifyOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyOrganizationMutation, VerifyOrganizationMutationVariables>(VerifyOrganizationDocument, options);
      }
export type VerifyOrganizationMutationHookResult = ReturnType<typeof useVerifyOrganizationMutation>;
export type VerifyOrganizationMutationResult = Apollo.MutationResult<VerifyOrganizationMutation>;
export type VerifyOrganizationMutationOptions = Apollo.BaseMutationOptions<VerifyOrganizationMutation, VerifyOrganizationMutationVariables>;
export const ChangeOrganizationStatusDocument = gql`
    mutation ChangeOrganizationStatus($id: UUID!, $status: String!, $reason: String = null) {
  changeOrganizationStatus(id: $id, status: $status, reason: $reason)
}
    `;
export type ChangeOrganizationStatusMutationFn = Apollo.MutationFunction<ChangeOrganizationStatusMutation, ChangeOrganizationStatusMutationVariables>;

/**
 * __useChangeOrganizationStatusMutation__
 *
 * To run a mutation, you first call `useChangeOrganizationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeOrganizationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeOrganizationStatusMutation, { data, loading, error }] = useChangeOrganizationStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useChangeOrganizationStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeOrganizationStatusMutation, ChangeOrganizationStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeOrganizationStatusMutation, ChangeOrganizationStatusMutationVariables>(ChangeOrganizationStatusDocument, options);
      }
export type ChangeOrganizationStatusMutationHookResult = ReturnType<typeof useChangeOrganizationStatusMutation>;
export type ChangeOrganizationStatusMutationResult = Apollo.MutationResult<ChangeOrganizationStatusMutation>;
export type ChangeOrganizationStatusMutationOptions = Apollo.BaseMutationOptions<ChangeOrganizationStatusMutation, ChangeOrganizationStatusMutationVariables>;
export const DeleteOrganizationDocument = gql`
    mutation DeleteOrganization($id: UUID!) {
  deleteOrganization(id: $id)
}
    `;
export type DeleteOrganizationMutationFn = Apollo.MutationFunction<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;

/**
 * __useDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationMutation, { data, loading, error }] = useDeleteOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>(DeleteOrganizationDocument, options);
      }
export type DeleteOrganizationMutationHookResult = ReturnType<typeof useDeleteOrganizationMutation>;
export type DeleteOrganizationMutationResult = Apollo.MutationResult<DeleteOrganizationMutation>;
export type DeleteOrganizationMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;
export const TransferOrganizationOwnershipDocument = gql`
    mutation TransferOrganizationOwnership($organizationId: UUID!, $newOwnerId: UUID!) {
  transferOrganizationOwnership(
    organizationId: $organizationId
    newOwnerId: $newOwnerId
  ) {
    success
    message
    newOwner {
      userId
      organizationId
      role
      joinedAt
      invitedBy
    }
  }
}
    `;
export type TransferOrganizationOwnershipMutationFn = Apollo.MutationFunction<TransferOrganizationOwnershipMutation, TransferOrganizationOwnershipMutationVariables>;

/**
 * __useTransferOrganizationOwnershipMutation__
 *
 * To run a mutation, you first call `useTransferOrganizationOwnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferOrganizationOwnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferOrganizationOwnershipMutation, { data, loading, error }] = useTransferOrganizationOwnershipMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      newOwnerId: // value for 'newOwnerId'
 *   },
 * });
 */
export function useTransferOrganizationOwnershipMutation(baseOptions?: Apollo.MutationHookOptions<TransferOrganizationOwnershipMutation, TransferOrganizationOwnershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferOrganizationOwnershipMutation, TransferOrganizationOwnershipMutationVariables>(TransferOrganizationOwnershipDocument, options);
      }
export type TransferOrganizationOwnershipMutationHookResult = ReturnType<typeof useTransferOrganizationOwnershipMutation>;
export type TransferOrganizationOwnershipMutationResult = Apollo.MutationResult<TransferOrganizationOwnershipMutation>;
export type TransferOrganizationOwnershipMutationOptions = Apollo.BaseMutationOptions<TransferOrganizationOwnershipMutation, TransferOrganizationOwnershipMutationVariables>;
export const GetOrganizationDocument = gql`
    query GetOrganization($id: UUID!) {
  organization(id: $id) {
    id
    name
    slug
    domain
    description
    billingEmail
    billingAddress
    billingContact
    taxId
    planType
    maxUsers
    maxClients
    maxProjects
    storageLimitGb
    sharedKnowledgeEnabled
    requireEmailVerification
    isActive
    isVerified
    createdAt
    updatedAt
    isFreePlan
    isEnterprisePlan
    activeUserCount
    activeProjectCount
    storageUsageGb
  }
}
    `;

/**
 * __useGetOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables> & ({ variables: GetOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
      }
export function useGetOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
        }
// @ts-ignore
export function useGetOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationQuery, GetOrganizationQueryVariables>;
export function useGetOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationQuery | undefined, GetOrganizationQueryVariables>;
export function useGetOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
        }
export type GetOrganizationQueryHookResult = ReturnType<typeof useGetOrganizationQuery>;
export type GetOrganizationLazyQueryHookResult = ReturnType<typeof useGetOrganizationLazyQuery>;
export type GetOrganizationSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationSuspenseQuery>;
export type GetOrganizationQueryResult = Apollo.QueryResult<GetOrganizationQuery, GetOrganizationQueryVariables>;
export const GetOrganizationBySlugDocument = gql`
    query GetOrganizationBySlug($slug: String!) {
  organizationBySlug(slug: $slug) {
    id
    name
    slug
    domain
    description
    billingEmail
    billingAddress
    billingContact
    taxId
    planType
    maxUsers
    maxClients
    maxProjects
    storageLimitGb
    sharedKnowledgeEnabled
    requireEmailVerification
    isActive
    isVerified
    createdAt
    updatedAt
    isFreePlan
    isEnterprisePlan
    activeUserCount
    activeProjectCount
    storageUsageGb
  }
}
    `;

/**
 * __useGetOrganizationBySlugQuery__
 *
 * To run a query within a React component, call `useGetOrganizationBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetOrganizationBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationBySlugQuery, GetOrganizationBySlugQueryVariables> & ({ variables: GetOrganizationBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationBySlugQuery, GetOrganizationBySlugQueryVariables>(GetOrganizationBySlugDocument, options);
      }
export function useGetOrganizationBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationBySlugQuery, GetOrganizationBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationBySlugQuery, GetOrganizationBySlugQueryVariables>(GetOrganizationBySlugDocument, options);
        }
// @ts-ignore
export function useGetOrganizationBySlugSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationBySlugQuery, GetOrganizationBySlugQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationBySlugQuery, GetOrganizationBySlugQueryVariables>;
export function useGetOrganizationBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationBySlugQuery, GetOrganizationBySlugQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationBySlugQuery | undefined, GetOrganizationBySlugQueryVariables>;
export function useGetOrganizationBySlugSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationBySlugQuery, GetOrganizationBySlugQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationBySlugQuery, GetOrganizationBySlugQueryVariables>(GetOrganizationBySlugDocument, options);
        }
export type GetOrganizationBySlugQueryHookResult = ReturnType<typeof useGetOrganizationBySlugQuery>;
export type GetOrganizationBySlugLazyQueryHookResult = ReturnType<typeof useGetOrganizationBySlugLazyQuery>;
export type GetOrganizationBySlugSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationBySlugSuspenseQuery>;
export type GetOrganizationBySlugQueryResult = Apollo.QueryResult<GetOrganizationBySlugQuery, GetOrganizationBySlugQueryVariables>;
export const GetOrganizationsDocument = gql`
    query GetOrganizations($filter: OrganizationFilterInput = null, $limit: Int! = 20, $offset: Int! = 0) {
  organizations(filter: $filter, limit: $limit, offset: $offset) {
    edges {
      cursor
      node {
        id
        name
        slug
        domain
        description
        billingEmail
        billingAddress
        billingContact
        taxId
        planType
        maxUsers
        maxClients
        maxProjects
        storageLimitGb
        sharedKnowledgeEnabled
        requireEmailVerification
        isActive
        isVerified
        createdAt
        updatedAt
        isFreePlan
        isEnterprisePlan
        activeUserCount
        activeProjectCount
        storageUsageGb
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
      }
export function useGetOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
// @ts-ignore
export function useGetOrganizationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export function useGetOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationsQuery | undefined, GetOrganizationsQueryVariables>;
export function useGetOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export type GetOrganizationsQueryHookResult = ReturnType<typeof useGetOrganizationsQuery>;
export type GetOrganizationsLazyQueryHookResult = ReturnType<typeof useGetOrganizationsLazyQuery>;
export type GetOrganizationsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationsSuspenseQuery>;
export type GetOrganizationsQueryResult = Apollo.QueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export const GetOrganizationOwnerDocument = gql`
    query GetOrganizationOwner($organizationId: UUID!) {
  organizationOwner(organizationId: $organizationId) {
    userId
    organizationId
    role
    joinedAt
    invitedBy
  }
}
    `;

/**
 * __useGetOrganizationOwnerQuery__
 *
 * To run a query within a React component, call `useGetOrganizationOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationOwnerQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationOwnerQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationOwnerQuery, GetOrganizationOwnerQueryVariables> & ({ variables: GetOrganizationOwnerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationOwnerQuery, GetOrganizationOwnerQueryVariables>(GetOrganizationOwnerDocument, options);
      }
export function useGetOrganizationOwnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationOwnerQuery, GetOrganizationOwnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationOwnerQuery, GetOrganizationOwnerQueryVariables>(GetOrganizationOwnerDocument, options);
        }
// @ts-ignore
export function useGetOrganizationOwnerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationOwnerQuery, GetOrganizationOwnerQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationOwnerQuery, GetOrganizationOwnerQueryVariables>;
export function useGetOrganizationOwnerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationOwnerQuery, GetOrganizationOwnerQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganizationOwnerQuery | undefined, GetOrganizationOwnerQueryVariables>;
export function useGetOrganizationOwnerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationOwnerQuery, GetOrganizationOwnerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationOwnerQuery, GetOrganizationOwnerQueryVariables>(GetOrganizationOwnerDocument, options);
        }
export type GetOrganizationOwnerQueryHookResult = ReturnType<typeof useGetOrganizationOwnerQuery>;
export type GetOrganizationOwnerLazyQueryHookResult = ReturnType<typeof useGetOrganizationOwnerLazyQuery>;
export type GetOrganizationOwnerSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationOwnerSuspenseQuery>;
export type GetOrganizationOwnerQueryResult = Apollo.QueryResult<GetOrganizationOwnerQuery, GetOrganizationOwnerQueryVariables>;
export const GetSearchOrganizationsDocument = gql`
    query GetSearchOrganizations($query: String!, $status: String = null, $plan: PlanType = null, $limit: Int! = 20, $offset: Int! = 0) {
  searchOrganizations(
    query: $query
    status: $status
    plan: $plan
    limit: $limit
    offset: $offset
  ) {
    edges {
      cursor
      node {
        id
        name
        slug
        domain
        description
        billingEmail
        billingAddress
        billingContact
        taxId
        planType
        maxUsers
        maxClients
        maxProjects
        storageLimitGb
        sharedKnowledgeEnabled
        requireEmailVerification
        isActive
        isVerified
        createdAt
        updatedAt
        isFreePlan
        isEnterprisePlan
        activeUserCount
        activeProjectCount
        storageUsageGb
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetSearchOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetSearchOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchOrganizationsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      status: // value for 'status'
 *      plan: // value for 'plan'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetSearchOrganizationsQuery(baseOptions: Apollo.QueryHookOptions<GetSearchOrganizationsQuery, GetSearchOrganizationsQueryVariables> & ({ variables: GetSearchOrganizationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchOrganizationsQuery, GetSearchOrganizationsQueryVariables>(GetSearchOrganizationsDocument, options);
      }
export function useGetSearchOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchOrganizationsQuery, GetSearchOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchOrganizationsQuery, GetSearchOrganizationsQueryVariables>(GetSearchOrganizationsDocument, options);
        }
// @ts-ignore
export function useGetSearchOrganizationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSearchOrganizationsQuery, GetSearchOrganizationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSearchOrganizationsQuery, GetSearchOrganizationsQueryVariables>;
export function useGetSearchOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchOrganizationsQuery, GetSearchOrganizationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSearchOrganizationsQuery | undefined, GetSearchOrganizationsQueryVariables>;
export function useGetSearchOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchOrganizationsQuery, GetSearchOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchOrganizationsQuery, GetSearchOrganizationsQueryVariables>(GetSearchOrganizationsDocument, options);
        }
export type GetSearchOrganizationsQueryHookResult = ReturnType<typeof useGetSearchOrganizationsQuery>;
export type GetSearchOrganizationsLazyQueryHookResult = ReturnType<typeof useGetSearchOrganizationsLazyQuery>;
export type GetSearchOrganizationsSuspenseQueryHookResult = ReturnType<typeof useGetSearchOrganizationsSuspenseQuery>;
export type GetSearchOrganizationsQueryResult = Apollo.QueryResult<GetSearchOrganizationsQuery, GetSearchOrganizationsQueryVariables>;
export const GetPrismScopesDocument = gql`
    query GetPrismScopes($projectId: UUID!) {
  projectScopes(projectId: $projectId) {
    id
    name
    origin
    rationale
    searchQuery
    analysisLens
    plan
    boostKeywords
    projectId
    viewId
    focusAtomIds
    createdAt
    functionCandidates {
      name
      category
      description
      priority
      source
    }
  }
}
    `;

/**
 * __useGetPrismScopesQuery__
 *
 * To run a query within a React component, call `useGetPrismScopesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrismScopesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrismScopesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetPrismScopesQuery(baseOptions: Apollo.QueryHookOptions<GetPrismScopesQuery, GetPrismScopesQueryVariables> & ({ variables: GetPrismScopesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrismScopesQuery, GetPrismScopesQueryVariables>(GetPrismScopesDocument, options);
      }
export function useGetPrismScopesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrismScopesQuery, GetPrismScopesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrismScopesQuery, GetPrismScopesQueryVariables>(GetPrismScopesDocument, options);
        }
// @ts-ignore
export function useGetPrismScopesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPrismScopesQuery, GetPrismScopesQueryVariables>): Apollo.UseSuspenseQueryResult<GetPrismScopesQuery, GetPrismScopesQueryVariables>;
export function useGetPrismScopesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPrismScopesQuery, GetPrismScopesQueryVariables>): Apollo.UseSuspenseQueryResult<GetPrismScopesQuery | undefined, GetPrismScopesQueryVariables>;
export function useGetPrismScopesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPrismScopesQuery, GetPrismScopesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPrismScopesQuery, GetPrismScopesQueryVariables>(GetPrismScopesDocument, options);
        }
export type GetPrismScopesQueryHookResult = ReturnType<typeof useGetPrismScopesQuery>;
export type GetPrismScopesLazyQueryHookResult = ReturnType<typeof useGetPrismScopesLazyQuery>;
export type GetPrismScopesSuspenseQueryHookResult = ReturnType<typeof useGetPrismScopesSuspenseQuery>;
export type GetPrismScopesQueryResult = Apollo.QueryResult<GetPrismScopesQuery, GetPrismScopesQueryVariables>;
export const GetPrismViewsDocument = gql`
    query GetPrismViews($projectId: UUID!, $limit: Int) {
  projectViews(projectId: $projectId, limit: $limit) {
    id
    projectId
    sourceType
    analysisSummary
    analysisResult
    sourceAtomIds
    scopeId
    generatedAt
  }
}
    `;

/**
 * __useGetPrismViewsQuery__
 *
 * To run a query within a React component, call `useGetPrismViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrismViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrismViewsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPrismViewsQuery(baseOptions: Apollo.QueryHookOptions<GetPrismViewsQuery, GetPrismViewsQueryVariables> & ({ variables: GetPrismViewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrismViewsQuery, GetPrismViewsQueryVariables>(GetPrismViewsDocument, options);
      }
export function useGetPrismViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrismViewsQuery, GetPrismViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrismViewsQuery, GetPrismViewsQueryVariables>(GetPrismViewsDocument, options);
        }
// @ts-ignore
export function useGetPrismViewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPrismViewsQuery, GetPrismViewsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPrismViewsQuery, GetPrismViewsQueryVariables>;
export function useGetPrismViewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPrismViewsQuery, GetPrismViewsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPrismViewsQuery | undefined, GetPrismViewsQueryVariables>;
export function useGetPrismViewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPrismViewsQuery, GetPrismViewsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPrismViewsQuery, GetPrismViewsQueryVariables>(GetPrismViewsDocument, options);
        }
export type GetPrismViewsQueryHookResult = ReturnType<typeof useGetPrismViewsQuery>;
export type GetPrismViewsLazyQueryHookResult = ReturnType<typeof useGetPrismViewsLazyQuery>;
export type GetPrismViewsSuspenseQueryHookResult = ReturnType<typeof useGetPrismViewsSuspenseQuery>;
export type GetPrismViewsQueryResult = Apollo.QueryResult<GetPrismViewsQuery, GetPrismViewsQueryVariables>;
export const GetPrismScopeDetailDocument = gql`
    query GetPrismScopeDetail($scopeId: UUID!) {
  scopeDetail(scopeId: $scopeId) {
    id
    name
    origin
    rationale
    searchQuery
    analysisLens
    plan
    boostKeywords
    projectId
    viewId
    focusAtomIds
    createdAt
    functionCandidates {
      name
      category
      description
      priority
      source
    }
  }
}
    `;

/**
 * __useGetPrismScopeDetailQuery__
 *
 * To run a query within a React component, call `useGetPrismScopeDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrismScopeDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrismScopeDetailQuery({
 *   variables: {
 *      scopeId: // value for 'scopeId'
 *   },
 * });
 */
export function useGetPrismScopeDetailQuery(baseOptions: Apollo.QueryHookOptions<GetPrismScopeDetailQuery, GetPrismScopeDetailQueryVariables> & ({ variables: GetPrismScopeDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrismScopeDetailQuery, GetPrismScopeDetailQueryVariables>(GetPrismScopeDetailDocument, options);
      }
export function useGetPrismScopeDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrismScopeDetailQuery, GetPrismScopeDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrismScopeDetailQuery, GetPrismScopeDetailQueryVariables>(GetPrismScopeDetailDocument, options);
        }
// @ts-ignore
export function useGetPrismScopeDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPrismScopeDetailQuery, GetPrismScopeDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetPrismScopeDetailQuery, GetPrismScopeDetailQueryVariables>;
export function useGetPrismScopeDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPrismScopeDetailQuery, GetPrismScopeDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetPrismScopeDetailQuery | undefined, GetPrismScopeDetailQueryVariables>;
export function useGetPrismScopeDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPrismScopeDetailQuery, GetPrismScopeDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPrismScopeDetailQuery, GetPrismScopeDetailQueryVariables>(GetPrismScopeDetailDocument, options);
        }
export type GetPrismScopeDetailQueryHookResult = ReturnType<typeof useGetPrismScopeDetailQuery>;
export type GetPrismScopeDetailLazyQueryHookResult = ReturnType<typeof useGetPrismScopeDetailLazyQuery>;
export type GetPrismScopeDetailSuspenseQueryHookResult = ReturnType<typeof useGetPrismScopeDetailSuspenseQuery>;
export type GetPrismScopeDetailQueryResult = Apollo.QueryResult<GetPrismScopeDetailQuery, GetPrismScopeDetailQueryVariables>;
export const GenerateGeneralScopesDocument = gql`
    mutation GenerateGeneralScopes($projectId: UUID!) {
  generateGeneralScopes(projectId: $projectId)
}
    `;
export type GenerateGeneralScopesMutationFn = Apollo.MutationFunction<GenerateGeneralScopesMutation, GenerateGeneralScopesMutationVariables>;

/**
 * __useGenerateGeneralScopesMutation__
 *
 * To run a mutation, you first call `useGenerateGeneralScopesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateGeneralScopesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateGeneralScopesMutation, { data, loading, error }] = useGenerateGeneralScopesMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGenerateGeneralScopesMutation(baseOptions?: Apollo.MutationHookOptions<GenerateGeneralScopesMutation, GenerateGeneralScopesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateGeneralScopesMutation, GenerateGeneralScopesMutationVariables>(GenerateGeneralScopesDocument, options);
      }
export type GenerateGeneralScopesMutationHookResult = ReturnType<typeof useGenerateGeneralScopesMutation>;
export type GenerateGeneralScopesMutationResult = Apollo.MutationResult<GenerateGeneralScopesMutation>;
export type GenerateGeneralScopesMutationOptions = Apollo.BaseMutationOptions<GenerateGeneralScopesMutation, GenerateGeneralScopesMutationVariables>;
export const GetPrismOrientForProjectDocument = gql`
    query GetPrismOrientForProject($projectId: UUID!) {
  orientForProject(projectId: $projectId) {
    id
    projectId
    summary
    recommendations
    confidence
    modelUsed
    judgments {
      aspect
      assessment
      severity
      actionable
    }
    generatedAt
    projectContext {
      purpose
      targetAudience
      objectives
      estimatedScale
      additionalNotes
    }
    userLockedFields
  }
}
    `;

/**
 * __useGetPrismOrientForProjectQuery__
 *
 * To run a query within a React component, call `useGetPrismOrientForProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrismOrientForProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrismOrientForProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetPrismOrientForProjectQuery(baseOptions: Apollo.QueryHookOptions<GetPrismOrientForProjectQuery, GetPrismOrientForProjectQueryVariables> & ({ variables: GetPrismOrientForProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrismOrientForProjectQuery, GetPrismOrientForProjectQueryVariables>(GetPrismOrientForProjectDocument, options);
      }
export function useGetPrismOrientForProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrismOrientForProjectQuery, GetPrismOrientForProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrismOrientForProjectQuery, GetPrismOrientForProjectQueryVariables>(GetPrismOrientForProjectDocument, options);
        }
// @ts-ignore
export function useGetPrismOrientForProjectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPrismOrientForProjectQuery, GetPrismOrientForProjectQueryVariables>): Apollo.UseSuspenseQueryResult<GetPrismOrientForProjectQuery, GetPrismOrientForProjectQueryVariables>;
export function useGetPrismOrientForProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPrismOrientForProjectQuery, GetPrismOrientForProjectQueryVariables>): Apollo.UseSuspenseQueryResult<GetPrismOrientForProjectQuery | undefined, GetPrismOrientForProjectQueryVariables>;
export function useGetPrismOrientForProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPrismOrientForProjectQuery, GetPrismOrientForProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPrismOrientForProjectQuery, GetPrismOrientForProjectQueryVariables>(GetPrismOrientForProjectDocument, options);
        }
export type GetPrismOrientForProjectQueryHookResult = ReturnType<typeof useGetPrismOrientForProjectQuery>;
export type GetPrismOrientForProjectLazyQueryHookResult = ReturnType<typeof useGetPrismOrientForProjectLazyQuery>;
export type GetPrismOrientForProjectSuspenseQueryHookResult = ReturnType<typeof useGetPrismOrientForProjectSuspenseQuery>;
export type GetPrismOrientForProjectQueryResult = Apollo.QueryResult<GetPrismOrientForProjectQuery, GetPrismOrientForProjectQueryVariables>;
export const GenerateOrientDocument = gql`
    mutation GenerateOrient($projectId: UUID!) {
  generateOrient(projectId: $projectId)
}
    `;
export type GenerateOrientMutationFn = Apollo.MutationFunction<GenerateOrientMutation, GenerateOrientMutationVariables>;

/**
 * __useGenerateOrientMutation__
 *
 * To run a mutation, you first call `useGenerateOrientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateOrientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateOrientMutation, { data, loading, error }] = useGenerateOrientMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGenerateOrientMutation(baseOptions?: Apollo.MutationHookOptions<GenerateOrientMutation, GenerateOrientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateOrientMutation, GenerateOrientMutationVariables>(GenerateOrientDocument, options);
      }
export type GenerateOrientMutationHookResult = ReturnType<typeof useGenerateOrientMutation>;
export type GenerateOrientMutationResult = Apollo.MutationResult<GenerateOrientMutation>;
export type GenerateOrientMutationOptions = Apollo.BaseMutationOptions<GenerateOrientMutation, GenerateOrientMutationVariables>;
export const DeleteScopeDocument = gql`
    mutation DeleteScope($scopeId: UUID!) {
  deleteScope(scopeId: $scopeId)
}
    `;
export type DeleteScopeMutationFn = Apollo.MutationFunction<DeleteScopeMutation, DeleteScopeMutationVariables>;

/**
 * __useDeleteScopeMutation__
 *
 * To run a mutation, you first call `useDeleteScopeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScopeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScopeMutation, { data, loading, error }] = useDeleteScopeMutation({
 *   variables: {
 *      scopeId: // value for 'scopeId'
 *   },
 * });
 */
export function useDeleteScopeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScopeMutation, DeleteScopeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteScopeMutation, DeleteScopeMutationVariables>(DeleteScopeDocument, options);
      }
export type DeleteScopeMutationHookResult = ReturnType<typeof useDeleteScopeMutation>;
export type DeleteScopeMutationResult = Apollo.MutationResult<DeleteScopeMutation>;
export type DeleteScopeMutationOptions = Apollo.BaseMutationOptions<DeleteScopeMutation, DeleteScopeMutationVariables>;
export const DeleteViewDocument = gql`
    mutation DeleteView($viewId: UUID!) {
  deleteView(viewId: $viewId)
}
    `;
export type DeleteViewMutationFn = Apollo.MutationFunction<DeleteViewMutation, DeleteViewMutationVariables>;

/**
 * __useDeleteViewMutation__
 *
 * To run a mutation, you first call `useDeleteViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteViewMutation, { data, loading, error }] = useDeleteViewMutation({
 *   variables: {
 *      viewId: // value for 'viewId'
 *   },
 * });
 */
export function useDeleteViewMutation(baseOptions?: Apollo.MutationHookOptions<DeleteViewMutation, DeleteViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteViewMutation, DeleteViewMutationVariables>(DeleteViewDocument, options);
      }
export type DeleteViewMutationHookResult = ReturnType<typeof useDeleteViewMutation>;
export type DeleteViewMutationResult = Apollo.MutationResult<DeleteViewMutation>;
export type DeleteViewMutationOptions = Apollo.BaseMutationOptions<DeleteViewMutation, DeleteViewMutationVariables>;
export const CreateConsolidatedDeliverableWithAiDocument = gql`
    mutation CreateConsolidatedDeliverableWithAi($projectId: String!, $input: ConsolidatedDeliverableSuggestionInput!) {
  createConsolidatedDeliverableWithAi(projectId: $projectId, input: $input)
}
    `;
export type CreateConsolidatedDeliverableWithAiMutationFn = Apollo.MutationFunction<CreateConsolidatedDeliverableWithAiMutation, CreateConsolidatedDeliverableWithAiMutationVariables>;

/**
 * __useCreateConsolidatedDeliverableWithAiMutation__
 *
 * To run a mutation, you first call `useCreateConsolidatedDeliverableWithAiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConsolidatedDeliverableWithAiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConsolidatedDeliverableWithAiMutation, { data, loading, error }] = useCreateConsolidatedDeliverableWithAiMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConsolidatedDeliverableWithAiMutation(baseOptions?: Apollo.MutationHookOptions<CreateConsolidatedDeliverableWithAiMutation, CreateConsolidatedDeliverableWithAiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConsolidatedDeliverableWithAiMutation, CreateConsolidatedDeliverableWithAiMutationVariables>(CreateConsolidatedDeliverableWithAiDocument, options);
      }
export type CreateConsolidatedDeliverableWithAiMutationHookResult = ReturnType<typeof useCreateConsolidatedDeliverableWithAiMutation>;
export type CreateConsolidatedDeliverableWithAiMutationResult = Apollo.MutationResult<CreateConsolidatedDeliverableWithAiMutation>;
export type CreateConsolidatedDeliverableWithAiMutationOptions = Apollo.BaseMutationOptions<CreateConsolidatedDeliverableWithAiMutation, CreateConsolidatedDeliverableWithAiMutationVariables>;
export const RegenerateSitemapForExistingDeliverableDocument = gql`
    mutation RegenerateSitemapForExistingDeliverable($projectId: String!, $input: GenerateConsolidatedSitemapInput = null) {
  regenerateSitemapForExistingDeliverable(projectId: $projectId, input: $input) {
    success
    totalPages
    functionCategories
    generationTimeMs
    sitemapJson
    errors
    warnings
  }
}
    `;
export type RegenerateSitemapForExistingDeliverableMutationFn = Apollo.MutationFunction<RegenerateSitemapForExistingDeliverableMutation, RegenerateSitemapForExistingDeliverableMutationVariables>;

/**
 * __useRegenerateSitemapForExistingDeliverableMutation__
 *
 * To run a mutation, you first call `useRegenerateSitemapForExistingDeliverableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateSitemapForExistingDeliverableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateSitemapForExistingDeliverableMutation, { data, loading, error }] = useRegenerateSitemapForExistingDeliverableMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegenerateSitemapForExistingDeliverableMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateSitemapForExistingDeliverableMutation, RegenerateSitemapForExistingDeliverableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateSitemapForExistingDeliverableMutation, RegenerateSitemapForExistingDeliverableMutationVariables>(RegenerateSitemapForExistingDeliverableDocument, options);
      }
export type RegenerateSitemapForExistingDeliverableMutationHookResult = ReturnType<typeof useRegenerateSitemapForExistingDeliverableMutation>;
export type RegenerateSitemapForExistingDeliverableMutationResult = Apollo.MutationResult<RegenerateSitemapForExistingDeliverableMutation>;
export type RegenerateSitemapForExistingDeliverableMutationOptions = Apollo.BaseMutationOptions<RegenerateSitemapForExistingDeliverableMutation, RegenerateSitemapForExistingDeliverableMutationVariables>;
export const CreateProjectDddDocument = gql`
    mutation CreateProjectDdd($input: CreateProjectInput!) {
  createProjectDdd(input: $input) {
    id
    name
    description
    clientId
    organizationId
    ownerId
    groupId
    projectType
    status
    priority
    developmentType
    projectPhase
    progress
    constitutionalFacts
    constitutionalVersion
    constitutionalApprovedBy
    constitutionalApprovedAt
    hasApprovedConstitution
    contextAnalysis
    contextAnalysisUpdatedAt
    promptEvolution {
      core
      version
      updatedAt
      history
      elements {
        needs {
          id
          content
          category
          priority
          createdAt
        }
        seeds {
          id
          content
          type
          confidence
          createdAt
        }
        wildIdeas {
          id
          content
          category
          riskLevel
          createdAt
        }
      }
    }
    settings
    projectMetadata
    tags
    color
    isActive
    isArchived
    archivedAt
    isDeleted
    deletedAt
    createdAt
    updatedAt
    isInProgress
    isCompleted
    canStart
    progressInfo {
      progress
      status
    }
    constitutionalLaws {
      needs
      seeds
    }
    systemInstanceId
    kind
    gitBranch
    prUrl
    prNumber
  }
}
    `;
export type CreateProjectDddMutationFn = Apollo.MutationFunction<CreateProjectDddMutation, CreateProjectDddMutationVariables>;

/**
 * __useCreateProjectDddMutation__
 *
 * To run a mutation, you first call `useCreateProjectDddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectDddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectDddMutation, { data, loading, error }] = useCreateProjectDddMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectDddMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectDddMutation, CreateProjectDddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectDddMutation, CreateProjectDddMutationVariables>(CreateProjectDddDocument, options);
      }
export type CreateProjectDddMutationHookResult = ReturnType<typeof useCreateProjectDddMutation>;
export type CreateProjectDddMutationResult = Apollo.MutationResult<CreateProjectDddMutation>;
export type CreateProjectDddMutationOptions = Apollo.BaseMutationOptions<CreateProjectDddMutation, CreateProjectDddMutationVariables>;
export const UpdateProjectDddDocument = gql`
    mutation UpdateProjectDdd($id: UUID!, $input: UpdateProjectInput!) {
  updateProjectDdd(id: $id, input: $input) {
    id
    name
    description
    clientId
    organizationId
    ownerId
    groupId
    projectType
    status
    priority
    developmentType
    projectPhase
    progress
    constitutionalFacts
    constitutionalVersion
    constitutionalApprovedBy
    constitutionalApprovedAt
    hasApprovedConstitution
    contextAnalysis
    contextAnalysisUpdatedAt
    promptEvolution {
      core
      version
      updatedAt
      history
      elements {
        needs {
          id
          content
          category
          priority
          createdAt
        }
        seeds {
          id
          content
          type
          confidence
          createdAt
        }
        wildIdeas {
          id
          content
          category
          riskLevel
          createdAt
        }
      }
    }
    settings
    projectMetadata
    tags
    color
    isActive
    isArchived
    archivedAt
    isDeleted
    deletedAt
    createdAt
    updatedAt
    isInProgress
    isCompleted
    canStart
    progressInfo {
      progress
      status
    }
    constitutionalLaws {
      needs
      seeds
    }
    systemInstanceId
    kind
    gitBranch
    prUrl
    prNumber
  }
}
    `;
export type UpdateProjectDddMutationFn = Apollo.MutationFunction<UpdateProjectDddMutation, UpdateProjectDddMutationVariables>;

/**
 * __useUpdateProjectDddMutation__
 *
 * To run a mutation, you first call `useUpdateProjectDddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectDddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectDddMutation, { data, loading, error }] = useUpdateProjectDddMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectDddMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectDddMutation, UpdateProjectDddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectDddMutation, UpdateProjectDddMutationVariables>(UpdateProjectDddDocument, options);
      }
export type UpdateProjectDddMutationHookResult = ReturnType<typeof useUpdateProjectDddMutation>;
export type UpdateProjectDddMutationResult = Apollo.MutationResult<UpdateProjectDddMutation>;
export type UpdateProjectDddMutationOptions = Apollo.BaseMutationOptions<UpdateProjectDddMutation, UpdateProjectDddMutationVariables>;
export const DeleteProjectDddDocument = gql`
    mutation DeleteProjectDdd($id: UUID!) {
  deleteProjectDdd(id: $id)
}
    `;
export type DeleteProjectDddMutationFn = Apollo.MutationFunction<DeleteProjectDddMutation, DeleteProjectDddMutationVariables>;

/**
 * __useDeleteProjectDddMutation__
 *
 * To run a mutation, you first call `useDeleteProjectDddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectDddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectDddMutation, { data, loading, error }] = useDeleteProjectDddMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectDddMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectDddMutation, DeleteProjectDddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectDddMutation, DeleteProjectDddMutationVariables>(DeleteProjectDddDocument, options);
      }
export type DeleteProjectDddMutationHookResult = ReturnType<typeof useDeleteProjectDddMutation>;
export type DeleteProjectDddMutationResult = Apollo.MutationResult<DeleteProjectDddMutation>;
export type DeleteProjectDddMutationOptions = Apollo.BaseMutationOptions<DeleteProjectDddMutation, DeleteProjectDddMutationVariables>;
export const RestoreProjectDddDocument = gql`
    mutation RestoreProjectDdd($id: UUID!) {
  restoreProjectDdd(id: $id)
}
    `;
export type RestoreProjectDddMutationFn = Apollo.MutationFunction<RestoreProjectDddMutation, RestoreProjectDddMutationVariables>;

/**
 * __useRestoreProjectDddMutation__
 *
 * To run a mutation, you first call `useRestoreProjectDddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreProjectDddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreProjectDddMutation, { data, loading, error }] = useRestoreProjectDddMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreProjectDddMutation(baseOptions?: Apollo.MutationHookOptions<RestoreProjectDddMutation, RestoreProjectDddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreProjectDddMutation, RestoreProjectDddMutationVariables>(RestoreProjectDddDocument, options);
      }
export type RestoreProjectDddMutationHookResult = ReturnType<typeof useRestoreProjectDddMutation>;
export type RestoreProjectDddMutationResult = Apollo.MutationResult<RestoreProjectDddMutation>;
export type RestoreProjectDddMutationOptions = Apollo.BaseMutationOptions<RestoreProjectDddMutation, RestoreProjectDddMutationVariables>;
export const HardDeleteProjectDddDocument = gql`
    mutation HardDeleteProjectDdd($id: UUID!) {
  hardDeleteProjectDdd(id: $id) {
    success
    projectId
    cascadeSummary
  }
}
    `;
export type HardDeleteProjectDddMutationFn = Apollo.MutationFunction<HardDeleteProjectDddMutation, HardDeleteProjectDddMutationVariables>;

/**
 * __useHardDeleteProjectDddMutation__
 *
 * To run a mutation, you first call `useHardDeleteProjectDddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHardDeleteProjectDddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hardDeleteProjectDddMutation, { data, loading, error }] = useHardDeleteProjectDddMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHardDeleteProjectDddMutation(baseOptions?: Apollo.MutationHookOptions<HardDeleteProjectDddMutation, HardDeleteProjectDddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HardDeleteProjectDddMutation, HardDeleteProjectDddMutationVariables>(HardDeleteProjectDddDocument, options);
      }
export type HardDeleteProjectDddMutationHookResult = ReturnType<typeof useHardDeleteProjectDddMutation>;
export type HardDeleteProjectDddMutationResult = Apollo.MutationResult<HardDeleteProjectDddMutation>;
export type HardDeleteProjectDddMutationOptions = Apollo.BaseMutationOptions<HardDeleteProjectDddMutation, HardDeleteProjectDddMutationVariables>;
export const UpdateConstitutionalFactsDocument = gql`
    mutation UpdateConstitutionalFacts($input: UpdateConstitutionalFactsInput!) {
  updateConstitutionalFacts(input: $input) {
    projectId
    facts {
      key
      fact {
        key
        value
        factType
        sourceType
        sourceRef
        confidence
        extractedAt
        notes
      }
    }
    version
    approvedBy
    approvedAt
    history {
      version
      changedAt
      changedBy
      changes
      factsSnapshot
      reason
    }
    needsLaws
    seedsLaws
    lastAnalysisAt
    totalFactsCount
    confirmedFactsCount
    pendingFactsCount
  }
}
    `;
export type UpdateConstitutionalFactsMutationFn = Apollo.MutationFunction<UpdateConstitutionalFactsMutation, UpdateConstitutionalFactsMutationVariables>;

/**
 * __useUpdateConstitutionalFactsMutation__
 *
 * To run a mutation, you first call `useUpdateConstitutionalFactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConstitutionalFactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConstitutionalFactsMutation, { data, loading, error }] = useUpdateConstitutionalFactsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateConstitutionalFactsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConstitutionalFactsMutation, UpdateConstitutionalFactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConstitutionalFactsMutation, UpdateConstitutionalFactsMutationVariables>(UpdateConstitutionalFactsDocument, options);
      }
export type UpdateConstitutionalFactsMutationHookResult = ReturnType<typeof useUpdateConstitutionalFactsMutation>;
export type UpdateConstitutionalFactsMutationResult = Apollo.MutationResult<UpdateConstitutionalFactsMutation>;
export type UpdateConstitutionalFactsMutationOptions = Apollo.BaseMutationOptions<UpdateConstitutionalFactsMutation, UpdateConstitutionalFactsMutationVariables>;
export const ApproveConstitutionDocument = gql`
    mutation ApproveConstitution($input: ApproveConstitutionInput!) {
  approveConstitution(input: $input) {
    projectId
    facts {
      key
      fact {
        key
        value
        factType
        sourceType
        sourceRef
        confidence
        extractedAt
        notes
      }
    }
    version
    approvedBy
    approvedAt
    history {
      version
      changedAt
      changedBy
      changes
      factsSnapshot
      reason
    }
    needsLaws
    seedsLaws
    lastAnalysisAt
    totalFactsCount
    confirmedFactsCount
    pendingFactsCount
  }
}
    `;
export type ApproveConstitutionMutationFn = Apollo.MutationFunction<ApproveConstitutionMutation, ApproveConstitutionMutationVariables>;

/**
 * __useApproveConstitutionMutation__
 *
 * To run a mutation, you first call `useApproveConstitutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveConstitutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveConstitutionMutation, { data, loading, error }] = useApproveConstitutionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveConstitutionMutation(baseOptions?: Apollo.MutationHookOptions<ApproveConstitutionMutation, ApproveConstitutionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveConstitutionMutation, ApproveConstitutionMutationVariables>(ApproveConstitutionDocument, options);
      }
export type ApproveConstitutionMutationHookResult = ReturnType<typeof useApproveConstitutionMutation>;
export type ApproveConstitutionMutationResult = Apollo.MutationResult<ApproveConstitutionMutation>;
export type ApproveConstitutionMutationOptions = Apollo.BaseMutationOptions<ApproveConstitutionMutation, ApproveConstitutionMutationVariables>;
export const ApplyConstitutionCandidateDocument = gql`
    mutation ApplyConstitutionCandidate($input: ApplyConstitutionCandidateInput!) {
  applyConstitutionCandidate(input: $input) {
    projectId
    facts {
      key
      fact {
        key
        value
        factType
        sourceType
        sourceRef
        confidence
        extractedAt
        notes
      }
    }
    version
    approvedBy
    approvedAt
    history {
      version
      changedAt
      changedBy
      changes
      factsSnapshot
      reason
    }
    needsLaws
    seedsLaws
    lastAnalysisAt
    totalFactsCount
    confirmedFactsCount
    pendingFactsCount
  }
}
    `;
export type ApplyConstitutionCandidateMutationFn = Apollo.MutationFunction<ApplyConstitutionCandidateMutation, ApplyConstitutionCandidateMutationVariables>;

/**
 * __useApplyConstitutionCandidateMutation__
 *
 * To run a mutation, you first call `useApplyConstitutionCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyConstitutionCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyConstitutionCandidateMutation, { data, loading, error }] = useApplyConstitutionCandidateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyConstitutionCandidateMutation(baseOptions?: Apollo.MutationHookOptions<ApplyConstitutionCandidateMutation, ApplyConstitutionCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyConstitutionCandidateMutation, ApplyConstitutionCandidateMutationVariables>(ApplyConstitutionCandidateDocument, options);
      }
export type ApplyConstitutionCandidateMutationHookResult = ReturnType<typeof useApplyConstitutionCandidateMutation>;
export type ApplyConstitutionCandidateMutationResult = Apollo.MutationResult<ApplyConstitutionCandidateMutation>;
export type ApplyConstitutionCandidateMutationOptions = Apollo.BaseMutationOptions<ApplyConstitutionCandidateMutation, ApplyConstitutionCandidateMutationVariables>;
export const CreateProjectDeliverableFromSuggestionsDocument = gql`
    mutation CreateProjectDeliverableFromSuggestions($projectId: String!, $input: CreateProjectDeliverableInput!) {
  createProjectDeliverableFromSuggestions(projectId: $projectId, input: $input) {
    id
    projectId
    name
    description
    priority
    boundedContexts {
      name
      nameJa
      type
      justification
      integrationApi
      isFrozen
      entityCount
      dynamicSpec
      publishes {
        name
        description
        payloadFields
        sourceBc
        action
      }
      subscribes {
        name
        description
        payloadFields
        sourceBc
        action
      }
      refs {
        targetBc
        targetEntity
        rpc
        listRpc
        purpose
        sourceField
      }
      entities {
        name
        nameJa
        fieldCount
        keyFields
      }
    }
    adminPages {
      bc
      entity
      role
      audience
      enabledActions
      labelJa
      description
    }
    publicPages {
      path
      role
      title
      primaryBc
      primaryEntity
      secondaryBcs
      displayFields
      actions
      audience
      acceptance
      description
      requiresAuth
    }
    enabledScenes
    businessFlowStories {
      name
      nameEn
      category
      description
      priority
      involvedBcs
      steps {
        order
        actor
        action
        stepType
        bc
        entity
        pagePath
        isPublic
        mutation
        query
        requiresAuth
        triggerEvent
        triggerAction
        condition
        yesStep
        noStep
        notificationChannel
        description
      }
    }
    systemArchitecture {
      architectureType
      deploymentStrategy
      componentCount
      scalingConsiderations
      componentsJson
    }
    version
    progress
    estimatedHours
    actualHours
    createdBy
    createdAt
    updatedAt
    isCompleted
    completionPercentage
    bcCount
    publicPageCount
    adminPageCount
  }
}
    `;
export type CreateProjectDeliverableFromSuggestionsMutationFn = Apollo.MutationFunction<CreateProjectDeliverableFromSuggestionsMutation, CreateProjectDeliverableFromSuggestionsMutationVariables>;

/**
 * __useCreateProjectDeliverableFromSuggestionsMutation__
 *
 * To run a mutation, you first call `useCreateProjectDeliverableFromSuggestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectDeliverableFromSuggestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectDeliverableFromSuggestionsMutation, { data, loading, error }] = useCreateProjectDeliverableFromSuggestionsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectDeliverableFromSuggestionsMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectDeliverableFromSuggestionsMutation, CreateProjectDeliverableFromSuggestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectDeliverableFromSuggestionsMutation, CreateProjectDeliverableFromSuggestionsMutationVariables>(CreateProjectDeliverableFromSuggestionsDocument, options);
      }
export type CreateProjectDeliverableFromSuggestionsMutationHookResult = ReturnType<typeof useCreateProjectDeliverableFromSuggestionsMutation>;
export type CreateProjectDeliverableFromSuggestionsMutationResult = Apollo.MutationResult<CreateProjectDeliverableFromSuggestionsMutation>;
export type CreateProjectDeliverableFromSuggestionsMutationOptions = Apollo.BaseMutationOptions<CreateProjectDeliverableFromSuggestionsMutation, CreateProjectDeliverableFromSuggestionsMutationVariables>;
export const UpdateProjectDeliverableDocument = gql`
    mutation UpdateProjectDeliverable($projectId: String!, $input: UpdateProjectDeliverableInput!) {
  updateProjectDeliverable(projectId: $projectId, input: $input) {
    id
    projectId
    name
    description
    priority
    boundedContexts {
      name
      nameJa
      type
      justification
      integrationApi
      isFrozen
      entityCount
      dynamicSpec
      publishes {
        name
        description
        payloadFields
        sourceBc
        action
      }
      subscribes {
        name
        description
        payloadFields
        sourceBc
        action
      }
      refs {
        targetBc
        targetEntity
        rpc
        listRpc
        purpose
        sourceField
      }
      entities {
        name
        nameJa
        fieldCount
        keyFields
      }
    }
    adminPages {
      bc
      entity
      role
      audience
      enabledActions
      labelJa
      description
    }
    publicPages {
      path
      role
      title
      primaryBc
      primaryEntity
      secondaryBcs
      displayFields
      actions
      audience
      acceptance
      description
      requiresAuth
    }
    enabledScenes
    businessFlowStories {
      name
      nameEn
      category
      description
      priority
      involvedBcs
      steps {
        order
        actor
        action
        stepType
        bc
        entity
        pagePath
        isPublic
        mutation
        query
        requiresAuth
        triggerEvent
        triggerAction
        condition
        yesStep
        noStep
        notificationChannel
        description
      }
    }
    systemArchitecture {
      architectureType
      deploymentStrategy
      componentCount
      scalingConsiderations
      componentsJson
    }
    version
    progress
    estimatedHours
    actualHours
    createdBy
    createdAt
    updatedAt
    isCompleted
    completionPercentage
    bcCount
    publicPageCount
    adminPageCount
  }
}
    `;
export type UpdateProjectDeliverableMutationFn = Apollo.MutationFunction<UpdateProjectDeliverableMutation, UpdateProjectDeliverableMutationVariables>;

/**
 * __useUpdateProjectDeliverableMutation__
 *
 * To run a mutation, you first call `useUpdateProjectDeliverableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectDeliverableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectDeliverableMutation, { data, loading, error }] = useUpdateProjectDeliverableMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectDeliverableMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectDeliverableMutation, UpdateProjectDeliverableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectDeliverableMutation, UpdateProjectDeliverableMutationVariables>(UpdateProjectDeliverableDocument, options);
      }
export type UpdateProjectDeliverableMutationHookResult = ReturnType<typeof useUpdateProjectDeliverableMutation>;
export type UpdateProjectDeliverableMutationResult = Apollo.MutationResult<UpdateProjectDeliverableMutation>;
export type UpdateProjectDeliverableMutationOptions = Apollo.BaseMutationOptions<UpdateProjectDeliverableMutation, UpdateProjectDeliverableMutationVariables>;
export const CreateArtifactDddDocument = gql`
    mutation CreateArtifactDdd($input: CreateArtifactDDDInput!) {
  createArtifactDdd(input: $input) {
    id
    projectId
    artifactType
    title
    description
    format
    content
    fileUrl
    fileSize
    status
    metadata
    createdBy
    createdAt
    generatedAt
    systemSpecData
    proposalMetadata {
      style
      includesDeliverables
      includesSitemap
      includesTechSpecs
      deliverablesCount
      sitemapPagesCount
      techComponentsCount
      estimatedReadingTime
      targetAudience
      totalContentLength
      dataSource
    }
  }
}
    `;
export type CreateArtifactDddMutationFn = Apollo.MutationFunction<CreateArtifactDddMutation, CreateArtifactDddMutationVariables>;

/**
 * __useCreateArtifactDddMutation__
 *
 * To run a mutation, you first call `useCreateArtifactDddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArtifactDddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArtifactDddMutation, { data, loading, error }] = useCreateArtifactDddMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateArtifactDddMutation(baseOptions?: Apollo.MutationHookOptions<CreateArtifactDddMutation, CreateArtifactDddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateArtifactDddMutation, CreateArtifactDddMutationVariables>(CreateArtifactDddDocument, options);
      }
export type CreateArtifactDddMutationHookResult = ReturnType<typeof useCreateArtifactDddMutation>;
export type CreateArtifactDddMutationResult = Apollo.MutationResult<CreateArtifactDddMutation>;
export type CreateArtifactDddMutationOptions = Apollo.BaseMutationOptions<CreateArtifactDddMutation, CreateArtifactDddMutationVariables>;
export const UpdateArtifactDddDocument = gql`
    mutation UpdateArtifactDdd($id: UUID!, $title: String = null, $description: String = null, $content: String = null, $metadata: JSON = null, $autoGenerationEnabled: Boolean = null) {
  updateArtifactDdd(
    id: $id
    title: $title
    description: $description
    content: $content
    metadata: $metadata
    autoGenerationEnabled: $autoGenerationEnabled
  ) {
    id
    projectId
    artifactType
    title
    description
    format
    content
    fileUrl
    fileSize
    status
    metadata
    createdBy
    createdAt
    generatedAt
    systemSpecData
    proposalMetadata {
      style
      includesDeliverables
      includesSitemap
      includesTechSpecs
      deliverablesCount
      sitemapPagesCount
      techComponentsCount
      estimatedReadingTime
      targetAudience
      totalContentLength
      dataSource
    }
  }
}
    `;
export type UpdateArtifactDddMutationFn = Apollo.MutationFunction<UpdateArtifactDddMutation, UpdateArtifactDddMutationVariables>;

/**
 * __useUpdateArtifactDddMutation__
 *
 * To run a mutation, you first call `useUpdateArtifactDddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArtifactDddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArtifactDddMutation, { data, loading, error }] = useUpdateArtifactDddMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      content: // value for 'content'
 *      metadata: // value for 'metadata'
 *      autoGenerationEnabled: // value for 'autoGenerationEnabled'
 *   },
 * });
 */
export function useUpdateArtifactDddMutation(baseOptions?: Apollo.MutationHookOptions<UpdateArtifactDddMutation, UpdateArtifactDddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateArtifactDddMutation, UpdateArtifactDddMutationVariables>(UpdateArtifactDddDocument, options);
      }
export type UpdateArtifactDddMutationHookResult = ReturnType<typeof useUpdateArtifactDddMutation>;
export type UpdateArtifactDddMutationResult = Apollo.MutationResult<UpdateArtifactDddMutation>;
export type UpdateArtifactDddMutationOptions = Apollo.BaseMutationOptions<UpdateArtifactDddMutation, UpdateArtifactDddMutationVariables>;
export const DeleteArtifactDddDocument = gql`
    mutation DeleteArtifactDdd($id: UUID!) {
  deleteArtifactDdd(id: $id)
}
    `;
export type DeleteArtifactDddMutationFn = Apollo.MutationFunction<DeleteArtifactDddMutation, DeleteArtifactDddMutationVariables>;

/**
 * __useDeleteArtifactDddMutation__
 *
 * To run a mutation, you first call `useDeleteArtifactDddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArtifactDddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArtifactDddMutation, { data, loading, error }] = useDeleteArtifactDddMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteArtifactDddMutation(baseOptions?: Apollo.MutationHookOptions<DeleteArtifactDddMutation, DeleteArtifactDddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteArtifactDddMutation, DeleteArtifactDddMutationVariables>(DeleteArtifactDddDocument, options);
      }
export type DeleteArtifactDddMutationHookResult = ReturnType<typeof useDeleteArtifactDddMutation>;
export type DeleteArtifactDddMutationResult = Apollo.MutationResult<DeleteArtifactDddMutation>;
export type DeleteArtifactDddMutationOptions = Apollo.BaseMutationOptions<DeleteArtifactDddMutation, DeleteArtifactDddMutationVariables>;
export const GenerateEnhancedProposalDocument = gql`
    mutation GenerateEnhancedProposal($input: EnhancedProposalGenerationInput!) {
  generateEnhancedProposal(input: $input) {
    id
    projectId
    artifactType
    title
    description
    format
    content
    fileUrl
    fileSize
    status
    metadata
    createdBy
    createdAt
    generatedAt
    systemSpecData
    proposalMetadata {
      style
      includesDeliverables
      includesSitemap
      includesTechSpecs
      deliverablesCount
      sitemapPagesCount
      techComponentsCount
      estimatedReadingTime
      targetAudience
      totalContentLength
      dataSource
    }
  }
}
    `;
export type GenerateEnhancedProposalMutationFn = Apollo.MutationFunction<GenerateEnhancedProposalMutation, GenerateEnhancedProposalMutationVariables>;

/**
 * __useGenerateEnhancedProposalMutation__
 *
 * To run a mutation, you first call `useGenerateEnhancedProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateEnhancedProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateEnhancedProposalMutation, { data, loading, error }] = useGenerateEnhancedProposalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateEnhancedProposalMutation(baseOptions?: Apollo.MutationHookOptions<GenerateEnhancedProposalMutation, GenerateEnhancedProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateEnhancedProposalMutation, GenerateEnhancedProposalMutationVariables>(GenerateEnhancedProposalDocument, options);
      }
export type GenerateEnhancedProposalMutationHookResult = ReturnType<typeof useGenerateEnhancedProposalMutation>;
export type GenerateEnhancedProposalMutationResult = Apollo.MutationResult<GenerateEnhancedProposalMutation>;
export type GenerateEnhancedProposalMutationOptions = Apollo.BaseMutationOptions<GenerateEnhancedProposalMutation, GenerateEnhancedProposalMutationVariables>;
export const DownloadArtifactAsPptxDocument = gql`
    mutation DownloadArtifactAsPptx($artifactId: String!, $colorScheme: String = null) {
  downloadArtifactAsPptx(artifactId: $artifactId, colorScheme: $colorScheme) {
    success
    fileUrl
    fileSize
    error
  }
}
    `;
export type DownloadArtifactAsPptxMutationFn = Apollo.MutationFunction<DownloadArtifactAsPptxMutation, DownloadArtifactAsPptxMutationVariables>;

/**
 * __useDownloadArtifactAsPptxMutation__
 *
 * To run a mutation, you first call `useDownloadArtifactAsPptxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadArtifactAsPptxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadArtifactAsPptxMutation, { data, loading, error }] = useDownloadArtifactAsPptxMutation({
 *   variables: {
 *      artifactId: // value for 'artifactId'
 *      colorScheme: // value for 'colorScheme'
 *   },
 * });
 */
export function useDownloadArtifactAsPptxMutation(baseOptions?: Apollo.MutationHookOptions<DownloadArtifactAsPptxMutation, DownloadArtifactAsPptxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadArtifactAsPptxMutation, DownloadArtifactAsPptxMutationVariables>(DownloadArtifactAsPptxDocument, options);
      }
export type DownloadArtifactAsPptxMutationHookResult = ReturnType<typeof useDownloadArtifactAsPptxMutation>;
export type DownloadArtifactAsPptxMutationResult = Apollo.MutationResult<DownloadArtifactAsPptxMutation>;
export type DownloadArtifactAsPptxMutationOptions = Apollo.BaseMutationOptions<DownloadArtifactAsPptxMutation, DownloadArtifactAsPptxMutationVariables>;
export const UpdateArtifactThemeDocument = gql`
    mutation UpdateArtifactTheme($artifactId: String!, $colorScheme: String!) {
  updateArtifactTheme(artifactId: $artifactId, colorScheme: $colorScheme) {
    success
    fileUrl
    fileSize
    error
  }
}
    `;
export type UpdateArtifactThemeMutationFn = Apollo.MutationFunction<UpdateArtifactThemeMutation, UpdateArtifactThemeMutationVariables>;

/**
 * __useUpdateArtifactThemeMutation__
 *
 * To run a mutation, you first call `useUpdateArtifactThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArtifactThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArtifactThemeMutation, { data, loading, error }] = useUpdateArtifactThemeMutation({
 *   variables: {
 *      artifactId: // value for 'artifactId'
 *      colorScheme: // value for 'colorScheme'
 *   },
 * });
 */
export function useUpdateArtifactThemeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateArtifactThemeMutation, UpdateArtifactThemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateArtifactThemeMutation, UpdateArtifactThemeMutationVariables>(UpdateArtifactThemeDocument, options);
      }
export type UpdateArtifactThemeMutationHookResult = ReturnType<typeof useUpdateArtifactThemeMutation>;
export type UpdateArtifactThemeMutationResult = Apollo.MutationResult<UpdateArtifactThemeMutation>;
export type UpdateArtifactThemeMutationOptions = Apollo.BaseMutationOptions<UpdateArtifactThemeMutation, UpdateArtifactThemeMutationVariables>;
export const ConvertSitemapToDeliverablesDocument = gql`
    mutation ConvertSitemapToDeliverables($projectId: UUID!, $sitemapData: JSON!, $uiCompletionData: JSON = null, $requirements: JSON = null) {
  convertSitemapToDeliverables(
    projectId: $projectId
    sitemapData: $sitemapData
    uiCompletionData: $uiCompletionData
    requirements: $requirements
  )
}
    `;
export type ConvertSitemapToDeliverablesMutationFn = Apollo.MutationFunction<ConvertSitemapToDeliverablesMutation, ConvertSitemapToDeliverablesMutationVariables>;

/**
 * __useConvertSitemapToDeliverablesMutation__
 *
 * To run a mutation, you first call `useConvertSitemapToDeliverablesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertSitemapToDeliverablesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertSitemapToDeliverablesMutation, { data, loading, error }] = useConvertSitemapToDeliverablesMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      sitemapData: // value for 'sitemapData'
 *      uiCompletionData: // value for 'uiCompletionData'
 *      requirements: // value for 'requirements'
 *   },
 * });
 */
export function useConvertSitemapToDeliverablesMutation(baseOptions?: Apollo.MutationHookOptions<ConvertSitemapToDeliverablesMutation, ConvertSitemapToDeliverablesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConvertSitemapToDeliverablesMutation, ConvertSitemapToDeliverablesMutationVariables>(ConvertSitemapToDeliverablesDocument, options);
      }
export type ConvertSitemapToDeliverablesMutationHookResult = ReturnType<typeof useConvertSitemapToDeliverablesMutation>;
export type ConvertSitemapToDeliverablesMutationResult = Apollo.MutationResult<ConvertSitemapToDeliverablesMutation>;
export type ConvertSitemapToDeliverablesMutationOptions = Apollo.BaseMutationOptions<ConvertSitemapToDeliverablesMutation, ConvertSitemapToDeliverablesMutationVariables>;
export const UpdateProjectSitemapDocument = gql`
    mutation UpdateProjectSitemap($projectId: UUID!, $sitemapData: JSON!) {
  updateProjectSitemap(projectId: $projectId, sitemapData: $sitemapData) {
    success
    message
    updatedAt
    error
  }
}
    `;
export type UpdateProjectSitemapMutationFn = Apollo.MutationFunction<UpdateProjectSitemapMutation, UpdateProjectSitemapMutationVariables>;

/**
 * __useUpdateProjectSitemapMutation__
 *
 * To run a mutation, you first call `useUpdateProjectSitemapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectSitemapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectSitemapMutation, { data, loading, error }] = useUpdateProjectSitemapMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      sitemapData: // value for 'sitemapData'
 *   },
 * });
 */
export function useUpdateProjectSitemapMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectSitemapMutation, UpdateProjectSitemapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectSitemapMutation, UpdateProjectSitemapMutationVariables>(UpdateProjectSitemapDocument, options);
      }
export type UpdateProjectSitemapMutationHookResult = ReturnType<typeof useUpdateProjectSitemapMutation>;
export type UpdateProjectSitemapMutationResult = Apollo.MutationResult<UpdateProjectSitemapMutation>;
export type UpdateProjectSitemapMutationOptions = Apollo.BaseMutationOptions<UpdateProjectSitemapMutation, UpdateProjectSitemapMutationVariables>;
export const CreateUiProjectDocument = gql`
    mutation CreateUiProject($input: CreateUIProjectInput!) {
  createUiProject(input: $input) {
    id
    name
    description
    createdAt
    updatedAt
    status
    sitemap
    pagesCount
    generatedFilesCount
    qualityScore
    generationTime
    uiMockUrl
    errors
    warnings
  }
}
    `;
export type CreateUiProjectMutationFn = Apollo.MutationFunction<CreateUiProjectMutation, CreateUiProjectMutationVariables>;

/**
 * __useCreateUiProjectMutation__
 *
 * To run a mutation, you first call `useCreateUiProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUiProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUiProjectMutation, { data, loading, error }] = useCreateUiProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUiProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateUiProjectMutation, CreateUiProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUiProjectMutation, CreateUiProjectMutationVariables>(CreateUiProjectDocument, options);
      }
export type CreateUiProjectMutationHookResult = ReturnType<typeof useCreateUiProjectMutation>;
export type CreateUiProjectMutationResult = Apollo.MutationResult<CreateUiProjectMutation>;
export type CreateUiProjectMutationOptions = Apollo.BaseMutationOptions<CreateUiProjectMutation, CreateUiProjectMutationVariables>;
export const UpdateUiProjectDocument = gql`
    mutation UpdateUiProject($projectId: String!, $input: UpdateUIProjectInput!) {
  updateUiProject(projectId: $projectId, input: $input) {
    id
    name
    description
    createdAt
    updatedAt
    status
    sitemap
    pagesCount
    generatedFilesCount
    qualityScore
    generationTime
    uiMockUrl
    errors
    warnings
  }
}
    `;
export type UpdateUiProjectMutationFn = Apollo.MutationFunction<UpdateUiProjectMutation, UpdateUiProjectMutationVariables>;

/**
 * __useUpdateUiProjectMutation__
 *
 * To run a mutation, you first call `useUpdateUiProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUiProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUiProjectMutation, { data, loading, error }] = useUpdateUiProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUiProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUiProjectMutation, UpdateUiProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUiProjectMutation, UpdateUiProjectMutationVariables>(UpdateUiProjectDocument, options);
      }
export type UpdateUiProjectMutationHookResult = ReturnType<typeof useUpdateUiProjectMutation>;
export type UpdateUiProjectMutationResult = Apollo.MutationResult<UpdateUiProjectMutation>;
export type UpdateUiProjectMutationOptions = Apollo.BaseMutationOptions<UpdateUiProjectMutation, UpdateUiProjectMutationVariables>;
export const DeleteUiProjectDocument = gql`
    mutation DeleteUiProject($projectId: String!) {
  deleteUiProject(projectId: $projectId)
}
    `;
export type DeleteUiProjectMutationFn = Apollo.MutationFunction<DeleteUiProjectMutation, DeleteUiProjectMutationVariables>;

/**
 * __useDeleteUiProjectMutation__
 *
 * To run a mutation, you first call `useDeleteUiProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUiProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUiProjectMutation, { data, loading, error }] = useDeleteUiProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDeleteUiProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUiProjectMutation, DeleteUiProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUiProjectMutation, DeleteUiProjectMutationVariables>(DeleteUiProjectDocument, options);
      }
export type DeleteUiProjectMutationHookResult = ReturnType<typeof useDeleteUiProjectMutation>;
export type DeleteUiProjectMutationResult = Apollo.MutationResult<DeleteUiProjectMutation>;
export type DeleteUiProjectMutationOptions = Apollo.BaseMutationOptions<DeleteUiProjectMutation, DeleteUiProjectMutationVariables>;
export const UpdateProjectContextDocument = gql`
    mutation UpdateProjectContext($projectId: UUID!, $purpose: String = null, $targetAudience: String = null, $objectives: [String!] = null, $estimatedScale: String = null, $additionalNotes: String = null) {
  updateProjectContext(
    projectId: $projectId
    purpose: $purpose
    targetAudience: $targetAudience
    objectives: $objectives
    estimatedScale: $estimatedScale
    additionalNotes: $additionalNotes
  )
}
    `;
export type UpdateProjectContextMutationFn = Apollo.MutationFunction<UpdateProjectContextMutation, UpdateProjectContextMutationVariables>;

/**
 * __useUpdateProjectContextMutation__
 *
 * To run a mutation, you first call `useUpdateProjectContextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectContextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectContextMutation, { data, loading, error }] = useUpdateProjectContextMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      purpose: // value for 'purpose'
 *      targetAudience: // value for 'targetAudience'
 *      objectives: // value for 'objectives'
 *      estimatedScale: // value for 'estimatedScale'
 *      additionalNotes: // value for 'additionalNotes'
 *   },
 * });
 */
export function useUpdateProjectContextMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectContextMutation, UpdateProjectContextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectContextMutation, UpdateProjectContextMutationVariables>(UpdateProjectContextDocument, options);
      }
export type UpdateProjectContextMutationHookResult = ReturnType<typeof useUpdateProjectContextMutation>;
export type UpdateProjectContextMutationResult = Apollo.MutationResult<UpdateProjectContextMutation>;
export type UpdateProjectContextMutationOptions = Apollo.BaseMutationOptions<UpdateProjectContextMutation, UpdateProjectContextMutationVariables>;
export const GenerateDesignProposalsDocument = gql`
    mutation GenerateDesignProposals($projectId: ID!, $referenceUrls: [String!] = null) {
  generateDesignProposals(projectId: $projectId, referenceUrls: $referenceUrls)
}
    `;
export type GenerateDesignProposalsMutationFn = Apollo.MutationFunction<GenerateDesignProposalsMutation, GenerateDesignProposalsMutationVariables>;

/**
 * __useGenerateDesignProposalsMutation__
 *
 * To run a mutation, you first call `useGenerateDesignProposalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateDesignProposalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateDesignProposalsMutation, { data, loading, error }] = useGenerateDesignProposalsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      referenceUrls: // value for 'referenceUrls'
 *   },
 * });
 */
export function useGenerateDesignProposalsMutation(baseOptions?: Apollo.MutationHookOptions<GenerateDesignProposalsMutation, GenerateDesignProposalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateDesignProposalsMutation, GenerateDesignProposalsMutationVariables>(GenerateDesignProposalsDocument, options);
      }
export type GenerateDesignProposalsMutationHookResult = ReturnType<typeof useGenerateDesignProposalsMutation>;
export type GenerateDesignProposalsMutationResult = Apollo.MutationResult<GenerateDesignProposalsMutation>;
export type GenerateDesignProposalsMutationOptions = Apollo.BaseMutationOptions<GenerateDesignProposalsMutation, GenerateDesignProposalsMutationVariables>;
export const SelectDesignProposalDocument = gql`
    mutation SelectDesignProposal($proposalId: ID!) {
  selectDesignProposal(proposalId: $proposalId)
}
    `;
export type SelectDesignProposalMutationFn = Apollo.MutationFunction<SelectDesignProposalMutation, SelectDesignProposalMutationVariables>;

/**
 * __useSelectDesignProposalMutation__
 *
 * To run a mutation, you first call `useSelectDesignProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectDesignProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectDesignProposalMutation, { data, loading, error }] = useSelectDesignProposalMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useSelectDesignProposalMutation(baseOptions?: Apollo.MutationHookOptions<SelectDesignProposalMutation, SelectDesignProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelectDesignProposalMutation, SelectDesignProposalMutationVariables>(SelectDesignProposalDocument, options);
      }
export type SelectDesignProposalMutationHookResult = ReturnType<typeof useSelectDesignProposalMutation>;
export type SelectDesignProposalMutationResult = Apollo.MutationResult<SelectDesignProposalMutation>;
export type SelectDesignProposalMutationOptions = Apollo.BaseMutationOptions<SelectDesignProposalMutation, SelectDesignProposalMutationVariables>;
export const DeleteDesignProposalsDocument = gql`
    mutation DeleteDesignProposals($projectId: ID!) {
  deleteDesignProposals(projectId: $projectId)
}
    `;
export type DeleteDesignProposalsMutationFn = Apollo.MutationFunction<DeleteDesignProposalsMutation, DeleteDesignProposalsMutationVariables>;

/**
 * __useDeleteDesignProposalsMutation__
 *
 * To run a mutation, you first call `useDeleteDesignProposalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDesignProposalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDesignProposalsMutation, { data, loading, error }] = useDeleteDesignProposalsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useDeleteDesignProposalsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDesignProposalsMutation, DeleteDesignProposalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDesignProposalsMutation, DeleteDesignProposalsMutationVariables>(DeleteDesignProposalsDocument, options);
      }
export type DeleteDesignProposalsMutationHookResult = ReturnType<typeof useDeleteDesignProposalsMutation>;
export type DeleteDesignProposalsMutationResult = Apollo.MutationResult<DeleteDesignProposalsMutation>;
export type DeleteDesignProposalsMutationOptions = Apollo.BaseMutationOptions<DeleteDesignProposalsMutation, DeleteDesignProposalsMutationVariables>;
export const GenerateStubArtifactDocument = gql`
    mutation GenerateStubArtifact($projectId: String!) {
  generateStubArtifact(projectId: $projectId) {
    success
    artifactId
    title
    fileCount
    error
  }
}
    `;
export type GenerateStubArtifactMutationFn = Apollo.MutationFunction<GenerateStubArtifactMutation, GenerateStubArtifactMutationVariables>;

/**
 * __useGenerateStubArtifactMutation__
 *
 * To run a mutation, you first call `useGenerateStubArtifactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateStubArtifactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateStubArtifactMutation, { data, loading, error }] = useGenerateStubArtifactMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGenerateStubArtifactMutation(baseOptions?: Apollo.MutationHookOptions<GenerateStubArtifactMutation, GenerateStubArtifactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateStubArtifactMutation, GenerateStubArtifactMutationVariables>(GenerateStubArtifactDocument, options);
      }
export type GenerateStubArtifactMutationHookResult = ReturnType<typeof useGenerateStubArtifactMutation>;
export type GenerateStubArtifactMutationResult = Apollo.MutationResult<GenerateStubArtifactMutation>;
export type GenerateStubArtifactMutationOptions = Apollo.BaseMutationOptions<GenerateStubArtifactMutation, GenerateStubArtifactMutationVariables>;
export const GetProjectDddDocument = gql`
    query GetProjectDdd($id: UUID!) {
  projectDdd(id: $id) {
    id
    name
    description
    clientId
    organizationId
    ownerId
    groupId
    projectType
    status
    priority
    developmentType
    projectPhase
    progress
    constitutionalFacts
    constitutionalVersion
    constitutionalApprovedBy
    constitutionalApprovedAt
    hasApprovedConstitution
    contextAnalysis
    contextAnalysisUpdatedAt
    promptEvolution {
      core
      version
      updatedAt
      history
      elements {
        needs {
          id
          content
          category
          priority
          createdAt
        }
        seeds {
          id
          content
          type
          confidence
          createdAt
        }
        wildIdeas {
          id
          content
          category
          riskLevel
          createdAt
        }
      }
    }
    settings
    projectMetadata
    tags
    color
    isActive
    isArchived
    archivedAt
    isDeleted
    deletedAt
    createdAt
    updatedAt
    isInProgress
    isCompleted
    canStart
    progressInfo {
      progress
      status
    }
    constitutionalLaws {
      needs
      seeds
    }
    systemInstanceId
    kind
    gitBranch
    prUrl
    prNumber
  }
}
    `;

/**
 * __useGetProjectDddQuery__
 *
 * To run a query within a React component, call `useGetProjectDddQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectDddQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectDddQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectDddQuery(baseOptions: Apollo.QueryHookOptions<GetProjectDddQuery, GetProjectDddQueryVariables> & ({ variables: GetProjectDddQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectDddQuery, GetProjectDddQueryVariables>(GetProjectDddDocument, options);
      }
export function useGetProjectDddLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectDddQuery, GetProjectDddQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectDddQuery, GetProjectDddQueryVariables>(GetProjectDddDocument, options);
        }
// @ts-ignore
export function useGetProjectDddSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectDddQuery, GetProjectDddQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectDddQuery, GetProjectDddQueryVariables>;
export function useGetProjectDddSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectDddQuery, GetProjectDddQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectDddQuery | undefined, GetProjectDddQueryVariables>;
export function useGetProjectDddSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectDddQuery, GetProjectDddQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectDddQuery, GetProjectDddQueryVariables>(GetProjectDddDocument, options);
        }
export type GetProjectDddQueryHookResult = ReturnType<typeof useGetProjectDddQuery>;
export type GetProjectDddLazyQueryHookResult = ReturnType<typeof useGetProjectDddLazyQuery>;
export type GetProjectDddSuspenseQueryHookResult = ReturnType<typeof useGetProjectDddSuspenseQuery>;
export type GetProjectDddQueryResult = Apollo.QueryResult<GetProjectDddQuery, GetProjectDddQueryVariables>;
export const GetProjectsDddDocument = gql`
    query GetProjectsDdd($organizationId: UUID!, $status: ProjectStatusType = null, $page: Int! = 1, $pageSize: Int! = 20) {
  projectsDdd(
    organizationId: $organizationId
    status: $status
    page: $page
    pageSize: $pageSize
  ) {
    projects {
      id
      name
      description
      clientId
      organizationId
      ownerId
      groupId
      projectType
      status
      priority
      developmentType
      projectPhase
      progress
      constitutionalFacts
      constitutionalVersion
      constitutionalApprovedBy
      constitutionalApprovedAt
      hasApprovedConstitution
      contextAnalysis
      contextAnalysisUpdatedAt
      settings
      projectMetadata
      tags
      color
      isActive
      isArchived
      archivedAt
      isDeleted
      deletedAt
      createdAt
      updatedAt
      isInProgress
      isCompleted
      canStart
      systemInstanceId
      kind
      gitBranch
      prUrl
      prNumber
      promptEvolution {
        core
        version
        updatedAt
        history
      }
      progressInfo {
        progress
        status
      }
      constitutionalLaws {
        needs
        seeds
      }
    }
    totalCount
    page
    pageSize
    hasNextPage
    hasPreviousPage
  }
}
    `;

/**
 * __useGetProjectsDddQuery__
 *
 * To run a query within a React component, call `useGetProjectsDddQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsDddQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsDddQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      status: // value for 'status'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetProjectsDddQuery(baseOptions: Apollo.QueryHookOptions<GetProjectsDddQuery, GetProjectsDddQueryVariables> & ({ variables: GetProjectsDddQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectsDddQuery, GetProjectsDddQueryVariables>(GetProjectsDddDocument, options);
      }
export function useGetProjectsDddLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectsDddQuery, GetProjectsDddQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectsDddQuery, GetProjectsDddQueryVariables>(GetProjectsDddDocument, options);
        }
// @ts-ignore
export function useGetProjectsDddSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectsDddQuery, GetProjectsDddQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectsDddQuery, GetProjectsDddQueryVariables>;
export function useGetProjectsDddSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectsDddQuery, GetProjectsDddQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectsDddQuery | undefined, GetProjectsDddQueryVariables>;
export function useGetProjectsDddSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectsDddQuery, GetProjectsDddQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectsDddQuery, GetProjectsDddQueryVariables>(GetProjectsDddDocument, options);
        }
export type GetProjectsDddQueryHookResult = ReturnType<typeof useGetProjectsDddQuery>;
export type GetProjectsDddLazyQueryHookResult = ReturnType<typeof useGetProjectsDddLazyQuery>;
export type GetProjectsDddSuspenseQueryHookResult = ReturnType<typeof useGetProjectsDddSuspenseQuery>;
export type GetProjectsDddQueryResult = Apollo.QueryResult<GetProjectsDddQuery, GetProjectsDddQueryVariables>;
export const GetTrashedProjectsDddDocument = gql`
    query GetTrashedProjectsDdd($organizationId: UUID!, $page: Int! = 1, $pageSize: Int! = 50) {
  trashedProjectsDdd(
    organizationId: $organizationId
    page: $page
    pageSize: $pageSize
  ) {
    projects {
      id
      name
      description
      clientId
      organizationId
      ownerId
      groupId
      projectType
      status
      priority
      developmentType
      projectPhase
      progress
      constitutionalFacts
      constitutionalVersion
      constitutionalApprovedBy
      constitutionalApprovedAt
      hasApprovedConstitution
      contextAnalysis
      contextAnalysisUpdatedAt
      settings
      projectMetadata
      tags
      color
      isActive
      isArchived
      archivedAt
      isDeleted
      deletedAt
      createdAt
      updatedAt
      isInProgress
      isCompleted
      canStart
      systemInstanceId
      kind
      gitBranch
      prUrl
      prNumber
      promptEvolution {
        core
        version
        updatedAt
        history
      }
      progressInfo {
        progress
        status
      }
      constitutionalLaws {
        needs
        seeds
      }
    }
    totalCount
    page
    pageSize
    hasNextPage
    hasPreviousPage
  }
}
    `;

/**
 * __useGetTrashedProjectsDddQuery__
 *
 * To run a query within a React component, call `useGetTrashedProjectsDddQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrashedProjectsDddQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrashedProjectsDddQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetTrashedProjectsDddQuery(baseOptions: Apollo.QueryHookOptions<GetTrashedProjectsDddQuery, GetTrashedProjectsDddQueryVariables> & ({ variables: GetTrashedProjectsDddQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrashedProjectsDddQuery, GetTrashedProjectsDddQueryVariables>(GetTrashedProjectsDddDocument, options);
      }
export function useGetTrashedProjectsDddLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrashedProjectsDddQuery, GetTrashedProjectsDddQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrashedProjectsDddQuery, GetTrashedProjectsDddQueryVariables>(GetTrashedProjectsDddDocument, options);
        }
// @ts-ignore
export function useGetTrashedProjectsDddSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTrashedProjectsDddQuery, GetTrashedProjectsDddQueryVariables>): Apollo.UseSuspenseQueryResult<GetTrashedProjectsDddQuery, GetTrashedProjectsDddQueryVariables>;
export function useGetTrashedProjectsDddSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTrashedProjectsDddQuery, GetTrashedProjectsDddQueryVariables>): Apollo.UseSuspenseQueryResult<GetTrashedProjectsDddQuery | undefined, GetTrashedProjectsDddQueryVariables>;
export function useGetTrashedProjectsDddSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTrashedProjectsDddQuery, GetTrashedProjectsDddQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTrashedProjectsDddQuery, GetTrashedProjectsDddQueryVariables>(GetTrashedProjectsDddDocument, options);
        }
export type GetTrashedProjectsDddQueryHookResult = ReturnType<typeof useGetTrashedProjectsDddQuery>;
export type GetTrashedProjectsDddLazyQueryHookResult = ReturnType<typeof useGetTrashedProjectsDddLazyQuery>;
export type GetTrashedProjectsDddSuspenseQueryHookResult = ReturnType<typeof useGetTrashedProjectsDddSuspenseQuery>;
export type GetTrashedProjectsDddQueryResult = Apollo.QueryResult<GetTrashedProjectsDddQuery, GetTrashedProjectsDddQueryVariables>;
export const GetProjectConstitutionDocument = gql`
    query GetProjectConstitution($projectId: UUID!) {
  projectConstitution(projectId: $projectId) {
    projectId
    facts {
      key
      fact {
        key
        value
        factType
        sourceType
        sourceRef
        confidence
        extractedAt
        notes
      }
    }
    version
    approvedBy
    approvedAt
    history {
      version
      changedAt
      changedBy
      changes
      factsSnapshot
      reason
    }
    needsLaws
    seedsLaws
    lastAnalysisAt
    totalFactsCount
    confirmedFactsCount
    pendingFactsCount
  }
}
    `;

/**
 * __useGetProjectConstitutionQuery__
 *
 * To run a query within a React component, call `useGetProjectConstitutionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectConstitutionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectConstitutionQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectConstitutionQuery(baseOptions: Apollo.QueryHookOptions<GetProjectConstitutionQuery, GetProjectConstitutionQueryVariables> & ({ variables: GetProjectConstitutionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectConstitutionQuery, GetProjectConstitutionQueryVariables>(GetProjectConstitutionDocument, options);
      }
export function useGetProjectConstitutionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectConstitutionQuery, GetProjectConstitutionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectConstitutionQuery, GetProjectConstitutionQueryVariables>(GetProjectConstitutionDocument, options);
        }
// @ts-ignore
export function useGetProjectConstitutionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectConstitutionQuery, GetProjectConstitutionQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectConstitutionQuery, GetProjectConstitutionQueryVariables>;
export function useGetProjectConstitutionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectConstitutionQuery, GetProjectConstitutionQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectConstitutionQuery | undefined, GetProjectConstitutionQueryVariables>;
export function useGetProjectConstitutionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectConstitutionQuery, GetProjectConstitutionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectConstitutionQuery, GetProjectConstitutionQueryVariables>(GetProjectConstitutionDocument, options);
        }
export type GetProjectConstitutionQueryHookResult = ReturnType<typeof useGetProjectConstitutionQuery>;
export type GetProjectConstitutionLazyQueryHookResult = ReturnType<typeof useGetProjectConstitutionLazyQuery>;
export type GetProjectConstitutionSuspenseQueryHookResult = ReturnType<typeof useGetProjectConstitutionSuspenseQuery>;
export type GetProjectConstitutionQueryResult = Apollo.QueryResult<GetProjectConstitutionQuery, GetProjectConstitutionQueryVariables>;
export const GetConstitutionCandidatesDocument = gql`
    query GetConstitutionCandidates($projectId: UUID!) {
  constitutionCandidates(projectId: $projectId) {
    id
    factType
    key
    value
    source
    confidence
    reasoning
    extractedFrom
    createdAt
  }
}
    `;

/**
 * __useGetConstitutionCandidatesQuery__
 *
 * To run a query within a React component, call `useGetConstitutionCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConstitutionCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConstitutionCandidatesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetConstitutionCandidatesQuery(baseOptions: Apollo.QueryHookOptions<GetConstitutionCandidatesQuery, GetConstitutionCandidatesQueryVariables> & ({ variables: GetConstitutionCandidatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConstitutionCandidatesQuery, GetConstitutionCandidatesQueryVariables>(GetConstitutionCandidatesDocument, options);
      }
export function useGetConstitutionCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConstitutionCandidatesQuery, GetConstitutionCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConstitutionCandidatesQuery, GetConstitutionCandidatesQueryVariables>(GetConstitutionCandidatesDocument, options);
        }
// @ts-ignore
export function useGetConstitutionCandidatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConstitutionCandidatesQuery, GetConstitutionCandidatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetConstitutionCandidatesQuery, GetConstitutionCandidatesQueryVariables>;
export function useGetConstitutionCandidatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConstitutionCandidatesQuery, GetConstitutionCandidatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetConstitutionCandidatesQuery | undefined, GetConstitutionCandidatesQueryVariables>;
export function useGetConstitutionCandidatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConstitutionCandidatesQuery, GetConstitutionCandidatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConstitutionCandidatesQuery, GetConstitutionCandidatesQueryVariables>(GetConstitutionCandidatesDocument, options);
        }
export type GetConstitutionCandidatesQueryHookResult = ReturnType<typeof useGetConstitutionCandidatesQuery>;
export type GetConstitutionCandidatesLazyQueryHookResult = ReturnType<typeof useGetConstitutionCandidatesLazyQuery>;
export type GetConstitutionCandidatesSuspenseQueryHookResult = ReturnType<typeof useGetConstitutionCandidatesSuspenseQuery>;
export type GetConstitutionCandidatesQueryResult = Apollo.QueryResult<GetConstitutionCandidatesQuery, GetConstitutionCandidatesQueryVariables>;
export const GetProjectDeliverableDocument = gql`
    query GetProjectDeliverable($projectId: String!) {
  projectDeliverable(projectId: $projectId) {
    id
    projectId
    name
    description
    priority
    boundedContexts {
      name
      nameJa
      type
      justification
      integrationApi
      isFrozen
      entityCount
      dynamicSpec
      publishes {
        name
        description
        payloadFields
        sourceBc
        action
      }
      subscribes {
        name
        description
        payloadFields
        sourceBc
        action
      }
      refs {
        targetBc
        targetEntity
        rpc
        listRpc
        purpose
        sourceField
      }
      entities {
        name
        nameJa
        fieldCount
        keyFields
      }
    }
    adminPages {
      bc
      entity
      role
      audience
      enabledActions
      labelJa
      description
    }
    publicPages {
      path
      role
      title
      primaryBc
      primaryEntity
      secondaryBcs
      displayFields
      actions
      audience
      acceptance
      description
      requiresAuth
    }
    enabledScenes
    businessFlowStories {
      name
      nameEn
      category
      description
      priority
      involvedBcs
      steps {
        order
        actor
        action
        stepType
        bc
        entity
        pagePath
        isPublic
        mutation
        query
        requiresAuth
        triggerEvent
        triggerAction
        condition
        yesStep
        noStep
        notificationChannel
        description
      }
    }
    systemArchitecture {
      architectureType
      deploymentStrategy
      componentCount
      scalingConsiderations
      componentsJson
    }
    version
    progress
    estimatedHours
    actualHours
    createdBy
    createdAt
    updatedAt
    isCompleted
    completionPercentage
    bcCount
    publicPageCount
    adminPageCount
  }
}
    `;

/**
 * __useGetProjectDeliverableQuery__
 *
 * To run a query within a React component, call `useGetProjectDeliverableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectDeliverableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectDeliverableQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectDeliverableQuery(baseOptions: Apollo.QueryHookOptions<GetProjectDeliverableQuery, GetProjectDeliverableQueryVariables> & ({ variables: GetProjectDeliverableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectDeliverableQuery, GetProjectDeliverableQueryVariables>(GetProjectDeliverableDocument, options);
      }
export function useGetProjectDeliverableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectDeliverableQuery, GetProjectDeliverableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectDeliverableQuery, GetProjectDeliverableQueryVariables>(GetProjectDeliverableDocument, options);
        }
// @ts-ignore
export function useGetProjectDeliverableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectDeliverableQuery, GetProjectDeliverableQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectDeliverableQuery, GetProjectDeliverableQueryVariables>;
export function useGetProjectDeliverableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectDeliverableQuery, GetProjectDeliverableQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectDeliverableQuery | undefined, GetProjectDeliverableQueryVariables>;
export function useGetProjectDeliverableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectDeliverableQuery, GetProjectDeliverableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectDeliverableQuery, GetProjectDeliverableQueryVariables>(GetProjectDeliverableDocument, options);
        }
export type GetProjectDeliverableQueryHookResult = ReturnType<typeof useGetProjectDeliverableQuery>;
export type GetProjectDeliverableLazyQueryHookResult = ReturnType<typeof useGetProjectDeliverableLazyQuery>;
export type GetProjectDeliverableSuspenseQueryHookResult = ReturnType<typeof useGetProjectDeliverableSuspenseQuery>;
export type GetProjectDeliverableQueryResult = Apollo.QueryResult<GetProjectDeliverableQuery, GetProjectDeliverableQueryVariables>;
export const GetProjectDeliverablesDocument = gql`
    query GetProjectDeliverables($filter: ProjectDeliverableFilterInput = null) {
  projectDeliverables(filter: $filter) {
    deliverables {
      id
      projectId
      name
      description
      priority
      enabledScenes
      version
      progress
      estimatedHours
      actualHours
      createdBy
      createdAt
      updatedAt
      isCompleted
      completionPercentage
      bcCount
      publicPageCount
      adminPageCount
      boundedContexts {
        name
        nameJa
        type
        justification
        integrationApi
        isFrozen
        entityCount
        dynamicSpec
      }
      adminPages {
        bc
        entity
        role
        audience
        enabledActions
        labelJa
        description
      }
      publicPages {
        path
        role
        title
        primaryBc
        primaryEntity
        secondaryBcs
        displayFields
        actions
        audience
        acceptance
        description
        requiresAuth
      }
      businessFlowStories {
        name
        nameEn
        category
        description
        priority
        involvedBcs
      }
      systemArchitecture {
        architectureType
        deploymentStrategy
        componentCount
        scalingConsiderations
        componentsJson
      }
    }
    totalCount
  }
}
    `;

/**
 * __useGetProjectDeliverablesQuery__
 *
 * To run a query within a React component, call `useGetProjectDeliverablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectDeliverablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectDeliverablesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetProjectDeliverablesQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectDeliverablesQuery, GetProjectDeliverablesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectDeliverablesQuery, GetProjectDeliverablesQueryVariables>(GetProjectDeliverablesDocument, options);
      }
export function useGetProjectDeliverablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectDeliverablesQuery, GetProjectDeliverablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectDeliverablesQuery, GetProjectDeliverablesQueryVariables>(GetProjectDeliverablesDocument, options);
        }
// @ts-ignore
export function useGetProjectDeliverablesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectDeliverablesQuery, GetProjectDeliverablesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectDeliverablesQuery, GetProjectDeliverablesQueryVariables>;
export function useGetProjectDeliverablesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectDeliverablesQuery, GetProjectDeliverablesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectDeliverablesQuery | undefined, GetProjectDeliverablesQueryVariables>;
export function useGetProjectDeliverablesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectDeliverablesQuery, GetProjectDeliverablesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectDeliverablesQuery, GetProjectDeliverablesQueryVariables>(GetProjectDeliverablesDocument, options);
        }
export type GetProjectDeliverablesQueryHookResult = ReturnType<typeof useGetProjectDeliverablesQuery>;
export type GetProjectDeliverablesLazyQueryHookResult = ReturnType<typeof useGetProjectDeliverablesLazyQuery>;
export type GetProjectDeliverablesSuspenseQueryHookResult = ReturnType<typeof useGetProjectDeliverablesSuspenseQuery>;
export type GetProjectDeliverablesQueryResult = Apollo.QueryResult<GetProjectDeliverablesQuery, GetProjectDeliverablesQueryVariables>;
export const GetProjectAiProposalStatesDocument = gql`
    query GetProjectAiProposalStates($projectIds: [String!]!) {
  projectAiProposalStates(projectIds: $projectIds) {
    projectId
    hasProposal
    bcCount
    adminPageCount
    publicPageCount
    deliverableVersion
    lastUpdatedAt
  }
}
    `;

/**
 * __useGetProjectAiProposalStatesQuery__
 *
 * To run a query within a React component, call `useGetProjectAiProposalStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectAiProposalStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectAiProposalStatesQuery({
 *   variables: {
 *      projectIds: // value for 'projectIds'
 *   },
 * });
 */
export function useGetProjectAiProposalStatesQuery(baseOptions: Apollo.QueryHookOptions<GetProjectAiProposalStatesQuery, GetProjectAiProposalStatesQueryVariables> & ({ variables: GetProjectAiProposalStatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectAiProposalStatesQuery, GetProjectAiProposalStatesQueryVariables>(GetProjectAiProposalStatesDocument, options);
      }
export function useGetProjectAiProposalStatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectAiProposalStatesQuery, GetProjectAiProposalStatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectAiProposalStatesQuery, GetProjectAiProposalStatesQueryVariables>(GetProjectAiProposalStatesDocument, options);
        }
// @ts-ignore
export function useGetProjectAiProposalStatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectAiProposalStatesQuery, GetProjectAiProposalStatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectAiProposalStatesQuery, GetProjectAiProposalStatesQueryVariables>;
export function useGetProjectAiProposalStatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectAiProposalStatesQuery, GetProjectAiProposalStatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectAiProposalStatesQuery | undefined, GetProjectAiProposalStatesQueryVariables>;
export function useGetProjectAiProposalStatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectAiProposalStatesQuery, GetProjectAiProposalStatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectAiProposalStatesQuery, GetProjectAiProposalStatesQueryVariables>(GetProjectAiProposalStatesDocument, options);
        }
export type GetProjectAiProposalStatesQueryHookResult = ReturnType<typeof useGetProjectAiProposalStatesQuery>;
export type GetProjectAiProposalStatesLazyQueryHookResult = ReturnType<typeof useGetProjectAiProposalStatesLazyQuery>;
export type GetProjectAiProposalStatesSuspenseQueryHookResult = ReturnType<typeof useGetProjectAiProposalStatesSuspenseQuery>;
export type GetProjectAiProposalStatesQueryResult = Apollo.QueryResult<GetProjectAiProposalStatesQuery, GetProjectAiProposalStatesQueryVariables>;
export const GetProjectScopesDocument = gql`
    query GetProjectScopes($projectId: UUID!) {
  projectScopes(projectId: $projectId) {
    id
    name
    origin
    rationale
    searchQuery
    boostKeywords
    analysisLens
    projectId
    viewId
    focusAtomIds
    createdAt
    plan
    functionCandidates {
      name
      category
      description
      priority
      source
    }
  }
}
    `;

/**
 * __useGetProjectScopesQuery__
 *
 * To run a query within a React component, call `useGetProjectScopesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectScopesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectScopesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectScopesQuery(baseOptions: Apollo.QueryHookOptions<GetProjectScopesQuery, GetProjectScopesQueryVariables> & ({ variables: GetProjectScopesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectScopesQuery, GetProjectScopesQueryVariables>(GetProjectScopesDocument, options);
      }
export function useGetProjectScopesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectScopesQuery, GetProjectScopesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectScopesQuery, GetProjectScopesQueryVariables>(GetProjectScopesDocument, options);
        }
// @ts-ignore
export function useGetProjectScopesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectScopesQuery, GetProjectScopesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectScopesQuery, GetProjectScopesQueryVariables>;
export function useGetProjectScopesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectScopesQuery, GetProjectScopesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectScopesQuery | undefined, GetProjectScopesQueryVariables>;
export function useGetProjectScopesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectScopesQuery, GetProjectScopesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectScopesQuery, GetProjectScopesQueryVariables>(GetProjectScopesDocument, options);
        }
export type GetProjectScopesQueryHookResult = ReturnType<typeof useGetProjectScopesQuery>;
export type GetProjectScopesLazyQueryHookResult = ReturnType<typeof useGetProjectScopesLazyQuery>;
export type GetProjectScopesSuspenseQueryHookResult = ReturnType<typeof useGetProjectScopesSuspenseQuery>;
export type GetProjectScopesQueryResult = Apollo.QueryResult<GetProjectScopesQuery, GetProjectScopesQueryVariables>;
export const GetProjectViewsDocument = gql`
    query GetProjectViews($projectId: UUID!, $limit: Int! = 50) {
  projectViews(projectId: $projectId, limit: $limit) {
    id
    projectId
    sourceType
    analysisSummary
    analysisResult
    sourceAtomIds
    scopeId
    generatedAt
  }
}
    `;

/**
 * __useGetProjectViewsQuery__
 *
 * To run a query within a React component, call `useGetProjectViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectViewsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetProjectViewsQuery(baseOptions: Apollo.QueryHookOptions<GetProjectViewsQuery, GetProjectViewsQueryVariables> & ({ variables: GetProjectViewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectViewsQuery, GetProjectViewsQueryVariables>(GetProjectViewsDocument, options);
      }
export function useGetProjectViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectViewsQuery, GetProjectViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectViewsQuery, GetProjectViewsQueryVariables>(GetProjectViewsDocument, options);
        }
// @ts-ignore
export function useGetProjectViewsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectViewsQuery, GetProjectViewsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectViewsQuery, GetProjectViewsQueryVariables>;
export function useGetProjectViewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectViewsQuery, GetProjectViewsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectViewsQuery | undefined, GetProjectViewsQueryVariables>;
export function useGetProjectViewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectViewsQuery, GetProjectViewsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectViewsQuery, GetProjectViewsQueryVariables>(GetProjectViewsDocument, options);
        }
export type GetProjectViewsQueryHookResult = ReturnType<typeof useGetProjectViewsQuery>;
export type GetProjectViewsLazyQueryHookResult = ReturnType<typeof useGetProjectViewsLazyQuery>;
export type GetProjectViewsSuspenseQueryHookResult = ReturnType<typeof useGetProjectViewsSuspenseQuery>;
export type GetProjectViewsQueryResult = Apollo.QueryResult<GetProjectViewsQuery, GetProjectViewsQueryVariables>;
export const GetOrientForProjectDocument = gql`
    query GetOrientForProject($projectId: UUID!) {
  orientForProject(projectId: $projectId) {
    id
    projectId
    summary
    recommendations
    confidence
    modelUsed
    judgments {
      aspect
      assessment
      severity
      actionable
    }
    generatedAt
    projectContext {
      purpose
      targetAudience
      objectives
      estimatedScale
      additionalNotes
    }
    userLockedFields
  }
}
    `;

/**
 * __useGetOrientForProjectQuery__
 *
 * To run a query within a React component, call `useGetOrientForProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrientForProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrientForProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetOrientForProjectQuery(baseOptions: Apollo.QueryHookOptions<GetOrientForProjectQuery, GetOrientForProjectQueryVariables> & ({ variables: GetOrientForProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrientForProjectQuery, GetOrientForProjectQueryVariables>(GetOrientForProjectDocument, options);
      }
export function useGetOrientForProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrientForProjectQuery, GetOrientForProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrientForProjectQuery, GetOrientForProjectQueryVariables>(GetOrientForProjectDocument, options);
        }
// @ts-ignore
export function useGetOrientForProjectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrientForProjectQuery, GetOrientForProjectQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrientForProjectQuery, GetOrientForProjectQueryVariables>;
export function useGetOrientForProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrientForProjectQuery, GetOrientForProjectQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrientForProjectQuery | undefined, GetOrientForProjectQueryVariables>;
export function useGetOrientForProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrientForProjectQuery, GetOrientForProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrientForProjectQuery, GetOrientForProjectQueryVariables>(GetOrientForProjectDocument, options);
        }
export type GetOrientForProjectQueryHookResult = ReturnType<typeof useGetOrientForProjectQuery>;
export type GetOrientForProjectLazyQueryHookResult = ReturnType<typeof useGetOrientForProjectLazyQuery>;
export type GetOrientForProjectSuspenseQueryHookResult = ReturnType<typeof useGetOrientForProjectSuspenseQuery>;
export type GetOrientForProjectQueryResult = Apollo.QueryResult<GetOrientForProjectQuery, GetOrientForProjectQueryVariables>;
export const GetProjectGroundedEntitiesDocument = gql`
    query GetProjectGroundedEntities($projectId: UUID!) {
  projectGroundedEntities(projectId: $projectId) {
    name
    canonicalName
    entityType
    category
    description
    officialUrl
    providerCompany
    keyFeatures
    technologyStack
    integrationProtocols
    industryRelevance
    confidence
    resolvedAt
    atomCount
  }
}
    `;

/**
 * __useGetProjectGroundedEntitiesQuery__
 *
 * To run a query within a React component, call `useGetProjectGroundedEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectGroundedEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectGroundedEntitiesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectGroundedEntitiesQuery(baseOptions: Apollo.QueryHookOptions<GetProjectGroundedEntitiesQuery, GetProjectGroundedEntitiesQueryVariables> & ({ variables: GetProjectGroundedEntitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectGroundedEntitiesQuery, GetProjectGroundedEntitiesQueryVariables>(GetProjectGroundedEntitiesDocument, options);
      }
export function useGetProjectGroundedEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectGroundedEntitiesQuery, GetProjectGroundedEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectGroundedEntitiesQuery, GetProjectGroundedEntitiesQueryVariables>(GetProjectGroundedEntitiesDocument, options);
        }
// @ts-ignore
export function useGetProjectGroundedEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectGroundedEntitiesQuery, GetProjectGroundedEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectGroundedEntitiesQuery, GetProjectGroundedEntitiesQueryVariables>;
export function useGetProjectGroundedEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectGroundedEntitiesQuery, GetProjectGroundedEntitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectGroundedEntitiesQuery | undefined, GetProjectGroundedEntitiesQueryVariables>;
export function useGetProjectGroundedEntitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectGroundedEntitiesQuery, GetProjectGroundedEntitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectGroundedEntitiesQuery, GetProjectGroundedEntitiesQueryVariables>(GetProjectGroundedEntitiesDocument, options);
        }
export type GetProjectGroundedEntitiesQueryHookResult = ReturnType<typeof useGetProjectGroundedEntitiesQuery>;
export type GetProjectGroundedEntitiesLazyQueryHookResult = ReturnType<typeof useGetProjectGroundedEntitiesLazyQuery>;
export type GetProjectGroundedEntitiesSuspenseQueryHookResult = ReturnType<typeof useGetProjectGroundedEntitiesSuspenseQuery>;
export type GetProjectGroundedEntitiesQueryResult = Apollo.QueryResult<GetProjectGroundedEntitiesQuery, GetProjectGroundedEntitiesQueryVariables>;
export const GetArtifactDddDocument = gql`
    query GetArtifactDdd($id: UUID!) {
  artifactDdd(id: $id) {
    id
    projectId
    artifactType
    title
    description
    format
    content
    fileUrl
    fileSize
    status
    metadata
    createdBy
    createdAt
    generatedAt
    systemSpecData
    proposalMetadata {
      style
      includesDeliverables
      includesSitemap
      includesTechSpecs
      deliverablesCount
      sitemapPagesCount
      techComponentsCount
      estimatedReadingTime
      targetAudience
      totalContentLength
      dataSource
    }
  }
}
    `;

/**
 * __useGetArtifactDddQuery__
 *
 * To run a query within a React component, call `useGetArtifactDddQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArtifactDddQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArtifactDddQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetArtifactDddQuery(baseOptions: Apollo.QueryHookOptions<GetArtifactDddQuery, GetArtifactDddQueryVariables> & ({ variables: GetArtifactDddQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArtifactDddQuery, GetArtifactDddQueryVariables>(GetArtifactDddDocument, options);
      }
export function useGetArtifactDddLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArtifactDddQuery, GetArtifactDddQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArtifactDddQuery, GetArtifactDddQueryVariables>(GetArtifactDddDocument, options);
        }
// @ts-ignore
export function useGetArtifactDddSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetArtifactDddQuery, GetArtifactDddQueryVariables>): Apollo.UseSuspenseQueryResult<GetArtifactDddQuery, GetArtifactDddQueryVariables>;
export function useGetArtifactDddSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArtifactDddQuery, GetArtifactDddQueryVariables>): Apollo.UseSuspenseQueryResult<GetArtifactDddQuery | undefined, GetArtifactDddQueryVariables>;
export function useGetArtifactDddSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArtifactDddQuery, GetArtifactDddQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArtifactDddQuery, GetArtifactDddQueryVariables>(GetArtifactDddDocument, options);
        }
export type GetArtifactDddQueryHookResult = ReturnType<typeof useGetArtifactDddQuery>;
export type GetArtifactDddLazyQueryHookResult = ReturnType<typeof useGetArtifactDddLazyQuery>;
export type GetArtifactDddSuspenseQueryHookResult = ReturnType<typeof useGetArtifactDddSuspenseQuery>;
export type GetArtifactDddQueryResult = Apollo.QueryResult<GetArtifactDddQuery, GetArtifactDddQueryVariables>;
export const GetArtifactsDddDocument = gql`
    query GetArtifactsDdd($projectId: UUID = null, $artifactType: String = null, $status: String = null, $first: Int = 50, $offset: Int = 0) {
  artifactsDdd(
    projectId: $projectId
    artifactType: $artifactType
    status: $status
    first: $first
    offset: $offset
  ) {
    id
    projectId
    artifactType
    title
    description
    format
    content
    fileUrl
    fileSize
    status
    metadata
    createdBy
    createdAt
    generatedAt
    systemSpecData
    proposalMetadata {
      style
      includesDeliverables
      includesSitemap
      includesTechSpecs
      deliverablesCount
      sitemapPagesCount
      techComponentsCount
      estimatedReadingTime
      targetAudience
      totalContentLength
      dataSource
    }
  }
}
    `;

/**
 * __useGetArtifactsDddQuery__
 *
 * To run a query within a React component, call `useGetArtifactsDddQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArtifactsDddQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArtifactsDddQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      artifactType: // value for 'artifactType'
 *      status: // value for 'status'
 *      first: // value for 'first'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetArtifactsDddQuery(baseOptions?: Apollo.QueryHookOptions<GetArtifactsDddQuery, GetArtifactsDddQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArtifactsDddQuery, GetArtifactsDddQueryVariables>(GetArtifactsDddDocument, options);
      }
export function useGetArtifactsDddLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArtifactsDddQuery, GetArtifactsDddQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArtifactsDddQuery, GetArtifactsDddQueryVariables>(GetArtifactsDddDocument, options);
        }
// @ts-ignore
export function useGetArtifactsDddSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetArtifactsDddQuery, GetArtifactsDddQueryVariables>): Apollo.UseSuspenseQueryResult<GetArtifactsDddQuery, GetArtifactsDddQueryVariables>;
export function useGetArtifactsDddSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArtifactsDddQuery, GetArtifactsDddQueryVariables>): Apollo.UseSuspenseQueryResult<GetArtifactsDddQuery | undefined, GetArtifactsDddQueryVariables>;
export function useGetArtifactsDddSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArtifactsDddQuery, GetArtifactsDddQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArtifactsDddQuery, GetArtifactsDddQueryVariables>(GetArtifactsDddDocument, options);
        }
export type GetArtifactsDddQueryHookResult = ReturnType<typeof useGetArtifactsDddQuery>;
export type GetArtifactsDddLazyQueryHookResult = ReturnType<typeof useGetArtifactsDddLazyQuery>;
export type GetArtifactsDddSuspenseQueryHookResult = ReturnType<typeof useGetArtifactsDddSuspenseQuery>;
export type GetArtifactsDddQueryResult = Apollo.QueryResult<GetArtifactsDddQuery, GetArtifactsDddQueryVariables>;
export const GetProjectArtifactsDddDocument = gql`
    query GetProjectArtifactsDdd($projectId: UUID!, $artifactType: String = null, $first: Int = null) {
  projectArtifactsDdd(
    projectId: $projectId
    artifactType: $artifactType
    first: $first
  ) {
    edges {
      cursor
      node {
        id
        projectId
        artifactType
        title
        description
        format
        content
        fileUrl
        fileSize
        status
        metadata
        createdBy
        createdAt
        generatedAt
        systemSpecData
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetProjectArtifactsDddQuery__
 *
 * To run a query within a React component, call `useGetProjectArtifactsDddQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectArtifactsDddQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectArtifactsDddQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      artifactType: // value for 'artifactType'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetProjectArtifactsDddQuery(baseOptions: Apollo.QueryHookOptions<GetProjectArtifactsDddQuery, GetProjectArtifactsDddQueryVariables> & ({ variables: GetProjectArtifactsDddQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectArtifactsDddQuery, GetProjectArtifactsDddQueryVariables>(GetProjectArtifactsDddDocument, options);
      }
export function useGetProjectArtifactsDddLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectArtifactsDddQuery, GetProjectArtifactsDddQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectArtifactsDddQuery, GetProjectArtifactsDddQueryVariables>(GetProjectArtifactsDddDocument, options);
        }
// @ts-ignore
export function useGetProjectArtifactsDddSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectArtifactsDddQuery, GetProjectArtifactsDddQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectArtifactsDddQuery, GetProjectArtifactsDddQueryVariables>;
export function useGetProjectArtifactsDddSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectArtifactsDddQuery, GetProjectArtifactsDddQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectArtifactsDddQuery | undefined, GetProjectArtifactsDddQueryVariables>;
export function useGetProjectArtifactsDddSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectArtifactsDddQuery, GetProjectArtifactsDddQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectArtifactsDddQuery, GetProjectArtifactsDddQueryVariables>(GetProjectArtifactsDddDocument, options);
        }
export type GetProjectArtifactsDddQueryHookResult = ReturnType<typeof useGetProjectArtifactsDddQuery>;
export type GetProjectArtifactsDddLazyQueryHookResult = ReturnType<typeof useGetProjectArtifactsDddLazyQuery>;
export type GetProjectArtifactsDddSuspenseQueryHookResult = ReturnType<typeof useGetProjectArtifactsDddSuspenseQuery>;
export type GetProjectArtifactsDddQueryResult = Apollo.QueryResult<GetProjectArtifactsDddQuery, GetProjectArtifactsDddQueryVariables>;
export const GetArtifactPreviewHtmlDocument = gql`
    query GetArtifactPreviewHtml($artifactId: UUID!, $colorScheme: String = null) {
  artifactPreviewHtml(artifactId: $artifactId, colorScheme: $colorScheme)
}
    `;

/**
 * __useGetArtifactPreviewHtmlQuery__
 *
 * To run a query within a React component, call `useGetArtifactPreviewHtmlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArtifactPreviewHtmlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArtifactPreviewHtmlQuery({
 *   variables: {
 *      artifactId: // value for 'artifactId'
 *      colorScheme: // value for 'colorScheme'
 *   },
 * });
 */
export function useGetArtifactPreviewHtmlQuery(baseOptions: Apollo.QueryHookOptions<GetArtifactPreviewHtmlQuery, GetArtifactPreviewHtmlQueryVariables> & ({ variables: GetArtifactPreviewHtmlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArtifactPreviewHtmlQuery, GetArtifactPreviewHtmlQueryVariables>(GetArtifactPreviewHtmlDocument, options);
      }
export function useGetArtifactPreviewHtmlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArtifactPreviewHtmlQuery, GetArtifactPreviewHtmlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArtifactPreviewHtmlQuery, GetArtifactPreviewHtmlQueryVariables>(GetArtifactPreviewHtmlDocument, options);
        }
// @ts-ignore
export function useGetArtifactPreviewHtmlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetArtifactPreviewHtmlQuery, GetArtifactPreviewHtmlQueryVariables>): Apollo.UseSuspenseQueryResult<GetArtifactPreviewHtmlQuery, GetArtifactPreviewHtmlQueryVariables>;
export function useGetArtifactPreviewHtmlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArtifactPreviewHtmlQuery, GetArtifactPreviewHtmlQueryVariables>): Apollo.UseSuspenseQueryResult<GetArtifactPreviewHtmlQuery | undefined, GetArtifactPreviewHtmlQueryVariables>;
export function useGetArtifactPreviewHtmlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArtifactPreviewHtmlQuery, GetArtifactPreviewHtmlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArtifactPreviewHtmlQuery, GetArtifactPreviewHtmlQueryVariables>(GetArtifactPreviewHtmlDocument, options);
        }
export type GetArtifactPreviewHtmlQueryHookResult = ReturnType<typeof useGetArtifactPreviewHtmlQuery>;
export type GetArtifactPreviewHtmlLazyQueryHookResult = ReturnType<typeof useGetArtifactPreviewHtmlLazyQuery>;
export type GetArtifactPreviewHtmlSuspenseQueryHookResult = ReturnType<typeof useGetArtifactPreviewHtmlSuspenseQuery>;
export type GetArtifactPreviewHtmlQueryResult = Apollo.QueryResult<GetArtifactPreviewHtmlQuery, GetArtifactPreviewHtmlQueryVariables>;
export const GetAvailableProposalsDocument = gql`
    query GetAvailableProposals($projectId: UUID!) {
  availableProposals(projectId: $projectId) {
    id
    projectId
    artifactType
    title
    description
    format
    content
    fileUrl
    fileSize
    status
    metadata
    createdBy
    createdAt
    generatedAt
    systemSpecData
    proposalMetadata {
      style
      includesDeliverables
      includesSitemap
      includesTechSpecs
      deliverablesCount
      sitemapPagesCount
      techComponentsCount
      estimatedReadingTime
      targetAudience
      totalContentLength
      dataSource
    }
  }
}
    `;

/**
 * __useGetAvailableProposalsQuery__
 *
 * To run a query within a React component, call `useGetAvailableProposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableProposalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableProposalsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetAvailableProposalsQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableProposalsQuery, GetAvailableProposalsQueryVariables> & ({ variables: GetAvailableProposalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableProposalsQuery, GetAvailableProposalsQueryVariables>(GetAvailableProposalsDocument, options);
      }
export function useGetAvailableProposalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableProposalsQuery, GetAvailableProposalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableProposalsQuery, GetAvailableProposalsQueryVariables>(GetAvailableProposalsDocument, options);
        }
// @ts-ignore
export function useGetAvailableProposalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAvailableProposalsQuery, GetAvailableProposalsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAvailableProposalsQuery, GetAvailableProposalsQueryVariables>;
export function useGetAvailableProposalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableProposalsQuery, GetAvailableProposalsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAvailableProposalsQuery | undefined, GetAvailableProposalsQueryVariables>;
export function useGetAvailableProposalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableProposalsQuery, GetAvailableProposalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableProposalsQuery, GetAvailableProposalsQueryVariables>(GetAvailableProposalsDocument, options);
        }
export type GetAvailableProposalsQueryHookResult = ReturnType<typeof useGetAvailableProposalsQuery>;
export type GetAvailableProposalsLazyQueryHookResult = ReturnType<typeof useGetAvailableProposalsLazyQuery>;
export type GetAvailableProposalsSuspenseQueryHookResult = ReturnType<typeof useGetAvailableProposalsSuspenseQuery>;
export type GetAvailableProposalsQueryResult = Apollo.QueryResult<GetAvailableProposalsQuery, GetAvailableProposalsQueryVariables>;
export const GetUiProjectsDocument = gql`
    query GetUiProjects {
  uiProjects {
    id
    name
    description
    status
    pagesCount
    qualityScore
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetUiProjectsQuery__
 *
 * To run a query within a React component, call `useGetUiProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUiProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUiProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUiProjectsQuery(baseOptions?: Apollo.QueryHookOptions<GetUiProjectsQuery, GetUiProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUiProjectsQuery, GetUiProjectsQueryVariables>(GetUiProjectsDocument, options);
      }
export function useGetUiProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUiProjectsQuery, GetUiProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUiProjectsQuery, GetUiProjectsQueryVariables>(GetUiProjectsDocument, options);
        }
// @ts-ignore
export function useGetUiProjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUiProjectsQuery, GetUiProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUiProjectsQuery, GetUiProjectsQueryVariables>;
export function useGetUiProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUiProjectsQuery, GetUiProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUiProjectsQuery | undefined, GetUiProjectsQueryVariables>;
export function useGetUiProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUiProjectsQuery, GetUiProjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUiProjectsQuery, GetUiProjectsQueryVariables>(GetUiProjectsDocument, options);
        }
export type GetUiProjectsQueryHookResult = ReturnType<typeof useGetUiProjectsQuery>;
export type GetUiProjectsLazyQueryHookResult = ReturnType<typeof useGetUiProjectsLazyQuery>;
export type GetUiProjectsSuspenseQueryHookResult = ReturnType<typeof useGetUiProjectsSuspenseQuery>;
export type GetUiProjectsQueryResult = Apollo.QueryResult<GetUiProjectsQuery, GetUiProjectsQueryVariables>;
export const GetUiProjectDocument = gql`
    query GetUiProject($projectId: String!) {
  uiProject(projectId: $projectId) {
    id
    name
    description
    createdAt
    updatedAt
    status
    sitemap
    pagesCount
    generatedFilesCount
    qualityScore
    generationTime
    uiMockUrl
    errors
    warnings
  }
}
    `;

/**
 * __useGetUiProjectQuery__
 *
 * To run a query within a React component, call `useGetUiProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUiProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUiProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetUiProjectQuery(baseOptions: Apollo.QueryHookOptions<GetUiProjectQuery, GetUiProjectQueryVariables> & ({ variables: GetUiProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUiProjectQuery, GetUiProjectQueryVariables>(GetUiProjectDocument, options);
      }
export function useGetUiProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUiProjectQuery, GetUiProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUiProjectQuery, GetUiProjectQueryVariables>(GetUiProjectDocument, options);
        }
// @ts-ignore
export function useGetUiProjectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUiProjectQuery, GetUiProjectQueryVariables>): Apollo.UseSuspenseQueryResult<GetUiProjectQuery, GetUiProjectQueryVariables>;
export function useGetUiProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUiProjectQuery, GetUiProjectQueryVariables>): Apollo.UseSuspenseQueryResult<GetUiProjectQuery | undefined, GetUiProjectQueryVariables>;
export function useGetUiProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUiProjectQuery, GetUiProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUiProjectQuery, GetUiProjectQueryVariables>(GetUiProjectDocument, options);
        }
export type GetUiProjectQueryHookResult = ReturnType<typeof useGetUiProjectQuery>;
export type GetUiProjectLazyQueryHookResult = ReturnType<typeof useGetUiProjectLazyQuery>;
export type GetUiProjectSuspenseQueryHookResult = ReturnType<typeof useGetUiProjectSuspenseQuery>;
export type GetUiProjectQueryResult = Apollo.QueryResult<GetUiProjectQuery, GetUiProjectQueryVariables>;
export const GetProposeProposalStructureDocument = gql`
    query GetProposeProposalStructure($projectId: ID!, $outputFormat: String = "slide") {
  proposeProposalStructure(projectId: $projectId, outputFormat: $outputFormat) {
    proposalId
    totalPages
    sections {
      sectionId
      sectionTitle
      required
      pages {
        pageNumber
        pageType
        sectionId
        sectionTitle
        subsectionTitle
        contentType
        templateName
        targetLength
      }
    }
  }
}
    `;

/**
 * __useGetProposeProposalStructureQuery__
 *
 * To run a query within a React component, call `useGetProposeProposalStructureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProposeProposalStructureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProposeProposalStructureQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      outputFormat: // value for 'outputFormat'
 *   },
 * });
 */
export function useGetProposeProposalStructureQuery(baseOptions: Apollo.QueryHookOptions<GetProposeProposalStructureQuery, GetProposeProposalStructureQueryVariables> & ({ variables: GetProposeProposalStructureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProposeProposalStructureQuery, GetProposeProposalStructureQueryVariables>(GetProposeProposalStructureDocument, options);
      }
export function useGetProposeProposalStructureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProposeProposalStructureQuery, GetProposeProposalStructureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProposeProposalStructureQuery, GetProposeProposalStructureQueryVariables>(GetProposeProposalStructureDocument, options);
        }
// @ts-ignore
export function useGetProposeProposalStructureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProposeProposalStructureQuery, GetProposeProposalStructureQueryVariables>): Apollo.UseSuspenseQueryResult<GetProposeProposalStructureQuery, GetProposeProposalStructureQueryVariables>;
export function useGetProposeProposalStructureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProposeProposalStructureQuery, GetProposeProposalStructureQueryVariables>): Apollo.UseSuspenseQueryResult<GetProposeProposalStructureQuery | undefined, GetProposeProposalStructureQueryVariables>;
export function useGetProposeProposalStructureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProposeProposalStructureQuery, GetProposeProposalStructureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProposeProposalStructureQuery, GetProposeProposalStructureQueryVariables>(GetProposeProposalStructureDocument, options);
        }
export type GetProposeProposalStructureQueryHookResult = ReturnType<typeof useGetProposeProposalStructureQuery>;
export type GetProposeProposalStructureLazyQueryHookResult = ReturnType<typeof useGetProposeProposalStructureLazyQuery>;
export type GetProposeProposalStructureSuspenseQueryHookResult = ReturnType<typeof useGetProposeProposalStructureSuspenseQuery>;
export type GetProposeProposalStructureQueryResult = Apollo.QueryResult<GetProposeProposalStructureQuery, GetProposeProposalStructureQueryVariables>;
export const GetArtifactProposalStructureDocument = gql`
    query GetArtifactProposalStructure($artifactId: String!) {
  artifactProposalStructure(artifactId: $artifactId) {
    proposalId
    totalPages
    sections {
      sectionId
      sectionTitle
      required
      pages {
        pageNumber
        pageType
        sectionId
        sectionTitle
        subsectionTitle
        contentType
        templateName
        targetLength
      }
    }
  }
}
    `;

/**
 * __useGetArtifactProposalStructureQuery__
 *
 * To run a query within a React component, call `useGetArtifactProposalStructureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArtifactProposalStructureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArtifactProposalStructureQuery({
 *   variables: {
 *      artifactId: // value for 'artifactId'
 *   },
 * });
 */
export function useGetArtifactProposalStructureQuery(baseOptions: Apollo.QueryHookOptions<GetArtifactProposalStructureQuery, GetArtifactProposalStructureQueryVariables> & ({ variables: GetArtifactProposalStructureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArtifactProposalStructureQuery, GetArtifactProposalStructureQueryVariables>(GetArtifactProposalStructureDocument, options);
      }
export function useGetArtifactProposalStructureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArtifactProposalStructureQuery, GetArtifactProposalStructureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArtifactProposalStructureQuery, GetArtifactProposalStructureQueryVariables>(GetArtifactProposalStructureDocument, options);
        }
// @ts-ignore
export function useGetArtifactProposalStructureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetArtifactProposalStructureQuery, GetArtifactProposalStructureQueryVariables>): Apollo.UseSuspenseQueryResult<GetArtifactProposalStructureQuery, GetArtifactProposalStructureQueryVariables>;
export function useGetArtifactProposalStructureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArtifactProposalStructureQuery, GetArtifactProposalStructureQueryVariables>): Apollo.UseSuspenseQueryResult<GetArtifactProposalStructureQuery | undefined, GetArtifactProposalStructureQueryVariables>;
export function useGetArtifactProposalStructureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArtifactProposalStructureQuery, GetArtifactProposalStructureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArtifactProposalStructureQuery, GetArtifactProposalStructureQueryVariables>(GetArtifactProposalStructureDocument, options);
        }
export type GetArtifactProposalStructureQueryHookResult = ReturnType<typeof useGetArtifactProposalStructureQuery>;
export type GetArtifactProposalStructureLazyQueryHookResult = ReturnType<typeof useGetArtifactProposalStructureLazyQuery>;
export type GetArtifactProposalStructureSuspenseQueryHookResult = ReturnType<typeof useGetArtifactProposalStructureSuspenseQuery>;
export type GetArtifactProposalStructureQueryResult = Apollo.QueryResult<GetArtifactProposalStructureQuery, GetArtifactProposalStructureQueryVariables>;
export const GetPreviewProjectIntegrationDocument = gql`
    query GetPreviewProjectIntegration($projectId: UUID!, $systemInstanceId: UUID!) {
  previewProjectIntegration(
    projectId: $projectId
    systemInstanceId: $systemInstanceId
  ) {
    projectId
    systemInstanceId
    currentBcSet
    proposedAdditions
    actuallyAdded
    alreadyInSet
    bcSummaries {
      bcName
      nameJa
      entityCount
      publishesEventCount
      dependsOn
    }
    resultingBcSet
    regenNeeded
  }
}
    `;

/**
 * __useGetPreviewProjectIntegrationQuery__
 *
 * To run a query within a React component, call `useGetPreviewProjectIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewProjectIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewProjectIntegrationQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      systemInstanceId: // value for 'systemInstanceId'
 *   },
 * });
 */
export function useGetPreviewProjectIntegrationQuery(baseOptions: Apollo.QueryHookOptions<GetPreviewProjectIntegrationQuery, GetPreviewProjectIntegrationQueryVariables> & ({ variables: GetPreviewProjectIntegrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreviewProjectIntegrationQuery, GetPreviewProjectIntegrationQueryVariables>(GetPreviewProjectIntegrationDocument, options);
      }
export function useGetPreviewProjectIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreviewProjectIntegrationQuery, GetPreviewProjectIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreviewProjectIntegrationQuery, GetPreviewProjectIntegrationQueryVariables>(GetPreviewProjectIntegrationDocument, options);
        }
// @ts-ignore
export function useGetPreviewProjectIntegrationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPreviewProjectIntegrationQuery, GetPreviewProjectIntegrationQueryVariables>): Apollo.UseSuspenseQueryResult<GetPreviewProjectIntegrationQuery, GetPreviewProjectIntegrationQueryVariables>;
export function useGetPreviewProjectIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPreviewProjectIntegrationQuery, GetPreviewProjectIntegrationQueryVariables>): Apollo.UseSuspenseQueryResult<GetPreviewProjectIntegrationQuery | undefined, GetPreviewProjectIntegrationQueryVariables>;
export function useGetPreviewProjectIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPreviewProjectIntegrationQuery, GetPreviewProjectIntegrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPreviewProjectIntegrationQuery, GetPreviewProjectIntegrationQueryVariables>(GetPreviewProjectIntegrationDocument, options);
        }
export type GetPreviewProjectIntegrationQueryHookResult = ReturnType<typeof useGetPreviewProjectIntegrationQuery>;
export type GetPreviewProjectIntegrationLazyQueryHookResult = ReturnType<typeof useGetPreviewProjectIntegrationLazyQuery>;
export type GetPreviewProjectIntegrationSuspenseQueryHookResult = ReturnType<typeof useGetPreviewProjectIntegrationSuspenseQuery>;
export type GetPreviewProjectIntegrationQueryResult = Apollo.QueryResult<GetPreviewProjectIntegrationQuery, GetPreviewProjectIntegrationQueryVariables>;
export const GetDesignProposalsDocument = gql`
    query GetDesignProposals($projectId: ID!) {
  designProposals(projectId: $projectId) {
    id
    projectId
    conceptName
    conceptDescription
    designGuidelines
    referenceUrls
    status
    isSelected
    errorMessage
    createdAt
  }
}
    `;

/**
 * __useGetDesignProposalsQuery__
 *
 * To run a query within a React component, call `useGetDesignProposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDesignProposalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDesignProposalsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetDesignProposalsQuery(baseOptions: Apollo.QueryHookOptions<GetDesignProposalsQuery, GetDesignProposalsQueryVariables> & ({ variables: GetDesignProposalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDesignProposalsQuery, GetDesignProposalsQueryVariables>(GetDesignProposalsDocument, options);
      }
export function useGetDesignProposalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDesignProposalsQuery, GetDesignProposalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDesignProposalsQuery, GetDesignProposalsQueryVariables>(GetDesignProposalsDocument, options);
        }
// @ts-ignore
export function useGetDesignProposalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDesignProposalsQuery, GetDesignProposalsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDesignProposalsQuery, GetDesignProposalsQueryVariables>;
export function useGetDesignProposalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDesignProposalsQuery, GetDesignProposalsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDesignProposalsQuery | undefined, GetDesignProposalsQueryVariables>;
export function useGetDesignProposalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDesignProposalsQuery, GetDesignProposalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDesignProposalsQuery, GetDesignProposalsQueryVariables>(GetDesignProposalsDocument, options);
        }
export type GetDesignProposalsQueryHookResult = ReturnType<typeof useGetDesignProposalsQuery>;
export type GetDesignProposalsLazyQueryHookResult = ReturnType<typeof useGetDesignProposalsLazyQuery>;
export type GetDesignProposalsSuspenseQueryHookResult = ReturnType<typeof useGetDesignProposalsSuspenseQuery>;
export type GetDesignProposalsQueryResult = Apollo.QueryResult<GetDesignProposalsQuery, GetDesignProposalsQueryVariables>;
export const GetDesignProposalPreviewHtmlDocument = gql`
    query GetDesignProposalPreviewHtml($proposalId: ID!) {
  designProposalPreviewHtml(proposalId: $proposalId)
}
    `;

/**
 * __useGetDesignProposalPreviewHtmlQuery__
 *
 * To run a query within a React component, call `useGetDesignProposalPreviewHtmlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDesignProposalPreviewHtmlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDesignProposalPreviewHtmlQuery({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useGetDesignProposalPreviewHtmlQuery(baseOptions: Apollo.QueryHookOptions<GetDesignProposalPreviewHtmlQuery, GetDesignProposalPreviewHtmlQueryVariables> & ({ variables: GetDesignProposalPreviewHtmlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDesignProposalPreviewHtmlQuery, GetDesignProposalPreviewHtmlQueryVariables>(GetDesignProposalPreviewHtmlDocument, options);
      }
export function useGetDesignProposalPreviewHtmlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDesignProposalPreviewHtmlQuery, GetDesignProposalPreviewHtmlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDesignProposalPreviewHtmlQuery, GetDesignProposalPreviewHtmlQueryVariables>(GetDesignProposalPreviewHtmlDocument, options);
        }
// @ts-ignore
export function useGetDesignProposalPreviewHtmlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDesignProposalPreviewHtmlQuery, GetDesignProposalPreviewHtmlQueryVariables>): Apollo.UseSuspenseQueryResult<GetDesignProposalPreviewHtmlQuery, GetDesignProposalPreviewHtmlQueryVariables>;
export function useGetDesignProposalPreviewHtmlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDesignProposalPreviewHtmlQuery, GetDesignProposalPreviewHtmlQueryVariables>): Apollo.UseSuspenseQueryResult<GetDesignProposalPreviewHtmlQuery | undefined, GetDesignProposalPreviewHtmlQueryVariables>;
export function useGetDesignProposalPreviewHtmlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDesignProposalPreviewHtmlQuery, GetDesignProposalPreviewHtmlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDesignProposalPreviewHtmlQuery, GetDesignProposalPreviewHtmlQueryVariables>(GetDesignProposalPreviewHtmlDocument, options);
        }
export type GetDesignProposalPreviewHtmlQueryHookResult = ReturnType<typeof useGetDesignProposalPreviewHtmlQuery>;
export type GetDesignProposalPreviewHtmlLazyQueryHookResult = ReturnType<typeof useGetDesignProposalPreviewHtmlLazyQuery>;
export type GetDesignProposalPreviewHtmlSuspenseQueryHookResult = ReturnType<typeof useGetDesignProposalPreviewHtmlSuspenseQuery>;
export type GetDesignProposalPreviewHtmlQueryResult = Apollo.QueryResult<GetDesignProposalPreviewHtmlQuery, GetDesignProposalPreviewHtmlQueryVariables>;
export const GetDeploymentsByProjectDocument = gql`
    query GetDeploymentsByProject($projectId: String!) {
  deploymentsByProject(projectId: $projectId) {
    deployments {
      id
      projectId
      artifactId
      createdBy
      name
      providerType
      status
      currentStage
      pipelineProgress
      liveUrl
      githubRepoUrl
      errorMessage
      retryCount
      progressPercentage
      createdAt
      startedAt
      completedAt
    }
    totalCount
  }
}
    `;

/**
 * __useGetDeploymentsByProjectQuery__
 *
 * To run a query within a React component, call `useGetDeploymentsByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeploymentsByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeploymentsByProjectQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetDeploymentsByProjectQuery(baseOptions: Apollo.QueryHookOptions<GetDeploymentsByProjectQuery, GetDeploymentsByProjectQueryVariables> & ({ variables: GetDeploymentsByProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeploymentsByProjectQuery, GetDeploymentsByProjectQueryVariables>(GetDeploymentsByProjectDocument, options);
      }
export function useGetDeploymentsByProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeploymentsByProjectQuery, GetDeploymentsByProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeploymentsByProjectQuery, GetDeploymentsByProjectQueryVariables>(GetDeploymentsByProjectDocument, options);
        }
// @ts-ignore
export function useGetDeploymentsByProjectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDeploymentsByProjectQuery, GetDeploymentsByProjectQueryVariables>): Apollo.UseSuspenseQueryResult<GetDeploymentsByProjectQuery, GetDeploymentsByProjectQueryVariables>;
export function useGetDeploymentsByProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeploymentsByProjectQuery, GetDeploymentsByProjectQueryVariables>): Apollo.UseSuspenseQueryResult<GetDeploymentsByProjectQuery | undefined, GetDeploymentsByProjectQueryVariables>;
export function useGetDeploymentsByProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeploymentsByProjectQuery, GetDeploymentsByProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDeploymentsByProjectQuery, GetDeploymentsByProjectQueryVariables>(GetDeploymentsByProjectDocument, options);
        }
export type GetDeploymentsByProjectQueryHookResult = ReturnType<typeof useGetDeploymentsByProjectQuery>;
export type GetDeploymentsByProjectLazyQueryHookResult = ReturnType<typeof useGetDeploymentsByProjectLazyQuery>;
export type GetDeploymentsByProjectSuspenseQueryHookResult = ReturnType<typeof useGetDeploymentsByProjectSuspenseQuery>;
export type GetDeploymentsByProjectQueryResult = Apollo.QueryResult<GetDeploymentsByProjectQuery, GetDeploymentsByProjectQueryVariables>;
export const GenerateConsolidatedSitemapDocument = gql`
    mutation GenerateConsolidatedSitemap($projectId: String!, $input: GenerateConsolidatedSitemapInput = null) {
  generateConsolidatedSitemap(projectId: $projectId, input: $input) {
    success
    totalPages
    functionCategories
    generationTimeMs
    sitemapJson
    errors
    warnings
  }
}
    `;
export type GenerateConsolidatedSitemapMutationFn = Apollo.MutationFunction<GenerateConsolidatedSitemapMutation, GenerateConsolidatedSitemapMutationVariables>;

/**
 * __useGenerateConsolidatedSitemapMutation__
 *
 * To run a mutation, you first call `useGenerateConsolidatedSitemapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateConsolidatedSitemapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateConsolidatedSitemapMutation, { data, loading, error }] = useGenerateConsolidatedSitemapMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateConsolidatedSitemapMutation(baseOptions?: Apollo.MutationHookOptions<GenerateConsolidatedSitemapMutation, GenerateConsolidatedSitemapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateConsolidatedSitemapMutation, GenerateConsolidatedSitemapMutationVariables>(GenerateConsolidatedSitemapDocument, options);
      }
export type GenerateConsolidatedSitemapMutationHookResult = ReturnType<typeof useGenerateConsolidatedSitemapMutation>;
export type GenerateConsolidatedSitemapMutationResult = Apollo.MutationResult<GenerateConsolidatedSitemapMutation>;
export type GenerateConsolidatedSitemapMutationOptions = Apollo.BaseMutationOptions<GenerateConsolidatedSitemapMutation, GenerateConsolidatedSitemapMutationVariables>;
export const ConsolidatedDeliverableUpdatesDocument = gql`
    subscription ConsolidatedDeliverableUpdates($projectId: String!) {
  consolidatedDeliverableUpdates(projectId: $projectId) {
    id
    type
    timestamp
    traceId
    projectId
    userId
    taskId
    status
    progress
    errorMessage
    deliverableId
    deliverableName
    functionsCount
    projectAnalysis
    sitemapGenerated
    sitemapPages
    data
  }
}
    `;

/**
 * __useConsolidatedDeliverableUpdatesSubscription__
 *
 * To run a query within a React component, call `useConsolidatedDeliverableUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useConsolidatedDeliverableUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsolidatedDeliverableUpdatesSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useConsolidatedDeliverableUpdatesSubscription(baseOptions: Apollo.SubscriptionHookOptions<ConsolidatedDeliverableUpdatesSubscription, ConsolidatedDeliverableUpdatesSubscriptionVariables> & ({ variables: ConsolidatedDeliverableUpdatesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ConsolidatedDeliverableUpdatesSubscription, ConsolidatedDeliverableUpdatesSubscriptionVariables>(ConsolidatedDeliverableUpdatesDocument, options);
      }
export type ConsolidatedDeliverableUpdatesSubscriptionHookResult = ReturnType<typeof useConsolidatedDeliverableUpdatesSubscription>;
export type ConsolidatedDeliverableUpdatesSubscriptionResult = Apollo.SubscriptionResult<ConsolidatedDeliverableUpdatesSubscription>;
export const UnifiedContentUpdatesDocument = gql`
    subscription UnifiedContentUpdates($projectId: String!) {
  unifiedContentUpdates(projectId: $projectId) {
    id
    type
    timestamp
    traceId
    projectId
    userId
    taskId
    status
    progress
    errorMessage
    contentType
    outputFormat
    currentStep
    artifactId
    fileUrl
    fileSize
    data
  }
}
    `;

/**
 * __useUnifiedContentUpdatesSubscription__
 *
 * To run a query within a React component, call `useUnifiedContentUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUnifiedContentUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnifiedContentUpdatesSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useUnifiedContentUpdatesSubscription(baseOptions: Apollo.SubscriptionHookOptions<UnifiedContentUpdatesSubscription, UnifiedContentUpdatesSubscriptionVariables> & ({ variables: UnifiedContentUpdatesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UnifiedContentUpdatesSubscription, UnifiedContentUpdatesSubscriptionVariables>(UnifiedContentUpdatesDocument, options);
      }
export type UnifiedContentUpdatesSubscriptionHookResult = ReturnType<typeof useUnifiedContentUpdatesSubscription>;
export type UnifiedContentUpdatesSubscriptionResult = Apollo.SubscriptionResult<UnifiedContentUpdatesSubscription>;
export const AtomProcessingUpdatesDocument = gql`
    subscription AtomProcessingUpdates($projectId: String = null, $clientId: String = null, $atomId: String = null) {
  atomProcessingUpdates(
    projectId: $projectId
    clientId: $clientId
    atomId: $atomId
  ) {
    id
    type
    timestamp
    traceId
    atomId
    projectId
    userId
    title
    atomType
    status
    progress
    errorMessage
    extractionResult
    metadata
  }
}
    `;

/**
 * __useAtomProcessingUpdatesSubscription__
 *
 * To run a query within a React component, call `useAtomProcessingUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAtomProcessingUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAtomProcessingUpdatesSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      clientId: // value for 'clientId'
 *      atomId: // value for 'atomId'
 *   },
 * });
 */
export function useAtomProcessingUpdatesSubscription(baseOptions?: Apollo.SubscriptionHookOptions<AtomProcessingUpdatesSubscription, AtomProcessingUpdatesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AtomProcessingUpdatesSubscription, AtomProcessingUpdatesSubscriptionVariables>(AtomProcessingUpdatesDocument, options);
      }
export type AtomProcessingUpdatesSubscriptionHookResult = ReturnType<typeof useAtomProcessingUpdatesSubscription>;
export type AtomProcessingUpdatesSubscriptionResult = Apollo.SubscriptionResult<AtomProcessingUpdatesSubscription>;
export const ClientResearchUpdatesDocument = gql`
    subscription ClientResearchUpdates($clientId: String!) {
  clientResearchUpdates(clientId: $clientId) {
    id
    type
    timestamp
    traceId
    clientId
    taskId
    status
    progress
    errorMessage
    clientName
    message
    data
  }
}
    `;

/**
 * __useClientResearchUpdatesSubscription__
 *
 * To run a query within a React component, call `useClientResearchUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useClientResearchUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientResearchUpdatesSubscription({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useClientResearchUpdatesSubscription(baseOptions: Apollo.SubscriptionHookOptions<ClientResearchUpdatesSubscription, ClientResearchUpdatesSubscriptionVariables> & ({ variables: ClientResearchUpdatesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ClientResearchUpdatesSubscription, ClientResearchUpdatesSubscriptionVariables>(ClientResearchUpdatesDocument, options);
      }
export type ClientResearchUpdatesSubscriptionHookResult = ReturnType<typeof useClientResearchUpdatesSubscription>;
export type ClientResearchUpdatesSubscriptionResult = Apollo.SubscriptionResult<ClientResearchUpdatesSubscription>;
export const CompanyProfileResearchUpdatesDocument = gql`
    subscription CompanyProfileResearchUpdates($companyProfileId: String!) {
  companyProfileResearchUpdates(companyProfileId: $companyProfileId) {
    id
    type
    timestamp
    traceId
    companyProfileId
    taskId
    status
    progress
    errorMessage
    companyName
    message
    data
  }
}
    `;

/**
 * __useCompanyProfileResearchUpdatesSubscription__
 *
 * To run a query within a React component, call `useCompanyProfileResearchUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCompanyProfileResearchUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyProfileResearchUpdatesSubscription({
 *   variables: {
 *      companyProfileId: // value for 'companyProfileId'
 *   },
 * });
 */
export function useCompanyProfileResearchUpdatesSubscription(baseOptions: Apollo.SubscriptionHookOptions<CompanyProfileResearchUpdatesSubscription, CompanyProfileResearchUpdatesSubscriptionVariables> & ({ variables: CompanyProfileResearchUpdatesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CompanyProfileResearchUpdatesSubscription, CompanyProfileResearchUpdatesSubscriptionVariables>(CompanyProfileResearchUpdatesDocument, options);
      }
export type CompanyProfileResearchUpdatesSubscriptionHookResult = ReturnType<typeof useCompanyProfileResearchUpdatesSubscription>;
export type CompanyProfileResearchUpdatesSubscriptionResult = Apollo.SubscriptionResult<CompanyProfileResearchUpdatesSubscription>;
export const IndustryResearchUpdatesDocument = gql`
    subscription IndustryResearchUpdates($industryId: String!) {
  industryResearchUpdates(industryId: $industryId) {
    id
    type
    timestamp
    traceId
    industryId
    taskId
    status
    progress
    errorMessage
    industryName
    message
    data
  }
}
    `;

/**
 * __useIndustryResearchUpdatesSubscription__
 *
 * To run a query within a React component, call `useIndustryResearchUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useIndustryResearchUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndustryResearchUpdatesSubscription({
 *   variables: {
 *      industryId: // value for 'industryId'
 *   },
 * });
 */
export function useIndustryResearchUpdatesSubscription(baseOptions: Apollo.SubscriptionHookOptions<IndustryResearchUpdatesSubscription, IndustryResearchUpdatesSubscriptionVariables> & ({ variables: IndustryResearchUpdatesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<IndustryResearchUpdatesSubscription, IndustryResearchUpdatesSubscriptionVariables>(IndustryResearchUpdatesDocument, options);
      }
export type IndustryResearchUpdatesSubscriptionHookResult = ReturnType<typeof useIndustryResearchUpdatesSubscription>;
export type IndustryResearchUpdatesSubscriptionResult = Apollo.SubscriptionResult<IndustryResearchUpdatesSubscription>;
export const PrismScopeUpdatesDocument = gql`
    subscription PrismScopeUpdates($projectId: String!) {
  prismScopeUpdates(projectId: $projectId) {
    id
    type
    timestamp
    traceId
    projectId
    taskId
    status
    progress
    errorMessage
    scopeCount
    message
    data
  }
}
    `;

/**
 * __usePrismScopeUpdatesSubscription__
 *
 * To run a query within a React component, call `usePrismScopeUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePrismScopeUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrismScopeUpdatesSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePrismScopeUpdatesSubscription(baseOptions: Apollo.SubscriptionHookOptions<PrismScopeUpdatesSubscription, PrismScopeUpdatesSubscriptionVariables> & ({ variables: PrismScopeUpdatesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PrismScopeUpdatesSubscription, PrismScopeUpdatesSubscriptionVariables>(PrismScopeUpdatesDocument, options);
      }
export type PrismScopeUpdatesSubscriptionHookResult = ReturnType<typeof usePrismScopeUpdatesSubscription>;
export type PrismScopeUpdatesSubscriptionResult = Apollo.SubscriptionResult<PrismScopeUpdatesSubscription>;
export const ApiCrawlUpdatesDocument = gql`
    subscription ApiCrawlUpdates($catalogId: String = null) {
  apiCrawlUpdates(catalogId: $catalogId) {
    id
    type
    timestamp
    traceId
    catalogId
    serviceName
    status
    progress
    message
    errorMessage
    endpointCount
    taskId
    data
  }
}
    `;

/**
 * __useApiCrawlUpdatesSubscription__
 *
 * To run a query within a React component, call `useApiCrawlUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useApiCrawlUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiCrawlUpdatesSubscription({
 *   variables: {
 *      catalogId: // value for 'catalogId'
 *   },
 * });
 */
export function useApiCrawlUpdatesSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ApiCrawlUpdatesSubscription, ApiCrawlUpdatesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ApiCrawlUpdatesSubscription, ApiCrawlUpdatesSubscriptionVariables>(ApiCrawlUpdatesDocument, options);
      }
export type ApiCrawlUpdatesSubscriptionHookResult = ReturnType<typeof useApiCrawlUpdatesSubscription>;
export type ApiCrawlUpdatesSubscriptionResult = Apollo.SubscriptionResult<ApiCrawlUpdatesSubscription>;
export const PrismOrientUpdatesDocument = gql`
    subscription PrismOrientUpdates($projectId: String!) {
  prismOrientUpdates(projectId: $projectId) {
    id
    type
    timestamp
    traceId
    projectId
    taskId
    status
    progress
    errorMessage
    orientId
    message
    data
  }
}
    `;

/**
 * __usePrismOrientUpdatesSubscription__
 *
 * To run a query within a React component, call `usePrismOrientUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePrismOrientUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrismOrientUpdatesSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePrismOrientUpdatesSubscription(baseOptions: Apollo.SubscriptionHookOptions<PrismOrientUpdatesSubscription, PrismOrientUpdatesSubscriptionVariables> & ({ variables: PrismOrientUpdatesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PrismOrientUpdatesSubscription, PrismOrientUpdatesSubscriptionVariables>(PrismOrientUpdatesDocument, options);
      }
export type PrismOrientUpdatesSubscriptionHookResult = ReturnType<typeof usePrismOrientUpdatesSubscription>;
export type PrismOrientUpdatesSubscriptionResult = Apollo.SubscriptionResult<PrismOrientUpdatesSubscription>;
export const CreateSystemInstanceDocument = gql`
    mutation CreateSystemInstance($input: CreateSystemInstanceInput!) {
  createSystemInstance(input: $input) {
    success
    instance {
      id
      organizationId
      clientId
      name
      slug
      isMain
      outputPath
      githubRepoName
      gitDefaultBranch
      vpsHost
      vpsUser
      vpsDeploymentConfig
      portOffset
      deploymentStatus
      lastGeneratedAt
      lastDeployedAt
      archivedAt
      createdAt
      updatedAt
      hasGit
      hasVps
      isArchived
      hasGithubToken
      deployTarget
      subdomainUrl
    }
    errorMessage
  }
}
    `;
export type CreateSystemInstanceMutationFn = Apollo.MutationFunction<CreateSystemInstanceMutation, CreateSystemInstanceMutationVariables>;

/**
 * __useCreateSystemInstanceMutation__
 *
 * To run a mutation, you first call `useCreateSystemInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSystemInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSystemInstanceMutation, { data, loading, error }] = useCreateSystemInstanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSystemInstanceMutation(baseOptions?: Apollo.MutationHookOptions<CreateSystemInstanceMutation, CreateSystemInstanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSystemInstanceMutation, CreateSystemInstanceMutationVariables>(CreateSystemInstanceDocument, options);
      }
export type CreateSystemInstanceMutationHookResult = ReturnType<typeof useCreateSystemInstanceMutation>;
export type CreateSystemInstanceMutationResult = Apollo.MutationResult<CreateSystemInstanceMutation>;
export type CreateSystemInstanceMutationOptions = Apollo.BaseMutationOptions<CreateSystemInstanceMutation, CreateSystemInstanceMutationVariables>;
export const UpdateSystemInstanceDocument = gql`
    mutation UpdateSystemInstance($input: UpdateSystemInstanceInput!) {
  updateSystemInstance(input: $input) {
    success
    instance {
      id
      organizationId
      clientId
      name
      slug
      isMain
      outputPath
      githubRepoName
      gitDefaultBranch
      vpsHost
      vpsUser
      vpsDeploymentConfig
      portOffset
      deploymentStatus
      lastGeneratedAt
      lastDeployedAt
      archivedAt
      createdAt
      updatedAt
      hasGit
      hasVps
      isArchived
      hasGithubToken
      deployTarget
      subdomainUrl
    }
    errorMessage
  }
}
    `;
export type UpdateSystemInstanceMutationFn = Apollo.MutationFunction<UpdateSystemInstanceMutation, UpdateSystemInstanceMutationVariables>;

/**
 * __useUpdateSystemInstanceMutation__
 *
 * To run a mutation, you first call `useUpdateSystemInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSystemInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSystemInstanceMutation, { data, loading, error }] = useUpdateSystemInstanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSystemInstanceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSystemInstanceMutation, UpdateSystemInstanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSystemInstanceMutation, UpdateSystemInstanceMutationVariables>(UpdateSystemInstanceDocument, options);
      }
export type UpdateSystemInstanceMutationHookResult = ReturnType<typeof useUpdateSystemInstanceMutation>;
export type UpdateSystemInstanceMutationResult = Apollo.MutationResult<UpdateSystemInstanceMutation>;
export type UpdateSystemInstanceMutationOptions = Apollo.BaseMutationOptions<UpdateSystemInstanceMutation, UpdateSystemInstanceMutationVariables>;
export const ArchiveSystemInstanceDocument = gql`
    mutation ArchiveSystemInstance($id: UUID!, $reason: String = null) {
  archiveSystemInstance(id: $id, reason: $reason) {
    success
    instance {
      id
      organizationId
      clientId
      name
      slug
      isMain
      outputPath
      githubRepoName
      gitDefaultBranch
      vpsHost
      vpsUser
      vpsDeploymentConfig
      portOffset
      deploymentStatus
      lastGeneratedAt
      lastDeployedAt
      archivedAt
      createdAt
      updatedAt
      hasGit
      hasVps
      isArchived
      hasGithubToken
      deployTarget
      subdomainUrl
    }
    errorMessage
  }
}
    `;
export type ArchiveSystemInstanceMutationFn = Apollo.MutationFunction<ArchiveSystemInstanceMutation, ArchiveSystemInstanceMutationVariables>;

/**
 * __useArchiveSystemInstanceMutation__
 *
 * To run a mutation, you first call `useArchiveSystemInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveSystemInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveSystemInstanceMutation, { data, loading, error }] = useArchiveSystemInstanceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useArchiveSystemInstanceMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveSystemInstanceMutation, ArchiveSystemInstanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveSystemInstanceMutation, ArchiveSystemInstanceMutationVariables>(ArchiveSystemInstanceDocument, options);
      }
export type ArchiveSystemInstanceMutationHookResult = ReturnType<typeof useArchiveSystemInstanceMutation>;
export type ArchiveSystemInstanceMutationResult = Apollo.MutationResult<ArchiveSystemInstanceMutation>;
export type ArchiveSystemInstanceMutationOptions = Apollo.BaseMutationOptions<ArchiveSystemInstanceMutation, ArchiveSystemInstanceMutationVariables>;
export const DeploySystemInstanceLocalDocument = gql`
    mutation DeploySystemInstanceLocal($id: UUID!) {
  deploySystemInstanceLocal(id: $id) {
    success
    systemInstanceId
    subdomainUrl
    teardownCount
    steps
    errorMessage
  }
}
    `;
export type DeploySystemInstanceLocalMutationFn = Apollo.MutationFunction<DeploySystemInstanceLocalMutation, DeploySystemInstanceLocalMutationVariables>;

/**
 * __useDeploySystemInstanceLocalMutation__
 *
 * To run a mutation, you first call `useDeploySystemInstanceLocalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeploySystemInstanceLocalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deploySystemInstanceLocalMutation, { data, loading, error }] = useDeploySystemInstanceLocalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeploySystemInstanceLocalMutation(baseOptions?: Apollo.MutationHookOptions<DeploySystemInstanceLocalMutation, DeploySystemInstanceLocalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeploySystemInstanceLocalMutation, DeploySystemInstanceLocalMutationVariables>(DeploySystemInstanceLocalDocument, options);
      }
export type DeploySystemInstanceLocalMutationHookResult = ReturnType<typeof useDeploySystemInstanceLocalMutation>;
export type DeploySystemInstanceLocalMutationResult = Apollo.MutationResult<DeploySystemInstanceLocalMutation>;
export type DeploySystemInstanceLocalMutationOptions = Apollo.BaseMutationOptions<DeploySystemInstanceLocalMutation, DeploySystemInstanceLocalMutationVariables>;
export const UnarchiveSystemInstanceDocument = gql`
    mutation UnarchiveSystemInstance($id: UUID!) {
  unarchiveSystemInstance(id: $id) {
    success
    instance {
      id
      organizationId
      clientId
      name
      slug
      isMain
      outputPath
      githubRepoName
      gitDefaultBranch
      vpsHost
      vpsUser
      vpsDeploymentConfig
      portOffset
      deploymentStatus
      lastGeneratedAt
      lastDeployedAt
      archivedAt
      createdAt
      updatedAt
      hasGit
      hasVps
      isArchived
      hasGithubToken
      deployTarget
      subdomainUrl
    }
    errorMessage
  }
}
    `;
export type UnarchiveSystemInstanceMutationFn = Apollo.MutationFunction<UnarchiveSystemInstanceMutation, UnarchiveSystemInstanceMutationVariables>;

/**
 * __useUnarchiveSystemInstanceMutation__
 *
 * To run a mutation, you first call `useUnarchiveSystemInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveSystemInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveSystemInstanceMutation, { data, loading, error }] = useUnarchiveSystemInstanceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnarchiveSystemInstanceMutation(baseOptions?: Apollo.MutationHookOptions<UnarchiveSystemInstanceMutation, UnarchiveSystemInstanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnarchiveSystemInstanceMutation, UnarchiveSystemInstanceMutationVariables>(UnarchiveSystemInstanceDocument, options);
      }
export type UnarchiveSystemInstanceMutationHookResult = ReturnType<typeof useUnarchiveSystemInstanceMutation>;
export type UnarchiveSystemInstanceMutationResult = Apollo.MutationResult<UnarchiveSystemInstanceMutation>;
export type UnarchiveSystemInstanceMutationOptions = Apollo.BaseMutationOptions<UnarchiveSystemInstanceMutation, UnarchiveSystemInstanceMutationVariables>;
export const SetAsMainSystemInstanceDocument = gql`
    mutation SetAsMainSystemInstance($id: UUID!) {
  setAsMainSystemInstance(id: $id) {
    success
    instance {
      id
      organizationId
      clientId
      name
      slug
      isMain
      outputPath
      githubRepoName
      gitDefaultBranch
      vpsHost
      vpsUser
      vpsDeploymentConfig
      portOffset
      deploymentStatus
      lastGeneratedAt
      lastDeployedAt
      archivedAt
      createdAt
      updatedAt
      hasGit
      hasVps
      isArchived
      hasGithubToken
      deployTarget
      subdomainUrl
    }
    errorMessage
  }
}
    `;
export type SetAsMainSystemInstanceMutationFn = Apollo.MutationFunction<SetAsMainSystemInstanceMutation, SetAsMainSystemInstanceMutationVariables>;

/**
 * __useSetAsMainSystemInstanceMutation__
 *
 * To run a mutation, you first call `useSetAsMainSystemInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAsMainSystemInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAsMainSystemInstanceMutation, { data, loading, error }] = useSetAsMainSystemInstanceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetAsMainSystemInstanceMutation(baseOptions?: Apollo.MutationHookOptions<SetAsMainSystemInstanceMutation, SetAsMainSystemInstanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAsMainSystemInstanceMutation, SetAsMainSystemInstanceMutationVariables>(SetAsMainSystemInstanceDocument, options);
      }
export type SetAsMainSystemInstanceMutationHookResult = ReturnType<typeof useSetAsMainSystemInstanceMutation>;
export type SetAsMainSystemInstanceMutationResult = Apollo.MutationResult<SetAsMainSystemInstanceMutation>;
export type SetAsMainSystemInstanceMutationOptions = Apollo.BaseMutationOptions<SetAsMainSystemInstanceMutation, SetAsMainSystemInstanceMutationVariables>;
export const MarkSystemInstanceGeneratedDocument = gql`
    mutation MarkSystemInstanceGenerated($id: UUID!) {
  markSystemInstanceGenerated(id: $id) {
    success
    instance {
      id
      organizationId
      clientId
      name
      slug
      isMain
      outputPath
      githubRepoName
      gitDefaultBranch
      vpsHost
      vpsUser
      vpsDeploymentConfig
      portOffset
      deploymentStatus
      lastGeneratedAt
      lastDeployedAt
      archivedAt
      createdAt
      updatedAt
      hasGit
      hasVps
      isArchived
      hasGithubToken
      deployTarget
      subdomainUrl
    }
    errorMessage
  }
}
    `;
export type MarkSystemInstanceGeneratedMutationFn = Apollo.MutationFunction<MarkSystemInstanceGeneratedMutation, MarkSystemInstanceGeneratedMutationVariables>;

/**
 * __useMarkSystemInstanceGeneratedMutation__
 *
 * To run a mutation, you first call `useMarkSystemInstanceGeneratedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSystemInstanceGeneratedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSystemInstanceGeneratedMutation, { data, loading, error }] = useMarkSystemInstanceGeneratedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkSystemInstanceGeneratedMutation(baseOptions?: Apollo.MutationHookOptions<MarkSystemInstanceGeneratedMutation, MarkSystemInstanceGeneratedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkSystemInstanceGeneratedMutation, MarkSystemInstanceGeneratedMutationVariables>(MarkSystemInstanceGeneratedDocument, options);
      }
export type MarkSystemInstanceGeneratedMutationHookResult = ReturnType<typeof useMarkSystemInstanceGeneratedMutation>;
export type MarkSystemInstanceGeneratedMutationResult = Apollo.MutationResult<MarkSystemInstanceGeneratedMutation>;
export type MarkSystemInstanceGeneratedMutationOptions = Apollo.BaseMutationOptions<MarkSystemInstanceGeneratedMutation, MarkSystemInstanceGeneratedMutationVariables>;
export const MarkSystemInstancePushedDocument = gql`
    mutation MarkSystemInstancePushed($id: UUID!) {
  markSystemInstancePushed(id: $id) {
    success
    instance {
      id
      organizationId
      clientId
      name
      slug
      isMain
      outputPath
      githubRepoName
      gitDefaultBranch
      vpsHost
      vpsUser
      vpsDeploymentConfig
      portOffset
      deploymentStatus
      lastGeneratedAt
      lastDeployedAt
      archivedAt
      createdAt
      updatedAt
      hasGit
      hasVps
      isArchived
      hasGithubToken
      deployTarget
      subdomainUrl
    }
    errorMessage
  }
}
    `;
export type MarkSystemInstancePushedMutationFn = Apollo.MutationFunction<MarkSystemInstancePushedMutation, MarkSystemInstancePushedMutationVariables>;

/**
 * __useMarkSystemInstancePushedMutation__
 *
 * To run a mutation, you first call `useMarkSystemInstancePushedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSystemInstancePushedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSystemInstancePushedMutation, { data, loading, error }] = useMarkSystemInstancePushedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkSystemInstancePushedMutation(baseOptions?: Apollo.MutationHookOptions<MarkSystemInstancePushedMutation, MarkSystemInstancePushedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkSystemInstancePushedMutation, MarkSystemInstancePushedMutationVariables>(MarkSystemInstancePushedDocument, options);
      }
export type MarkSystemInstancePushedMutationHookResult = ReturnType<typeof useMarkSystemInstancePushedMutation>;
export type MarkSystemInstancePushedMutationResult = Apollo.MutationResult<MarkSystemInstancePushedMutation>;
export type MarkSystemInstancePushedMutationOptions = Apollo.BaseMutationOptions<MarkSystemInstancePushedMutation, MarkSystemInstancePushedMutationVariables>;
export const MarkSystemInstanceRunningDocument = gql`
    mutation MarkSystemInstanceRunning($id: UUID!) {
  markSystemInstanceRunning(id: $id) {
    success
    instance {
      id
      organizationId
      clientId
      name
      slug
      isMain
      outputPath
      githubRepoName
      gitDefaultBranch
      vpsHost
      vpsUser
      vpsDeploymentConfig
      portOffset
      deploymentStatus
      lastGeneratedAt
      lastDeployedAt
      archivedAt
      createdAt
      updatedAt
      hasGit
      hasVps
      isArchived
      hasGithubToken
      deployTarget
      subdomainUrl
    }
    errorMessage
  }
}
    `;
export type MarkSystemInstanceRunningMutationFn = Apollo.MutationFunction<MarkSystemInstanceRunningMutation, MarkSystemInstanceRunningMutationVariables>;

/**
 * __useMarkSystemInstanceRunningMutation__
 *
 * To run a mutation, you first call `useMarkSystemInstanceRunningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSystemInstanceRunningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSystemInstanceRunningMutation, { data, loading, error }] = useMarkSystemInstanceRunningMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkSystemInstanceRunningMutation(baseOptions?: Apollo.MutationHookOptions<MarkSystemInstanceRunningMutation, MarkSystemInstanceRunningMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkSystemInstanceRunningMutation, MarkSystemInstanceRunningMutationVariables>(MarkSystemInstanceRunningDocument, options);
      }
export type MarkSystemInstanceRunningMutationHookResult = ReturnType<typeof useMarkSystemInstanceRunningMutation>;
export type MarkSystemInstanceRunningMutationResult = Apollo.MutationResult<MarkSystemInstanceRunningMutation>;
export type MarkSystemInstanceRunningMutationOptions = Apollo.BaseMutationOptions<MarkSystemInstanceRunningMutation, MarkSystemInstanceRunningMutationVariables>;
export const DeploySystemInstanceViaSshDocument = gql`
    mutation DeploySystemInstanceViaSsh($id: UUID!) {
  deploySystemInstanceViaSsh(id: $id) {
    success
    errorMessage
    transferredBytes
    elapsedSeconds
    healthPassed
    markedRunning
    connected
    transferred
    composeUp
    alembicAttempted
    alembicSuccess
    logTail
  }
}
    `;
export type DeploySystemInstanceViaSshMutationFn = Apollo.MutationFunction<DeploySystemInstanceViaSshMutation, DeploySystemInstanceViaSshMutationVariables>;

/**
 * __useDeploySystemInstanceViaSshMutation__
 *
 * To run a mutation, you first call `useDeploySystemInstanceViaSshMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeploySystemInstanceViaSshMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deploySystemInstanceViaSshMutation, { data, loading, error }] = useDeploySystemInstanceViaSshMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeploySystemInstanceViaSshMutation(baseOptions?: Apollo.MutationHookOptions<DeploySystemInstanceViaSshMutation, DeploySystemInstanceViaSshMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeploySystemInstanceViaSshMutation, DeploySystemInstanceViaSshMutationVariables>(DeploySystemInstanceViaSshDocument, options);
      }
export type DeploySystemInstanceViaSshMutationHookResult = ReturnType<typeof useDeploySystemInstanceViaSshMutation>;
export type DeploySystemInstanceViaSshMutationResult = Apollo.MutationResult<DeploySystemInstanceViaSshMutation>;
export type DeploySystemInstanceViaSshMutationOptions = Apollo.BaseMutationOptions<DeploySystemInstanceViaSshMutation, DeploySystemInstanceViaSshMutationVariables>;
export const CheckSystemInstanceDeployStatusDocument = gql`
    mutation CheckSystemInstanceDeployStatus($id: UUID!) {
  checkSystemInstanceDeployStatus(id: $id) {
    attempted
    reason
    found
    runId
    status
    conclusion
    htmlUrl
    headSha
    createdAt
    updatedAt
    markedRunning
    error
  }
}
    `;
export type CheckSystemInstanceDeployStatusMutationFn = Apollo.MutationFunction<CheckSystemInstanceDeployStatusMutation, CheckSystemInstanceDeployStatusMutationVariables>;

/**
 * __useCheckSystemInstanceDeployStatusMutation__
 *
 * To run a mutation, you first call `useCheckSystemInstanceDeployStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckSystemInstanceDeployStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkSystemInstanceDeployStatusMutation, { data, loading, error }] = useCheckSystemInstanceDeployStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCheckSystemInstanceDeployStatusMutation(baseOptions?: Apollo.MutationHookOptions<CheckSystemInstanceDeployStatusMutation, CheckSystemInstanceDeployStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckSystemInstanceDeployStatusMutation, CheckSystemInstanceDeployStatusMutationVariables>(CheckSystemInstanceDeployStatusDocument, options);
      }
export type CheckSystemInstanceDeployStatusMutationHookResult = ReturnType<typeof useCheckSystemInstanceDeployStatusMutation>;
export type CheckSystemInstanceDeployStatusMutationResult = Apollo.MutationResult<CheckSystemInstanceDeployStatusMutation>;
export type CheckSystemInstanceDeployStatusMutationOptions = Apollo.BaseMutationOptions<CheckSystemInstanceDeployStatusMutation, CheckSystemInstanceDeployStatusMutationVariables>;
export const CreateGithubRepoForSystemInstanceDocument = gql`
    mutation CreateGithubRepoForSystemInstance($input: CreateGithubRepoForSystemInstanceInput!) {
  createGithubRepoForSystemInstance(input: $input) {
    success
    repoUrl
    fullName
    githubRepoName
    errorMessage
  }
}
    `;
export type CreateGithubRepoForSystemInstanceMutationFn = Apollo.MutationFunction<CreateGithubRepoForSystemInstanceMutation, CreateGithubRepoForSystemInstanceMutationVariables>;

/**
 * __useCreateGithubRepoForSystemInstanceMutation__
 *
 * To run a mutation, you first call `useCreateGithubRepoForSystemInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGithubRepoForSystemInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGithubRepoForSystemInstanceMutation, { data, loading, error }] = useCreateGithubRepoForSystemInstanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGithubRepoForSystemInstanceMutation(baseOptions?: Apollo.MutationHookOptions<CreateGithubRepoForSystemInstanceMutation, CreateGithubRepoForSystemInstanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGithubRepoForSystemInstanceMutation, CreateGithubRepoForSystemInstanceMutationVariables>(CreateGithubRepoForSystemInstanceDocument, options);
      }
export type CreateGithubRepoForSystemInstanceMutationHookResult = ReturnType<typeof useCreateGithubRepoForSystemInstanceMutation>;
export type CreateGithubRepoForSystemInstanceMutationResult = Apollo.MutationResult<CreateGithubRepoForSystemInstanceMutation>;
export type CreateGithubRepoForSystemInstanceMutationOptions = Apollo.BaseMutationOptions<CreateGithubRepoForSystemInstanceMutation, CreateGithubRepoForSystemInstanceMutationVariables>;
export const SetSystemInstanceVpsCredentialsDocument = gql`
    mutation SetSystemInstanceVpsCredentials($input: SetVpsCredentialsInput!) {
  setSystemInstanceVpsCredentials(input: $input) {
    success
    savedToDb
    githubSync {
      attempted
      reason
      allSuccess
      setCount
      skippedCount
      entries {
        secretName
        success
        error
      }
    }
    errorMessage
  }
}
    `;
export type SetSystemInstanceVpsCredentialsMutationFn = Apollo.MutationFunction<SetSystemInstanceVpsCredentialsMutation, SetSystemInstanceVpsCredentialsMutationVariables>;

/**
 * __useSetSystemInstanceVpsCredentialsMutation__
 *
 * To run a mutation, you first call `useSetSystemInstanceVpsCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSystemInstanceVpsCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSystemInstanceVpsCredentialsMutation, { data, loading, error }] = useSetSystemInstanceVpsCredentialsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetSystemInstanceVpsCredentialsMutation(baseOptions?: Apollo.MutationHookOptions<SetSystemInstanceVpsCredentialsMutation, SetSystemInstanceVpsCredentialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSystemInstanceVpsCredentialsMutation, SetSystemInstanceVpsCredentialsMutationVariables>(SetSystemInstanceVpsCredentialsDocument, options);
      }
export type SetSystemInstanceVpsCredentialsMutationHookResult = ReturnType<typeof useSetSystemInstanceVpsCredentialsMutation>;
export type SetSystemInstanceVpsCredentialsMutationResult = Apollo.MutationResult<SetSystemInstanceVpsCredentialsMutation>;
export type SetSystemInstanceVpsCredentialsMutationOptions = Apollo.BaseMutationOptions<SetSystemInstanceVpsCredentialsMutation, SetSystemInstanceVpsCredentialsMutationVariables>;
export const GenerateSystemInstanceDocument = gql`
    mutation GenerateSystemInstance($id: UUID!, $dryRun: Boolean! = false, $force: Boolean! = false) {
  generateSystemInstance(id: $id, dryRun: $dryRun, force: $force) {
    success
    systemInstanceId
    outputPath
    totalBcs
    totalFiles
    elapsedSeconds
    capturedLog
    errorMessage
    touchedBcs
    isIncremental
    gitCommitHash
    gitBranch
    gitError
    gitPushed
    gitRemoteUrl
    gitPushError
    prUrl
    prNumber
    prError
  }
}
    `;
export type GenerateSystemInstanceMutationFn = Apollo.MutationFunction<GenerateSystemInstanceMutation, GenerateSystemInstanceMutationVariables>;

/**
 * __useGenerateSystemInstanceMutation__
 *
 * To run a mutation, you first call `useGenerateSystemInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSystemInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSystemInstanceMutation, { data, loading, error }] = useGenerateSystemInstanceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      dryRun: // value for 'dryRun'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useGenerateSystemInstanceMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSystemInstanceMutation, GenerateSystemInstanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSystemInstanceMutation, GenerateSystemInstanceMutationVariables>(GenerateSystemInstanceDocument, options);
      }
export type GenerateSystemInstanceMutationHookResult = ReturnType<typeof useGenerateSystemInstanceMutation>;
export type GenerateSystemInstanceMutationResult = Apollo.MutationResult<GenerateSystemInstanceMutation>;
export type GenerateSystemInstanceMutationOptions = Apollo.BaseMutationOptions<GenerateSystemInstanceMutation, GenerateSystemInstanceMutationVariables>;
export const IntegrateProjectIntoSystemInstanceDocument = gql`
    mutation IntegrateProjectIntoSystemInstance($projectId: UUID!, $systemInstanceId: UUID!) {
  integrateProjectIntoSystemInstance(
    projectId: $projectId
    systemInstanceId: $systemInstanceId
  ) {
    success
    projectId
    systemInstanceId
    bcsAdded
    newBcSet
    regenNeeded
    errorMessage
  }
}
    `;
export type IntegrateProjectIntoSystemInstanceMutationFn = Apollo.MutationFunction<IntegrateProjectIntoSystemInstanceMutation, IntegrateProjectIntoSystemInstanceMutationVariables>;

/**
 * __useIntegrateProjectIntoSystemInstanceMutation__
 *
 * To run a mutation, you first call `useIntegrateProjectIntoSystemInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrateProjectIntoSystemInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrateProjectIntoSystemInstanceMutation, { data, loading, error }] = useIntegrateProjectIntoSystemInstanceMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      systemInstanceId: // value for 'systemInstanceId'
 *   },
 * });
 */
export function useIntegrateProjectIntoSystemInstanceMutation(baseOptions?: Apollo.MutationHookOptions<IntegrateProjectIntoSystemInstanceMutation, IntegrateProjectIntoSystemInstanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IntegrateProjectIntoSystemInstanceMutation, IntegrateProjectIntoSystemInstanceMutationVariables>(IntegrateProjectIntoSystemInstanceDocument, options);
      }
export type IntegrateProjectIntoSystemInstanceMutationHookResult = ReturnType<typeof useIntegrateProjectIntoSystemInstanceMutation>;
export type IntegrateProjectIntoSystemInstanceMutationResult = Apollo.MutationResult<IntegrateProjectIntoSystemInstanceMutation>;
export type IntegrateProjectIntoSystemInstanceMutationOptions = Apollo.BaseMutationOptions<IntegrateProjectIntoSystemInstanceMutation, IntegrateProjectIntoSystemInstanceMutationVariables>;
export const GetHealthCheckDocument = gql`
    query GetHealthCheck {
  healthCheck {
    status
    version
    timestamp
  }
}
    `;

/**
 * __useGetHealthCheckQuery__
 *
 * To run a query within a React component, call `useGetHealthCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHealthCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHealthCheckQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHealthCheckQuery(baseOptions?: Apollo.QueryHookOptions<GetHealthCheckQuery, GetHealthCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHealthCheckQuery, GetHealthCheckQueryVariables>(GetHealthCheckDocument, options);
      }
export function useGetHealthCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHealthCheckQuery, GetHealthCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHealthCheckQuery, GetHealthCheckQueryVariables>(GetHealthCheckDocument, options);
        }
// @ts-ignore
export function useGetHealthCheckSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHealthCheckQuery, GetHealthCheckQueryVariables>): Apollo.UseSuspenseQueryResult<GetHealthCheckQuery, GetHealthCheckQueryVariables>;
export function useGetHealthCheckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHealthCheckQuery, GetHealthCheckQueryVariables>): Apollo.UseSuspenseQueryResult<GetHealthCheckQuery | undefined, GetHealthCheckQueryVariables>;
export function useGetHealthCheckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHealthCheckQuery, GetHealthCheckQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHealthCheckQuery, GetHealthCheckQueryVariables>(GetHealthCheckDocument, options);
        }
export type GetHealthCheckQueryHookResult = ReturnType<typeof useGetHealthCheckQuery>;
export type GetHealthCheckLazyQueryHookResult = ReturnType<typeof useGetHealthCheckLazyQuery>;
export type GetHealthCheckSuspenseQueryHookResult = ReturnType<typeof useGetHealthCheckSuspenseQuery>;
export type GetHealthCheckQueryResult = Apollo.QueryResult<GetHealthCheckQuery, GetHealthCheckQueryVariables>;
export const GetAnalysisCapabilitiesDocument = gql`
    query GetAnalysisCapabilities {
  analysisCapabilities {
    version
    capabilities
    performance
  }
}
    `;

/**
 * __useGetAnalysisCapabilitiesQuery__
 *
 * To run a query within a React component, call `useGetAnalysisCapabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalysisCapabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalysisCapabilitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAnalysisCapabilitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetAnalysisCapabilitiesQuery, GetAnalysisCapabilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalysisCapabilitiesQuery, GetAnalysisCapabilitiesQueryVariables>(GetAnalysisCapabilitiesDocument, options);
      }
export function useGetAnalysisCapabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalysisCapabilitiesQuery, GetAnalysisCapabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalysisCapabilitiesQuery, GetAnalysisCapabilitiesQueryVariables>(GetAnalysisCapabilitiesDocument, options);
        }
// @ts-ignore
export function useGetAnalysisCapabilitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAnalysisCapabilitiesQuery, GetAnalysisCapabilitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnalysisCapabilitiesQuery, GetAnalysisCapabilitiesQueryVariables>;
export function useGetAnalysisCapabilitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalysisCapabilitiesQuery, GetAnalysisCapabilitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAnalysisCapabilitiesQuery | undefined, GetAnalysisCapabilitiesQueryVariables>;
export function useGetAnalysisCapabilitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalysisCapabilitiesQuery, GetAnalysisCapabilitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnalysisCapabilitiesQuery, GetAnalysisCapabilitiesQueryVariables>(GetAnalysisCapabilitiesDocument, options);
        }
export type GetAnalysisCapabilitiesQueryHookResult = ReturnType<typeof useGetAnalysisCapabilitiesQuery>;
export type GetAnalysisCapabilitiesLazyQueryHookResult = ReturnType<typeof useGetAnalysisCapabilitiesLazyQuery>;
export type GetAnalysisCapabilitiesSuspenseQueryHookResult = ReturnType<typeof useGetAnalysisCapabilitiesSuspenseQuery>;
export type GetAnalysisCapabilitiesQueryResult = Apollo.QueryResult<GetAnalysisCapabilitiesQuery, GetAnalysisCapabilitiesQueryVariables>;
export const GetSystemGenerationStatusDocument = gql`
    query GetSystemGenerationStatus($taskId: String!) {
  systemGenerationStatus(taskId: $taskId) {
    status
    progress
    result {
      totalLines
      qualityScore
      deploymentUrl
      metadata
      files {
        path
        type
        lines
        content
      }
    }
    error
  }
}
    `;

/**
 * __useGetSystemGenerationStatusQuery__
 *
 * To run a query within a React component, call `useGetSystemGenerationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemGenerationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemGenerationStatusQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetSystemGenerationStatusQuery(baseOptions: Apollo.QueryHookOptions<GetSystemGenerationStatusQuery, GetSystemGenerationStatusQueryVariables> & ({ variables: GetSystemGenerationStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSystemGenerationStatusQuery, GetSystemGenerationStatusQueryVariables>(GetSystemGenerationStatusDocument, options);
      }
export function useGetSystemGenerationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSystemGenerationStatusQuery, GetSystemGenerationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSystemGenerationStatusQuery, GetSystemGenerationStatusQueryVariables>(GetSystemGenerationStatusDocument, options);
        }
// @ts-ignore
export function useGetSystemGenerationStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSystemGenerationStatusQuery, GetSystemGenerationStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetSystemGenerationStatusQuery, GetSystemGenerationStatusQueryVariables>;
export function useGetSystemGenerationStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSystemGenerationStatusQuery, GetSystemGenerationStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetSystemGenerationStatusQuery | undefined, GetSystemGenerationStatusQueryVariables>;
export function useGetSystemGenerationStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSystemGenerationStatusQuery, GetSystemGenerationStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSystemGenerationStatusQuery, GetSystemGenerationStatusQueryVariables>(GetSystemGenerationStatusDocument, options);
        }
export type GetSystemGenerationStatusQueryHookResult = ReturnType<typeof useGetSystemGenerationStatusQuery>;
export type GetSystemGenerationStatusLazyQueryHookResult = ReturnType<typeof useGetSystemGenerationStatusLazyQuery>;
export type GetSystemGenerationStatusSuspenseQueryHookResult = ReturnType<typeof useGetSystemGenerationStatusSuspenseQuery>;
export type GetSystemGenerationStatusQueryResult = Apollo.QueryResult<GetSystemGenerationStatusQuery, GetSystemGenerationStatusQueryVariables>;
export const GetSystemInstanceDocument = gql`
    query GetSystemInstance($id: UUID!) {
  systemInstance(id: $id) {
    id
    organizationId
    clientId
    name
    slug
    isMain
    outputPath
    githubRepoName
    gitDefaultBranch
    vpsHost
    vpsUser
    vpsDeploymentConfig
    portOffset
    deploymentStatus
    lastGeneratedAt
    lastDeployedAt
    archivedAt
    createdAt
    updatedAt
    hasGit
    hasVps
    isArchived
    hasGithubToken
    deployTarget
    subdomainUrl
  }
}
    `;

/**
 * __useGetSystemInstanceQuery__
 *
 * To run a query within a React component, call `useGetSystemInstanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemInstanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemInstanceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSystemInstanceQuery(baseOptions: Apollo.QueryHookOptions<GetSystemInstanceQuery, GetSystemInstanceQueryVariables> & ({ variables: GetSystemInstanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSystemInstanceQuery, GetSystemInstanceQueryVariables>(GetSystemInstanceDocument, options);
      }
export function useGetSystemInstanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSystemInstanceQuery, GetSystemInstanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSystemInstanceQuery, GetSystemInstanceQueryVariables>(GetSystemInstanceDocument, options);
        }
// @ts-ignore
export function useGetSystemInstanceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSystemInstanceQuery, GetSystemInstanceQueryVariables>): Apollo.UseSuspenseQueryResult<GetSystemInstanceQuery, GetSystemInstanceQueryVariables>;
export function useGetSystemInstanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSystemInstanceQuery, GetSystemInstanceQueryVariables>): Apollo.UseSuspenseQueryResult<GetSystemInstanceQuery | undefined, GetSystemInstanceQueryVariables>;
export function useGetSystemInstanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSystemInstanceQuery, GetSystemInstanceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSystemInstanceQuery, GetSystemInstanceQueryVariables>(GetSystemInstanceDocument, options);
        }
export type GetSystemInstanceQueryHookResult = ReturnType<typeof useGetSystemInstanceQuery>;
export type GetSystemInstanceLazyQueryHookResult = ReturnType<typeof useGetSystemInstanceLazyQuery>;
export type GetSystemInstanceSuspenseQueryHookResult = ReturnType<typeof useGetSystemInstanceSuspenseQuery>;
export type GetSystemInstanceQueryResult = Apollo.QueryResult<GetSystemInstanceQuery, GetSystemInstanceQueryVariables>;
export const GetSystemInstancesDocument = gql`
    query GetSystemInstances($includeArchived: Boolean! = false) {
  systemInstances(includeArchived: $includeArchived) {
    id
    organizationId
    clientId
    name
    slug
    isMain
    outputPath
    githubRepoName
    gitDefaultBranch
    vpsHost
    vpsUser
    vpsDeploymentConfig
    portOffset
    deploymentStatus
    lastGeneratedAt
    lastDeployedAt
    archivedAt
    createdAt
    updatedAt
    hasGit
    hasVps
    isArchived
    hasGithubToken
    deployTarget
    subdomainUrl
  }
}
    `;

/**
 * __useGetSystemInstancesQuery__
 *
 * To run a query within a React component, call `useGetSystemInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemInstancesQuery({
 *   variables: {
 *      includeArchived: // value for 'includeArchived'
 *   },
 * });
 */
export function useGetSystemInstancesQuery(baseOptions?: Apollo.QueryHookOptions<GetSystemInstancesQuery, GetSystemInstancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSystemInstancesQuery, GetSystemInstancesQueryVariables>(GetSystemInstancesDocument, options);
      }
export function useGetSystemInstancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSystemInstancesQuery, GetSystemInstancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSystemInstancesQuery, GetSystemInstancesQueryVariables>(GetSystemInstancesDocument, options);
        }
// @ts-ignore
export function useGetSystemInstancesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSystemInstancesQuery, GetSystemInstancesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSystemInstancesQuery, GetSystemInstancesQueryVariables>;
export function useGetSystemInstancesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSystemInstancesQuery, GetSystemInstancesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSystemInstancesQuery | undefined, GetSystemInstancesQueryVariables>;
export function useGetSystemInstancesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSystemInstancesQuery, GetSystemInstancesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSystemInstancesQuery, GetSystemInstancesQueryVariables>(GetSystemInstancesDocument, options);
        }
export type GetSystemInstancesQueryHookResult = ReturnType<typeof useGetSystemInstancesQuery>;
export type GetSystemInstancesLazyQueryHookResult = ReturnType<typeof useGetSystemInstancesLazyQuery>;
export type GetSystemInstancesSuspenseQueryHookResult = ReturnType<typeof useGetSystemInstancesSuspenseQuery>;
export type GetSystemInstancesQueryResult = Apollo.QueryResult<GetSystemInstancesQuery, GetSystemInstancesQueryVariables>;
export const GetMainSystemInstanceDocument = gql`
    query GetMainSystemInstance($clientId: UUID = null) {
  mainSystemInstance(clientId: $clientId) {
    id
    organizationId
    clientId
    name
    slug
    isMain
    outputPath
    githubRepoName
    gitDefaultBranch
    vpsHost
    vpsUser
    vpsDeploymentConfig
    portOffset
    deploymentStatus
    lastGeneratedAt
    lastDeployedAt
    archivedAt
    createdAt
    updatedAt
    hasGit
    hasVps
    isArchived
    hasGithubToken
    deployTarget
    subdomainUrl
  }
}
    `;

/**
 * __useGetMainSystemInstanceQuery__
 *
 * To run a query within a React component, call `useGetMainSystemInstanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMainSystemInstanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMainSystemInstanceQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetMainSystemInstanceQuery(baseOptions?: Apollo.QueryHookOptions<GetMainSystemInstanceQuery, GetMainSystemInstanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMainSystemInstanceQuery, GetMainSystemInstanceQueryVariables>(GetMainSystemInstanceDocument, options);
      }
export function useGetMainSystemInstanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMainSystemInstanceQuery, GetMainSystemInstanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMainSystemInstanceQuery, GetMainSystemInstanceQueryVariables>(GetMainSystemInstanceDocument, options);
        }
// @ts-ignore
export function useGetMainSystemInstanceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMainSystemInstanceQuery, GetMainSystemInstanceQueryVariables>): Apollo.UseSuspenseQueryResult<GetMainSystemInstanceQuery, GetMainSystemInstanceQueryVariables>;
export function useGetMainSystemInstanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMainSystemInstanceQuery, GetMainSystemInstanceQueryVariables>): Apollo.UseSuspenseQueryResult<GetMainSystemInstanceQuery | undefined, GetMainSystemInstanceQueryVariables>;
export function useGetMainSystemInstanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMainSystemInstanceQuery, GetMainSystemInstanceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMainSystemInstanceQuery, GetMainSystemInstanceQueryVariables>(GetMainSystemInstanceDocument, options);
        }
export type GetMainSystemInstanceQueryHookResult = ReturnType<typeof useGetMainSystemInstanceQuery>;
export type GetMainSystemInstanceLazyQueryHookResult = ReturnType<typeof useGetMainSystemInstanceLazyQuery>;
export type GetMainSystemInstanceSuspenseQueryHookResult = ReturnType<typeof useGetMainSystemInstanceSuspenseQuery>;
export type GetMainSystemInstanceQueryResult = Apollo.QueryResult<GetMainSystemInstanceQuery, GetMainSystemInstanceQueryVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($input: CreateUserInput!) {
  createUser(input: $input) {
    id
    email
    username
    displayName
    authProvider
    avatarUrl
    bio
    timezone
    locale
    status
    isEmailVerified
    createdAt
    updatedAt
    lastLoginAt
    loginCount
    fullName
    isActive
    organizations {
      id
      name
      slug
      domain
      description
      billingEmail
      billingAddress
      billingContact
      taxId
      planType
      maxUsers
      maxClients
      maxProjects
      storageLimitGb
      sharedKnowledgeEnabled
      requireEmailVerification
      isActive
      isVerified
      createdAt
      updatedAt
      isFreePlan
      isEnterprisePlan
      activeUserCount
      activeProjectCount
      storageUsageGb
    }
    organization {
      id
      name
      slug
      domain
      description
      billingEmail
      billingAddress
      billingContact
      taxId
      planType
      maxUsers
      maxClients
      maxProjects
      storageLimitGb
      sharedKnowledgeEnabled
      requireEmailVerification
      isActive
      isVerified
      createdAt
      updatedAt
      isFreePlan
      isEnterprisePlan
      activeUserCount
      activeProjectCount
      storageUsageGb
    }
    ownedProjects {
      id
      name
      description
      clientId
      organizationId
      ownerId
      groupId
      projectType
      status
      priority
      developmentType
      projectPhase
      progress
      constitutionalFacts
      constitutionalVersion
      constitutionalApprovedBy
      constitutionalApprovedAt
      hasApprovedConstitution
      contextAnalysis
      contextAnalysisUpdatedAt
      settings
      projectMetadata
      tags
      color
      isActive
      isArchived
      archivedAt
      isDeleted
      deletedAt
      createdAt
      updatedAt
      isInProgress
      isCompleted
      canStart
      systemInstanceId
      kind
      gitBranch
      prUrl
      prNumber
      promptEvolution {
        core
        version
        updatedAt
        history
      }
      progressInfo {
        progress
        status
      }
      constitutionalLaws {
        needs
        seeds
      }
    }
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($id: UUID!, $input: UpdateUserInput!) {
  updateUser(id: $id, input: $input) {
    id
    email
    username
    displayName
    authProvider
    avatarUrl
    bio
    timezone
    locale
    status
    isEmailVerified
    createdAt
    updatedAt
    lastLoginAt
    loginCount
    fullName
    isActive
    organizations {
      id
      name
      slug
      domain
      description
      billingEmail
      billingAddress
      billingContact
      taxId
      planType
      maxUsers
      maxClients
      maxProjects
      storageLimitGb
      sharedKnowledgeEnabled
      requireEmailVerification
      isActive
      isVerified
      createdAt
      updatedAt
      isFreePlan
      isEnterprisePlan
      activeUserCount
      activeProjectCount
      storageUsageGb
    }
    organization {
      id
      name
      slug
      domain
      description
      billingEmail
      billingAddress
      billingContact
      taxId
      planType
      maxUsers
      maxClients
      maxProjects
      storageLimitGb
      sharedKnowledgeEnabled
      requireEmailVerification
      isActive
      isVerified
      createdAt
      updatedAt
      isFreePlan
      isEnterprisePlan
      activeUserCount
      activeProjectCount
      storageUsageGb
    }
    ownedProjects {
      id
      name
      description
      clientId
      organizationId
      ownerId
      groupId
      projectType
      status
      priority
      developmentType
      projectPhase
      progress
      constitutionalFacts
      constitutionalVersion
      constitutionalApprovedBy
      constitutionalApprovedAt
      hasApprovedConstitution
      contextAnalysis
      contextAnalysisUpdatedAt
      settings
      projectMetadata
      tags
      color
      isActive
      isArchived
      archivedAt
      isDeleted
      deletedAt
      createdAt
      updatedAt
      isInProgress
      isCompleted
      canStart
      systemInstanceId
      kind
      gitBranch
      prUrl
      prNumber
      promptEvolution {
        core
        version
        updatedAt
        history
      }
      progressInfo {
        progress
        status
      }
      constitutionalLaws {
        needs
        seeds
      }
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const ChangeUserStatusDocument = gql`
    mutation ChangeUserStatus($userId: UUID!, $status: UserStatusType!, $reason: String = null) {
  changeUserStatus(userId: $userId, status: $status, reason: $reason)
}
    `;
export type ChangeUserStatusMutationFn = Apollo.MutationFunction<ChangeUserStatusMutation, ChangeUserStatusMutationVariables>;

/**
 * __useChangeUserStatusMutation__
 *
 * To run a mutation, you first call `useChangeUserStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeUserStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeUserStatusMutation, { data, loading, error }] = useChangeUserStatusMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      status: // value for 'status'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useChangeUserStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeUserStatusMutation, ChangeUserStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeUserStatusMutation, ChangeUserStatusMutationVariables>(ChangeUserStatusDocument, options);
      }
export type ChangeUserStatusMutationHookResult = ReturnType<typeof useChangeUserStatusMutation>;
export type ChangeUserStatusMutationResult = Apollo.MutationResult<ChangeUserStatusMutation>;
export type ChangeUserStatusMutationOptions = Apollo.BaseMutationOptions<ChangeUserStatusMutation, ChangeUserStatusMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($id: UUID!) {
  deleteUser(id: $id)
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const HardDeleteUserDocument = gql`
    mutation HardDeleteUser($id: UUID!) {
  hardDeleteUser(id: $id)
}
    `;
export type HardDeleteUserMutationFn = Apollo.MutationFunction<HardDeleteUserMutation, HardDeleteUserMutationVariables>;

/**
 * __useHardDeleteUserMutation__
 *
 * To run a mutation, you first call `useHardDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHardDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hardDeleteUserMutation, { data, loading, error }] = useHardDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHardDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<HardDeleteUserMutation, HardDeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HardDeleteUserMutation, HardDeleteUserMutationVariables>(HardDeleteUserDocument, options);
      }
export type HardDeleteUserMutationHookResult = ReturnType<typeof useHardDeleteUserMutation>;
export type HardDeleteUserMutationResult = Apollo.MutationResult<HardDeleteUserMutation>;
export type HardDeleteUserMutationOptions = Apollo.BaseMutationOptions<HardDeleteUserMutation, HardDeleteUserMutationVariables>;
export const RestoreUserDocument = gql`
    mutation RestoreUser($id: UUID!) {
  restoreUser(id: $id) {
    id
    email
    username
    displayName
    authProvider
    avatarUrl
    bio
    timezone
    locale
    status
    isEmailVerified
    createdAt
    updatedAt
    lastLoginAt
    loginCount
    fullName
    isActive
    organizations {
      id
      name
      slug
      domain
      description
      billingEmail
      billingAddress
      billingContact
      taxId
      planType
      maxUsers
      maxClients
      maxProjects
      storageLimitGb
      sharedKnowledgeEnabled
      requireEmailVerification
      isActive
      isVerified
      createdAt
      updatedAt
      isFreePlan
      isEnterprisePlan
      activeUserCount
      activeProjectCount
      storageUsageGb
    }
    organization {
      id
      name
      slug
      domain
      description
      billingEmail
      billingAddress
      billingContact
      taxId
      planType
      maxUsers
      maxClients
      maxProjects
      storageLimitGb
      sharedKnowledgeEnabled
      requireEmailVerification
      isActive
      isVerified
      createdAt
      updatedAt
      isFreePlan
      isEnterprisePlan
      activeUserCount
      activeProjectCount
      storageUsageGb
    }
    ownedProjects {
      id
      name
      description
      clientId
      organizationId
      ownerId
      groupId
      projectType
      status
      priority
      developmentType
      projectPhase
      progress
      constitutionalFacts
      constitutionalVersion
      constitutionalApprovedBy
      constitutionalApprovedAt
      hasApprovedConstitution
      contextAnalysis
      contextAnalysisUpdatedAt
      settings
      projectMetadata
      tags
      color
      isActive
      isArchived
      archivedAt
      isDeleted
      deletedAt
      createdAt
      updatedAt
      isInProgress
      isCompleted
      canStart
      systemInstanceId
      kind
      gitBranch
      prUrl
      prNumber
      promptEvolution {
        core
        version
        updatedAt
        history
      }
      progressInfo {
        progress
        status
      }
      constitutionalLaws {
        needs
        seeds
      }
    }
  }
}
    `;
export type RestoreUserMutationFn = Apollo.MutationFunction<RestoreUserMutation, RestoreUserMutationVariables>;

/**
 * __useRestoreUserMutation__
 *
 * To run a mutation, you first call `useRestoreUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreUserMutation, { data, loading, error }] = useRestoreUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreUserMutation(baseOptions?: Apollo.MutationHookOptions<RestoreUserMutation, RestoreUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreUserMutation, RestoreUserMutationVariables>(RestoreUserDocument, options);
      }
export type RestoreUserMutationHookResult = ReturnType<typeof useRestoreUserMutation>;
export type RestoreUserMutationResult = Apollo.MutationResult<RestoreUserMutation>;
export type RestoreUserMutationOptions = Apollo.BaseMutationOptions<RestoreUserMutation, RestoreUserMutationVariables>;
export const GetUserDocument = gql`
    query GetUser($id: UUID!) {
  user(id: $id) {
    id
    email
    username
    displayName
    authProvider
    avatarUrl
    bio
    timezone
    locale
    status
    isEmailVerified
    createdAt
    updatedAt
    lastLoginAt
    loginCount
    fullName
    isActive
    organizations {
      id
      name
      slug
      domain
      description
      billingEmail
      billingAddress
      billingContact
      taxId
      planType
      maxUsers
      maxClients
      maxProjects
      storageLimitGb
      sharedKnowledgeEnabled
      requireEmailVerification
      isActive
      isVerified
      createdAt
      updatedAt
      isFreePlan
      isEnterprisePlan
      activeUserCount
      activeProjectCount
      storageUsageGb
    }
    organization {
      id
      name
      slug
      domain
      description
      billingEmail
      billingAddress
      billingContact
      taxId
      planType
      maxUsers
      maxClients
      maxProjects
      storageLimitGb
      sharedKnowledgeEnabled
      requireEmailVerification
      isActive
      isVerified
      createdAt
      updatedAt
      isFreePlan
      isEnterprisePlan
      activeUserCount
      activeProjectCount
      storageUsageGb
    }
    ownedProjects {
      id
      name
      description
      clientId
      organizationId
      ownerId
      groupId
      projectType
      status
      priority
      developmentType
      projectPhase
      progress
      constitutionalFacts
      constitutionalVersion
      constitutionalApprovedBy
      constitutionalApprovedAt
      hasApprovedConstitution
      contextAnalysis
      contextAnalysisUpdatedAt
      settings
      projectMetadata
      tags
      color
      isActive
      isArchived
      archivedAt
      isDeleted
      deletedAt
      createdAt
      updatedAt
      isInProgress
      isCompleted
      canStart
      systemInstanceId
      kind
      gitBranch
      prUrl
      prNumber
      promptEvolution {
        core
        version
        updatedAt
        history
      }
      progressInfo {
        progress
        status
      }
      constitutionalLaws {
        needs
        seeds
      }
    }
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables> & ({ variables: GetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
// @ts-ignore
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserQuery, GetUserQueryVariables>;
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserQuery | undefined, GetUserQueryVariables>;
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetUserByEmailDocument = gql`
    query GetUserByEmail($email: String!) {
  userByEmail(email: $email) {
    id
    email
    username
    displayName
    authProvider
    avatarUrl
    bio
    timezone
    locale
    status
    isEmailVerified
    createdAt
    updatedAt
    lastLoginAt
    loginCount
    fullName
    isActive
    organizations {
      id
      name
      slug
      domain
      description
      billingEmail
      billingAddress
      billingContact
      taxId
      planType
      maxUsers
      maxClients
      maxProjects
      storageLimitGb
      sharedKnowledgeEnabled
      requireEmailVerification
      isActive
      isVerified
      createdAt
      updatedAt
      isFreePlan
      isEnterprisePlan
      activeUserCount
      activeProjectCount
      storageUsageGb
    }
    organization {
      id
      name
      slug
      domain
      description
      billingEmail
      billingAddress
      billingContact
      taxId
      planType
      maxUsers
      maxClients
      maxProjects
      storageLimitGb
      sharedKnowledgeEnabled
      requireEmailVerification
      isActive
      isVerified
      createdAt
      updatedAt
      isFreePlan
      isEnterprisePlan
      activeUserCount
      activeProjectCount
      storageUsageGb
    }
    ownedProjects {
      id
      name
      description
      clientId
      organizationId
      ownerId
      groupId
      projectType
      status
      priority
      developmentType
      projectPhase
      progress
      constitutionalFacts
      constitutionalVersion
      constitutionalApprovedBy
      constitutionalApprovedAt
      hasApprovedConstitution
      contextAnalysis
      contextAnalysisUpdatedAt
      settings
      projectMetadata
      tags
      color
      isActive
      isArchived
      archivedAt
      isDeleted
      deletedAt
      createdAt
      updatedAt
      isInProgress
      isCompleted
      canStart
      systemInstanceId
      kind
      gitBranch
      prUrl
      prNumber
      promptEvolution {
        core
        version
        updatedAt
        history
      }
      progressInfo {
        progress
        status
      }
      constitutionalLaws {
        needs
        seeds
      }
    }
  }
}
    `;

/**
 * __useGetUserByEmailQuery__
 *
 * To run a query within a React component, call `useGetUserByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetUserByEmailQuery(baseOptions: Apollo.QueryHookOptions<GetUserByEmailQuery, GetUserByEmailQueryVariables> & ({ variables: GetUserByEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByEmailQuery, GetUserByEmailQueryVariables>(GetUserByEmailDocument, options);
      }
export function useGetUserByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByEmailQuery, GetUserByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByEmailQuery, GetUserByEmailQueryVariables>(GetUserByEmailDocument, options);
        }
// @ts-ignore
export function useGetUserByEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserByEmailQuery, GetUserByEmailQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserByEmailQuery, GetUserByEmailQueryVariables>;
export function useGetUserByEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserByEmailQuery, GetUserByEmailQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserByEmailQuery | undefined, GetUserByEmailQueryVariables>;
export function useGetUserByEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserByEmailQuery, GetUserByEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserByEmailQuery, GetUserByEmailQueryVariables>(GetUserByEmailDocument, options);
        }
export type GetUserByEmailQueryHookResult = ReturnType<typeof useGetUserByEmailQuery>;
export type GetUserByEmailLazyQueryHookResult = ReturnType<typeof useGetUserByEmailLazyQuery>;
export type GetUserByEmailSuspenseQueryHookResult = ReturnType<typeof useGetUserByEmailSuspenseQuery>;
export type GetUserByEmailQueryResult = Apollo.QueryResult<GetUserByEmailQuery, GetUserByEmailQueryVariables>;
export const GetUserByUsernameDocument = gql`
    query GetUserByUsername($username: String!) {
  userByUsername(username: $username) {
    id
    email
    username
    displayName
    authProvider
    avatarUrl
    bio
    timezone
    locale
    status
    isEmailVerified
    createdAt
    updatedAt
    lastLoginAt
    loginCount
    fullName
    isActive
    organizations {
      id
      name
      slug
      domain
      description
      billingEmail
      billingAddress
      billingContact
      taxId
      planType
      maxUsers
      maxClients
      maxProjects
      storageLimitGb
      sharedKnowledgeEnabled
      requireEmailVerification
      isActive
      isVerified
      createdAt
      updatedAt
      isFreePlan
      isEnterprisePlan
      activeUserCount
      activeProjectCount
      storageUsageGb
    }
    organization {
      id
      name
      slug
      domain
      description
      billingEmail
      billingAddress
      billingContact
      taxId
      planType
      maxUsers
      maxClients
      maxProjects
      storageLimitGb
      sharedKnowledgeEnabled
      requireEmailVerification
      isActive
      isVerified
      createdAt
      updatedAt
      isFreePlan
      isEnterprisePlan
      activeUserCount
      activeProjectCount
      storageUsageGb
    }
    ownedProjects {
      id
      name
      description
      clientId
      organizationId
      ownerId
      groupId
      projectType
      status
      priority
      developmentType
      projectPhase
      progress
      constitutionalFacts
      constitutionalVersion
      constitutionalApprovedBy
      constitutionalApprovedAt
      hasApprovedConstitution
      contextAnalysis
      contextAnalysisUpdatedAt
      settings
      projectMetadata
      tags
      color
      isActive
      isArchived
      archivedAt
      isDeleted
      deletedAt
      createdAt
      updatedAt
      isInProgress
      isCompleted
      canStart
      systemInstanceId
      kind
      gitBranch
      prUrl
      prNumber
      promptEvolution {
        core
        version
        updatedAt
        history
      }
      progressInfo {
        progress
        status
      }
      constitutionalLaws {
        needs
        seeds
      }
    }
  }
}
    `;

/**
 * __useGetUserByUsernameQuery__
 *
 * To run a query within a React component, call `useGetUserByUsernameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByUsernameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByUsernameQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useGetUserByUsernameQuery(baseOptions: Apollo.QueryHookOptions<GetUserByUsernameQuery, GetUserByUsernameQueryVariables> & ({ variables: GetUserByUsernameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByUsernameQuery, GetUserByUsernameQueryVariables>(GetUserByUsernameDocument, options);
      }
export function useGetUserByUsernameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByUsernameQuery, GetUserByUsernameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByUsernameQuery, GetUserByUsernameQueryVariables>(GetUserByUsernameDocument, options);
        }
// @ts-ignore
export function useGetUserByUsernameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserByUsernameQuery, GetUserByUsernameQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserByUsernameQuery, GetUserByUsernameQueryVariables>;
export function useGetUserByUsernameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserByUsernameQuery, GetUserByUsernameQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserByUsernameQuery | undefined, GetUserByUsernameQueryVariables>;
export function useGetUserByUsernameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserByUsernameQuery, GetUserByUsernameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserByUsernameQuery, GetUserByUsernameQueryVariables>(GetUserByUsernameDocument, options);
        }
export type GetUserByUsernameQueryHookResult = ReturnType<typeof useGetUserByUsernameQuery>;
export type GetUserByUsernameLazyQueryHookResult = ReturnType<typeof useGetUserByUsernameLazyQuery>;
export type GetUserByUsernameSuspenseQueryHookResult = ReturnType<typeof useGetUserByUsernameSuspenseQuery>;
export type GetUserByUsernameQueryResult = Apollo.QueryResult<GetUserByUsernameQuery, GetUserByUsernameQueryVariables>;
export const GetUsersDocument = gql`
    query GetUsers($filter: UserFilterInput = null, $limit: Int! = 20, $offset: Int! = 0) {
  users(filter: $filter, limit: $limit, offset: $offset) {
    edges {
      cursor
      node {
        id
        email
        username
        displayName
        authProvider
        avatarUrl
        bio
        timezone
        locale
        status
        isEmailVerified
        createdAt
        updatedAt
        lastLoginAt
        loginCount
        fullName
        isActive
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
// @ts-ignore
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersQuery, GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersQuery | undefined, GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetSearchUsersDocument = gql`
    query GetSearchUsers($query: String!, $organizationId: UUID = null, $status: UserStatusType = null, $limit: Int! = 20, $offset: Int! = 0) {
  searchUsers(
    query: $query
    organizationId: $organizationId
    status: $status
    limit: $limit
    offset: $offset
  ) {
    edges {
      cursor
      node {
        id
        email
        username
        displayName
        authProvider
        avatarUrl
        bio
        timezone
        locale
        status
        isEmailVerified
        createdAt
        updatedAt
        lastLoginAt
        loginCount
        fullName
        isActive
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetSearchUsersQuery__
 *
 * To run a query within a React component, call `useGetSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchUsersQuery({
 *   variables: {
 *      query: // value for 'query'
 *      organizationId: // value for 'organizationId'
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetSearchUsersQuery(baseOptions: Apollo.QueryHookOptions<GetSearchUsersQuery, GetSearchUsersQueryVariables> & ({ variables: GetSearchUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchUsersQuery, GetSearchUsersQueryVariables>(GetSearchUsersDocument, options);
      }
export function useGetSearchUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchUsersQuery, GetSearchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchUsersQuery, GetSearchUsersQueryVariables>(GetSearchUsersDocument, options);
        }
// @ts-ignore
export function useGetSearchUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSearchUsersQuery, GetSearchUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetSearchUsersQuery, GetSearchUsersQueryVariables>;
export function useGetSearchUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchUsersQuery, GetSearchUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetSearchUsersQuery | undefined, GetSearchUsersQueryVariables>;
export function useGetSearchUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchUsersQuery, GetSearchUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchUsersQuery, GetSearchUsersQueryVariables>(GetSearchUsersDocument, options);
        }
export type GetSearchUsersQueryHookResult = ReturnType<typeof useGetSearchUsersQuery>;
export type GetSearchUsersLazyQueryHookResult = ReturnType<typeof useGetSearchUsersLazyQuery>;
export type GetSearchUsersSuspenseQueryHookResult = ReturnType<typeof useGetSearchUsersSuspenseQuery>;
export type GetSearchUsersQueryResult = Apollo.QueryResult<GetSearchUsersQuery, GetSearchUsersQueryVariables>;
export const GetDeletedUsersDocument = gql`
    query GetDeletedUsers($limit: Int! = 20, $offset: Int! = 0) {
  deletedUsers(limit: $limit, offset: $offset) {
    edges {
      cursor
      node {
        id
        email
        username
        displayName
        authProvider
        avatarUrl
        bio
        timezone
        locale
        status
        isEmailVerified
        createdAt
        updatedAt
        lastLoginAt
        loginCount
        fullName
        isActive
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetDeletedUsersQuery__
 *
 * To run a query within a React component, call `useGetDeletedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDeletedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDeletedUsersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetDeletedUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetDeletedUsersQuery, GetDeletedUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDeletedUsersQuery, GetDeletedUsersQueryVariables>(GetDeletedUsersDocument, options);
      }
export function useGetDeletedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDeletedUsersQuery, GetDeletedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDeletedUsersQuery, GetDeletedUsersQueryVariables>(GetDeletedUsersDocument, options);
        }
// @ts-ignore
export function useGetDeletedUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDeletedUsersQuery, GetDeletedUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetDeletedUsersQuery, GetDeletedUsersQueryVariables>;
export function useGetDeletedUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeletedUsersQuery, GetDeletedUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetDeletedUsersQuery | undefined, GetDeletedUsersQueryVariables>;
export function useGetDeletedUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDeletedUsersQuery, GetDeletedUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDeletedUsersQuery, GetDeletedUsersQueryVariables>(GetDeletedUsersDocument, options);
        }
export type GetDeletedUsersQueryHookResult = ReturnType<typeof useGetDeletedUsersQuery>;
export type GetDeletedUsersLazyQueryHookResult = ReturnType<typeof useGetDeletedUsersLazyQuery>;
export type GetDeletedUsersSuspenseQueryHookResult = ReturnType<typeof useGetDeletedUsersSuspenseQuery>;
export type GetDeletedUsersQueryResult = Apollo.QueryResult<GetDeletedUsersQuery, GetDeletedUsersQueryVariables>;
export const GetMyOrganizationsDocument = gql`
    query GetMyOrganizations {
  myOrganizations {
    id
    name
    slug
    domain
    description
    billingEmail
    billingAddress
    billingContact
    taxId
    planType
    maxUsers
    maxClients
    maxProjects
    storageLimitGb
    sharedKnowledgeEnabled
    requireEmailVerification
    isActive
    isVerified
    createdAt
    updatedAt
    isFreePlan
    isEnterprisePlan
    activeUserCount
    activeProjectCount
    storageUsageGb
  }
}
    `;

/**
 * __useGetMyOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetMyOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyOrganizationsQuery, GetMyOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyOrganizationsQuery, GetMyOrganizationsQueryVariables>(GetMyOrganizationsDocument, options);
      }
export function useGetMyOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyOrganizationsQuery, GetMyOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyOrganizationsQuery, GetMyOrganizationsQueryVariables>(GetMyOrganizationsDocument, options);
        }
// @ts-ignore
export function useGetMyOrganizationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyOrganizationsQuery, GetMyOrganizationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyOrganizationsQuery, GetMyOrganizationsQueryVariables>;
export function useGetMyOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyOrganizationsQuery, GetMyOrganizationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyOrganizationsQuery | undefined, GetMyOrganizationsQueryVariables>;
export function useGetMyOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyOrganizationsQuery, GetMyOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyOrganizationsQuery, GetMyOrganizationsQueryVariables>(GetMyOrganizationsDocument, options);
        }
export type GetMyOrganizationsQueryHookResult = ReturnType<typeof useGetMyOrganizationsQuery>;
export type GetMyOrganizationsLazyQueryHookResult = ReturnType<typeof useGetMyOrganizationsLazyQuery>;
export type GetMyOrganizationsSuspenseQueryHookResult = ReturnType<typeof useGetMyOrganizationsSuspenseQuery>;
export type GetMyOrganizationsQueryResult = Apollo.QueryResult<GetMyOrganizationsQuery, GetMyOrganizationsQueryVariables>;
export const GetMeDocument = gql`
    query GetMe {
  me {
    id
    email
    username
    displayName
    isActive
    isSuperuser
    organizationId
    organizationRole
    organizationName
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
// @ts-ignore
export function useGetMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>): Apollo.UseSuspenseQueryResult<GetMeQuery, GetMeQueryVariables>;
export function useGetMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>): Apollo.UseSuspenseQueryResult<GetMeQuery | undefined, GetMeQueryVariables>;
export function useGetMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeSuspenseQueryHookResult = ReturnType<typeof useGetMeSuspenseQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const GetConsolidatedTaskStatusDocument = gql`
    query GetConsolidatedTaskStatus($taskId: String!) {
  consolidatedTaskStatus(taskId: $taskId) {
    taskId
    status
    result
    error
    startedAt
    completedAt
    progress
  }
}
    `;

/**
 * __useGetConsolidatedTaskStatusQuery__
 *
 * To run a query within a React component, call `useGetConsolidatedTaskStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsolidatedTaskStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsolidatedTaskStatusQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetConsolidatedTaskStatusQuery(baseOptions: Apollo.QueryHookOptions<GetConsolidatedTaskStatusQuery, GetConsolidatedTaskStatusQueryVariables> & ({ variables: GetConsolidatedTaskStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConsolidatedTaskStatusQuery, GetConsolidatedTaskStatusQueryVariables>(GetConsolidatedTaskStatusDocument, options);
      }
export function useGetConsolidatedTaskStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConsolidatedTaskStatusQuery, GetConsolidatedTaskStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConsolidatedTaskStatusQuery, GetConsolidatedTaskStatusQueryVariables>(GetConsolidatedTaskStatusDocument, options);
        }
// @ts-ignore
export function useGetConsolidatedTaskStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConsolidatedTaskStatusQuery, GetConsolidatedTaskStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetConsolidatedTaskStatusQuery, GetConsolidatedTaskStatusQueryVariables>;
export function useGetConsolidatedTaskStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConsolidatedTaskStatusQuery, GetConsolidatedTaskStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetConsolidatedTaskStatusQuery | undefined, GetConsolidatedTaskStatusQueryVariables>;
export function useGetConsolidatedTaskStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConsolidatedTaskStatusQuery, GetConsolidatedTaskStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConsolidatedTaskStatusQuery, GetConsolidatedTaskStatusQueryVariables>(GetConsolidatedTaskStatusDocument, options);
        }
export type GetConsolidatedTaskStatusQueryHookResult = ReturnType<typeof useGetConsolidatedTaskStatusQuery>;
export type GetConsolidatedTaskStatusLazyQueryHookResult = ReturnType<typeof useGetConsolidatedTaskStatusLazyQuery>;
export type GetConsolidatedTaskStatusSuspenseQueryHookResult = ReturnType<typeof useGetConsolidatedTaskStatusSuspenseQuery>;
export type GetConsolidatedTaskStatusQueryResult = Apollo.QueryResult<GetConsolidatedTaskStatusQuery, GetConsolidatedTaskStatusQueryVariables>;